<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar />
      <UploadBast
        :bastData="selectedBast"
        :type="uploadBastType"
        :companyName="companyName"
        :bastPO="bastPO"
        :orderId="orderId"
        :bastItem="bastItems"
        :bastLPs="bastLPs"
      />
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav
          style="justify-content: flex-start"
          class="
            navbar navbar-expand-lg navbar-light
            bg-light
            border-bottom
            floating
          "
        >
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar">
              <span class="navbar-toggler-icon"></span>
            </button>

            <button
              style="color: rgba(0, 0, 0, 0.5);border-color: rgba(0, 0, 0, 0.1);"
              class="btn btn-outline navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span style="padding-top: 0.5em"
                ><i class="fas fa-user-alt"></i><span class="account-div"></span
                ><i class="fas fa-angle-down"></i
              ></span>
            </button>
          </div>
          <div class="d-flex">
            <p class="text-muted mb-0 hover-cursor link" @click="toOrder">
              &nbsp;Order&nbsp;
            </p>
            <p class="text-primary mb-0 hover-cursor">
              /&nbsp;{{ orderCode }} ({{ statusName(orderStatus) }})
            </p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ admin }}
                </a>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="navbarDropdown"
                >
                  <a class="dropdown-item link" @click="toPage('/password')">
                    <i class="fas fa-cog"></i
                    ><span class="right-dropdown">Change Password</span></a
                  >
                  <a class="dropdown-item link" @click="handleLogout"
                    ><i class="fas fa-sign-out-alt"></i
                    ><span class="right-dropdown">Logout</span></a
                  >
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <!-- HOT & Warn (ORDER PROPRITY PART) -->
        <div class="container-fluid">
          <div class="row mr-1">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <div class="row">
                  <div class="col-lg-8 col-md-12 col-sm-12">
                    <table>
                      <tr>
                        <th colspan="3" class="py-2">
                          <h5><b>Order</b></h5>
                        </th>
                      </tr>
                    </table>
                  </div>

                  <div class="col-lg-4 col-md-9 col-sm-12">
                    <div v-if="showSetupStagingOrder" class="py-2" :class="[{'editablePriorityBox': canReadOrderStagingAssigment}]" style="display: flex; justify-content: space-between; border: solid 1px; border-color: #E4E4E4; border-radius : 8px; padding-left: 8px;padding-right : 8px;">
                      <b v-if="orderPriority.label" class="py-1" style="font-size : 14px;">
                        Pengaturan Staging Order
                      </b>  
                      <div class="orderPriorityChips py-1" :style="`background-color: ${orderPriority.colorHex}; cursor: ${canReadOrderStagingAssigment ? 'pointer' : 'default'}`"  v-if="orderPriority.label" @click="canReadOrderStagingAssigment? showEditPriorityModal() : null">
                        <span class="option__title" style="font-weight : 600;">
                          <img v-if="orderPriority.label == 'Warm'" src="~@/assets/icon/warm-white.png" width="18px" height="18px" style="margin-bottom : 2px;"/>
                          <img v-else-if="orderPriority.label == 'Hot'" src="~@/assets/icon/hot-white.png" width="18px" height="18px" style="margin-bottom : 2px;"/>
                          <span :style="`color : ${orderPriority.label == 'None' ? '#808080' : '#FFFFFF'}`"> {{orderPriority.label}}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ENF OF ORDER PRIORITY PART -->
        <div class="container-fluid">
          <div class="row mr-1">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <div class="row">
                  <div class="col-lg-6 col-md-12 col-sm-12">
                    <table>
                      <tr>
                        <th colspan="3" class="py-2">
                          <h5>Company Info</h5>
                        </th>
                      </tr>
                      <tr>
                        <td class="align-top">Name (Akta)</td>
                        <td class="align-top">&emsp;:&emsp;</td>
                        <td>
                          {{ companyName }}
                          <span v-if="newUser" class="badge badge-primary"
                            >NEW</span
                          >
                          <img
                            v-if="companyStatus == 8"
                            src="~@/assets/images/icon-verified.png"
                            alt="Brand Logo"
                            class="icon-verified septian-font"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td class="align-top">Name (NPWP)</td>
                        <td class="align-top">&emsp;:&emsp;</td>
                        <td>
                          {{ companyNameNPWP || '-' }}
                        </td>
                      </tr>
                      <tr>
                        <td class="align-top">Province</td>
                        <td class="align-top">&emsp;:&emsp;</td>
                        <td>{{ companyProvince }}</td>
                      </tr>
                      <tr>
                        <td class="align-top">City</td>
                        <td class="align-top">&emsp;:&emsp;</td>
                        <td>{{ companyCity }}</td>
                      </tr>
                      <tr>
                        <td class="align-top">District</td>
                        <td class="align-top">&emsp;:&emsp;</td>
                        <td>{{ companyDistrict }}</td>
                      </tr>
                      <tr>
                        <td class="align-top">Village</td>
                        <td class="align-top">&emsp;:&emsp;</td>
                        <td style="word-wrap: break-word; max-width: 200px">
                          {{ companyVillage }}
                        </td>
                      </tr>
                      <tr>
                        <td class="align-top" style="min-width: 100px">
                          Zip Code
                        </td>
                        <td class="align-top">&emsp;:&emsp;</td>
                        <td style="word-wrap: break-word; max-width: 200px">
                          {{ companyZip }}
                        </td>
                      </tr>
                      <tr>
                        <td class="align-top">Address</td>
                        <td class="align-top">&emsp;:&emsp;</td>
                        <td style="word-wrap: break-word; max-width: 200px">
                          {{ companyAddress }}
                        </td>
                      </tr>
                      <tr>
                        <td>Phone</td>
                        <td>&emsp;:&emsp;</td>
                        <td style="word-wrap: break-word; max-width: 200px">
                          {{ companyPhone }}
                        </td>
                      </tr>
                      <tr>
                        <td>Citizenship</td>
                        <td>&emsp;:&emsp;</td>
                        <td style="word-wrap: break-word; max-width: 200px; text-transform: uppercase">
                          {{ citizenship }}
                        </td>
                      </tr>
                      <tr>
                        <td>KTP Director</td>
                        <td>&emsp;:&emsp;</td>
                        <td style="word-wrap: break-word; max-width: 200px;">
                          {{ companyKtpPassport }}
                        </td>
                      </tr>
                      <tr v-if="companyNPWP16 !== undefined">
                        <td>NPWP</td>
                        <td>&emsp;:&emsp;</td>
                        <td>{{ companyNPWP16 }}</td>
                      </tr>
                      <tr v-if="companyNPWP22 !== undefined">
                        <td>NITKU</td>
                        <td>&emsp;:&emsp;</td>
                        <td>{{ companyNPWP22 }}</td>
                      </tr>
                      <tr>
                        <td class="align-top">Akta Address</td>
                        <td class="align-top">&emsp;:&emsp;</td>
                        <td style="word-wrap: break-word; max-width: 200px">
                          {{ aktaAddress }}
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-lg-4 col-md-9 col-sm-12">
                    <table>
                      <tr>
                        <th colspan="3" class="py-2">
                          <h5>
                            Company Person In Charge (PIC)
                            <span
                              class="link ml-2"
                              @click="openModalOne('EditPIC')"
                              v-if="!statusRenting"
                              ><i
                                class="fas fa-edit"
                                data-toggle="tooltip"
                                title="Edit"
                              ></i
                            ></span>
                          </h5>
                        </th>
                      </tr>
                      <tr>
                        <td width="30%">Name</td>
                        <td width="10%">&emsp;:&emsp;</td>
                        <td width="60%">{{ userName }}</td>
                      </tr>
                      <tr>
                        <td width="30%">Phone</td>
                        <td width="10%">&emsp;:&emsp;</td>
                        <td width="60%">{{ userPhone }}</td>
                      </tr>
                      <tr>
                        <td width="30%">Email</td>
                        <td width="10%">&emsp;:&emsp;</td>
                        <td width="60%">{{ userEmail }}</td>
                      </tr>
                      <tr>
                        <td width="30%">Position</td>
                        <td width="10%">&emsp;:&emsp;</td>
                        <td width="60%">{{ userPosition }}</td>
                      </tr>
                      <tr>
                        <td width="30%">Division</td>
                        <td width="10%">&emsp;:&emsp;</td>
                        <td width="60%">{{ userDivision }}</td>
                      </tr>
                    </table>
                    <table class="mt-3">
                      <tr>
                        <th colspan="3" class="py-2">
                          <h5>
                            ASANI Person In Charge (PIC)
                            <span
                              class="link"
                              @click="openModalOne('EditAsaniPIC')"
                              v-if="!statusRenting"
                              ><i
                                class="fas fa-edit"
                                data-toggle="tooltip"
                                title="Edit"
                              ></i
                            ></span>
                          </h5>
                        </th>
                      </tr>
                      <tr>
                        <td width="30%">Name</td>
                        <td width="10%">&emsp;:&emsp;</td>
                        <td width="60%" v-if="asaniEmployeeName">
                          {{ asaniEmployeeName }}
                        </td>
                        <td width="60%" v-else>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </td>
                      </tr>
                    </table>

                    <deal-owner-section 
                      :employeeList="employeeSelect" 
                      :dealOwner="dealOwner"
                      :orderStatus="orderStatus"
                      @deal-owner-updated="getData"
                    />

                    <table class="mt-3">
                      <tr>
                        <th colspan="3" class="py-2">
                          <h5>
                            Finance
                            <span
                              class="link ml-2"
                              @click="openModalOne('EditDepositDate')"
                              v-if="orderStatus < 14"
                              ><i
                                class="fas fa-edit"
                                data-toggle="tooltip"
                                title="Edit"
                              ></i
                            ></span>
                          </h5>
                        </th>
                      </tr>
                      <tr>
                        <td width="30%">Deposit</td>
                        <td width="10%">&emsp;:&emsp;</td>
                        <td
                          width="60%"
                          v-if="depositDate != '' && depositDate != null"
                        >
                          {{ depositDate }}
                        </td>
                      </tr>
                      <tr>
                        <td width="30%">Email</td>
                        <td width="10%">&emsp;:&emsp;</td>
                        <td width="60%">
                          <div v-for="(emailData,index) in financeEmailInfo" :key="index" >{{ emailData }}</div>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    <div class="py-1">
                      <img class="img-logo" :src="companyLogoUrl" />
                    </div>
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col-2">
                    <button
                      class="btn-warning btn"
                      @click="openModalOne('Remarks')"
                    >
                      Remarks
                    </button>
                  </div>
                </div>
                <div class="row py-2"></div>
                <div class="row">
                  <div class="col-12">
                    <h5>Documents</h5>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-lg-2">
                    Purchase Order<br />
                    <div class="py-1">
                      <button
                        class="btn btn-primary btn-sm"
                        disabled
                        v-if="purchaseUrl == null || purchaseUrl == ''"
                      >
                        Download
                      </button>
                      <a
                        :href="purchaseUrl + '?token=' + jwt"
                        target="_blank"
                        class="btn btn-primary btn-sm"
                        v-else
                      >
                        Download
                      </a>
                      <br />
                      <label class="edit-status"> Status : </label>
                      <a v-if="loadingStatusPurchase == true">
                        <span class="link-biru"
                          ><img src="~@/assets/images/load-button.gif"
                        /></span>
                      </a>
                      <a
                        @click="
                          openModalThree(
                            'DocPending',
                            'Purchase Order',
                            purchaseStatus
                          )
                        "
                        v-else-if="
                          purchaseStatus == 0 && loadingStatusPurchase == false
                        "
                      >
                        <span class="link-biru"> pending</span>
                        <span class="text-new"> (NEW) </span>
                      </a>
                      <a
                        @click="
                          openModalThree(
                            'DocPending',
                            'Purchase Order',
                            purchaseStatus
                          )
                        "
                        v-else-if="
                          purchaseStatus == 1 && loadingStatusPurchase == false
                        "
                      >
                        <span class="link-biru"> Approved</span>
                      </a>
                      <a
                        @click="
                          openModalThree(
                            'DocPending',
                            'Purchase Order',
                            purchaseStatus
                          )
                        "
                        v-else-if="
                          purchaseStatus == 2 && loadingStatusPurchase == false
                        "
                      >
                        <span class="link-biru"> Rejected</span>
                      </a>
                      <a v-else>
                        <span> None</span>
                      </a>
                    </div>
                    <a
                      @click="openModalOne('UploadPurchase')"
                      class="link"
                      v-if="orderStatus >= 5 && orderStatus <= 13"
                      ><i class="fas fa-edit"></i
                    ></a>
                  </div>
                  <ActionDownloadSPH/>
                  <div class="col-lg-2">
                    Handover<br />
                    <div class="py-1">
                      <button
                        class="btn btn-primary btn-sm"
                        disabled
                        v-if="handoverUrl == null || handoverUrl == ''"
                      >
                        Download
                      </button>
                      <a
                        :href="handoverUrl + '?token=' + jwt"
                        target="_blank"
                        class="btn btn-primary btn-sm"
                        v-else
                      >
                        Download
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mr-1">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <h5 class="card-title">Log Order</h5>
                <div class="card">
                  <div class="card-body">
                    <table class="fixed_header table-bordered table-striped">
                      <tbody class="full-width">
                        <tr>
                          <th width="25%">When</th>
                          <th width="45%">What</th>
                          <th width="30%">Who</th>
                        </tr>
                        <tr v-if="dataLogOrder.length == 0">
                          <td colspan="3">Tidak ada Log</td>
                        </tr>
                        <tr v-else v-for="(data, index) in dataLogOrder" :key="index">
                          <td class="align-top" >{{ data.time }}</td>
                          <td class="align-top"  v-html="data.text"></td>
                          <td class="align-top" >{{ data.ids }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- DETAIL NEW LOOK -->
          <div class="row mr-1">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <!-- <div class="card" style="padding:3px;"> -->
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-end flex-wrap">
                    <div class="d-flex">
                      <h5 class="card-title">
                        Detail Order
                        <span v-if="orderExtendFrom.orderId != ''">
                          (Extended from
                          <span
                            class="link-biru"
                            @click="
                              toDetailExtendBefore(
                                orderExtendFrom.orderId,
                                orderExtendFrom.orderCode,
                                companyId
                              )
                            "
                            >{{ orderExtendFrom.orderCode }}</span
                          >)
                        </span>
                        <button
                          class="btn btn-primary btn-sm ml-2"
                          v-if="orderStatus >= 7 && orderStatus <= 11"
                          @click="openReschedule"
                        >
                          Reschedule Delivery
                        </button>
                      </h5>
                    </div>
                  </div>
                  <div
                    class="
                      d-flex
                      justify-content-between
                      align-items-end
                      flex-wrap
                    "
                    v-if="typeCatalog != ''"
                  >
                    <button
                      type="button"
                      class="btn btn-primary btn-sm btn-icon mt-2 mb-2 mt-xl-0"
                      @click="openModalOne('Add')"
                      v-if="
                        orderStatus >= 0 &&
                        orderStatus <= 9 &&
                        loadingTable == false &&
                        orderExtendFrom.orderId == ''
                      "
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 px-0">
                  <div class="container">
                    <div class="row">
                      <div
                        class="col-lg-3 col-md-12 col-sm-12 px-0"
                        style="margin-bottom: 5px; margin-right: 10px"
                      >
                        <input
                          type="text"
                          class="form-control"
                          name="search_sn_product"
                          placeholder="SN / LP"
                          v-model="searchSnLp"
                        />
                      </div>
                      <div class="col-lg-3 col-md-12 col-sm-12 px-0">
                        <button
                          class="btn btn-primary"
                          @click="submitSearchSnLp"
                        >
                          Search
                        </button>
                        <button
                          class="btn btn-primary"
                          @click="resetOrderDetailFilter"
                        >
                          Reset Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="loadingDetail == true">
                          
                  <img src="~@/assets/images/load-button.gif" />
                </div>
                <div v-else>
                  <div v-if="orderStatus > 6 && orderStatus < 99">
                    <div class="card">
                      <div
                        class="card-body"
                        style="padding:0.8rem 0.5rem;"
                      >
                        <div
                          v-for="(data, index) in detailOrderDeliver"
                          :key="`detailOrderDeliverItem-${index}`"
                        >
                          <span
                            v-if="
                              data != null && data != '' && data.startRent == null
                            "
                          >
                            SLA Delivery Schedule : {{ data.maxSchedule }} <br
                          /></span>
                          <span
                            v-if="
                              data != null && data != '' && data.startRent == null
                            "
                          >
                            Actual Delivery Schedule : {{ data.actualSchedule }}
                            <br
                          /></span>

                          <div v-for="(orderItem, idx) in detailOrder" :key="`detailOrder-${idx}`">
                            <div
                              class="card order-item-detail"
                              style="overflow: auto"
                              v-if="
                                (orderItem.startRent == data.startRent &&
                                  data.startRent != null) ||
                                (orderItem.deliverSchedule ==
                                  data.actualSchedule &&
                                  orderItem.maxSchedule == data.maxSchedule &&
                                  !data.startRent &&
                                  !orderItem.startRent)
                              "
                            >
                              <div
                                class="card-title"
                                style="margin-right: 1.3rem; margin-bottom: 0rem"
                              >
                                <div style="text-align: right">
                                  <div class="black-text" style ="font-size: 80%;">
                                    Start Rent : {{ orderItem.startRent ? orderItem.startRent:'-'}}<br>
                                    End Rent : {{ orderItem.endRent ? orderItem.endRent:'-' }}
                                  </div>
                                </div>
                              </div>
                              <div class="card-body new-detail">
                                <div class="grid-container">
                                  <div
                                    class="grid-item"
                                    style="text-align: center;vertical-align: middle;"
                                  >
                                    <span
                                      class="black-text"
                                      style="font-weight: bold;display: block;font-size: 2rem;"
                                      >{{ orderItem.qty }}</span
                                    >
                                    <small
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Rp
                                      {{ formatPrice(orderItem.orderItemPrice) }}
                                      /month</small
                                    >
                                  </div>
                                  <div class="grid-item">
                                    <div>
                                      <small
                                        class="black-text"
                                        style="font-weight: bold; display: block"
                                        >{{ orderItem.productTypeName }}</small
                                      >
                                      <small
                                        class="black-text"
                                        style="font-weight: bold; display: block"
                                        >{{ orderItem.productTitle }} ({{
                                          orderItem.catalogProductTypeName
                                        }})</small
                                      >
                                    </div>

                                    <small
                                      class="black-text"
                                      style="display: block; margin-top: 10px"
                                      >Special Request :
                                      {{
                                        orderItem.orderItemNote
                                          ? orderItem.orderItemNote
                                          : "-"
                                      }}
                                    </small>
                                  </div>
                                  <div class="grid-item">
                                    <small
                                      style="
                                        font-weight: bold;
                                        display: block;
                                        color: black;
                                      "
                                      >
                                      {{ orderItem.condition }}
                                    </small>
                                    <a
                                      href="#"
                                      class="form-text product-specs"
                                      style="
                                        font-weight: bold;
                                        font-style: italic;
                                        color: #3099F8;
                                        margin-top: -2px;
                                        font-size: 80%;
                                      "
                                      @click="
                                        openModal(
                                          'Detail',
                                          orderItem.productTypeId,
                                          idx
                                        )
                                      "
                                      >{{ orderItem.specificationsView }}</a
                                    >
                                  </div>
                                  <div class="grid-item">
                                    <!-- status -->
                                    <small
                                      v-if="orderItem.orderItemStatus == 0"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Pending -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 7"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Ready to Pickup -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 8"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Picking Up -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 9 && orderItem.finalPrepared"
                                      class="black-text"
                                      style="font-weight: bold; display: block; font-size: 0.688rem;"
                                      >
                                      Ready to Prepare (Final QC) -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 9 && !orderItem.finalPrepared"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Ready to Prepare -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 10"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Prepared -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 11"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Ready to Deliver -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 12"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Shipping -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 13"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Renting -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 14"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Finished -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 15"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Return Schedule -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 16"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Return Assign -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 17"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Return Match -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 18"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Return Unmatch -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 19"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Completed -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 98"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Replaced -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 99"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Canceled -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <!-- End Of status -->
                                    <small
                                      class="black-text"
                                      style="display: block; margin-top: -3px"
                                      >Catalog :Rp
                                      {{
                                        formatPrice(orderItem.itemPrice)
                                      }}/unit/month</small
                                    >
                                    <small
                                      class="black-text"
                                      style="display: block; margin-top: -3px"
                                      >Discount :
                                      {{
                                        orderItem.discountPrice
                                          ? `Rp ${formatPrice(
                                              orderItem.discountPrice
                                            )}/unit/month `
                                          : "-"
                                      }}</small
                                    >
                                    <small
                                      class="black-text"
                                      style="
                                        font-weight: bold;
                                        display: block;
                                        margin-top: -3px;
                                      "
                                      >Final : Rp
                                      {{
                                        formatPrice(orderItem.finalPrice)
                                      }}/unit/month</small
                                    >
                                  </div>
                                  <!-- Action Button -->
                                  <div
                                    v-if="
                                      orderItem.deliverSchedule ==
                                        data.actualSchedule &&
                                      orderItem.maxSchedule == data.maxSchedule &&
                                      !data.startRent &&
                                      !orderItem.startRent
                                    "
                                  >
                                    <div
                                      class="grid-item"
                                      v-if="typeCatalog == ''"
                                    >
                                      <img
                                        src="~@/assets/images/load-button.gif"
                                      />
                                    </div>
                                    <div
                                      class="grid-item"
                                      v-else-if="
                                        typeCatalog != '' &&
                                        orderStatus <= 3 &&
                                        orderItem.orderItemStatus == 0
                                      "
                                    >
                                      <button
                                        class="btn btn-primary btn-small"
                                        @click="
                                          openmodalEditProduct(
                                            orderItem.productTitle,
                                            orderItem.catalogId,
                                            idx,
                                            orderItem.orderItemNote,
                                            orderItem.durationValue,
                                            orderItem.orderItemStatus,
                                            orderItem.isReserved,
                                          )
                                        "
                                      >
                                        <i class="fas fa-edit"></i>
                                      </button>

                                      <button
                                        class="btn btn-primary btn-small"
                                        @click="
                                          openModal(
                                            'Delete',
                                            orderItem.productTitle,
                                            orderItem.productId,
                                            orderItem.qty,
                                            orderItem.durationValue
                                          )
                                        "
                                      >
                                        <i class="fas fa-trash"></i>
                                      </button>
                                    </div>
                                    <div
                                      class="grid-item"
                                      v-if="
                                        orderStatus > 5 &&
                                        orderItem.orderItemStatus > 0 &&
                                        typeCatalog != ''
                                      "
                                    >
                                      <button
                                        class="btn btn-primary btn-small"
                                        @click="
                                          openmodalEditProduct(
                                            orderItem.productTitle,
                                            orderItem.catalogId,
                                            idx,
                                            orderItem.orderItemNote,
                                            orderItem.durationValue,
                                            orderItem.orderItemStatus,
                                            orderItem.isReserved,
                                          )
                                        "
                                        v-if="orderItem.orderItemStatus <= 9"
                                      >
                                        <i class="fas fa-edit"></i>
                                      </button>

                                      <!-- <button
                                                                                  class="btn btn-primary btn-small"
                                                                                  @click="assignDetail(orderItem.productId,orderItem.productType,idx,orderItem.deliverSchedule,orderItem.maxSchedule,orderItem.orderItemStatus,null,orderItem.startRent,orderItem.orderItemDuration)"
                                                                                  v-if="orderStatus < 13"
                                                                              >
                                                                                  Info
                                                                              </button> -->

                                      <!-- <button
                                        class="btn btn-primary btn-sm mt-1"
                                        @click="
                                          toPageEditLessor(
                                            orderId,
                                            orderCode,
                                            companyId,
                                            orderItem.productId,
                                            orderItem.condition,
                                            'edit',
                                            orderItem.orderItemStatus,
                                            orderItem.maxSchedule,
                                            orderItem.orderItemDuration,
                                            orderItem.qty,
                                            orderItem.orderItemNote,
                                            orderItem.finalPrice
                                          )
                                        "
                                        v-if="
                                          orderItem.orderItemStatus >= 7 &&
                                          orderItem.orderItemStatus <= 9 &&
                                          !orderItem.isReserved
                                        "
                                      >
                                        Edit Assigned
                                      </button> -->
                                    </div>

                                    <div
                                      class="grid-item"
                                      v-if="
                                        orderStatus > 5 &&
                                        orderStatus < 10 &&
                                        orderItem.orderItemStatus == 0
                                      "
                                    >
                                      <button
                                        class="btn btn-primary btn-sm"
                                        @click="
                                          openmodalEditProduct(
                                            orderItem.productTitle,
                                            orderItem.catalogId,
                                            idx,
                                            orderItem.orderItemNote,
                                            orderItem.durationValue,
                                            orderItem.orderItemStatus,
                                            orderItem.isReserved,
                                          )
                                        "
                                        v-if="orderItem.orderItemStatus <= 9"
                                      >
                                        <i class="fas fa-edit"></i>
                                      </button>
                                      <!-- Assign Order -->
                                      <!-- <button
                                        class="btn btn-primary btn-sm mt-1"
                                        @click="
                                          toPageEditLessor(
                                            orderId,
                                            orderCode,
                                            companyId,
                                            orderItem.productId,
                                            orderItem.condition,
                                            'set',
                                            orderItem.orderItemStatus,
                                            orderItem.maxSchedule,
                                            orderItem.orderItemDuration,
                                            orderItem.qty,
                                            orderItem.orderItemNote,
                                            orderItem.finalPrice
                                          )
                                        "
                                      >
                                        Assign Order
                                      </button> -->
                                    </div>

                                    <!-- Extend -->
                                    <div
                                      class="grid-item"
                                      v-if="
                                        orderStatus > 5 &&
                                        orderItem.orderItemStatus == 0 &&
                                        orderExtendFrom.orderId != '' &&
                                        typeCatalog != ''
                                      "
                                    >
                                      <!-- <button
                                                                                  class="btn btn-primary btn-sm"
                                                                                  @click="assignDetail(orderItem.productId,orderItem.productType,idx,orderItem.deliverSchedule,orderItem.maxSchedule,orderItem.orderItemStatus,orderItem.id,orderItem.startRent,orderItem.orderItemDuration)"
                                                                              >
                                                                                  Info
                                                                              </button> -->
                                    </div>
                                  </div>
                                  <div v-else>
                                    <div
                                      class="grid-item"
                                      v-if="typeCatalog == ''"
                                    >
                                      <img
                                        src="~@/assets/images/load-button.gif"
                                      />
                                    </div>
                                    <div
                                      class="grid-item"
                                      v-else-if="
                                        typeCatalog != '' &&
                                        orderStatus <= 6 &&
                                        orderItem.orderItemStatus == 0
                                      "
                                    >
                                      <button
                                        class="btn btn-primary btn-small"
                                        @click="
                                          openmodalEditProduct(
                                            orderItem.productTitle,
                                            orderItem.catalogId,
                                            idx,
                                            orderItem.orderItemNote,
                                            orderItem.durationValue,
                                            orderItem.orderItemStatus,
                                            orderItem.isReserved,
                                          )
                                        "
                                      >
                                        <i class="fas fa-edit"></i>
                                      </button>

                                      <button
                                        class="btn btn-primary btn-small"
                                        @click="
                                          openModal(
                                            'Delete',
                                            orderItem.productTitle,
                                            orderItem.productId,
                                            orderItem.Qty,
                                            orderItem.durationValue
                                          )
                                        "
                                      >
                                        <i class="fas fa-trash"></i>
                                      </button>
                                    </div>

                                    <div
                                      class="grid-item"
                                      v-if="
                                        orderStatus > 5 &&
                                        orderItem.orderItemStatus > 0 &&
                                        typeCatalog != ''
                                      "
                                    >
                                      <button
                                        class="btn btn-primary btn-small"
                                        @click="
                                          openmodalEditProduct(
                                            orderItem.productTitle,
                                            orderItem.catalogId,
                                            idx,
                                            orderItem.orderItemNote,
                                            orderItem.durationValue,
                                            orderItem.orderItemStatus,
                                            orderItem.isReserved,
                                          )
                                        "
                                        v-if="orderItem.orderItemStatus <= 9"
                                      >
                                        <i class="fas fa-edit"></i>
                                      </button>
                                      <!-- <button
                                                                                  class="btn btn-primary btn-small"
                                                                                  @click="assignDetail(orderItem.productId,orderItem.productType,idx,orderItem.startRent,null,orderItem.orderItemStatus,null,orderItem.startRent, orderItem.orderItemDuration)"
                                                                                  v-if="orderItem.startRent != null"
                                                                              >
                                                                                  Info
                                                                              </button> -->
                                      <br />
                                      <!-- <button
                                        class="btn btn-primary btn-sm mt-1"
                                        @click="
                                          toPageEditLessor(
                                            orderId,
                                            orderCode,
                                            companyId,
                                            orderItem.productId,
                                            orderItem.condition,
                                            'edit',
                                            orderItem.orderItemStatus,
                                            '',
                                            orderItem.orderItemDuration,
                                            orderItem.qty,
                                            orderItem.orderItemNote,
                                            orderItem.finalPrice
                                          )
                                        "
                                        v-if="
                                          orderItem.orderItemStatus >= 7 &&
                                          orderItem.orderItemStatus <= 9 &&
                                          !orderItem.isReserved
                                        "
                                      >
                                        Edit Assigned
                                      </button> -->
                                    </div>
                                  </div>
                                  <!-- End Of Action Button -->
                                </div>

                                <!-- Endpoint Security -->
                                <!-- <div class="grid-container" style="grid-template-columns : 10% auto">
                                  <div class="grid-item"></div>
                                  <div class="grid-item">
                                    <div class="mt-3 mb-1" style="color:#2E3646; font-weight : 700; font-size : 1rem; line-height : 1.25rem;">
                                      Add-Ons : 
                                    </div>
                                    <div
                                      class="alignLeft total-data mb-2"
                                      style="display: inline-block"
                                    >
                                      <span
                                        class="item-badge-addons"
                                      >
                                        Webroot Endpoint Security Basic
                                      </span>
                                      <span
                                        class="item-badge-addons"
                                      >
                                        Webroot Advanced Threat Security
                                      </span>
                                      
                                    </div>
                                  </div>
                                </div> -->
                                <!-- END of Endpoint Security -->

                              </div>
                              <hr
                                style="
                                  height: 1.5px;
                                  border-width: 0;
                                  color: black;
                                  background-color: black;
                                  margin-right: 1.25rem;
                                  margin-left: 1.25rem;
                                  margin-bottom: 5px;
                                  margin-top: 5px;
                                "
                              />

                              <div
                                class="collapse"
                                :id="'collapseInfo' + idx"
                                style="
                                  margin-right: 1.25rem;
                                  margin-left: 1.25rem;
                                  margin-top: 10px;
                                  padding-bottom: 1.25rem;
                                "
                              >
                                <div v-for="(item, index) in orderItem.items" :key="index" >
                                  <div class="card" style="margin-bottom: 10px">
                                    <div
                                      class="card-body"
                                      style="
                                        padding-top: 0.5rem;
                                        padding-bottom: 0.5rem;
                                      "
                                    >
                                    <div class='card'>
                                      <table class="table table-bordered unit-detail" style="width: 100%; margin-bottom:0;border: 0px;">
                                        <thead style="background : #F8F9FB">
                                          <tr style="border-bottom: 1px solid #dee2e6;">
                                            <td scope="col" style="width : 20%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">LP/SN</small>
                                            </td>
                                            <td scope="col" style="width : 25%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">Order Spec</small>
                                            </td>
                                            <td scope="col" style="width : 20%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">Original Product Code</small>
                                            </td>
                                            <td scope="col" style="width : 20%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">Status</small>
                                            </td>
                                            <td scope="col" style="width : 15%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">Action</small>
                                            </td>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <small style="font-size:0.75rem; font-weight: 600;">
                                                {{item.productCode ? item.productCode : "-"}} / {{item.serialNumber ? item.serialNumber : '-'}} 
                                              </small>
                                            </td>
                                            <td>
                                              <a
                                                v-if="item.bom.name"
                                                href="#"
                                                class="product-specs"
                                                style="color: #3099F8;font-size:0.75rem; font-weight: 500;"
                                                @click="openBomDetailModal(item.bom,idx)"
                                              >
                                                {{item.bom.name ? item.bom.name : "-"}}
                                              </a>
                                              <small
                                                  v-else
                                                  class="black-text"
                                                  style="
                                                    font-size: 0.75rem;
                                                    font-weight: 500;
                                                  "
                                                  >{{
                                                    item.bom.name
                                                      ? item.bom.name
                                                      : "-"
                                                  }}
                                              </small>
                                              <div class="mt-2">
                                                <div v-if="item.actualSpecification">
                                                  <small
                                                    class="black-text mb-2"
                                                    style="display: block;font-size:0.75rem; font-weight: 500;"
                                                    >Processor :
                                                    {{
                                                      item.actualSpecification
                                                        ? JSON.parse(
                                                            item.actualSpecification
                                                          ).processor
                                                        : "-"
                                                    }}
                                                  </small>
                                                  <small
                                                    class="black-text mb-2"
                                                    style="display: block;font-size:0.75rem; font-weight: 500;"
                                                    >RAM :
                                                    {{
                                                      item.actualSpecification
                                                        ? `${
                                                            JSON.parse(
                                                              item.actualSpecification
                                                            ).ram
                                                          } GB`
                                                        : "-"
                                                    }}
                                                  </small>
                                                  <small
                                                    class="black-text mb-2"
                                                    style="display: block;font-size:0.75rem; font-weight: 500;"
                                                    >Storage :
                                                    {{
                                                      item.actualSpecification
                                                        ? JSON.parse(
                                                            item.actualSpecification
                                                          ).storage
                                                        : "-"
                                                    }}
                                                  </small>
                                                  <small
                                                    class="black-text mb-2"
                                                    style="display: block;font-size:0.75rem; font-weight: 500;"
                                                    >VGA :
                                                    {{
                                                      item.actualSpecification
                                                        ? JSON.parse(
                                                            item.actualSpecification
                                                          ).vga
                                                        : "-"
                                                    }}
                                                  </small>
                                                </div>
                                                <div v-else-if="item.bom.itemBom && item.bom.itemBom.length > 0">
                                                  <div v-for="(itemBom, i) in item.bom.itemBom" :key="i" >
                                                    <small
                                                      class="black-text mb-2"
                                                      style="display: block;font-size:0.75rem; font-weight: 500;"
                                                      >
                                                      {{itemBom.itemQty}}
                                                      {{
                                                        itemBom.itemName
                                                          ? itemBom.itemName
                                                          : "-"
                                                      }}
                                                    </small>
                                                  </div>
                                                </div>
                                                <div v-else>
                                                  -
                                                </div> 
                                              </div>
                                            </td>
                                            <td>
                                              <small
                                                class="black-text"
                                                style="
                                                  display: block;
                                                  font-size:0.75rem; 
                                                  font-weight: 500;
                                                "
                                                >
                                                {{
                                                  item.originalProductCode
                                                    ? item.originalProductCode
                                                    : "-"
                                                }}
                                              </small>
                                            </td>
                                            <td>
                                              <div v-if="item.tag">
                                                <div
                                                  class="alignLeft total-data"
                                                  style="display: inline-block"
                                                  v-for="(tag, index) in item.tag"
                                                  :key="index"
                                                >
                                                  <span
                                                    class="item-badge ticket-badge"
                                                    v-if="tag.ticketId != 0"
                                                    :style="
                                                      'background-color:' +
                                                      tag.colorHex +
                                                      ';'
                                                    "
                                                    @click="
                                                      toTicketDetail(tag.ticketId)
                                                    "
                                                    >{{ tag.label }}
                                                    <i
                                                      class="fas fa-info-circle"
                                                      data-toggle="tooltip"
                                                      title="view ticket"
                                                    ></i
                                                  ></span>
                                                  <span
                                                    class="item-badge"
                                                    v-else
                                                    :style="
                                                      'background-color:' +
                                                      tag.colorHex +
                                                      ';'"
                                                    >{{ tag.label }}
                                                  </span>
                                                </div>
                                              </div>
                                              <div v-else> - </div>
                                            </td>
                                            <td>
                                              <button
                                                type="button"
                                                class="btn btn-outline-dark btn-sm"
                                                @click="
                                                  openHistoryModal(
                                                    item.orderDetailId,
                                                    idx, 
                                                    item
                                                  )
                                                "
                                              >
                                                <i
                                                  class="fas fa-history"
                                                  data-toggle="tooltip"
                                                  title="view history"
                                                ></i>
                                                History
                                              </button>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                      <!-- <div class="item-detail-container">
                                        <div
                                          class="detail-item"
                                          style="
                                            text-align: center;
                                            margin-top: 50%;
                                            margin-bottom: 50%;
                                          "
                                        >
                                          <div class="black-text">
                                            <span style="font-weight:bold; font-size:90%;">
                                              {{item.productCode ? item.productCode : "-"}}
                                            </span>
                                            <br>
                                            <small>{{item.serialNumber}}</small>
                                          </div>
                                        </div>
                                        <div class="detail-item">
                                          <div>
                                            <div style="display: block">
                                              <small
                                                class="black-text"
                                                style="
                                                  font-weight: bold;
                                                  font-style: italic;
                                                "
                                                >Order Spec -
                                              </small>
                                              <a
                                                v-if="item.bom.name"
                                                href="#"
                                                class="product-specs"
                                                style="
                                                  color: blue;
                                                  font-style: italic;
                                                  font-weight: bold;
                                                "
                                                @click="
                                                  openBomDetailModal(
                                                    item.bom,
                                                    idx
                                                  )
                                                "
                                                >"{{
                                                  item.bom.name
                                                    ? item.bom.name
                                                    : "-"
                                                }}"</a
                                              >
                                              <small
                                                v-else
                                                class="black-text"
                                                style="
                                                  font-style: italic;
                                                  font-weight: bold;
                                                "
                                                >"{{
                                                  item.bom.name
                                                    ? item.bom.name
                                                    : "-"
                                                }}"</small
                                              >
                                            </div>

                                            <small
                                              class="black-text"
                                              style="display: block"
                                              >Processor :
                                              {{
                                                JSON.parse(item.specification)
                                                  .processor
                                                  ? JSON.parse(item.specification)
                                                      .processor
                                                  : "-"
                                              }}</small
                                            >
                                            <small
                                              class="black-text"
                                              style="
                                                display: block;
                                                margin-top: -3px;
                                              "
                                              >RAM :
                                              {{
                                                JSON.parse(item.specification).ram
                                                  ? JSON.parse(item.specification)
                                                      .ram
                                                  : "-"
                                              }}
                                              GB</small
                                            >
                                            <small
                                              class="black-text"
                                              style="
                                                display: block;
                                                margin-top: -3px;
                                              "
                                              >Storage :
                                              {{
                                                JSON.parse(item.specification)
                                                  .storage
                                                  ? JSON.parse(item.specification)
                                                      .storage
                                                  : "-"
                                              }}</small
                                            >
                                            <small
                                              class="black-text"
                                              style="
                                                display: block;
                                                margin-top: -3px;
                                              "
                                              >VGA :
                                              {{
                                                JSON.parse(item.specification).vga
                                                  ? JSON.parse(item.specification)
                                                      .vga
                                                  : "-"
                                              }}</small
                                            >
                                            <small
                                              class="black-text"
                                              style="
                                                font-weight: bold;
                                                display: block;
                                                font-style: italic;
                                                margin-top: -3px;
                                              "
                                              >Original Product Code :
                                              {{
                                                item.originalProductCode
                                                  ? item.originalProductCode
                                                  : "-"
                                              }}</small
                                            >
                                          </div>
                                        </div>

                                        <div
                                          class="detail-item"
                                          v-if="
                                            item.bom.itemBom &&
                                            item.bom.itemBom.length > 0
                                          "
                                        >
                                          <div style="display: block">
                                            <small
                                              style="
                                                font-weight: bold;
                                                color: black;
                                              "
                                              >Current Spec</small
                                            >
                                          </div>
                                          <div
                                            v-for="(itemBom, index) in item.bom.itemBom"
                                            :key="index"
                                            >
                                            <small
                                              class="black-text"
                                              style="display: block"
                                              >{{ itemBom.itemGroup }} :
                                              {{itemBom.itemQty}}
                                              {{
                                                itemBom.itemName
                                                  ? itemBom.itemName
                                                  : "-"
                                              }}
                                            </small>
                                          </div>
                                        </div>

                                        <div
                                          class="detail-item"
                                          v-else-if="item.actualSpecification"
                                        >
                                          <div style="display: block">
                                            <small
                                              style="
                                                font-weight: bold;
                                                color: black;
                                              "
                                              >Current Spec</small
                                            >
                                          </div>
                                          <small
                                            class="black-text"
                                            style="display: block"
                                            >Processor :
                                            {{
                                              item.actualSpecification
                                                ? JSON.parse(
                                                    item.actualSpecification
                                                  ).processor
                                                : "-"
                                            }}</small
                                          >
                                          <small
                                            class="black-text"
                                            style="
                                              display: block;
                                              margin-top: -3px;
                                            "
                                            >RAM :
                                            {{
                                              item.actualSpecification
                                                ? `${
                                                    JSON.parse(
                                                      item.actualSpecification
                                                    ).ram
                                                  } GB`
                                                : "-"
                                            }}</small
                                          >
                                          <small
                                            class="black-text"
                                            style="
                                              display: block;
                                              margin-top: -3px;
                                            "
                                            >Storage :
                                            {{
                                              item.actualSpecification
                                                ? JSON.parse(
                                                    item.actualSpecification
                                                  ).storage
                                                : "-"
                                            }}</small
                                          >
                                          <small
                                            class="black-text"
                                            style="
                                              display: block;
                                              margin-top: -3px;
                                            "
                                            >VGA :
                                            {{
                                              item.actualSpecification
                                                ? JSON.parse(
                                                    item.actualSpecification
                                                  ).vga
                                                : "-"
                                            }}</small
                                          >
                                        </div>

                                      
                                      </div> -->

                                      <!-- <div class="wrapperr">
                                        <div id="c1">
                                          <div
                                            class="alignLeft total-data"
                                            style="display: inline-block"
                                            v-for="(tag, index) in item.tag"
                                            :key="index"
                                          >
                                            <span
                                              class="item-badge ticket-badge"
                                              v-if="tag.ticketId != 0"
                                              :style="
                                                'background-color:' +
                                                tag.colorHex +
                                                ';'
                                              "
                                              @click="
                                                toTicketDetail(tag.ticketId)
                                              "
                                              >{{ tag.label }}
                                              <i
                                                class="fas fa-info-circle"
                                                data-toggle="tooltip"
                                                title="view ticket"
                                              ></i
                                            ></span>
                                            <span
                                              class="item-badge"
                                              v-else
                                              :style="
                                                'background-color:' +
                                                tag.colorHex +
                                                ';'
                                              "
                                              >{{ tag.label }}</span
                                            >
                                          </div>
                                        </div>
                                        <div id="c2">
                                          <div class="alignRight">
                                            <button
                                              type="button"
                                              class="btn btn-primary btn-sm"
                                              @click="
                                                openHistoryModal(
                                                  item.orderDetailId,
                                                  idx, 
                                                  item
                                                )
                                              "
                                            >
                                              <i
                                                class="fas fa-history"
                                                data-toggle="tooltip"
                                                title="view history"
                                              ></i>
                                              History
                                            </button>
                                          </div>
                                        </div>
                                      </div> -->
                                      <!--  -->
                                    </div>
                                  </div>
                                </div>

                                <!--  -->
                              </div>

                              <a
                                class="black-text"
                                v-if="!orderItem.isInfoOpened"
                                data-toggle="collapse"
                                :href="'#collapseInfo' + idx"
                                role="button"
                                aria-expanded="false"
                                :aria-controls="'collapseInfo' + idx"
                                style="
                                  text-align: center;
                                  margin-bottom: 5px;
                                  font-size: 80%;
                                "
                                @click="changeInfoOpenedStatus(idx)"
                              >
                                Info Selengkapnya
                                <img
                                  src="~@/assets/icon/arrow-down.png"
                                  style="width: 10px"
                                />
                              </a>

                              <a
                                class="black-text"
                                v-if="orderItem.isInfoOpened"
                                data-toggle="collapse"
                                :href="'#collapseInfo' + idx"
                                role="button"
                                aria-expanded="true"
                                :aria-controls="'collapseInfo' + idx"
                                style="
                                  text-align: center;
                                  margin-bottom: 5px;
                                  font-size: 80%;
                                "
                                @click="changeInfoOpenedStatus(idx)"
                              >
                                Tutup
                                <img
                                  src="~@/assets/icon/arrow-up.png"
                                  style="width: 10px"
                                />
                              </a>
                            </div>
                          </div>
                        </div>

                        <div v-for="(data, index) in detailOrderReplace" :key="index">
                          <span> Delivery Schedule : {{ data }} </span>

                          <div v-if="loadingTable == true">
                            <img src="~@/assets/images/load-button.gif" />
                          </div>

                          <div
                            v-else-if="loadingTable == false && detailOrder != ''"
                            v-for="(orderItem, idx) in detailOrder" :key="idx"
                          >
                            <div
                              class="card order-item-detail"
                              style="overflow: auto"
                            >
                              <div
                                class="card-title"
                                style="margin-right: 1.3rem; margin-bottom:0rem"
                              >
                                <div style="text-align: right">
                                  <div class="black-text" style ="font-size: 80%;">
                                    Start Rent : {{ orderItem.startRent ? orderItem.startRent:'-'}}<br>
                                    End Rent : {{ orderItem.endRent ? orderItem.endRent:'-' }}
                                  </div>
                                </div>
                              </div>
                              <div class="card-body new-detail">
                                <div class="grid-container">
                                  <div
                                    class="grid-item"
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    <span
                                      class="black-text"
                                      style="
                                        font-weight: bold;
                                        display: block;
                                        font-size: 2rem;
                                      "
                                      >{{ orderItem.qty }}</span
                                    >
                                    <small
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Rp
                                      {{ formatPrice(orderItem.orderItemPrice) }}
                                      /month</small
                                    >
                                  </div>
                                  <div class="grid-item">
                                    <div>
                                      <small
                                        class="black-text"
                                        style="font-weight: bold; display: block"
                                        >{{ orderItem.productTypeName }}</small
                                      >
                                      <small
                                        class="black-text"
                                        style="font-weight: bold; display: block"
                                        >{{ orderItem.productTitle }} ({{
                                          orderItem.catalogProductTypeName
                                        }})</small
                                      >
                                    </div>

                                    <small
                                      class="black-text"
                                      style="display: block; margin-top: 10px"
                                      >Special Request :
                                      {{
                                        orderItem.orderItemNote
                                          ? orderItem.orderItemNote
                                          : "-"
                                      }}</small
                                    >
                                  </div>
                                  <div class="grid-item">
                                    <small
                                      style="
                                        font-weight: bold;
                                        display: block;
                                        color: black;
                                      "
                                      >{{ orderItem.condition }}</small
                                    >
                                    <a
                                      href="#"
                                      class="form-text product-specs"
                                      style="
                                        font-weight: bold;
                                        font-style: italic;
                                        color: #3099F8;
                                        margin-top: -2px;
                                        font-size: 80%;
                                      "
                                      @click="
                                        openModal(
                                          'Detail',
                                          orderItem.productTypeId,
                                          idx
                                        )
                                      "
                                      >{{ orderItem.specificationsView }}</a
                                    >
                                  </div>
                                  <div class="grid-item">
                                    <!-- status -->
                                    <small
                                      v-if="orderItem.orderItemStatus == 0"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Pending -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 7"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Ready to Pickup -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 8"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Picking Up -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 9 && orderItem.finalPrepared"
                                      class="black-text"
                                      style="font-weight: bold; display: block; font-size: 0.688rem;"
                                      >Ready to Prepare (Final QC) -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 9 && !orderItem.finalPrepared"
                                      class="black-text"
                                      style="font-weight: bold; display: block;"
                                      >Ready to Prepare -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 10"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Prepared -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 11"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Ready to Deliver -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 12"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Shipping -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 13"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Renting -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 14"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Finished -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 15"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Return Schedule -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 16"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Return Assign -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 17"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Return Match -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 18"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Return Unmatch -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 19"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Completed -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 98"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Replaced -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <small
                                      v-if="orderItem.orderItemStatus == 99"
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >Canceled -
                                      {{ orderItem.durationValue }} bulan</small
                                    >
                                    <!-- End Of status -->
                                    <small
                                      class="black-text"
                                      style="display: block; margin-top: -3px"
                                      >Catalog : Rp
                                      {{
                                        formatPrice(orderItem.itemPrice)
                                      }}/unit/month</small
                                    >
                                    <small
                                      class="black-text"
                                      style="display: block; margin-top: -3px"
                                      >Discount :
                                      {{
                                        orderItem.discountPrice
                                          ? `Rp ${formatPrice(
                                              orderItem.discountPrice
                                            )}/unit/month `
                                          : "-"
                                      }}</small
                                    >
                                    <small
                                      class="black-text"
                                      style="
                                        font-weight: bold;
                                        display: block;
                                        margin-top: -3px;
                                      "
                                      >Final : Rp
                                      {{
                                        formatPrice(orderItem.finalPrice)
                                      }}/unit/month</small
                                    >
                                  </div>
                                  <!-- Action Button -->
                                  <div v-if="orderItem.deliverSchedule == data">
                                    <div
                                      class="grid-item"
                                      v-if="typeCatalog == ''"
                                    >
                                      <img
                                        src="~@/assets/images/load-button.gif"
                                      />
                                    </div>

                                    <div
                                      class="grid-item"
                                      v-else-if="
                                        typeCatalog != '' &&
                                        orderStatus <= 6 &&
                                        orderItem.orderItemStatus == 0
                                      "
                                    >
                                      <button
                                        class="btn btn-primary btn-small"
                                        @click="
                                          openmodalEditProduct(
                                            orderItem.productTitle,
                                            orderItem.catalogId,
                                            idx,
                                            orderItem.orderItemNote,
                                            orderItem.durationValue,
                                            orderItem.orderItemStatus,
                                            orderItem.isReserved,
                                          )
                                        "
                                      >
                                        <i class="fas fa-edit"></i>
                                      </button>

                                      <button
                                        class="btn btn-primary btn-small"
                                        @click="
                                          openModal(
                                            'Delete',
                                            orderItem.productTitle,
                                            orderItem.productId,
                                            orderItem.qty,
                                            orderItem.durationValue
                                          )
                                        "
                                      >
                                        <i class="fas fa-trash"></i>
                                      </button>
                                    </div>
                                    <div
                                      class="grid-item"
                                      v-if="
                                        orderStatus > 5 &&
                                        orderItem.orderItemStatus > 0 &&
                                        typeCatalog != ''
                                      "
                                    >
                                      <button
                                        class="btn btn-primary btn-small"
                                        @click="
                                          openmodalEditProduct(
                                            orderItem.productTitle,
                                            orderItem.catalogId,
                                            idx,
                                            orderItem.orderItemNote,
                                            orderItem.durationValue,
                                            orderItem.orderItemStatus,
                                            orderItem.isReserved,
                                          )
                                        "
                                        v-if="orderItem.orderItemStatus <= 9"
                                      >
                                        <i class="fas fa-edit"></i>
                                      </button>
                                      <!-- <button
                                                                                  class="btn btn-primary btn-sm"
                                                                                  @click="assignDetail(orderItem.productId,orderItem.productType,index,orderItem.deliverSchedule,orderItem.maxSchedule,orderItem.orderItemStatus,orderItem.id,orderItem.startRent,orderItem.orderItemDuration)"
                                                                              >
                                                                                  Info
                                                                              </button> -->
                                      <br />
                                      <!-- <button
                                        class="btn btn-primary btn-sm mt-1"
                                        @click="
                                          toPageEditLessor(
                                            orderId,
                                            orderCode,
                                            companyId,
                                            orderItem.productId,
                                            orderItem.condition,
                                            'edit',
                                            orderItem.orderItemStatus,
                                            orderItem.maxSchedule,
                                            orderItem.orderItemDuration,
                                            orderItem.qty,
                                            orderItem.orderItemNote,
                                            orderItem.finalPrice
                                          )
                                        "
                                        v-if="
                                          orderItem.orderItemStatus >= 7 &&
                                          orderItem.orderItemStatus <= 9 &&
                                          !orderItem.isReserved
                                        "
                                      >
                                        Edit Assigned
                                      </button> -->
                                    </div>
                                    <div
                                      class="grid-item"
                                      v-if="
                                        orderStatus > 5 &&
                                        orderItem.orderItemStatus == 0 &&
                                        orderExtendFrom.orderId != ''
                                      "
                                    >
                                      <!-- <button
                                                                                  class="btn btn-primary btn-sm"
                                                                                  @click="assignDetail(orderItem.productId,orderItem.productType,idx,orderItem.startRent,null,orderItem.orderItemStatus,null,orderItem.startRent,orderItem.orderItemDuration)"
                                                                                  v-if="data.startRent != null"
                                                                              >
                                                                                  Info
                                                                              </button> -->
                                    </div>
                                  </div>
                                  <!-- End Of Action Button -->
                                </div>

                                <!-- Endpoint Security -->
                                <!-- <div class="grid-container" style="grid-template-columns : 10% auto">
                                  <div class="grid-item"></div>
                                  <div class="grid-item">
                                    <div class="mt-3 mb-1" style="color:#2E3646; font-weight : 700; font-size : 1rem; line-height : 1.25rem;">
                                      Add-Ons : 
                                    </div>
                                    <div
                                      class="alignLeft total-data mb-2"
                                      style="display: inline-block"
                                    >
                                      <span
                                        class="item-badge-addons"
                                      >
                                        Webroot Endpoint Security Basic
                                      </span>
                                      <span
                                        class="item-badge-addons"
                                      >
                                        Webroot Advanced Threat Security
                                      </span>
                                      
                                    </div>
                                  </div>
                                </div> -->
                                <!-- End OF Endpoint Security -->

                              </div>
                              <hr
                                style="
                                  height: 1.5px;
                                  border-width: 0;
                                  color: black;
                                  background-color: black;
                                  margin-right: 1.25rem;
                                  margin-left: 1.25rem;
                                  margin-bottom: 5px;
                                  margin-top: 5px;
                                "
                              />

                              <div
                                class="collapse"
                                :id="'collapseInfo' + idx"
                                style="
                                  margin-right: 1.25rem;
                                  margin-left: 1.25rem;
                                  margin-top: 10px;
                                  padding-bottom: 1.25rem;
                                "
                              >
                                <div class="card">
                                  <div
                                    class="card-body"
                                    style="
                                      padding-top: 0.5rem;
                                      padding-bottom: 0.5rem;
                                    "
                                  >
                                    <div class='card'>
                                      <table class="table table-bordered unit-detail" style="width: 100%; margin-bottom:0;border: 0px;">
                                        <thead style="background : #F8F9FB">
                                          <tr style="border-bottom: 1px solid #dee2e6;">
                                            <td scope="col" style="width : 20%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">LP/SN</small>
                                            </td>
                                            <td scope="col" style="width : 25%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">Order Spec</small>
                                            </td>
                                            <td scope="col" style="width : 20%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">Original Product Code</small>
                                            </td>
                                            <td scope="col" style="width : 20%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">Status</small>
                                            </td>
                                            <td scope="col" style="width : 15%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">Action</small>
                                            </td>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <small style="font-size:0.75rem; font-weight: 600;">
                                                {{item.productCode ? item.productCode : "-"}} / {{item.serialNumber ? item.serialNumber : '-'}} 
                                              </small>
                                            </td>
                                            <td>
                                              <a
                                                v-if="item.bom.name"
                                                href="#"
                                                class="product-specs"
                                                style="color: #3099F8;font-size:0.75rem; font-weight: 500;"
                                                @click="openBomDetailModal(item.bom,idx)"
                                              >
                                                {{item.bom.name ? item.bom.name : "-"}}
                                              </a>
                                              <small
                                                  v-else
                                                  class="black-text"
                                                  style="
                                                    font-size: 0.75rem;
                                                    font-weight: 500;
                                                  "
                                                  >{{
                                                    item.bom.name
                                                      ? item.bom.name
                                                      : "-"
                                                  }}
                                              </small>
                                              <div class="mt-2">
                                                <div v-if="item.actualSpecification">
                                                  <small
                                                    class="black-text mb-2"
                                                    style="display: block;font-size: 0.75rem;font-weight: 500;"
                                                    >Processor :
                                                    {{
                                                      item.actualSpecification
                                                        ? JSON.parse(
                                                            item.actualSpecification
                                                          ).processor
                                                        : "-"
                                                    }}
                                                  </small>
                                                  <small
                                                    class="black-text mb-2"
                                                    style="display: block;font-size: 0.75rem;font-weight: 500;"
                                                    >RAM :
                                                    {{
                                                      item.actualSpecification
                                                        ? `${
                                                            JSON.parse(
                                                              item.actualSpecification
                                                            ).ram
                                                          } GB`
                                                        : "-"
                                                    }}
                                                  </small>
                                                  <small
                                                    class="black-text mb-2"
                                                    style="display: block;font-size: 0.75rem;font-weight: 500;"
                                                    >Storage :
                                                    {{
                                                      item.actualSpecification
                                                        ? JSON.parse(
                                                            item.actualSpecification
                                                          ).storage
                                                        : "-"
                                                    }}
                                                  </small>
                                                  <small
                                                    class="black-text mb-2"
                                                    style="display: block;font-size: 0.75rem;font-weight: 500;"
                                                    >VGA :
                                                    {{
                                                      item.actualSpecification
                                                        ? JSON.parse(
                                                            item.actualSpecification
                                                          ).vga
                                                        : "-"
                                                    }}
                                                  </small>
                                                </div>
                                                <div v-else-if="item.bom.itemBom && item.bom.itemBom.length > 0">
                                                  <div v-for="(itemBom, i) in item.bom.itemBom" :key="i" >
                                                    <small
                                                      class="black-text mb-2"
                                                      style="display: block;font-size:0.75rem; font-weight: 500;"
                                                      >
                                                      {{itemBom.itemQty}}
                                                      {{
                                                        itemBom.itemName
                                                          ? itemBom.itemName
                                                          : "-"
                                                      }}
                                                    </small>
                                                  </div>
                                                </div>
                                                <!-- <div v-else>
                                                  -
                                                </div>  -->
                                              </div>
                                            </td>
                                            <td>
                                              <small
                                                class="black-text"
                                                style="
                                                  display: block;
                                                  font-size:0.75rem; 
                                                  font-weight: 500;
                                                "
                                                >
                                                {{
                                                  item.originalProductCode
                                                    ? item.originalProductCode
                                                    : "-"
                                                }}
                                              </small>
                                            </td>
                                            <td>
                                              <div v-if="item.tag">
                                                <div
                                                  class="alignLeft total-data"
                                                  style="display: inline-block"
                                                  v-for="(tag, index) in item.tag"
                                                  :key="index"
                                                >
                                                  <span
                                                    class="item-badge ticket-badge"
                                                    v-if="tag.ticketId != 0"
                                                    :style="
                                                      'background-color:' +
                                                      tag.colorHex +
                                                      ';'
                                                    "
                                                    @click="
                                                      toTicketDetail(tag.ticketId)
                                                    "
                                                    >{{ tag.label }}
                                                    <i
                                                      class="fas fa-info-circle"
                                                      data-toggle="tooltip"
                                                      title="view ticket"
                                                    ></i
                                                  ></span>
                                                  <span
                                                    class="item-badge"
                                                    v-else
                                                    :style="
                                                      'background-color:' +
                                                      tag.colorHex +
                                                      ';'"
                                                    >{{ tag.label }}
                                                  </span>
                                                </div>
                                              </div>
                                              <div v-else> - </div>
                                            </td>
                                            <td>
                                              <button
                                                type="button"
                                                class="btn btn-outline-dark btn-sm"
                                                @click="
                                                  openHistoryModal(
                                                    item.orderDetailId,
                                                    idx, 
                                                    item
                                                  )
                                                "
                                              >
                                                <i
                                                  class="fas fa-history"
                                                  data-toggle="tooltip"
                                                  title="view history"
                                                ></i>
                                                History
                                              </button>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                    <!-- <div class="item-detail-container">
                                      <div
                                        class="detail-item"
                                        style="
                                          text-align: center;
                                          margin-top: 50%;
                                          margin-bottom: 50%;
                                        "
                                      >
                                        <div class="black-text">
                                          <span style="font-weight:bold; font-size:90%;">
                                            {{item.productCode ? item.productCode : "-"}}
                                          </span>
                                          <br>
                                          <small>{{item.serialNumber}}</small>
                                        </div>
                                      </div>
                                      <div class="detail-item">
                                        <div>
                                          <div style="display: block">
                                            <small
                                              class="black-text"
                                              style="
                                                font-weight: bold;
                                                font-style: italic;
                                              "
                                              >Order Spec -
                                            </small>
                                            <a
                                              v-if="item.bom.name"
                                              href="#"
                                              class="product-specs"
                                              style="
                                                color: blue;
                                                font-style: italic;
                                                font-weight: bold;
                                              "
                                              @click="
                                                openBomDetailModal(
                                                  item.bom,
                                                  idx
                                                )
                                              "
                                              >"{{
                                                item.bom.name
                                                  ? item.bom.name
                                                  : "-"
                                              }}"</a
                                            >
                                            <small
                                              v-else
                                              class="black-text"
                                              style="
                                                font-style: italic;
                                                font-weight: bold;
                                              "
                                              >"{{
                                                item.bom.name
                                                  ? item.bom.name
                                                  : "-"
                                              }}"</small
                                            >
                                          </div>
                                          <small
                                            class="black-text"
                                            style="display: block"
                                            >Processor :
                                            {{
                                              JSON.parse(item.specification)
                                                .processor
                                                ? JSON.parse(item.specification)
                                                    .processor
                                                : "-"
                                            }}</small
                                          >
                                          <small
                                            class="black-text"
                                            style="
                                              display: block;
                                              margin-top: -3px;
                                            "
                                            >RAM :
                                            {{
                                              JSON.parse(item.specification).ram
                                                ? `${
                                                    JSON.parse(item.specification)
                                                      .ram
                                                  } GB`
                                                : "-"
                                            }}
                                          </small>
                                          <small
                                            class="black-text"
                                            style="
                                              display: block;
                                              margin-top: -3px;
                                            "
                                            >Storage :
                                            {{
                                              JSON.parse(item.specification)
                                                .storage
                                                ? JSON.parse(item.specification)
                                                    .storage
                                                : "-"
                                            }}</small
                                          >
                                          <small
                                            class="black-text"
                                            style="
                                              display: block;
                                              margin-top: -3px;
                                            "
                                            >VGA :
                                            {{
                                              JSON.parse(item.specification).vga
                                            }}</small
                                          >
                                          <small
                                            class="black-text"
                                            style="font-weight: bold; display:block; font-style:italic; margin-top:-3px;"
                                            >Original Product Code :
                                            {{
                                              item.originalProductCode
                                                ? item.originalProductCode
                                                : "-"
                                            }}</small
                                          >
                                        </div>
                                      </div>
                                      <div
                                        class="detail-item"
                                        v-if="item.actualSpecification"
                                      >
                                        <div style="display: block">
                                          <small
                                            style="
                                              font-weight: bold;
                                              color: black;
                                            "
                                            >Current Spec</small
                                          >
                                        </div>
                                        <small
                                          class="black-text"
                                          style="display: block"
                                          >Processor :
                                          {{
                                            item.actualSpecification
                                              ? JSON.parse(
                                                  item.actualSpecification
                                                ).processor
                                              : "-"
                                          }}</small
                                        >
                                        <small
                                          class="black-text"
                                          style="display: block; margin-top: -3px"
                                          >RAM :
                                          {{
                                            item.actualSpecification
                                              ? `${
                                                  JSON.parse(
                                                    item.actualSpecification
                                                  ).ram
                                                } GB`
                                              : "-"
                                          }}</small
                                        >
                                        <small
                                          class="black-text"
                                          style="display: block; margin-top: -3px"
                                          >Storage :
                                          {{
                                            item.actualSpecification
                                              ? JSON.parse(
                                                  item.actualSpecification
                                                ).storage
                                              : "-"
                                          }}</small
                                        >
                                        <small
                                          class="black-text"
                                          style="display: block; margin-top: -3px"
                                          >VGA :
                                          {{
                                            item.actualSpecification
                                              ? JSON.parse(
                                                  item.actualSpecification
                                                ).vga
                                              : "-"
                                          }}</small
                                        >
                                      </div>

                                      <div
                                        class="detail-item"
                                        v-if="
                                          item.bom.itemBom &&
                                          item.bom.itemBom.length > 0
                                        "
                                      >
                                        <div style="display: block">
                                          <small
                                            style="
                                              font-weight: bold;
                                              color: black;
                                            "
                                            >Current Spec</small
                                          >
                                        </div>
                                        <div v-for="(itemBom, i) in item.bom.itemBom" :key="i">
                                          <small
                                            class="black-text"
                                            style="display: block"
                                            >{{ itemBom.itemGroup }} :
                                            {{itemBom.itemQty}}
                                            {{
                                              itemBom.itemName
                                                ? itemBom.itemName
                                                : "-"
                                            }}</small
                                          >
                                        </div>
                                      </div>
                                    </div> -->

                                    <!-- <div class="wrapperr">
                                      <div id="c1">
                                        <div
                                          class="alignLeft total-data"
                                          style="display: inline-block"
                                          v-for="(tag, i) in item.tag"
                                          :key="i"
                                        >
                                          <span
                                            class="item-badge ticket-badge"
                                            v-if="tag.ticketId != 0"
                                            :style="
                                              'background-color:' +
                                              tag.colorHex +
                                              ';'
                                            "
                                            @click="toTicketDetail(tag.ticketId)"
                                            >{{ tag.label }}
                                            <i
                                              class="fas fa-info-circle"
                                              data-toggle="tooltip"
                                              title="view ticket"
                                            ></i
                                          ></span>
                                          <span
                                            class="item-badge"
                                            v-else
                                            :style="
                                              'background-color:' +
                                              tag.colorHex +
                                              ';'
                                            "
                                            >{{ tag.label }}</span
                                          >
                                        </div>
                                      </div>
                                      <div id="c2">
                                        <div class="alignRight">
                                          <button
                                            type="button"
                                            class="btn btn-primary btn-sm"
                                            @click="
                                              openHistoryModal(
                                                item.orderDetailId,
                                                idx,
                                                item
                                              )
                                            "
                                          >
                                            <i
                                              class="fas fa-history"
                                              data-toggle="tooltip"
                                              title="view history"
                                            ></i>
                                            History
                                          </button>
                                        </div>
                                      </div>
                                    </div> -->
                                    <!--  -->
                                  </div>
                                </div>

                                <!--  -->
                              </div>

                              <a
                                class="black-text"
                                v-if="!orderItem.isInfoOpened"
                                data-toggle="collapse"
                                :href="'#collapseInfo' + idx"
                                role="button"
                                aria-expanded="false"
                                :aria-controls="'collapseInfo' + idx"
                                style="
                                  text-align: center;
                                  margin-bottom: 5px;
                                  font-size: 80%;
                                "
                                @click="changeInfoOpenedStatus(idx)"
                              >
                                Info Selengkapnya
                                <img
                                  src="~@/assets/icon/arrow-down.png"
                                  style="width: 10px"
                                />
                              </a>

                              <a
                                class="black-text"
                                v-if="orderItem.isInfoOpened"
                                data-toggle="collapse"
                                :href="'#collapseInfo' + idx"
                                role="button"
                                aria-expanded="true"
                                :aria-controls="'collapseInfo' + idx"
                                style="
                                  text-align: center;
                                  margin-bottom: 5px;
                                  font-size: 80%;
                                "
                                @click="changeInfoOpenedStatus(idx)"
                              >
                                Tutup
                                <img
                                  src="~@/assets/icon/arrow-up.png"
                                  style="width: 10px"
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                        <!-- ACTION BUTTON -->
                        <div id="wrapperr mt-2" style="margin-top: 20px">
                          <div id="c1">
                            <div class="alignRight total-data">
                              <h5 style="font-weight: bold">
                                Total Price/month : Rp
                                {{ formatPrice(totalPrice) }}
                              </h5>
                              <br
                                v-if="
                                  rejectReasonOrder == '' &&
                                  rejectReasonOrder == null
                                "
                              />
                              <h5
                                class="font-red"
                                style="margin-top: 0px"
                                v-if="
                                  rejectReasonOrder != '' &&
                                  rejectReasonOrder != null
                                "
                              >
                                Reason : {{ rejectReasonOrder }}
                              </h5>
                            </div>
                          </div>
                          <div id="c2">
                            <div class="pagination p8 alignRight">
                              <ul v-if="detailOrder != '' && !loadingTable">
                                <button
                                  class="btn btn-danger btn-sm"
                                  @click="isNotReserved ? openModalOne('Reject') : openCannotModifyModal('pembatalan')"
                                  v-if="
                                    orderStatus == 0 ||
                                    orderStatus == 1 ||
                                    orderStatus == 2 ||
                                    orderStatus == 3 ||
                                    orderStatus == 4 ||
                                    orderStatus == 5
                                  "
                                >
                                  Reject Order
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="openModalOne('Process')"
                                  v-if="orderStatus == 0 && !newUser"
                                >
                                  Process Order
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="openModalOne('Match')"
                                  v-if="orderStatus == 0 && newUser"
                                >
                                  Process Order
                                </button>
                                <div
                                  class="dropdown"
                                  style="display: contents"
                                  v-if="(orderStatus >= 1) && (orderStatus <= 7)"
                                >
                                  <button
                                    class="btn btn-primary btn-sm dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    :class="{
                                      'btn-success': quotationStatus == '1',
                                    }"
                                  >
                                    Quotation
                                  </button>
                                  <div
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    <span
                                      class="dropdown-item link"
                                      @click="openGenerateQuotation"
                                      >Generate Quotation</span
                                    >
                                    <span
                                      class="dropdown-item link"
                                      @click="openModalOne('Quotation')"
                                      v-if="quotationCount == 0"
                                      >Send Quotation</span
                                    >
                                    <span
                                      class="dropdown-item link"
                                      @click="openModalOne('RenewQuotation')"
                                      v-if="
                                        quotationCount > 0 && orderStatus <= 3
                                      "
                                      >Renew Quotation (
                                      {{ quotationCount }} )</span
                                    >
                                  </div>
                                </div>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="openModalOne('UploadPurchase')"
                                  v-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    !purchaseUrl
                                  "
                                >
                                  Upload Purchase Order
                                </button>
                                <button
                                  class="btn btn-success btn-sm"
                                  @click="openModalOne('UploadPurchase')"
                                  v-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    purchaseUrl
                                  "
                                >
                                  Upload Purchase Order
                                </button>
                                <div
                                  class="dropdown"
                                  style="display: contents"
                                  v-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    (invoiceTime == null ||
                                      invoiceTime < quotationTime) &&
                                    orderExtendFrom.orderId != '' &&
                                    invoiceStatus != 1
                                  "
                                >
                                  <button
                                    class="btn btn-primary btn-sm dropdown-toggle"
                                    type="button"
                                    id="dropdownInvoice"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                  >
                                    Invoice
                                  </button>
                                  <div
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownInvoice"
                                  >
                                    <span
                                      class="dropdown-item link"
                                      @click="openModalOne('KeepCurrentInvoice')"
                                      >Keep using curent invoice</span
                                    >
                                    <span
                                      class="dropdown-item link"
                                      @click="handleClickSendInvoice('renewInvoiceExtend')"
                                      >Renew Invoice</span
                                    >
                                  </div>
                                </div>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="handleClickSendInvoice('sendInvoice')"
                                  v-else-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    (invoiceTime == null ||
                                      invoiceTime < quotationTime) &&
                                    orderExtendFrom.orderId == ''
                                  "
                                >
                                  Send Invoice
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="openModalOne('ProcessInvoice')"
                                  v-else-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    invoiceTime != null &&
                                    invoiceStatus != 1
                                  "
                                >
                                  Process Invoice ({{ invoiceCount }})
                                </button>
                                <button
                                  class="btn btn-success btn-sm"
                                  v-else-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    invoiceTime != null &&
                                    invoiceStatus == 1
                                  "
                                >
                                  Process Invoice ({{ invoiceCount }})
                                </button>
                                <button
                                  
                                  class="btn btn-primary btn-sm"
                                  @click="cekDoc"
                                  v-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    !loadingNextStep
                                  "
                                >
                                  Next Step > 
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  disabled=""
                                  v-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    loadingNextStep
                                  "
                                >
                                  <img
                                    src="~@/assets/images/2.gif"
                                    style="height: 18px"
                                  />
                                  Next Step >
                                </button>
                                <!-- <button class="btn btn-primary btn-sm" @click="openModal('FillMandatory')" v-if="orderStatus >= 3 && orderStatus <= 4 && nextStepFill"> Next Step > </button> -->
                                <!-- Extend -->
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="isNotReserved ? openModalOne('UpdateProduct') : openCannotModifyModal('pembaruan')"
                                  v-if="
                                    orderStatus > 3 &&
                                    orderStatus <= 11 &&
                                    orderExtendFrom.orderId != ''
                                  "
                                >
                                  Update Products
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="isNotReserved ? openModalOne('UpdateProduct') : openCannotModifyModal('pembaruan')"
                                  v-if="
                                    orderStatus > 3 &&
                                    orderStatus <= 6 &&
                                    orderExtendFrom.orderId == ''
                                  "
                                >
                                  Update Products
                                </button>
                                <div class="d-inline">
                                  <!-- <button
                                    class="btn btn-primary btn-sm"
                                    @click="handleClickInvoicePaid()"
                                    v-if="
                                      orderStatus == 5 &&
                                      invoiceCode(dataPayment[0].invoiceNumber) ==
                                        'DEP'
                                    "
                                  >
                                    Invoice Paid
                                  </button> -->
                                  <button
                                    class="btn btn-primary btn-sm"
                                    @click="handleClickInvoicePaid()"
                                    v-if="
                                      orderStatus == 5 
                                    "
                                  >
                                    Invoice Paid
                                  </button>
                                </div>
                                <!-- <button class="btn btn-primary btn-sm" @click="openModalOne('Deliver')" v-if="orderStatus > 6 && orderStatus < 12 && orderExtendFrom.orderId == ''">Deliver Order</button> -->
                                <!-- <button class="btn btn-primary btn-sm" @click="openModalOne('DeliverItem')" v-if="itemDeliverReplace > 0">Deliver Item Replace</button>
                                                                  <button class="btn btn-primary btn-sm" @click="openModalOne('StartRent')" v-if="orderStatus == 12">Start a Rent</button>
                                                                  <button class="btn btn-primary btn-sm" @click="openModalOne('StartRentItem')" v-if="itemDeliverReplace == 0 && itemStartReplace > 0">Start a Rent Item Replace</button> -->
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="toExtendPage"
                                  v-if="statusRenting"
                                >
                                  Extend Order
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  disabled=""
                                  v-if="loadingBtnReturn"
                                >
                                  <img
                                    src="~@/assets/images/2.gif"
                                    style="height: 18px"
                                  />
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="openModalSetReturn"
                                  v-if="valBtnSetReturn()"
                                >
                                  Set Return
                                </button>
                                
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="openModalSetReturn"
                                  v-if="valBtnRescheduleReturn()"
                                >
                                  Reschedule Return
                                </button>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <!-- END OF ACTION BUTTON -->
                      </div>
                    </div>
                    <!-- ENF OF outer card -->
                  </div>
                  <!-- ENF OF if orderStatus>6 && orderStatus < 99 -->
                  <div v-else>
                    <div class="card">
                      <div
                        class="card-body"
                        style="
                          padding-top: 0.5rem;
                          padding-bottom: 0.5rem;
                          padding-left: 0.8rem;
                          padding-right: 0.8rem;
                        "
                      >
                        <div v-for="(orderItem, idx) in detailOrder" :key="idx" >
                          <div
                            class="card order-item-detail"
                            style="overflow: auto"
                          >
                            <div class="card-title" style="margin-right: 1.3rem">
                              <div style="text-align: right">
                                <div class="black-text" style ="font-size: 80%;">
                                  Start Rent : {{ orderItem.startRent ? orderItem.startRent:'-'}}<br>
                                  End Rent : {{ orderItem.endRent ? orderItem.endRent:'-' }}
                                </div>
                              </div>
                            </div>
                            <div
                              class="card-body new-detail"
                              style="margin-bottom: 5px"
                            >
                              <div class="grid-container">
                                <div class="grid-item" style="text-align: center">
                                  <span
                                    class="black-text"
                                    style="
                                      font-weight: bold;
                                      display: block;
                                      font-size: 2rem;
                                    "
                                    >{{ orderItem.qty }}</span
                                  >
                                  <small
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Rp
                                    {{ formatPrice(orderItem.orderItemPrice) }}
                                    /month</small
                                  >
                                </div>
                                <div class="grid-item">
                                  <div>
                                    <small
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >{{ orderItem.productTypeName }}</small
                                    >
                                    <small
                                      class="black-text"
                                      style="font-weight: bold; display: block"
                                      >{{ orderItem.productTitle }} ({{
                                        orderItem.catalogProductTypeName
                                      }})</small
                                    >
                                  </div>

                                  <small
                                    class="black-text"
                                    style="display: block; margin-top: 10px"
                                    >Special Request :
                                    {{
                                      orderItem.orderItemNote
                                        ? orderItem.orderItemNote
                                        : "-"
                                    }}</small
                                  >
                                </div>
                                <div class="grid-item">
                                  <small
                                    style="
                                      font-weight: bold;
                                      display: block;
                                      color: black;
                                    "
                                    >{{ orderItem.condition }}</small
                                  >
                                  <a
                                    href="#"
                                    class="form-text product-specs"
                                    style="
                                      font-weight: bold;
                                      font-style: italic;
                                      color: #3099F8;
                                      margin-top: -2px;
                                      font-size: 80%;
                                    "
                                    @click="
                                      openModal(
                                        'Detail',
                                        orderItem.productTypeId,
                                        idx
                                      )
                                    "
                                    >{{ orderItem.specificationsView }}</a
                                  >
                                </div>
                                <div class="grid-item">
                                  <!-- status -->
                                  <small
                                    v-if="orderItem.orderItemStatus == 0"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Pending -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 7"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Ready to Pickup -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 8"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Picking Up -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 9 && orderItem.finalPrepared "
                                    class="black-text"
                                    style="font-weight: bold; display: block; font-size: 0.688rem;"
                                    >Ready to Prepare (Final QC) -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 9 && !orderItem.finalPrepared "
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Ready to Prepare -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 10"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Prepared -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 11"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Ready to Deliver -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 12"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Shipping -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 13"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Renting -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 14"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Finished -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 15"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Return Schedule -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 16"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Return Assign -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 17"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Return Match -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 18"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Return Unmatch -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 19"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Completed -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 98"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Replaced -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <small
                                    v-if="orderItem.orderItemStatus == 99"
                                    class="black-text"
                                    style="font-weight: bold; display: block"
                                    >Canceled -
                                    {{ orderItem.durationValue }} bulan</small
                                  >
                                  <!-- End Of status -->
                                  <small
                                    class="black-text"
                                    style="display: block; margin-top: -3px"
                                    >Catalog : Rp
                                    {{
                                      formatPrice(orderItem.itemPrice)
                                    }}/unit/month</small
                                  >
                                  <small
                                    class="black-text"
                                    style="display: block; margin-top: -3px"
                                    >Discount :
                                    {{
                                      orderItem.discountPrice
                                        ? `Rp ${formatPrice(
                                            orderItem.discountPrice
                                          )}/unit/month `
                                        : "-"
                                    }}</small
                                  >
                                  <small
                                    class="black-text"
                                    style="
                                      font-weight: bold;
                                      display: block;
                                      margin-top: -3px;
                                    "
                                    >Final : Rp
                                    {{
                                      formatPrice(orderItem.finalPrice)
                                    }}/unit/month</small
                                  >
                                </div>
                                <!-- Action Button -->
                                <div class="grid-item" v-if="typeCatalog == ''">
                                  <img src="~@/assets/images/load-button.gif" />
                                </div>

                                <div
                                  class="grid-item"
                                  v-else-if="
                                    typeCatalog != '' &&
                                    orderStatus <= 3 &&
                                    orderItem.orderItemStatus == 0 &&
                                    orderExtendFrom.orderId == ''
                                  "
                                >
                                  <button
                                    class="btn btn-primary btn-small"
                                    @click="
                                      openmodalEditProduct(
                                        orderItem.productTitle,
                                        orderItem.catalogId,
                                        idx,
                                        orderItem.orderItemNote,
                                        orderItem.durationValue,
                                        orderItem.orderItemStatus,
                                        orderItem.isReserved,
                                      )
                                    "
                                  >
                                    <i class="fas fa-edit"></i>
                                  </button>

                                  <button
                                    class="btn btn-primary btn-small"
                                    @click="
                                      openModalFive(
                                        'Delete',
                                        orderItem.productTitle,
                                        orderItem.productId,
                                        orderItem.qty,
                                        orderItem.durationValue,
                                        orderItem.condition,
                                        idx
                                      )
                                    "
                                  >
                                    <i class="fas fa-trash"></i>
                                  </button>
                                </div>
                                <div
                                  class="grid-item"
                                  v-else-if="
                                    typeCatalog != '' &&
                                    orderStatus <= 3 &&
                                    orderItem.orderItemStatus == 0 &&
                                    orderExtendFrom.orderId != ''
                                  "
                                >
                                  <button
                                    class="btn btn-primary btn-small"
                                    @click="
                                      toEditItemExtend(
                                        orderItem.productId,
                                        orderItem.condition,
                                        orderItem.durationValue
                                      )
                                    "
                                  >
                                    <i class="fas fa-edit"></i>
                                  </button>

                                  <button
                                    class="btn btn-primary btn-small"
                                    @click="
                                      openModalFour(
                                        'RemoveItemExtend',
                                        orderItem.productTitle,
                                        orderItem.productId,
                                        orderItem.durationValue,
                                        orderItem.condition
                                      )
                                    "
                                  >
                                    <i class="fas fa-trash"></i>
                                  </button>
                                </div>
                                <!-- EXtend -->
                                <td
                                  class="grid-item"
                                  v-else-if="
                                    orderStatus >= 5 &&
                                    orderItem.orderItemStatus == 0 &&
                                    orderExtendFrom.orderId != '' &&
                                    typeCatalog != ''
                                  "
                                >
                                  <!-- <button class="btn btn-primary btn-sm" @click="assignDetail(orderItem.productId,orderItem.productType,index,orderItem.deliverSchedule,orderItem.maxSchedule,orderItem.orderItemStatus,orderItem.id,orderItem.startRent,orderItem.orderItemDuration)">Info</button> -->
                                </td>
                                <td
                                  class="grid-item"
                                  v-else-if="
                                    orderStatus > 5 &&
                                    orderItem.orderItemStatus > 0 &&
                                    typeCatalog != ''
                                  "
                                >
                                  <button
                                    class="btn btn-primary btn-small"
                                    @click="
                                      openmodalEditProduct(
                                        orderItem.productTitle,
                                        orderItem.catalogId,
                                        idx,
                                        orderItem.orderItemNote,
                                        orderItem.durationValue,
                                        orderItem.orderItemStatus,
                                        orderItem.isReserved,
                                      )
                                    "
                                    v-if="orderItem.orderItemStatus <= 9"
                                  >
                                    <i class="fas fa-edit"></i>
                                  </button>
                                  <!-- <button class="btn btn-primary btn-sm" @click="assignDetail(orderItem.productId,orderItem.productType,index,orderItem.deliverSchedule,orderItem.maxSchedule,orderItem.orderItemStatus,null,orderItem.startRent,orderItem.orderItemDuration)">Info</button><br /> -->
                                  <!-- <button
                                    class="btn btn-primary btn-sm mt-1"
                                    @click="
                                      toPageEditLessor(
                                        orderId,
                                        orderCode,
                                        companyId,
                                        orderItem.productId,
                                        orderItem.condition,
                                        'edit',
                                        orderItem.orderItemStatus,
                                        orderItem.maxSchedule,
                                        orderItem.orderItemDuration,
                                        orderItem.qty,
                                        orderItem.orderItemNote,
                                        orderItem.finalPrice
                                      )
                                    "
                                    v-if="
                                      orderItem.orderItemStatus >= 6 &&
                                      orderItem.orderItemStatus <= 9 &&
                                      !orderItem.isReserved
                                    "
                                  >
                                    Edit Assigned
                                  </button> -->
                                </td>
                                <td class="grid-item" v-else>
                                  <button
                                    class="btn btn-primary btn-small"
                                    @click="
                                      openmodalEditProduct(
                                        orderItem.productTitle,
                                        orderItem.catalogId,
                                        idx,
                                        orderItem.orderItemNote,
                                        orderItem.durationValue,
                                        orderItem.orderItemStatus,
                                        orderItem.isReserved,
                                      )
                                    "
                                    v-if="orderItem.orderItemStatus <= 9"
                                  >
                                    <i class="fas fa-edit"></i>
                                  </button>
                                  <!-- Assign Order -->
                                  <!-- <button
                                    class="btn btn-primary btn-sm mt-1"
                                    @click="
                                      toPageEditLessor(
                                        orderId,
                                        orderCode,
                                        companyId,
                                        orderItem.productId,
                                        orderItem.condition,
                                        'set',
                                        orderItem.orderItemStatus,
                                        orderItem.maxSchedule,
                                        orderItem.orderItemDuration,
                                        orderItem.qty,
                                        orderItem.orderItemNote,
                                        orderItem.finalPrice
                                      )
                                    "
                                    v-if="
                                      orderItem.orderItemStatus == 0 &&
                                      orderStatus > 5
                                    "
                                  >
                                    Assign Order
                                  </button> -->
                                </td>
                                <!-- End Of Action Button -->
                              </div>

                              <!-- Endpoint Security -->
                              <!-- <div class="grid-container" style="grid-template-columns : 10% auto">
                                  <div class="grid-item"></div>
                                  <div class="grid-item">
                                    <div class="mt-3 mb-1" style="color:#2E3646; font-weight : 700; font-size : 1rem; line-height : 1.25rem;">
                                      Add-Ons : 
                                    </div>
                                    <div
                                      class="alignLeft total-data mb-2"
                                      style="display: inline-block"
                                    >
                                      <span
                                        class="item-badge-addons"
                                      >
                                        Webroot Endpoint Security Basic
                                      </span>
                                      <span
                                        class="item-badge-addons"
                                      >
                                        Webroot Advanced Threat Security
                                      </span>
                                      
                                    </div>
                                  </div>
                              </div> -->
                              <!-- End Of Endpoint Security -->
                            </div>
                            <hr
                              style="
                                height: 1.5px;
                                border-width: 0;
                                color: black;
                                background-color: black;
                                margin-right: 1.25rem;
                                margin-left: 1.25rem;
                                margin-bottom: 5px;
                                margin-top: 5px;
                              "
                            />

                            <div
                              class="collapse"
                              :id="'collapseInfo' + idx"
                              style="
                                margin-right: 1.25rem;
                                margin-left: 1.25rem;
                                margin-top: 10px;
                                padding-bottom: 1.25rem;
                              "
                            >
                              <div v-for="(item, i) in orderItem.items" :key="i">
                                <div class="card" style="margin-bottom: 10px">
                                  <div
                                    class="card-body"
                                    style="
                                      padding-top: 0.5rem;
                                      padding-bottom: 0.5rem;
                                    "
                                  >
                                  <div class='card'>
                                      <table class="table table-bordered unit-detail" style="width: 100%; margin-bottom:0;border: 0px;">
                                        <thead style="background : #F8F9FB">
                                          <tr style="border-bottom: 1px solid #dee2e6;">
                                            <td scope="col" style="width : 20%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">LP/SN</small>
                                            </td>
                                            <td scope="col" style="width : 25%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">Order Spec</small>
                                            </td>
                                            <td scope="col" style="width : 20%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">Original Product Code</small>
                                            </td>
                                            <td scope="col" style="width : 20%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">Status</small>
                                            </td>
                                            <td scope="col" style="width : 15%;">
                                              <small style="font-size : 0.75rem;font-weight : 500;">Action</small>
                                            </td>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <small style="font-size:0.75rem; font-weight: 600;">
                                                {{item.productCode ? item.productCode : "-"}} / {{item.serialNumber ? item.serialNumber : '-'}} 
                                              </small>
                                            </td>
                                            <td>
                                              <a
                                                v-if="item.bom.name"
                                                href="#"
                                                class="product-specs mb-4"
                                                style="color: #3099F8;font-size:0.75rem; font-weight: 500;"
                                                @click="openBomDetailModal(item.bom,idx)"
                                              >
                                                {{item.bom.name ? item.bom.name : "-"}}
                                              </a>
                                              <small
                                                  v-else
                                                  class="black-text"
                                                  style="
                                                    font-size: 0.75rem;
                                                    font-weight: 500;
                                                  "
                                                  >{{
                                                    item.bom.name
                                                      ? item.bom.name
                                                      : '-'
                                                  }}
                                              </small>
                                              <div class="mt-2">
                                                <div v-if="item.actualSpecification">
                                                  <small
                                                    class="black-text mb-2"
                                                    style="display: block;font-size:0.75rem; font-weight: 500;"
                                                    >Processor :
                                                    {{
                                                      item.actualSpecification
                                                        ? JSON.parse(
                                                            item.actualSpecification
                                                          ).processor
                                                        : "-"
                                                    }}
                                                  </small>
                                                  <small
                                                    class="black-text mb-2"
                                                    style="display: block;font-size:0.75rem; font-weight: 500;"
                                                    >RAM :
                                                    {{
                                                      item.actualSpecification
                                                        ? `${
                                                            JSON.parse(
                                                              item.actualSpecification
                                                            ).ram
                                                          } GB`
                                                        : "-"
                                                    }}
                                                  </small>
                                                  <small
                                                    class="black-text mb-2"
                                                    style="display: block;font-size:0.75rem; font-weight: 500;"
                                                    >Storage :
                                                    {{
                                                      item.actualSpecification
                                                        ? JSON.parse(
                                                            item.actualSpecification
                                                          ).storage
                                                        : "-"
                                                    }}
                                                  </small>
                                                  <small
                                                    class="black-text mb-2"
                                                    style="display: block;font-size:0.75rem; font-weight: 500;"
                                                    >VGA :
                                                    {{
                                                      item.actualSpecification
                                                        ? JSON.parse(
                                                            item.actualSpecification
                                                          ).vga
                                                        : "-"
                                                    }}
                                                  </small>
                                                </div>
                                                <div v-else-if="item.bom.itemBom && item.bom.itemBom.length > 0">
                                                  <div v-for="(itemBom, i) in item.bom.itemBom" :key="i" >
                                                    <small
                                                      class="black-text mb-2"
                                                      style="display: block;font-size:0.75rem; font-weight: 500;"
                                                      >
                                                      {{itemBom.itemQty}}
                                                      {{
                                                        itemBom.itemName
                                                          ? itemBom.itemName
                                                          : "-"
                                                      }}
                                                    </small>
                                                  </div>
                                                </div>
                                                <!-- <div v-else>
                                                  -
                                                </div>  -->
                                              </div>
                                            </td>
                                            <td>
                                              <small
                                                class="black-text"
                                                style="
                                                  display: block;
                                                  font-size:0.75rem; 
                                                  font-weight: 500;
                                                "
                                                >
                                                {{
                                                  item.originalProductCode
                                                    ? item.originalProductCode
                                                    : "-"
                                                }}
                                              </small>
                                            </td>
                                            <td>
                                              <div v-if="item.tag">
                                                <div
                                                  class="alignLeft total-data"
                                                  style="display: inline-block"
                                                  v-for="(tag, index) in item.tag"
                                                  :key="index"
                                                >
                                                  <span
                                                    class="item-badge ticket-badge"
                                                    v-if="tag.ticketId != 0"
                                                    :style="
                                                      'background-color:' +
                                                      tag.colorHex +
                                                      ';'
                                                    "
                                                    @click="
                                                      toTicketDetail(tag.ticketId)
                                                    "
                                                    >{{ tag.label }}
                                                    <i
                                                      class="fas fa-info-circle"
                                                      data-toggle="tooltip"
                                                      title="view ticket"
                                                    ></i
                                                  ></span>
                                                  <span
                                                    class="item-badge"
                                                    v-else
                                                    :style="
                                                      'background-color:' +
                                                      tag.colorHex +
                                                      ';'"
                                                    >{{ tag.label }}
                                                  </span>
                                                </div>
                                              </div>
                                              <div v-else> - </div>
                                            </td>
                                            <td>
                                              <button
                                                type="button"
                                                class="btn btn-outline-dark btn-sm"
                                                @click="
                                                  openHistoryModal(
                                                    item.orderDetailId,
                                                    idx, 
                                                    item
                                                  )
                                                "
                                              >
                                                <i
                                                  class="fas fa-history"
                                                  data-toggle="tooltip"
                                                  title="view history"
                                                ></i>
                                                History
                                              </button>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                    <!-- OLD -->
                                    <!-- <div class="item-detail-container">
                                      <div
                                        class="detail-item"
                                        style="
                                          text-align: center;
                                          margin-top: 50%;
                                          margin-bottom: 50%;
                                        "
                                      >
                                        <div class="black-text">
                                          <span style="font-weight:bold; font-size:90%;">
                                            {{item.productCode ? item.productCode : "-"}}
                                          </span>
                                          <br>
                                          <small>{{item.serialNumber}}</small>
                                        </div>
                                      </div>
                                      <div class="detail-item">
                                        <div>
                                          <div style="display: block">
                                            <small
                                              class="black-text"
                                              style="
                                                font-weight: bold;
                                                font-style: italic;
                                              "
                                              >Order Spec -
                                            </small>
                                            <a
                                              v-if="item.bom.name"
                                              href="#"
                                              class="product-specs"
                                              style="
                                                color: blue;
                                                font-style: italic;
                                                font-weight: bold;
                                              "
                                              @click="
                                                openBomDetailModal(
                                                  item.bom,
                                                  idx
                                                )
                                              "
                                              >"{{
                                                item.bom.name
                                                  ? item.bom.name
                                                  : "-"
                                              }}"</a
                                            >
                                            <small
                                              v-else
                                              class="black-text"
                                              style="
                                                font-style: italic;
                                                font-weight: bold;
                                              "
                                              >"{{
                                                item.bom.name
                                                  ? item.bom.name
                                                  : "-"
                                              }}"</small
                                            >
                                          </div>
                                          <small
                                            class="black-text"
                                            style="display: block"
                                            >Processor :
                                            {{
                                              JSON.parse(item.specification)
                                                .processor
                                                ? JSON.parse(item.specification)
                                                    .processor
                                                : "-"
                                            }}</small
                                          >
                                          <small
                                            class="black-text"
                                            style="
                                              display: block;
                                              margin-top: -3px;
                                            "
                                            >RAM :
                                            {{
                                              JSON.parse(item.specification).ram
                                                ? `${
                                                    JSON.parse(item.specification)
                                                      .ram
                                                  } GB`
                                                : "-"
                                            }}</small
                                          >
                                          <small
                                            class="black-text"
                                            style="
                                              display: block;
                                              margin-top: -3px;
                                            "
                                            >Storage :
                                            {{
                                              JSON.parse(item.specification)
                                                .storage
                                            }}</small
                                          >
                                          <small
                                            class="black-text"
                                            style="
                                              display: block;
                                              margin-top: -3px;
                                            "
                                            >VGA :
                                            {{
                                              JSON.parse(item.specification).vga
                                                ? JSON.parse(item.specification)
                                                    .vga
                                                : "-"
                                            }}</small
                                          >
                                          <small
                                            class="black-text"
                                            style="
                                              font-weight: bold;
                                              display: block;
                                              font-style: italic;
                                              margin-top: -3px;
                                            "
                                            >Original Product Code :
                                            {{
                                              item.originalProductCode
                                                ? item.originalProductCode
                                                : "-"
                                            }}</small
                                          >
                                        </div>
                                      </div>
                                      <div
                                        class="detail-item"
                                        v-if="item.actualSpecification"
                                      >
                                        <div style="display: block">
                                          <small
                                            style="
                                              font-weight: bold;
                                              color: black;
                                            "
                                            >Current Spec</small
                                          >
                                        </div>
                                        <small
                                          class="black-text"
                                          style="display: block"
                                          >Processor :
                                          {{
                                            item.actualSpecification
                                              ? JSON.parse(
                                                  item.actualSpecification
                                                ).processor
                                              : "-"
                                          }}</small
                                        >
                                        <small
                                          class="black-text"
                                          style="display: block; margin-top: -3px"
                                          >RAM :
                                          {{
                                            item.actualSpecification
                                              ? `${
                                                  JSON.parse(
                                                    item.actualSpecification
                                                  ).ram
                                                } GB`
                                              : "-"
                                          }}</small
                                        >
                                        <small
                                          class="black-text"
                                          style="display: block; margin-top: -3px"
                                          >Storage :
                                          {{
                                            item.actualSpecification
                                              ? JSON.parse(
                                                  item.actualSpecification
                                                ).storage
                                              : "-"
                                          }}</small
                                        >
                                        <small
                                          class="black-text"
                                          style="display: block; margin-top: -3px"
                                          >VGA :
                                          {{
                                            item.actualSpecification
                                              ? JSON.parse(
                                                  item.actualSpecification
                                                ).vga
                                              : "-"
                                          }}</small
                                        >
                                      </div>

                                      <div
                                        class="detail-item"
                                        v-if="
                                          item.bom.itemBom &&
                                          item.bom.itemBom.length > 0
                                        "
                                      >
                                        <div style="display: block">
                                          <small
                                            style="
                                              font-weight: bold;
                                              color: black;
                                            "
                                            >Current Spec</small
                                          >
                                        </div>
                                        <div v-for="(itemBom, i) in item.bom.itemBom" :key="i" >
                                          <small
                                            class="black-text"
                                            style="display: block"
                                            >{{ itemBom.itemGroup }} :
                                            {{itemBom.itemQty}}
                                            {{
                                              itemBom.itemName
                                                ? itemBom.itemName
                                                : "-"
                                            }}</small
                                          >
                                        </div>
                                      </div>
                                    </div> -->

                                    <!-- <div class="wrapperr">
                                      <div id="c1">
                                        <div
                                          class="alignLeft total-data"
                                          style="display: inline-block"
                                          v-for="(tag, i) in item.tag"
                                          :key="i"
                                        >
                                          <span
                                            class="item-badge ticket-badge"
                                            v-if="tag.ticketId != 0"
                                            :style="
                                              'background-color:' +
                                              tag.colorHex +
                                              ';'
                                            "
                                            @click="toTicketDetail(tag.ticketId)"
                                            >{{ tag.label }}
                                            <i
                                              class="fas fa-info-circle"
                                              data-toggle="tooltip"
                                              title="view ticket"
                                            ></i
                                          ></span>
                                          <span
                                            class="item-badge"
                                            v-else
                                            :style="
                                              'background-color:' +
                                              tag.colorHex +
                                              ';'
                                            "
                                            >{{ tag.label }}</span
                                          >
                                        </div>
                                      </div>
                                      <div id="c2">
                                        <div class="alignRight">
                                          <button
                                            type="button"
                                            class="btn btn-primary btn-sm"
                                            @click="
                                              openHistoryModal(
                                                item.orderDetailId,
                                                index,
                                                item
                                              )
                                            "
                                          >
                                            <i
                                              class="fas fa-history"
                                              data-toggle="tooltip"
                                              title="view history"
                                            ></i>
                                            History
                                          </button>
                                        </div>
                                      </div>
                                    </div> -->
                                    <!-- END OF OLD -->
                                  </div>
                                </div>
                              </div>

                              <!--  -->
                            </div>

                            <a
                              class="black-text"
                              v-if="!orderItem.isInfoOpened"
                              data-toggle="collapse"
                              :href="'#collapseInfo' + idx"
                              role="button"
                              aria-expanded="false"
                              :aria-controls="'collapseInfo' + idx"
                              style="
                                text-align: center;
                                margin-bottom: 5px;
                                font-size: 80%;
                              "
                              @click="changeInfoOpenedStatus(idx)"
                            >
                              Info Selengkapnya
                              <img
                                src="~@/assets/icon/arrow-down.png"
                                style="width: 10px"
                              />
                            </a>

                            <a
                              class="black-text"
                              v-if="orderItem.isInfoOpened"
                              data-toggle="collapse"
                              :href="'#collapseInfo' + idx"
                              role="button"
                              aria-expanded="true"
                              :aria-controls="'collapseInfo' + idx"
                              style="
                                text-align: center;
                                margin-bottom: 5px;
                                font-size: 80%;
                              "
                              @click="changeInfoOpenedStatus(idx)"
                            >
                              Tutup
                              <img
                                src="~@/assets/icon/arrow-up.png"
                                style="width: 10px"
                              />
                            </a>
                          </div>
                        </div>
                        <!-- ACTION BUTTON -->
                        <div id="wrapperr mt-2" style="margin-top: 20px">
                          <div id="c1">
                            <div class="alignRight total-data">
                              <h5 style="font-weight: bold">
                                Total Price/month : Rp
                                {{ formatPrice(totalPrice) }}
                              </h5>
                              <br
                                v-if="
                                  rejectReasonOrder == '' &&
                                  rejectReasonOrder == null
                                "
                              />
                              <h5
                                class="font-red"
                                style="margin-top: 0px"
                                v-if="
                                  rejectReasonOrder != '' &&
                                  rejectReasonOrder != null
                                "
                              >
                                Reason : {{ rejectReasonOrder }}
                              </h5>
                            </div>
                          </div>
                          <div id="c2">
                            <div class="pagination p8 alignRight">
                              <ul v-if="detailOrder != '' && !loadingTable">
                                <button
                                  class="btn btn-danger btn-sm"
                                  @click="isNotReserved ? openModalOne('Reject') : openCannotModifyModal('pembatalan')"
                                  v-if="
                                    orderStatus == 0 ||
                                    orderStatus == 1 ||
                                    orderStatus == 2 ||
                                    orderStatus == 3 ||
                                    orderStatus == 4 ||
                                    orderStatus == 5
                                  "
                                >
                                  Reject Order
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="openBast"
                                  v-if="
                                    statusDeliver && orderExtendFrom.orderId == ''
                                  "
                                >
                                  Download BAST
                                </button>
                                <!-- Extend -->
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="openBastExtend"
                                  v-if="
                                    orderStatus == 11 &&
                                    orderExtendFrom.orderId != ''
                                  "
                                >
                                  Download BAST
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="openModalOne('Process')"
                                  v-if="orderStatus == 0 && !newUser"
                                >
                                  Process Order
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="openModalOne('Match')"
                                  v-if="orderStatus == 0 && newUser"
                                >
                                  Process Order
                                </button>
                                <div
                                  class="dropdown"
                                  style="display: contents"
                                  v-if="(orderStatus >= 1) & (orderStatus <= 9)"
                                >
                                  <button
                                    class="btn btn-primary btn-sm dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    :class="{
                                      'btn-success': quotationStatus == '1',
                                    }"
                                  >
                                    Quotation
                                  </button>
                                  <div
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    <span
                                      class="dropdown-item link"
                                      @click="openGenerateQuotation"
                                      >Generate Quotation</span
                                    >
                                    <span
                                      class="dropdown-item link"
                                      @click="openModalOne('Quotation')"
                                      v-if="quotationCount == 0"
                                      >Send Quotation</span
                                    >
                                    <span
                                      class="dropdown-item link"
                                      @click="openModalOne('RenewQuotation')"
                                      v-if="
                                        quotationCount > 0 && orderStatus <= 3
                                      "
                                      >Renew Quotation (
                                      {{ quotationCount }} )</span
                                    >
                                  </div>
                                </div>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="openModalOne('UploadPurchase')"
                                  v-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    !purchaseUrl
                                  "
                                >
                                  Upload Purchase Order
                                </button>
                                <button
                                  class="btn btn-success btn-sm"
                                  @click="openModalOne('UploadPurchase')"
                                  v-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    purchaseUrl
                                  "
                                >
                                  Upload Purchase Order
                                </button>
                                <div
                                  class="dropdown"
                                  style="display: contents"
                                  v-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    (invoiceTime == null ||
                                      invoiceTime < quotationTime) &&
                                    orderExtendFrom.orderId != '' &&
                                    invoiceStatus != 1
                                  "
                                >
                                  <button
                                    class="btn btn-primary btn-sm dropdown-toggle"
                                    type="button"
                                    id="dropdownInvoice"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                  >
                                    Invoice
                                  </button>
                                  <div
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownInvoice"
                                  >
                                    <span
                                      class="dropdown-item link"
                                      @click="openModalOne('KeepCurrentInvoice')"
                                      >Keep using curent invoice</span
                                    >
                                    <span
                                      class="dropdown-item link"
                                      @click="handleClickSendInvoice('renewInvoiceExtend')"
                                      >Renew Invoice</span
                                    >
                                  </div>
                                </div>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="handleClickSendInvoice('sendInvoice')"
                                  v-else-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    (invoiceTime == null ||
                                      invoiceTime < quotationTime) &&
                                    orderExtendFrom.orderId == ''
                                  "
                                >
                                  Send Invoice
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="openModalOne('ProcessInvoice')"
                                  v-else-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    invoiceTime != null &&
                                    invoiceStatus != 1
                                  "
                                >
                                  Process Invoice ({{ invoiceCount }})
                                </button>
                                <button
                                  class="btn btn-success btn-sm"
                                  v-else-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    invoiceTime != null &&
                                    invoiceStatus == 1
                                  "
                                >
                                  Process Invoice ({{ invoiceCount }})
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="cekDoc"
                                  v-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    !loadingNextStep
                                  "
                                >
                                  Next Step >
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  disabled=""
                                  v-if="
                                    orderStatus >= 3 &&
                                    orderStatus <= 4 &&
                                    loadingNextStep
                                  "
                                >
                                  <img
                                    src="~@/assets/images/2.gif"
                                    style="height: 18px"
                                  />
                                  Next Step >
                                </button>
                                <!-- <button class="btn btn-primary btn-sm" @click="openModal('FillMandatory')" v-if="orderStatus >= 3 && orderStatus <= 4 && nextStepFill"> Next Step > </button> -->
                                <!-- Extend -->
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="isNotReserved ? openModalOne('UpdateProduct') : openCannotModifyModal('pembaruan')"
                                  v-if="
                                    orderStatus > 3 &&
                                    orderStatus <= 11 &&
                                    orderExtendFrom.orderId != ''
                                  "
                                >
                                  Update Products
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="isNotReserved ? openModalOne('UpdateProduct') : openCannotModifyModal('pembaruan')"
                                  v-if="
                                    orderStatus > 3 &&
                                    orderStatus <= 6 &&
                                    orderExtendFrom.orderId == ''
                                  "
                                >
                                  Update Products
                                </button>
                                <div class="d-inline">
                                  <!-- <button
                                    class="btn btn-primary btn-sm"
                                    @click="handleClickInvoicePaid()"
                                    v-if="
                                      orderStatus == 5 &&
                                      invoiceCode(dataPayment[0].invoiceNumber) ==
                                        'DEP'
                                    "
                                  >
                                    Invoice Paid
                                  </button> -->
                                  <button
                                    class="btn btn-primary btn-sm"
                                    @click="handleClickInvoicePaid()"
                                    v-if="
                                      orderStatus == 5
                                    "
                                  >
                                    Invoice Paid
                                  </button>
                                </div>
                                <!-- <button class="btn btn-primary btn-sm" @click="openModalOne('Deliver')" v-if="orderStatus > 6 && orderStatus < 12 && orderExtendFrom.orderId == ''">Deliver Order</button> -->
                                <!-- <button class="btn btn-primary btn-sm" @click="openModalOne('DeliverItem')" v-if="itemDeliverReplace > 0">Deliver Item Replace</button>
                                                                  <button class="btn btn-primary btn-sm" @click="openModalOne('StartRent')" v-if="orderStatus == 12">Start a Rent</button>
                                                                  <button class="btn btn-primary btn-sm" @click="openModalOne('StartRentItem')" v-if="itemDeliverReplace == 0 && itemStartReplace > 0">Start a Rent Item Replace</button> -->
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="toExtendPage"
                                  v-if="statusRenting"
                                >
                                  Extend Order
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  disabled=""
                                  v-if="loadingBtnReturn"
                                >
                                  <img
                                    src="~@/assets/images/2.gif"
                                    style="height: 18px"
                                  />
                                </button>
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="openModalSetReturn"
                                  v-if="valBtnSetReturn()"
                                >
                                  Set Return
                                </button>
                              
                                <button
                                  class="btn btn-primary btn-sm"
                                  @click="openModalSetReturn"
                                  v-if="valBtnRescheduleReturn()"
                                >
                                  Reschedule Return
                                </button>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <!-- END OF ACTION BUTTON -->
                      </div>
                    </div>
                    <!-- ENF OF outer card -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- SECTION START BAST -->
          <div class="row mr-1">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <div class="bast-section">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h5 class="mb-0">BAST List</h5>
                    <button
                      class="btn btn-primary btn-sm ml-2"
                      style="font-size: 14px; font-weight: 500"
                      @click="openBast"
                      v-if="
                        (orderStatus == 6 ||
                          orderStatus == 9 ||
                          orderStatus == 10 ||
                          orderStatus == 11 ||
                          orderStatus == 12 ||
                          orderStatus == 13 ||
                          orderStatus == 14 ||
                          orderStatus == 15 ||
                          orderStatus == 16 ||
                          orderStatus == 17) 
                      "
                    >
                      <img src="~@/assets/icon/add-doc-white.svg" alt="icon-add-doc" />
                      {{orderExtendFrom.orderId == '' ? 'Generate BAST' : 'Generate New BAST'}}
                    </button>
                  </div>
                  <hr />
                  <div>
                    <table
                        class="
                          table
                          table-sm
                          table-bordered
                          table-striped
                          table-responsive-sm
                          payment
                        "
                        v-if="loadingTable == true"
                      >
                        <thead>
                          <tr>
                            <th>Tipe</th>
                            <th>Kode Produk</th>
                            <th>Tanggal BAST</th>
                            <th>Tanggal Generate</th>
                            <th>Versi Doc</th>
                            <th>Status</th>
                            <th style="width: 150px">Aksi</th>
                            <th style="width: 100px">Riwayat Versi</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colspan="8" class="text-center">
                              <img src="~@/assets/images/load-button.gif" />
                            </td>
                          </tr>
                        </tbody>
                    </table>
                    <table
                      class="
                        table
                        table-sm
                        table-bordered
                        table-striped
                        table-responsive-sm
                        payment
                      "
                      v-else-if="loadingTable == false && !bastData.length"
                    >
                      <thead>
                        <tr>
                          <th>Tipe</th>
                          <th>Kode Produk</th>
                          <th>Tanggal BAST</th>
                          <th>Tanggal Generate</th>
                          <th>Versi Doc</th>
                          <th>Status</th>
                          <th style="width: 150px">Aksi</th>
                          <th style="width: 100px">Riwayat Versi</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colspan="8" class="text-center">
                            No Data Available
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table
                      v-else-if="loadingTable == false && bastData.length"
                      class="
                        table
                        table-sm
                        table-bordered
                        table-responsive-sm
                        payment
                      "
                    >
                      <thead>
                        <tr>
                          <th>Tipe</th>
                          <th>Kode Produk</th>
                          <th>Tanggal BAST</th>
                          <th>Tanggal Generate</th>
                          <th>Versi Doc</th>
                          <th>Status</th>
                          <th style="width: 150px">Aksi</th>
                          <th style="width: 150px">Riwayat Versi</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(data, i) in bastData" :key="`bastData-${i}`">
                          <td class="text-capitalize">
                            {{ data.type }}
                          </td>

                          <td>
                            <div>
                              {{ data.orderLP || "-" }}
                            </div>
                          </td>

                          <td>
                            <div>
                              {{ data.bastDate }}
                            </div>
                          </td>

                          <td>
                            <div>
                              {{ data.createdDate }}
                            </div>
                          </td>

                          <td>{{ Number.isInteger(data.version) ? data.version : "-"}}</td>

                          <td>
                            <span
                              v-if="data.status"
                              :class="getStatusBadgeClass(data.status)"
                              class="badge px-2 py-1"
                            >
                              {{ getStatusLabel(data.status) }}
                            </span>
                            <span v-else class="badge badge-secondary px-2 py-1">-</span>
                          </td>
                          
                          <td>
                            <div class="d-flex flex-wrap" style="gap: 4px">
                              <button
                                v-if="checkStatusBast(data)"
                                class="btn primary-bg-color fw-500 btn-sm"
                                @click="editBast(data, 1)"
                                title="Download BAST"
                              >
                                <img
                                  width="20"
                                  src="~@/assets/icon/download-white.svg"
                                  alt="icon-download"
                                />
                                Download BAST
                              </button>
                              <button
                                class="btn success-bg-color fw-500 btn-sm"
                                @click="openUploadBast(data, 'Upload')"
                                title="Upload Lampiran Penyerahan"
                              >
                                <div class="d-flex align-items-start" style="gap: 4px">
                                  <div style="padding-left: 2px">
                                    <img
                                      src="~@/assets/icon/upload-white.svg"
                                      alt="icon-upload"
                                    />
                                  </div>
                                  <p class="m-0">Upload Lampiran Penyerahan</p>
                                </div>
                              </button>
                              <!-- <button
                                v-if="data.linkBast"
                                class="btn success-bg-color fw-500 btn-sm"
                                @click="openUploadBast(data, 'Re-Upload')"
                                title="Re-Upload Lampiran Penyerahan"
                              >
                                <div class="d-flex align-items-start" style="gap: 4px">
                                  <img
                                    src="~@/assets/icon/upload-white.svg"
                                    alt="icon-upload"
                                  />
                                  <p class="m-0">Re-Upload Lampiran Penyerahan</p>
                                </div>
                              </button> -->
                              <button
                                v-if="checkStatusBast(data) && !data.hideRemove"
                                class="btn error-bg-color fw-500 btn-sm"
                                @click="deleteBast(data)"
                                title="Delete"
                              >
                                <img
                                  src="~@/assets/icon/trash-white.svg"
                                  alt="icon-trash"
                                />
                                Hapus
                              </button>
                            </div>
                            <!-- Tadinya checkernya data.senderRole -->
                            <!-- <button
                              v-if="data.linkBast"
                              class="btn btn-primary btn-sm mb-1"
                              @click="previewBast(data.linkBast)"
                            >
                              <i
                                class="fas fa-eye"
                                data-toggle="tooltip"
                                title="Preview"
                              ></i>
                            </button> -->
                          </td>
                          <td>
                            <ModalBASTHistory
                              :bastId="data.bastId"
                              :orderId="orderCode"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="modal fade" id="modalBast" role="dialog">
                    <div class="modal-dialog modal-dialog-centered modal-xl modal-bast">
                      <!-- Modal content-->
                      <div class="modal-content">
                        <div class="modal-header">
                          <div class="change-title">
                            <h4 class="modal-title ml-2">Generate BAST</h4>
                          </div>
                          <button style="font-size: 24px" type="button" class="close" data-dismiss="modal">
                            &times;
                          </button>
                        </div>
                        <div>
                          <div class="modal-body">
                            <div v-if="!generate">
                              <div class="card">
                                <div class="container card-body" >
                                  <strong>Tipe BAST</strong>
                                  <p class="m-0 mt-1 text-subtitle">
                                    Pilih tipe BAST yang akan di-generate
                                  </p>
                                  <div class="d-flex align-items-center mt-3" style="gap: 10px">
                                    <label class="px-0">BAST Type :</label>
                                    <div class="pl-1 pr-0">
                                      <select
                                        class="form-control"
                                        name="bastType"
                                        id="bastType"
                                        v-model="bastType"
                                        :disabled="disableTypeBast"
                                      >
                                        <option value="Delivery">Delivery</option>
                                        <option value="Return">Return</option>
                                        <option value="Ticket">Ticket</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <!-- <div class="card-body" style="padding: 0.5rem">
                                  <span class="float-left">
                                    Select the items you want to generate BAST
                                  </span>
                                  <span class="float-right">
                                    <div class="form-check">
                                      <input
                                        class="form-check-input"
                                        type="checkbox"
                                        id="cekAll"
                                        name="cekAll"
                                        @change="ceklistAllItem"
                                        v-model="ceklistAll"
                                      />
                                      <label class="form-check-label" for="gridCheck1">
                                        Checklist All
                                      </label>
                                    </div>
                                  </span>
                                </div> -->
                              </div>
                              <br />
                              <div class="card p-3">
                                <strong>Item Selection</strong>
                                <p class="m-0 mt-1 text-subtitle">
                                  Pilih unit yang akan dimasukkan ke dalam BAST
                                </p>
                                <br />
                                <table
                                  class="table table-sm table-bordered table-striped table-responsive-sm payment"
                                >
                                  <thead>
                                    <tr>
                                      <th>Category</th>
                                      <th>Type</th>
                                      <th>Require Specification</th>
                                      <th>Actual Specification</th>
                                      <th>Product Code</th>
                                      <th style="text-align: center">
                                        <input
                                          type="checkbox"
                                          id="cekListHeader"
                                          ref="headerCheckbox"
                                          :checked="ceklistAll"
                                          :disabled="
                                            dataAllItemBast == '' || dataAllItemBast.length === 0
                                          "
                                          @change="ceklistAllItem"
                                        />
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody v-if="loadingTableBast">
                                    <tr>
                                      <td colspan="6" class="text-center">
                                        <img src="~@/assets/images/load-button.gif" />
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tbody v-else-if="!loadingTableBast && dataAllItemBast == ''">
                                    <tr>
                                      <td colspan="6" class="text-center">Data Not Available</td>
                                    </tr>
                                  </tbody>
                                  <tbody v-else-if="!loadingTableBast && dataAllItemBast != ''">
                                    <tr
                                      v-for="(data, id) in dataAllItemBast"
                                      :key="`allItemBast-${id}`"
                                    >
                                      <td>
                                        {{ data.category }}
                                      </td>
                                      <td>
                                        {{ data.type }}
                                      </td>
                                      <td>
                                        {{ data.specificationsView }}
                                      </td>
                                      <td v-if="data.actualSpecificationsView">
                                        {{ data.actualSpecificationsView }}
                                      </td>
                                      <td v-else>
                                        <div
                                          v-for="(item, i) in data.bomItem"
                                          :key="`${item.itemName}-${i}`"
                                        >
                                          <div
                                            v-for="(qty, j) in item.itemQty"
                                            :key="`${item.itemName}-${i}-${j}`"
                                          >
                                            {{ item.itemName }}
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        {{ data.productCode }}
                                      </td>
                                      <td>
                                        <input
                                          type="checkbox"
                                          :id="data.id"
                                          :value="data.id"
                                          v-model="selectBastItem"
                                          @change="sublist"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div v-if="generate">
                              <div class="card p-3">
                                <strong>Item selected</strong>
                                <p class="m-0 mt-1 text-subtitle">
                                  Berikut adalah items yang dipilih untuk dokumen BAST
                                </p>
                                <br />
                                <table
                                  class="table table-sm table-bordered table-striped table-responsive-sm payment"
                                >
                                  <thead>
                                    <tr>
                                      <th>Category</th>
                                      <th>Type</th>
                                      <th>Require Specification</th>
                                      <th>Actual Specification</th>
                                      <th>Qty</th>
                                      <th>Product Code</th>
                                    </tr>
                                  </thead>
                                  <tbody v-if="loadingTableGenerate">
                                    <tr>
                                      <td colspan="6" class="text-center">
                                        <img src="~@/assets/images/load-button.gif" />
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tbody
                                    v-else-if="!loadingTableGenerate && bastItemChoose == ''"
                                  >
                                    <tr>
                                      <td colspan="6" class="text-center">Data Not Available</td>
                                    </tr>
                                  </tbody>
                                  <tbody v-else-if="!loadingTableBast && bastItemChoose != ''">
                                    <tr
                                      v-for="(data, i) in bastItemChoose"
                                      :key="`choosedBastItem-${i}`"
                                    >
                                      <td>
                                        {{ data.category }}
                                      </td>
                                      <td>
                                        {{ data.type }}
                                      </td>
                                      <td>
                                        {{ data.specificationsView }}
                                      </td>
                                      <td v-if="data.actualSpecificationsView">
                                        {{ data.actualSpecificationsView }}
                                      </td>
                                      <td v-else>
                                        <div
                                          v-for="(item, i) in data.bomItem"
                                          :key="`${item.itemName}-${i}`"
                                        >
                                          <div
                                            v-for="(qty, j) in item.itemQty"
                                            :key="`${item.itemName}-${i}-${j}`"
                                          >
                                            {{ item.itemName }}
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        {{ data.qty }}
                                      </td>
                                      <td>
                                        {{ mergeProductCode(data) }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div class="card p-3 mt-3">
                                <strong>Informasi BAST</strong>
                                <p class="m-0 mt-1 text-subtitle">
                                  Isi tanggal dan catatan untuk dokumen BAST
                                </p>
                                <br />
                                <table>
                                  <tbody>
                                    <tr>
                                      <td><div class="ol-label">Tanggal BAST</div></td>
                                      <td>:</td>
                                      <td>
                                        <date-picker
                                          v-model="bastDate"
                                          type="date"
                                          format="DD-MM-YYYY"
                                          placeholder="Select Date"
                                          style="width: 100%"
                                        ></date-picker>
                                      </td>
                                    </tr>
                                    <br>

                                    <tr>
                                      <td><div class="ol-label">Catatan</div></td>
                                      <td>:</td>
                                      <td>
                                        <textarea
                                          type="text"
                                          name="role"
                                          class="form-control"
                                          v-model="bastNote"
                                          rows="3"
                                          style="resize: none;"
                                        ></textarea>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div class="card p-3 mt-3">
                                <strong>Alamat Penyerahan</strong>
                                <p class="m-0 mt-1 text-subtitle">
                                  Lengkapi informasi alamat untuk penyerahan barang
                                </p>
                                <br />
                                <table>
                                  <tbody>
                                    <tr>
                                      <td><div class="ol-label">Province <label style="color: red">*</label></div></td>
                                      <td>:</td>
                                      <td>
                                        <multiselect
                                          v-model="bastProvinceMandatory"
                                          :options="province"
                                          label="provinceName"
                                          track-by="provinceName"
                                          :allow-empty="false"
                                          deselect-label="Can't remove this value"
                                          @input="getKabkot('ada', true)"
                                        ></multiselect>
                                      </td>
                                    </tr>
                                    <br>
                                    <tr>
                                      <td><div class="ol-label">City <label style="color: red">*</label></div></td>
                                      <td>:</td>
                                      <td>
                                        <multiselect
                                          v-model="bastCityMandatory"
                                          :options="kabkot"
                                          label="kabKotName"
                                          track-by="kabKotName"
                                          :allow-empty="false"
                                          deselect-label="Can't remove this value"
                                          @input="getKecamatan('ada', true)"
                                        ></multiselect>
                                      </td>
                                    </tr>
                                    <br>
                                    <tr>
                                      <td><div class="ol-label">District <label style="color: red">*</label></div></td>
                                      <td>:</td>
                                      <td>
                                        <multiselect
                                          v-model="bastDistrictMandatory"
                                          :options="kecamatan"
                                          label="kecamatanName"
                                          track-by="kecamatanName"
                                          :allow-empty="false"
                                          deselect-label="Can't remove this value"
                                        ></multiselect>
                                      </td>
                                    </tr>
                                    <br>
                                    <tr>
                                      <td><div class="ol-label">Village</div></td>
                                      <td>:</td>
                                      <td>
                                        <input
                                          type="text"
                                          name=""
                                          v-model="bastVillage"
                                          class="form-control"
                                        />
                                      </td>
                                    </tr>
                                    <br>
                                    <tr>
                                      <td><div class="ol-label">Zip</div></td>
                                      <td>:</td>
                                      <td>
                                        <input
                                          type="text"
                                          name=""
                                          v-model="bastZip"
                                          class="form-control"
                                          @keypress="isNumber($event)"
                                          maxlength="5"
                                        />
                                      </td>
                                    </tr>
                                    <br>
                                    <tr>
                                      <td><div class="ol-label">Address</div></td>
                                      <td>:</td>
                                      <td>
                                        <textarea
                                          class="form-control"
                                          rows="5"
                                          v-model="bastAddress"
                                          style="resize: none"
                                        >
                                        </textarea>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div 
                          class="modal-footer d-flex" 
                          :class="bastAction !== 'edit' && generate ? 'justify-content-between' : 'justify-content-end'"
                        >
                          <button
                            v-if="bastAction !== 'edit' && generate"
                            type="button"
                            class="btn btn-back btn-sm"
                            @click="backGenerate"
                          >
                            <div class="d-flex align-items-center">
                              <i class="fas fa-chevron-left" style="font-size: 8px"></i>
                              <p class="m-0 ml-2" style="font-weight: 500;">Back</p>
                            </div>
                          </button>
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            @click="generateNow"
                            :disabled="selectBastItem.length <= 0"
                            v-if="loadingButtonProcess == false && !generate"
                          >
                            Generate Now
                          </button>
                          <button
                            type="button"
                            @click="downloadBast"
                            class="btn btn-primary btn-sm"
                            v-else-if="generate && !loadingDownload"
                          >
                            Download
                          </button>
                          <button
                            type="button"
                            disabled
                            class="btn btn-primary btn-sm"
                            v-else-if="generate && loadingDownload"
                          >
                            <img src="~@/assets/images/2.gif" style="height: 18px" />Download
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- SECTION END BAST -->

          <!-- <div class="row mr-1">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <h5 class="card-title">Payment History</h5>
                <div class="card">
                  <div class="card-body">
                    <table
                      class="
                        table
                        table-sm
                        table-bordered
                        table-striped
                        table-responsive-sm
                        fixed_header
                        payment
                      "
                      v-if="loadingTable == true"
                    >
                      <tbody>
                        <tr>
                          <th>Rental Price/month</th>
                          <th>Invoice Number</th>
                          <th>Due Date</th>
                          <th>Payment Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                        <tr>
                          <td colspan="6" class="text-center">
                            <img src="~@/assets/images/load-button.gif" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table
                      class="
                        table
                        table-sm
                        table-bordered
                        table-striped
                        table-responsive-sm
                        fixed_header
                        payment
                      "
                      v-else-if="loadingTable == false && dataPayment == ''"
                    >
                      <tbody>
                        <tr>
                          <th>Rental Price/month</th>
                          <th>Invoice Number</th>
                          <th>Due Date</th>
                          <th>Payment Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                        <tr>
                          <td colspan="6" class="text-center">
                            Data Not Available
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table
                      class="
                        table
                        table-sm
                        table-bordered
                        table-striped
                        table-responsive-sm
                        fixed_header
                        payment
                      "
                      v-else
                    >
                      <tbody>
                        <tr>
                          <th>Rental Price/month</th>
                          <th>Invoice Number</th>
                          <th>Due Date</th>
                          <th>Payment Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                        <tr v-for="(data,i) in dataPayment" :key="i" >
                          <td>Rp {{ formatPrice(data.pricePerMonth) }}</td>
                          <td>{{ data.invoiceNumber }}</td>
                          <td>{{ data.dueDate }}</td>
                          <td>{{ data.paymentDate }}</td>
                          <td v-if="data.paymentStatus == 0">
                            <label class="badge badge-primary"
                              >Waiting Payment</label
                            >
                          </td>
                          <td v-if="data.paymentStatus == 1">
                            <label class="badge badge-danger">Overdue</label>
                          </td>
                          <td v-if="data.paymentStatus == 2">
                            <label class="badge badge-success">Paid</label>
                          </td>
                          <td v-if="data.paymentStatus == 3">
                            <label class="badge badge-warning"
                              >Paid (late)</label
                            >
                          </td>
                          <td class="text-center">
                            <button
                              class="btn btn-primary btn-sm"
                              @click="
                                openModalEditInvoice(
                                  data.paymentId,
                                  data.tanggal,
                                  data.invoiceTo,
                                  data.pricePerMonth
                                )
                              "
                              v-if="
                                (data.paymentStatus == 0 ||
                                  data.paymentStatus == 1) &&
                                data.invoiceStatus == 0
                              "
                            >
                              <i
                                class="fas fa-edit"
                                data-toggle="tooltip"
                                title="Edit"
                              ></i>
                            </button>
                            <button
                              class="btn btn-primary btn-sm"
                              @click="
                                exportInvoice(
                                  data.paymentId,
                                  data.invoiceNumber
                                )
                              "
                              v-if="loadingExport == false"
                            >
                              <i class="fas fa-download"></i>
                            </button>
                            <button
                              class="btn btn-primary btn-sm"
                              disabled=""
                              v-else
                            >
                              <img
                                src="~@/assets/images/2.gif"
                                style="height: 18px"
                              />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="row mr-1">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-end flex-wrap">
                    <div class="d-flex">
                      <h5 class="card-title">Company History</h5>
                      <h6 class="ml-2 pt-1 prod-rent">
                        (Product Renting : {{ productRenting }})
                      </h6>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <table
                      class="
                        fixed-header
                        table
                        table-sm
                        table-bordered
                        table-striped
                        table-responsive-sm
                      "
                    >
                      <tbody>
                        <tr>
                          <th>Order ID</th>
                          <th>Submit Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                        <tr v-if="loadingTable == true">
                          <td colspan="4" class="text-center">
                            <img src="~@/assets/images/load-button.gif" />
                          </td>
                        </tr>
                        <tr v-for="(data, i) in historyOrder" :key="i" v-else>
                          <td>{{ data.orderCode }}</td>
                          <td>{{ data.submitDate }}</td>
                          <td>
                            <label
                              v-if="data.status == 0"
                              class="badge badge-secondary"
                              >Pending</label
                            >
                            <label
                              v-if="data.status == 1"
                              class="badge badge-warning"
                              >On Process</label
                            >
                            <label
                              v-if="data.status == 2"
                              class="badge badge-warning"
                              >Quotation Review</label
                            >
                            <label
                              v-if="data.status == 3"
                              class="badge badge-warning"
                              >Waiting for PO</label
                            >
                            <label
                              v-if="data.status == 4"
                              class="badge badge-warning"
                              >Agreement Review</label
                            >
                            <label
                              v-if="data.status == 5"
                              class="badge badge-warning"
                              >Waiting for Payment</label
                            >
                            <label
                              v-if="data.status == 6"
                              class="badge badge-warning"
                              >Ready to Book</label
                            >
                            <label
                              v-if="data.status == 7"
                              class="badge badge-warning"
                              >Ready to Pickup</label
                            >
                            <label
                              v-if="data.status == 8"
                              class="badge badge-warning"
                              >Picking Up</label
                            >
                            <label
                              v-if="data.status == 9"
                              class="badge badge-warning"
                              >Ready to Prepare</label
                            >
                            <label
                              v-if="data.status == 10"
                              class="badge badge-warning"
                              >Prepared</label
                            >
                            <label
                              v-if="data.status == 11"
                              class="badge badge-info"
                              >Ready to Deliver</label
                            >
                            <label
                              v-if="data.status == 12"
                              class="badge badge-success"
                              >Shipping</label
                            >
                            <label
                              v-if="data.status == 13"
                              class="badge badge-success"
                              >Renting</label
                            >
                            <label
                              v-if="data.status == 14"
                              class="badge badge-success"
                              >Finished</label
                            >
                            <label
                              v-if="data.status == 15"
                              class="badge badge-success"
                              >Return Scheduled</label
                            >
                            <label
                              v-if="data.status == 16"
                              class="badge badge-info"
                              >Return Assign</label
                            >
                            <label
                              v-if="data.status == 17"
                              class="badge badge-success"
                              >Return Match</label
                            >
                            <label
                              v-if="data.status == 18"
                              class="badge badge-danger"
                              >Return Unmatch</label
                            >
                            <label
                              v-if="data.status == 19"
                              class="badge badge-success"
                              >Completed</label
                            >
                            <label
                              v-if="data.status == 99"
                              class="badge badge-danger"
                              >Cancelled</label
                            >
                          </td>
                          <td>
                            <button
                              class="btn btn-primary btn-sm"
                              @click="
                                toDetail(
                                  data.orderId,
                                  data.orderCode,
                                  data.companyId
                                )
                              "
                            >
                              Detail
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-if="loadingTable == false && historyOrder == ''">
                        <tr>
                          <td colspan="4" class="text-center">
                            Data not available
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
    </div>

    <!-- History Modal -->
    <div class="modal fade" id="modalViewHistory" role="dialog">
      <div
        class="modal-dialog modal-dialog-centered modal-scroll"
        style="max-width: 1500px; margin-left: 15px"
      >
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title black-text" style="font-weight: bold">
                {{ selectedOrderItemDetailHistory.productName }} -
                {{ selectedOrderItemDetailHistory.specificationsView }} ({{
                  selectedOrderItemDetailHistory.condition
                }})
              </h4>
              <h4 class="modal-title black-text" style="font-weight: bold">
                {{ selectedOrderItemDetailHistory.productCode }}
              </h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <table
              class="
                table table-sm table-bordered table-striped table-responsive-sm
              "
            >
              <thead>
                <tr class="black-text" style="font-weight: bold">
                  <th style="width: 200px">Activity</th>
                  <th style="width: 100px">Serial Number</th>
                  <th style="width: 180px">Accessories</th>
                  <th style="width: 220px">PIC</th>
                  <th style="width: 180px">BOM</th>
                  <th>Actual Spec</th>
                </tr>
              </thead>
              <tbody>
                <!-- <div v-for="data in selectedOrderItemDetailHistory.historyOrder"> -->
                <tr v-for="(data,i) in selectedOrderItemDetailHistory.historyOrder" :key="i">
                  <td
                    v-if="data.activity.activityName == 'Initial Order'"
                    style="text-align: center"
                  >
                    {{ data.activity.activityName }}
                  </td>
                  <td v-else style="text-align: center">
                    {{ data.activity.activityName }} <br />
                    <a
                      class="ticket-no"
                      href="#"
                      @click="toTicketDetail(data.activity.ticketId)"
                      style="color: blue"
                      >{{ data.activity.ticketNo }}</a
                    >
                  </td>

                  <!-- SERIAL NUMBER -->
                  <td
                    v-if="data.activity.activityName == 'Initial Order'"
                    style="text-align: center"
                  >
                    {{ data.serialNumber.serialNo }}
                    <br />
                    {{ data.serialNumber.productCode }}
                  </td>
                  <td v-else style="text-align: center">
                    {{ data.serialNumber.serialNo }}
                  </td>

                  <!-- ACCESSORIES -->
                  <td>
                    <div
                      v-for="(accessories, count) in data.accessories
                        .orderAccessories"
                      :key="count"
                    >
                      {{ accessories }}
                      <div
                        v-if="
                          count == data.accessories.orderAccessories.length - 1
                        "
                      >
                        <br />
                      </div>
                      <div v-else>
                        <br />
                      </div>
                    </div>

                    <strong>Office lincense :</strong>
                    {{
                      data.accessories.officeLicense
                        ? data.accessories.officeLicense
                        : "-"
                    }}<br />
                    <strong>Windows lincense :</strong>
                    {{
                      data.accessories.windowsLicense
                        ? data.accessories.windowsLicense
                        : "-"
                    }}<br />
                  </td>

                  <!-- PIC -->
                  <td v-if="data.activity.activityName == 'Initial Order'">
                    Prepared By :
                    {{ data.pic.preparedBy ? data.pic.preparedBy : "-" }}<br />
                    Delivered By :
                    {{ data.pic.deliveredBy ? data.pic.deliveredBy : "-" }}
                    <br />
                    Delivered To :
                    {{ data.pic.deliveredTo ? data.pic.deliveredTo : "-" }}
                  </td>
                  <td v-else-if="data.activity.activityName == 'Ticket'">
                    Create Time :
                    {{ data.pic.createdAt ? data.pic.createdAt : "-" }}<br />
                    <br />
                    Last Held By :
                    {{ data.pic.lastHeldBy ? data.pic.lastHeldBy : "-" }} <br />
                  </td>
                  <td v-else>
                    Create Time :{{
                      data.pic.createdAt ? data.pic.createdAt : "-"
                    }}
                  </td>

                  <!-- BOM -->
                  <td>
                    <strong>{{ data.bom.name }}</strong
                    ><br />
                    <div v-for="(item, i) in data.bom.itemBom" :key="i" >
                      {{ item.itemCode }} -
                      {{ item.itemName ? item.itemName : "-" }}<br />
                    </div>
                  </td>

                  <!-- Actual Spec -->
                  <td v-if="data.actualSpecification">
                    <div
                      v-for="(value, propertyName) in JSON.parse(
                        data.actualSpecification
                      )"
                      :key="propertyName"
                    >
                      {{ propertyName }} : {{ value ? value : "-" }} <br />
                    </div>
                  </td>

                  <td v-else-if="data.bom.itemBom">
                    <div v-for="(item, i) in data.bom.itemBom"  :key="i">
                      {{ item.itemGroup }} :
                      {{ item.itemName ? `${item.itemQty} ${item.itemName}` : "-" }}<br />
                    </div>
                  </td>

                  <td v-else></td>
                </tr>
                <!-- </div> -->
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- SN/LP Modal -->
    <!-- <div class="modal fade" id="modalSearchInfo" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-scroll" style="max-width: 1500px; margin-left: 15px;">
                            <div class="modal-content" v-if="dataInfoSearch != ''">
                    <div class="modal-header">
                        <div class="row">
                            <div class="col-12">
                                <h4 class="modal-title">{{ dataInfoSearch.productName }} - {{ dataInfoSearch.actual }} ({{ dataInfoSearch.conditionName }})</h4>
                            </div>
                            <div class="col-12">
                                <h5>Start Rent : {{ dataInfoSearch.startRent }}</h5>
                            </div>
                            <div class="col-12">
                                <h5>End Rent : {{ dataInfoSearch.endRent }}</h5>
                            </div>
                        </div>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body modal-scroll" v-if="loadingTableAssign == false">
                        <div>
                            <div class="input-one-line-assign">
                                <div class="input-title-assign">
                                    <label class="text-partnership">Point Address</label>
                                    <h3>{{ dataInfoSearch.pickupPlaceName }}</h3>
                                    <h6>Pickup Schedule : {{ dataInfoSearch.pickupSchedule }}</h6>
                                </div>
                            </div>
                            <table class="table table-sm table-bordered">
                                <tr>
                                    <th style="width: 50px;">Product Code</th>
                                    <th style="width: 200px;">Accesories</th>
                                    <th style="width: 150px;">Assigned By</th>
                                    <th style="width: 150px;">Prepared By</th>
                                    <th style="width: 200px;">Note</th>
                                    <th style="width: 300px;">Actual Specification</th>
                                </tr>
                                <tr>
                                    <td>
                                        {{ dataInfoSearch.productCode }}
                                        <span v-if="dataInfoSearch.stockCode != null">
                                            <br />
                                            ({{ dataInfoSearch.stockCode}})
                                        </span>
                                        <span v-if="dataInfoSearch.temporary == 1">
                                            <br />
                                            <div class="badge badge-primary">Temporary</div>
                                        </span>
                                    </td>
                                    <td>
                                        <div v-if="dataInfoSearch.erpAccessories">
                                            <span v-for="(acc,i) in dataInfoSearch.erpAccessories" :key="i">
                                                {{acc.itemName}}
                                            </span>
                                        </div><br />
                                        <span v-if="dataInfoSearch.officeLicense != '' && dataInfoSearch.officeLicense != null"><b>Office license : </b></span>{{ dataInfoSearch.officeLicense }}
                                        <span v-if="dataInfoSearch.officeLicense != '' && dataInfoSearch.officeLicense != null"><br /></span>
                                        <span v-if="dataInfoSearch.windowsLicense != '' && dataInfoSearch.windowsLicense != null"><b>Windows license : </b></span>{{ dataInfoSearch.windowsLicense }}
                                        <span v-if="dataInfoSearch.windowsLicense != '' && dataInfoSearch.windowsLicense != null"><br /></span>
                                        <span v-if="dataInfoSearch.serialNumber != '' && dataInfoSearch.serialNumber != null"><b>Serial Number : </b></span>{{ dataInfoSearch.serialNumber }}
                                    </td>
                                    <td>{{ dataInfoSearch.assignedBy }}</td>
                                    <td>{{ dataInfoSearch.preparedBy }}</td>
                                    <td v-if="dataInfoSearch.status == 18">
                                        Unmatched Reason : {{dataInfoSearch.unmatchReason}}<br />
                                        <br />
                                        {{ dataInfoSearch.itemNote }}
                                    </td>
                                    <td v-else-if="dataInfoSearch.status != 18">
                                        {{ dataInfoSearch.itemNote }}
                                    </td>
                                    <td v-if="dataInfoSearch.productType == 1 || dataInfoSearch.productType == 2">
                                        <div v-if="dataInfoSearch.bomId">
                                            <div v-for="(bom,i) in dataInfoSearch.bomItem" :key="i">
                                                <div v-for="(qty,j) in bom.itemQty" :key="j">
                                                    {{bom.itemName}}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <span v-if="actualSpecProcessor[0] != ''"> Processor : {{ actualSpecProcessor[0] }}<br /></span>
                                            <span v-if="actualSpecRAM[0] != ''"> RAM : {{ actualSpecRAM[0] }}<br /></span>
                                            <span v-if="actualSpecStorage[0] != ''"> Storage : {{ actualSpecStorage[0] }}<br /></span>
                                            <span v-if="actualSpecVGA[0] != ''"> VGA : {{ actualSpecVGA[0] }}</span>
                                        </div>
                                    </td>
                                    <td v-if="dataInfoSearch.productType == 3">
                                        <span v-if="actualSpecProcessor[0] != ''"> Size : {{ actualSpecProcessor[0] }}<br /></span>
                                        <span v-if="actualSpecRAM[0] != ''"> Type : {{ actualSpecRAM[0] }}<br /></span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    <!-- endModal -->
    <!-- Modal Detail -->
    <div class="modal fade" id="modalDetail" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title" v-if="detailOrder != ''">
              <h4 class="modal-title">
                {{ detailOrder[idx].productTitle }} -
                {{ detailOrder[idx].specificationsView }}
              </h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body" v-if="detailOrder != '' && docPilih == '1'">
            {{ toArray(detailOrder[idx].items[0].specification) }}
            <table>
              <tr>
                <td>Condition</td>
                <td>:&nbsp;</td>
                <td>{{ conditionNameModal }}</td>
              </tr>
              <tr>
                <td>Brand</td>
                <td>:&nbsp;</td>
                <td>{{ detailProductBrand }}</td>
              </tr>
              <tr>
                <td>Model</td>
                <td>:&nbsp;</td>
                <td>{{ detailProductModel }}</td>
              </tr>
              <tr>
                <td>Screen</td>
                <td>:&nbsp;</td>
                <td>{{ detailProductScreen }}</td>
              </tr>
              <tr>
                <td>Processor</td>
                <td>:&nbsp;</td>
                <td>{{ detailProductProcessor }}</td>
              </tr>
              <tr>
                <td>RAM</td>
                <td>:&nbsp;</td>
                <td>{{ detailProductRAM }}GB</td>
              </tr>
              <tr>
                <td>Storage</td>
                <td>:&nbsp;</td>
                <td>{{ detailProductStorage }}</td>
              </tr>
              <tr>
                <td>VGA</td>
                <td>:&nbsp;</td>
                <td>{{ detailProductVGA }}</td>
              </tr>
            </table>
          </div>
          <div
            class="modal-body"
            v-else-if="detailOrder != '' && docPilih == '2'"
          >
            {{ toArray(detailOrder[idx].items[0].specification) }}
            <table>
              <tr>
                <td>Condition</td>
                <td>:</td>
                <td>{{ conditionNameModal }}</td>
              </tr>
              <tr>
                <td>Brand</td>
                <td>:</td>
                <td>{{ detailProductBrand }}</td>
              </tr>
              <tr>
                <td>Model</td>
                <td>:</td>
                <td>{{ detailProductModel }}</td>
              </tr>
              <tr>
                <td>Screen</td>
                <td>:</td>
                <td>{{ detailProductScreen }}</td>
              </tr>
              <tr>
                <td>Processor</td>
                <td>:</td>
                <td>{{ detailProductProcessor }}</td>
              </tr>
              <tr>
                <td>RAM</td>
                <td>:</td>
                <td>{{ detailProductRAM }}GB</td>
              </tr>
              <tr>
                <td>Storage</td>
                <td>:</td>
                <td>{{ detailProductStorage }}</td>
              </tr>
              <tr>
                <td>VGA</td>
                <td>:</td>
                <td>{{ detailProductVGA }}</td>
              </tr>
            </table>
          </div>
          <div
            class="modal-body"
            v-else-if="detailOrder != '' && docPilih == '3'"
          >
            {{ toArray(detailOrder[idx].items[0].specification) }}
            <table>
              <tr>
                <td>Condition</td>
                <td>:</td>
                <td>{{ conditionNameModal }}</td>
              </tr>
              <tr>
                <td>Brand</td>
                <td>:</td>
                <td>{{ detailProductBrand }}</td>
              </tr>
              <tr>
                <td>Model</td>
                <td>:</td>
                <td>{{ detailProductModel }}</td>
              </tr>
              <tr>
                <td>Display</td>
                <td>:</td>
                <td>{{ detailProductDisplaySize }} Inch</td>
              </tr>
              <tr>
                <td>Display Type</td>
                <td>:</td>
                <td>{{ detailProductDisplayType }}</td>
              </tr>
              <tr>
                <td>Port VGA</td>
                <td>:</td>
                <td>{{ detailProductPortVGA }}</td>
              </tr>
              <tr>
                <td>Port DVI-D</td>
                <td>:</td>
                <td>{{ detailProductPortDvid }}</td>
              </tr>
              <tr>
                <td>Port HDMI</td>
                <td>:</td>
                <td>{{ detailProductPortHDMI }}</td>
              </tr>
            </table>
          </div>
          <div
            class="modal-body"
            v-else-if="detailOrder != '' && docPilih == '4'"
          >
            {{ toArray(detailOrder[idx].items[0].specification) }}
            <table>
              <tr>
                <td>Condition</td>
                <td>:</td>
                <td>{{ conditionNameModal }}</td>
              </tr>
              <tr>
                <td>Brand</td>
                <td>:</td>
                <td>{{ detailProductBrand }}</td>
              </tr>
              <tr>
                <td>Model</td>
                <td>:</td>
                <td>{{ detailProductModel }}</td>
              </tr>
              <tr>
                <td>Color Tech</td>
                <td>:</td>
                <td>{{ detailProductColorTech }}</td>
              </tr>
              <tr>
                <td>Feature</td>
                <td>:</td>
                <td>{{ detailProductFeature }}</td>
              </tr>
            </table>
          </div>
          <div
            class="modal-body"
            v-else-if="
              detailOrder != '' && (docPilih == '4' || docPilih == '5')
            "
          >
            {{ toArray(detailOrder[idx].items[0].specification) }}
            <table>
              <tr>
                <td>Brand</td>
                <td>:</td>
                <td>{{ detailProductBrand }}</td>
              </tr>
              <tr>
                <td>Model</td>
                <td>:</td>
                <td>{{ detailProductModel }}</td>
              </tr>
              <tr>
                <td>Screen</td>
                <td>:</td>
                <td>{{ detailProductScreen }}</td>
              </tr>
              <tr>
                <td>Processor</td>
                <td>:</td>
                <td>{{ detailProductProcessor }}</td>
              </tr>
              <tr>
                <td>RAM</td>
                <td>:</td>
                <td>{{ detailProductRAM }}GB</td>
              </tr>
              <tr>
                <td>Storage</td>
                <td>:</td>
                <td>{{ detailProductStorage }}</td>
              </tr>
            </table>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>

    <!-- Modal BOM -->
    <div class="modal fade" id="modalBom" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title" v-if="detailOrder != ''">
              <h4 class="modal-title">
                {{ detailOrder[idx].productTitle }}
                {{
                  selectedOrderItemBOM.name
                    ? `(${selectedOrderItemBOM.name})`
                    : "-"
                }}
              </h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <table>
              <div
                v-for="itemBom in selectedOrderItemBOM.itemBom"
                :key="itemBom.itemCode"
              >
                <tr>
                  <td>{{ `${itemBom.itemQty} ${itemBom.itemName}` }}</td>
                </tr>
              </div>
            </table>
          </div>

          <div class="modal-footer"></div>
        </div>
      </div>
    </div>

    <!-- Modal Add-->
    <div class="modal fade" id="modalAdd" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Add Product</h4>
              <h6>to Order ID : {{ orderCode }}</h6>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="one-line">
              <label class="ol-label"> Choose Category </label>
              <label class="ol-titik2">:</label>
              <multiselect
                v-model="productCategoryAdd"
                :options="typeCatalog"
                label="catalogType"
                @select="inputResetAdd('category')"
                :allow-empty="false"
                deselect-label=""
                @input="getProductName('add')"
                select-label=""
              ></multiselect>
            </div>
            <div class="one-line">
              <label class="ol-label"> Choose Product </label>
              <label class="ol-titik2">:</label>
              <multiselect
                v-model="pilihProductAdd"
                :options="selectProductName"
                label="catalogName"
                track-by="catalogName"
                @select="inputResetAdd('product')"
                :allow-empty="false"
                deselect-label=""
                @input="getProductVarian('add')"
                select-label=""
              ></multiselect>
            </div>
            <div class="one-line">
              <label class="ol-label"> Choose Varian </label>
              <label class="ol-titik2">:</label>
              <multiselect
                v-model="pilihVarianAdd"
                :options="selectProductVarian"
                label="specification"
                track-by="specification"
                @select="inputResetAdd('varian')"
                :allow-empty="false"
                deselect-label=""
                @input="getProductCondition('add')"
                select-label=""
              ></multiselect>
            </div>
            <div class="one-line">
              <label class="ol-label"> Condition </label>
              <label class="ol-titik2">:</label>
              <multiselect
                v-model="conditionChoosedAdd"
                :options="selectCondition"
                label="condition"
                track-by="condition"
                @select="inputResetAdd('condition')"
                :allow-empty="false"
                deselect-label=""
                @input="getProductDuration('add')"
                select-label=""
              ></multiselect>
            </div>
            <div class="one-line">
              <label class="ol-label"> Duration (Month)</label>
              <label class="ol-titik2">:</label>
              <input
                type="text"
                name="qty"
                class="form-control form-control-sm"
                v-model="addDuration"
                @keypress="isNumber($event)"
                @input="getProductPricing('add')"
              />
            </div>
            <div class="one-line">
              <label class="ol-label"> Qty </label>
              <label class="ol-titik2">:</label>
              <input
                type="text"
                name="qty"
                class="form-control form-control-sm"
                v-model="addQty"
                @keypress="isNumber($event)"
              />
            </div>
            <div class="one-line">
              <label class="ol-label-price"> Unit Price </label>
              <label class="ol-titik2-price ml-2">:</label>
              <span class="input-group-addon">
                <label class="label-addon-rp">Rp</label>
              </span>
              <money
                type="text"
                class="form-control form-control-sm duration"
                name=""
                v-model="addPrice"
                @keypress="isNumber($event)"
                v-bind="money"
              />
              <label class="permonth">/month</label>
            </div>
            <div class="one-line">
              <label class="ol-label"> Note </label>
              <label class="ol-titik2">:</label>
              <input
                type="text"
                name="note"
                class="form-control form-control-sm"
                v-model="addNote"
              />
            </div>
            <!-- Hide deliver schedule -->
            <!-- <div class="one-line" v-if="orderStatus == 9">
              <div
                class="ol-label"
                style="margin-top: auto; margin-bottom: auto"
              >
                Deliver Schedule
              </div>
              <div
                class="ol-titik2"
                style="margin-top: auto; margin-bottom: auto"
              >
                :
              </div>
              <div class="ol-value">
                <input
                  type="date"
                  class="form-control"
                  v-model="addDeliverSchedule"
                  placeholder="Start rent to"
                />
              </div>
            </div> -->
            <!-- Hide warehouse -->
            <!-- <div class="one-line" v-if="orderStatus == 9">
              <label
                class="ol-label"
                style="margin-top: auto; margin-bottom: auto"
              >
                Warehouse
              </label>
              <label
                class="ol-titik2"
                style="margin-top: auto; margin-bottom: auto"
                >:</label
              >
              <multiselect
                v-model="warehouseAdd"
                :options="warehouseList"
                :allow-empty="false"
                deselect-label=""
                select-label=""
              ></multiselect>
            </div> -->
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="addOrderItem"
              v-if="loadingButtonProcess == false"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- Modal Edit-->
    <div class="modal fade" id="modalEdit" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Change Product</h4>
              <h6>{{ editProductName }} - {{ specModal }}</h6>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <!-- {{product Category}} -->
          <div class="modal-body">
            <div class="one-line">
              <label class="ol-label"> Choose Category </label>
              <label class="ol-titik2">:</label>
              <multiselect
                v-model="productCategory"
                :options="typeCatalog"
                label="catalogType"
                track-by="catalogType"
                @select="inputReset('category')"
                :allow-empty="false"
                deselect-label=""
                @input="getProductName('edit')"
                select-label=""
              ></multiselect>
            </div>
            <!-- {{pilihProduct}} -->
            <div class="one-line">
              <label class="ol-label"> Choose Product </label>
              <label class="ol-titik2">:</label>
              <multiselect
                v-model="pilihProduct"
                :options="selectProductName"
                label="catalogName"
                track-by="catalogName"
                @select="inputReset('product')"
                :allow-empty="false"
                deselect-label=""
                @input="getProductVarian('edit')"
                select-label=""
              ></multiselect>
            </div>
            <!-- {{pilihVarian}} -->
            <div class="one-line">
              <label class="ol-label"> Choose Varian </label>
              <label class="ol-titik2">:</label>
              <multiselect
                v-model="pilihVarian"
                :options="selectProductVarian"
                label="specification"
                track-by="specification"
                @select="inputReset('varian')"
                :allow-empty="false"
                deselect-label=""
                @input="getProductCondition('edit')"
                select-label=""
              ></multiselect>
            </div>
            <!-- {{conditionChoosed}} -->
            <div class="one-line">
              <label class="ol-label"> Condition </label>
              <label class="ol-titik2">:</label>
              <multiselect
                v-model="conditionChoosed"
                :options="selectCondition"
                label="condition"
                track-by="condition"
                @select="inputReset('condition')"
                :allow-empty="false"
                deselect-label=""
                @input="getProductDuration('edit')"
                select-label=""
              ></multiselect>
            </div>
            <!-- {{pilihDurasi}} -->
            <div class="one-line">
              <label class="ol-label"> Duration (Month) </label>
              <label class="ol-titik2">:</label>
              <input
                type="text"
                name=""
                class="form-control form-control-sm"
                v-model="editDuration"
                @keypress="isNumber($event)"
                @input="getProductPricing('edit')"
              />
            </div>
            <div class="one-line">
              <label class="ol-label"> Qty </label>
              <label class="ol-titik2">:</label>
              <input
                type="text"
                name="qty"
                class="form-control form-control-sm"
                v-model="editQty"
                @keypress="isNumber($event)"
              />
            </div>
            <div class="one-line">
              <label class="ol-label-price"> Unit Price </label>
              <label class="ol-titik2-price ml-2">:</label>
              <span class="input-group-addon">
                <label class="label-addon-rp">Rp</label>
              </span>
              <money
                type="text"
                class="form-control form-control-sm duration"
                name=""
                v-model="editPrice"
                @keypress="isNumber($event)"
                v-bind="money"
              />
              <label class="permonth">/month</label>
            </div>
            <div class="one-line">
              <label class="ol-label"> Note </label>
              <label class="ol-titik2">:</label>
              <input
                type="text"
                name="note"
                class="form-control form-control-sm"
                v-model="editNote"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="editOrderItem"
              v-if="loadingButtonProcess == false"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- Modal Delete-->
    <div class="modal fade" id="modalDelete" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Delete Product</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure to delete product {{ deleteProductName }} ?</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="deleteOrderItem"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalReject -->
    <div class="modal fade" id="modalReject" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Reject Order</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>
              Are you sure reject order ID {{ orderCode }} by
              {{ companyName }} ?
            </p>
            <div class="one-line">
              <label class="ol-label-reason"> Reason </label>
              <label class="ol-titik2">:</label>
              <input
                type="text"
                name="note"
                class="form-control form-control-sm"
                v-model="inputReason"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="updateStatus('Reject')"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalVerifyStep -->
    <div class="modal fade" id="modalVerifyStep" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Process to next step</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>Do you want to continue process order ID {{ orderCode }} ?</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="nextStep"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalMatch -->
    <div class="modal fade" id="modalMatch" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Company Verification</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <section id="tabs" class="project-tab">
              <div class="container">
                <div class="row">
                  <div class="col-md-12">
                    <nav>
                      <div
                        class="nav nav-tabs nav-fill"
                        id="nav-tab"
                        role="tablist"
                      >
                        <a
                          class="nav-item nav-link active"
                          id="nav-home-tab"
                          data-toggle="tab"
                          href="#nav-home"
                          role="tab"
                          aria-controls="nav-home"
                          aria-selected="true"
                          @click="clickTab('new')"
                          >New Company</a
                        >
                        <a
                          class="nav-item nav-link"
                          id="nav-profile-tab"
                          data-toggle="tab"
                          href="#nav-profile"
                          role="tab"
                          aria-controls="nav-profile"
                          aria-selected="false"
                          @click="clickTab('existing')"
                        >
                          Existing Company
                        </a>
                      </div>
                    </nav>
                    <div class="tab-content mt-2" id="nav-tabContent">
                      <div
                        class="tab-pane fade show active"
                        id="nav-home"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab"
                      >
                        <div class="row">
                          <div class="col-lg-5 col-md-5 col-sm-12">
                            <table class="font-black">
                              <tr>
                                <th colspan="3" class="py-2">
                                  <h5>Company Info</h5>
                                </th>
                              </tr>
                              <tr>
                                <td class="align-top">Name (Akta)</td>
                                <td class="align-top">&emsp;:&emsp;</td>
                                <td>{{ companyName }}</td>
                              </tr>
                              <tr>
                                <td class="align-top">Name (NPWP)</td>
                                <td class="align-top">&emsp;:&emsp;</td>
                                <td>
                                  {{ companyNameNPWP || '-' }}
                                </td>
                              </tr>
                              <tr>
                                <td class="align-top">Province</td>
                                <td class="align-top">&emsp;:&emsp;</td>
                                <td>{{ companyProvince }}</td>
                              </tr>
                              <tr>
                                <td class="align-top">City</td>
                                <td class="align-top">&emsp;:&emsp;</td>
                                <td>{{ companyCity }}</td>
                              </tr>
                              <tr>
                                <td class="align-top">District</td>
                                <td class="align-top">&emsp;:&emsp;</td>
                                <td>{{ companyDistrict }}</td>
                              </tr>
                              <tr>
                                <td class="align-top">Village</td>
                                <td class="align-top">&emsp;:&emsp;</td>
                                <td>{{ companyVillage }}</td>
                              </tr>
                              <tr>
                                <td class="align-top" style="min-width: 100px">
                                  Zip Code
                                </td>
                                <td class="align-top">&emsp;:&emsp;</td>
                                <td>{{ companyZip }}</td>
                              </tr>
                              <tr>
                                <td class="align-top">Address</td>
                                <td class="align-top">&emsp;:&emsp;</td>
                                <td>{{ companyAddress }}</td>
                              </tr>
                              <tr>
                                <td>Phone</td>
                                <td>&emsp;:&emsp;</td>
                                <td>{{ companyPhone }}</td>
                              </tr>
                              <tr>
                                <td>Citizenship</td>
                                <td>&emsp;:&emsp;</td>
                                <td style="word-wrap: break-word; max-width: 200px; text-transform: uppercase">
                                  {{ citizenship }}
                                </td>
                              </tr>
                              <tr>
                                <td>KTP Number</td>
                                <td>&emsp;:&emsp;</td>
                                <td>{{ companyKtpPassport }}</td>
                              </tr>
                              <tr v-if="companyNPWP16 !== undefined">
                                <td>NPWP</td>
                                <td>&emsp;:&emsp;</td>
                                <td>{{ companyNPWP16 }}</td>
                              </tr>
                              <tr v-if="companyNPWP22 !== undefined">
                                <td>NITKU</td>
                                <td>&emsp;:&emsp;</td>
                                <td>{{ companyNPWP22 }}</td>
                              </tr>
                              <tr>
                                <td class="align-top">Akta Address</td>
                                <td class="align-top">&emsp;:&emsp;</td>
                                <td>{{ aktaAddress }}</td>
                              </tr>
                            </table>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-12">
                            <table class="font-black">
                              <tr>
                                <th colspan="3" class="py-2">
                                  <h5>Company Person In Charge (PIC)</h5>
                                </th>
                              </tr>
                              <tr>
                                <td>Name</td>
                                <td>&emsp;:&emsp;</td>
                                <td>{{ userName }}</td>
                              </tr>
                              <!-- <tr>
                                                        <td>KTP Number</td>
                                                        <td>&emsp;:&emsp;</td>
                                                        <td>{{ userKTP }}</td>
                                                    </tr> -->
                              <tr>
                                <td>Phone</td>
                                <td>&emsp;:&emsp;</td>
                                <td>{{ userPhone }}</td>
                              </tr>
                              <tr>
                                <td>Email</td>
                                <td>&emsp;:&emsp;</td>
                                <td>{{ userEmail }}</td>
                              </tr>
                              <tr>
                                <td>Position</td>
                                <td>&emsp;:&emsp;</td>
                                <td>{{ userPosition }}</td>
                              </tr>
                              <tr>
                                <td>Division</td>
                                <td>&emsp;:&emsp;</td>
                                <td>{{ userDivision }}</td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div
                        class="tab-pane fade"
                        id="nav-profile"
                        role="tabpanel"
                        aria-labelledby="nav-profile-tab"
                      >
                        <label class="font-black">Existing Company</label>
                        <multiselect
                          v-model="existingValue"
                          :options="companySelect"
                          label="companyName"
                          :allow-empty="false"
                          deselect-label=""
                          style=""
                          track-by="companyName"
                          placeholder="Select Existing Company"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitVerifCompany('save')"
              v-if="loadVerif == false && newCompany"
            >
              Save & Process
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitVerifCompany('match')"
              v-if="loadVerif == false && !newCompany"
            >
              Match & Process
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-if="loadVerif"
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" /><span
                v-if="loadVerif && newCompany"
                >Save & Process</span
              ><span v-if="loadVerif && !newCompany">Match & Process</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalFillMandatory -->
    <div class="modal fade" id="modalFillMandatory" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Please Complete Mandatory Info</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="row mr-1">
              <div class="col-md-12 grid-margin stretch-card card-div">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <table style="width: 100%">
                        <tr>
                          <th colspan="3" class="py-2">
                            <h5>Company Info</h5>
                          </th>
                        </tr>
                        <tr>
                          <td class="align-top">
                            Name <span class="text-star">*</span>
                          </td>
                          <td>
                            <input
                              class="form-control form-control-sm mb-2"
                              type="text"
                              name="company_name"
                              v-model="companyNameMandatory"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="align-top">
                            Province <span class="text-star">*</span>
                          </td>
                          <td>
                            <multiselect
                              class="mb-2"
                              v-model="companyProvinceMandatory"
                              :options="province"
                              label="provinceName"
                              :allow-empty="false"
                              deselect-label="Can't remove this value"
                              @change="getKabkot('ada')"
                              track-by="provinceName"
                            ></multiselect>
                          </td>
                        </tr>
                        <tr>
                          <td class="align-top">
                            District <span class="text-star">*</span>
                          </td>
                          <td>
                            <multiselect
                              class="mb-2"
                              v-model="companyDistrictMandatory"
                              :options="kabkot"
                              label="kabKotName"
                              :allow-empty="false"
                              deselect-label="Can't remove this value"
                              @change="getKecamatan('ada')"
                              track-by="kabKotName"
                            ></multiselect>
                          </td>
                        </tr>
                        <tr>
                          <td class="align-top">
                            City <span class="text-star">*</span>
                          </td>
                          <td>
                            <multiselect
                              class="mb-2"
                              v-model="companyCityMandatory"
                              :options="kecamatan"
                              label="kecamatanName"
                              :allow-empty="false"
                              deselect-label="Can't remove this value"
                              track-by="kecamatanName"
                            ></multiselect>
                          </td>
                        </tr>
                        <tr>
                          <td class="align-top">
                            Village <span class="text-star">*</span>
                          </td>
                          <td>
                            <input
                              class="form-control form-control-sm mb-2"
                              type="text"
                              name="company_name"
                              v-model="companyVillageMandatory"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="align-top" style="min-width: 100px">
                            Zip Code <span class="text-star">*</span>
                          </td>
                          <td>
                            <input
                              class="form-control form-control-sm mb-2"
                              type="text"
                              name="company_name"
                              v-model="companyZipMandatory"
                              @keypress="isNumber($event)"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="align-top">
                            Address <span class="text-star">*</span>
                          </td>
                          <td>
                            <textarea
                              class="form-control form-control-sm mb-2"
                              type="text"
                              name="company_name"
                              v-model="companyAddressMandatory"
                              style="height: 80px; resize: none"
                            ></textarea>
                          </td>
                        </tr>
                        <tr>
                          <td>Phone</td>
                          <td>
                            <input
                              class="form-control form-control-sm"
                              type="text"
                              name="company_name"
                              v-model="companyPhoneMandatory"
                              @keypress="isNumber($event)"
                            />
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <table style="width: 100%">
                        <tr>
                          <th colspan="3" class="py-2">
                            <h5>Company Person In Charge (PIC)</h5>
                          </th>
                        </tr>
                        <tr>
                          <td>Name <span class="text-star">*</span></td>
                          <td>
                            <input
                              class="form-control form-control-sm mb-2"
                              type="text"
                              name="company_name"
                              v-model="picNameMandatory"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>Phone<span class="text-star">*</span></td>
                          <td>
                            <input
                              class="form-control form-control-sm mb-2"
                              type="text"
                              name="company_name"
                              v-model="picPhoneMandatory"
                              @keypress="isNumber($event)"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>Email<span class="text-star">*</span></td>
                          <td>
                            <input
                              class="form-control form-control-sm mb-2"
                              type="text"
                              name="company_name"
                              v-model="picEmailMandatory"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>Position</td>
                          <td>
                            <input
                              class="form-control form-control-sm mb-2"
                              type="text"
                              name="company_name"
                              v-model="picPositionMandatory"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>Division</td>
                          <td>
                            <input
                              class="form-control form-control-sm"
                              type="text"
                              name="company_name"
                              v-model="picDivisionMandatory"
                            />
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              v-if="loadingButtonProcess == false"
              @click="submitMandatoryField"
            >
              Save & Process
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled=""
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" /> Save &
              Process
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalProcess -->
    <div class="modal fade" id="modalProcess" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Process Order</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>
              Are you sure to process order ID {{ orderCode }} by
              {{ companyName }} ?
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="updateStatus('Process')"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalQuotation -->
    <div class="modal fade" id="modalQuotation" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Send Quotation</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>
              Are you sure to send quotation of order ID {{ orderCode }} to
              {{ companyName }} ?
            </p>
            <div class="one-line">
              <div class="ol-label-time">Time</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <date-picker
                  v-model="sendQuotationDate"
                  type="datetime"
                  format="DD-MM-YYYY HH:mm"
                  placeholder="Select Date and Time"
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="updateStatus('Quotation')"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalRenewQuotation" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Renew Quotation</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="one-line">
              <div class="ol-label-time">Time</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <date-picker
                  v-model="renewQuotationDate"
                  type="datetime"
                  format="DD-MM-YYYY HH:mm"
                  placeholder="Select Date and Time"
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="updateStatus('RenewQuotation')"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalProcessAgreement" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Process Agreement</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="one-line">
              <label class="ol-label"> Option</label>
              <label class="ol-titik2">:</label>
              <select
                class="form-control form-control-sm"
                v-model="chooseAgreementStatus"
              >
                <option value="1">Agreement Accepted</option>
                <option value="2">Renew Agreement</option>
              </select>
            </div>
            <div class="one-line">
              <div class="ol-label-time">Time</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <input
                  type="datetime-local"
                  class="form-control form-control-sm"
                  name="datepaid"
                  v-model="processAgreementDate"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="sendAgreement('process')"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalProcessInvoice" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Process Invoice</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="one-line">
              <label class="ol-label"> Option</label>
              <label class="ol-titik2">:</label>
              <select
                class="form-control form-control-sm"
                v-model="chooseInvoiceStatus"
              >
                <option value="1">Accepted Invoice</option>
                <option value="2">Resend Invoice</option>
              </select>
            </div>
            <div class="one-line">
              <div class="ol-label-time">Time</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <date-picker
                  v-model="processInvoiceDate"
                  type="datetime"
                  format="DD-MM-YYYY HH:mm"
                  placeholder="Select Date and Time"
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="sendInvoice('process')"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalReject -->
    <div class="modal fade" id="modalPrepare" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Prepare Product</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure to prepare all products?</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="cekStatusOrder('Prepare')"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalReject -->
    <div class="modal fade" id="modalDeliver" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Deliver</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <input
              type="checkbox"
              name=""
              v-model="ceklistDeliver"
              :value="1"
            />
            The devices' physical condition have been cheked as SOP. <br />
            <input
              type="checkbox"
              name=""
              v-model="ceklistDeliver"
              :value="2"
            />
            The devices' function have been cheked as SOP.<br />
            <br />
            <p>Are you sure send process delivery Order ID {{ orderCode }} ?</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="cekStatusOrder('Deliver')"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalReject -->
    <div class="modal fade" id="modalDeliverItem" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Deliver Item</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <input
              type="checkbox"
              name=""
              v-model="ceklistDeliver"
              :value="1"
            />
            The devices' physical condition have been cheked as SOP. <br />
            <input
              type="checkbox"
              name=""
              v-model="ceklistDeliver"
              :value="2"
            />
            The devices' function have been cheked as SOP.<br />
            <br />
            <p>Are you sure send process delivery Order ID {{ orderCode }} ?</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="cekStatusOrder('DeliverItem')"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalReject -->
    <div class="modal fade" id="modalAssignOrder" role="dialog">
      <div
        class="modal-dialog modal-dialog-centered modal-scroll"
        style="max-width: 1500px; margin-left: 15px"
      >
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header" v-if="detailOrder != ''">
            <div class="row">
              <div class="col-12">
                <h4 class="modal-title">
                  {{ detailOrder[idx].productName }} -
                  {{ detailOrder[idx].specificationsView }} ({{
                    detailOrder[idx].conditionName
                  }})
                </h4>
              </div>
              <div class="col-12" v-if="detailOrder[idx].startRent != null">
                <h5>Start Rent : {{ detailOrder[idx].startRent }}</h5>
              </div>
              <div class="col-12" v-if="detailOrder[idx].endRent != null">
                <h5>End Rent : {{ detailOrder[idx].endRent }}</h5>
              </div>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div
            class="modal-body modal-scroll"
            v-if="loadingTableAssign == false"
          >
            <div v-for="(dataPlace, idx) in alt" :key="`place-${idx}`">
              <div class="input-one-line-assign" v-if="idx == '0'">
                <div class="input-title-assign">
                  <label class="text-partnership">Point Address</label>
                  <h3>{{ dataPlace.pickupPlaceName }}</h3>
                  <h6>Pickup Schedule : {{ dataPlace.pickupSchedule }}</h6>
                </div>
                <div class="input-title-qty">
                  <label class="text-partnership">Qty</label>
                  <h3>{{ dataPlace.qty }}</h3>
                </div>
              </div>
              <div class="input-one-line-assign mt-3" v-else>
                <div class="input-title-assign">
                  <label class="text-partnership">Point Address</label>
                  <h3>{{ dataPlace.pickupPlaceName }}</h3>
                  <h6>Pickup Schedule : {{ dataPlace.pickupSchedule }}</h6>
                </div>
                <div class="input-title-qty">
                  <label class="text-partnership">Qty</label>
                  <h3>{{ dataPlace.qty }}</h3>
                </div>
              </div>
              <table class="table table-sm table-bordered">
                <tr>
                  <th style="width: 50px">Product Code</th>
                  <th style="width: 200px">Accesories</th>
                  <th style="width: 150px">Assigned By</th>
                  <th style="width: 150px">Prepared By</th>
                  <th style="width: 200px">Note</th>
                  <th style="width: 300px">Actual Specification</th>
                </tr>
                <tr v-if="loadingTableAssign == true">
                  <td colspan="5" class="text-center">
                    <img src="~@/assets/images/load-button.gif" />
                  </td>
                </tr>
                <tr
                  v-for="(data, index) in dataPlace.detailProduct"
                  :key="`placeDetail-${index}`"
                  v-else
                >
                  <td>
                    {{ data.productCode }}
                    <span v-if="data.stockCode != null">
                      <br />
                      ({{ data.stockCode }})
                    </span>
                    <span
                      v-if="data.temporary == 1"
                      class="bg-primary p-1 text-light"
                      style="border-radius: 15px; font-size: 0.9rem"
                      >Temporary</span
                    >
                  </td>
                  <td>
                    <div v-if="erpAcc.length">
                      <div
                        v-for="(item, i) in erpAcc[index]"
                        :key="item.itemName + i"
                      >
                        {{ item.itemName }}
                      </div>
                    </div>
                    <br />
                    <span
                      v-if="
                        data.officeLicense != '' && data.officeLicense != null
                      "
                      ><b>Office license : </b></span
                    >{{ data.officeLicense }}
                    <span
                      v-if="
                        data.officeLicense != '' && data.officeLicense != null
                      "
                      ><br
                    /></span>
                    <span
                      v-if="
                        data.windowsLicense != '' && data.windowsLicense != null
                      "
                      ><b>Windows license : </b></span
                    >{{ data.windowsLicense }}
                    <span
                      v-if="
                        data.windowsLicense != '' && data.windowsLicense != null
                      "
                      ><br
                    /></span>
                    <span
                      v-if="
                        data.serialNumber != '' && data.serialNumber != null
                      "
                      ><b>Serial Number : </b></span
                    >{{ data.serialNumber }}
                  </td>
                  <td>{{ data.assignedBy }}</td>
                  <td>{{ data.preparedBy }}</td>
                  <td v-if="data.status == 18">
                    Unmatched Reason : {{ data.unmatchReason }}<br />
                    <br />
                    {{ data.itemNote }}
                  </td>
                  <td
                    v-else-if="
                      data.status != 18 &&
                      dataPlace.pickupPLace == data.pickupPLace
                    "
                  >
                    {{ data.itemNote }}
                  </td>
                  <td
                    v-if="
                      (data.productType == 1 && !data.bomItem.length) ||
                      (data.productType == 2 && !data.bomItem.length)
                    "
                  >
                    <span v-if="actualSpecProcessor[index] != ''">
                      Processor : {{ actualSpecProcessor[index] }}<br
                    /></span>
                    <span v-if="actualSpecRAM[index] != ''">
                      RAM : {{ actualSpecRAM[index] }}<br
                    /></span>
                    <span v-if="actualSpecStorage[index] != ''">
                      Storage : {{ actualSpecStorage[index] }}<br
                    /></span>
                    <span v-if="actualSpecVGA[index] != ''">
                      VGA : {{ actualSpecVGA[index] }}</span
                    >
                  </td>
                  <td
                    v-if="
                      (data.productType == 1 && data.bomItem.length) ||
                      (data.productType == 2 && data.bomItem.length)
                    "
                  >
                    <span v-for="(item, index) in data.bomItem" :key="`${item.itemName}-${index}`"
                      ><div v-for="(qty, j) in item.itemQty" :key="`${item.itemName}-${index}-${j}`">
                        {{ item.itemName }}
                      </div></span
                    >
                  </td>
                  <td v-if="data.productType == 3">
                    <span v-if="actualSpecProcessor[index] != ''">
                      Size : {{ actualSpecProcessor[index] }}<br
                    /></span>
                    <span v-if="actualSpecRAM[index] != ''">
                      Type : {{ actualSpecRAM[index] }}<br
                    /></span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="modal-body" v-else>
            <div class="input-one-line-assign">
              <div class="input-title-assign">
                <label class="text-partnership">Partnership</label>
                <h3><img src="~@/assets/images/load-button.gif" /></h3>
              </div>
              <div class="input-title-qty">
                <label class="text-partnership">Qty</label>
                <h3><img src="~@/assets/images/load-button.gif" /></h3>
              </div>
            </div>
            <table class="table table-sm table-bordered">
              <tr>
                <th>Product Code</th>
                <th>Accesories</th>
                <th>By</th>
                <th>Note</th>
              </tr>
              <tr v-if="loadingTableAssign == true">
                <td colspan="5" class="text-center">
                  <img src="~@/assets/images/load-button.gif" />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalReject -->
    <div class="modal fade" id="modalStartRent" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Start Rent</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>Start Rent Order ID {{ orderId }} by {{ companyName }}?</p>
            <div class="text-center">
              <img
                src="~@/assets/images/no-image.png"
                class="img-responsive"
                id="show_img_rent"
              />
            </div>
            <input
              type="file"
              ref="file_foto"
              name="file_foto_rent"
              id="file_foto_rent"
              @change="onrentImagePicked"
            />
            <hr />
            <div class="one-line">
              <div class="ol-label">Select Start Date</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <input
                  type="date"
                  class="form-control form-control-sm"
                  name="datestart"
                  v-model="startDate"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="StartRent"
              v-if="loadingButtonProcess == false"
            >
              Start a Rent
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Start a
              Rent
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalReject -->
    <div class="modal fade" id="modalStartRentItem" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Start Rent Item</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>Start Rent Order ID {{ orderId }} by {{ companyName }}?</p>
            <div class="text-center">
              <img
                src="~@/assets/images/no-image.png"
                class="img-responsive"
                id="show_img_rent_item"
              />
            </div>
            <input
              type="file"
              ref="file_foto"
              name="file_foto_rent"
              id="file_foto_rent"
              @change="onrentImagePicked($event, 'item')"
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="updateStatusItem('StartRentItem')"
              v-if="loadingButtonProcess == false"
            >
              Start a Rent
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Start a
              Rent
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- Modal Verify-->
    <div class="modal fade" id="modalVerify" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Documents Verification</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure the documents are verified?</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="updateStatus('Verify')"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- Modal Verify-->
    <div class="modal fade" id="modalUploadLegalDocument" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Upload Legal Documents</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="one-line">
              <div class="ol-label">NPWP/SKT</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <input
                  type="file"
                  id="npwpInput"
                  name="npwpSkt"
                  @change="onFilePicked($event, 'npwp')"
                />
              </div>
            </div>
            <div
              class="one-line"
              v-if="getNPWPName != null && getNPWPName != '' && NPWPStatus == 1"
            >
              <div class="ol-label"></div>
              <div class="ol-titik2"></div>
              <div class="ol-value">
                <i class="fa fa-check-circle" aria-hidden="true"></i>
                <a
                  class="link-biru"
                  :href="NPWPUrl + '?token=' + jwt"
                  target="_blank"
                  >Lihat file</a
                >
              </div>
            </div>
            <div class="one-line" v-if="NPWPFileName != ''">
              <div class="ol-label">NPWP Number</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  name="npwpNumber"
                  v-model="inputNPWP"
                />
              </div>
            </div>
            <div class="one-line">
              <div class="ol-label">Akta</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <input
                  type="file"
                  id="aktaInput"
                  name="Akta"
                  @change="onFilePicked($event, 'akta')"
                />
              </div>
            </div>
            <div
              class="one-line"
              v-if="getAktaName != null && getAktaName != '' && aktaStatus == 1"
            >
              <div class="ol-label"></div>
              <div class="ol-titik2"></div>
              <div class="ol-value">
                <i class="fa fa-check-circle" aria-hidden="true"></i>
                <a
                  class="link-biru"
                  :href="aktaUrl + '?token=' + jwt"
                  target="_blank"
                  >Lihat file</a
                >
              </div>
            </div>
            <div class="one-line" v-if="aktaFileName != ''">
              <div class="ol-label">Address</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  name="address"
                  v-model="inputAddress"
                />
              </div>
            </div>
            <div class="one-line">
              <div class="ol-label">SIUP</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <input
                  type="file"
                  id="siupInput"
                  name="siup"
                  @change="onFilePicked($event, 'siup')"
                />
              </div>
            </div>
            <div
              class="one-line"
              v-if="getSiupName != null && getSiupName != '' && siupStatus == 1"
            >
              <div class="ol-label"></div>
              <div class="ol-titik2"></div>
              <div class="ol-value">
                <i class="fa fa-check-circle" aria-hidden="true"></i>
                <a
                  class="link-biru"
                  :href="siupUrl + '?token=' + jwt"
                  target="_blank"
                  >Lihat file</a
                >
              </div>
            </div>
            <div class="one-line">
              <div class="ol-label">KTP PIC/Director</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <input
                  type="file"
                  id="ktpInput"
                  name="ktp"
                  @change="onFilePicked($event, 'ktp')"
                />
              </div>
            </div>
            <div
              class="one-line"
              v-if="
                getKtpName != null && getKtpName != '' && companyKTPStatus == 1
              "
            >
              <div class="ol-label"></div>
              <div class="ol-titik2"></div>
              <div class="ol-value">
                <i class="fa fa-check-circle" aria-hidden="true"></i>
                <a
                  class="link-biru"
                  :href="companyKTPUrl + '?token=' + jwt"
                  target="_blank"
                  >Lihat file</a
                >
              </div>
            </div>
            <div class="one-line" v-if="KTPFileName != ''">
              <div class="ol-label">KTP Number</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  @keypress="isNumber($event)"
                  name="ktpNumber"
                  v-model="inputKTP"
                />
              </div>
            </div>
            <div class="one-line">
              <div class="ol-label">SK Menkumham</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <input
                  type="file"
                  id="skmInput"
                  name="skm"
                  @change="onFilePicked($event, 'skm')"
                />
              </div>
            </div>
            <div
              class="one-line"
              v-if="
                getSKMName != null && getSKMName != '' && companySKMStatus == 1
              "
            >
              <div class="ol-label"></div>
              <div class="ol-titik2"></div>
              <div class="ol-value">
                <i class="fa fa-check-circle" aria-hidden="true"></i>
                <a
                  class="link-biru"
                  :href="companySKMUrl + '?token=' + jwt"
                  target="_blank"
                  >Lihat file</a
                >
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="uploadLegalDoc()"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- Modal Verify-->
    <div class="modal fade" id="modalUploadPurchase" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Upload Purchase Order</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="one-line">
              <div class="ol-label">Purchase Order</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <input
                  type="file"
                  id="purchaseInput"
                  name="npwpSkt"
                  @change="onFilePicked($event, 'purchase')"
                />
              </div>
            </div>
            <div class="one-line">
              <div class="ol-label">PO Number</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <input
                  type="text"
                  name="poNumber"
                  v-model="poNumberInput"
                  class="form-control form-control-sm"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="uploadPurchaseOrder()"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- Modal Agreement-->
    <div class="modal fade" id="modalSendAgreement" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Send Agreement</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure to send agreement to {{ userName }}?</p>
            <div class="one-line">
              <div class="ol-label-time">Time</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <date-picker
                  v-model="sendAgreementDate"
                  type="datetime"
                  format="DD-MM-YYYY HH:mm"
                  placeholder="Select Date and Time"
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="sendAgreement('send')"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- Modal Invoice-->
    <div class="modal fade" id="modalSendInvoice" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Send Invoice</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>
              Are you sure want to send invoice of order ID {{ orderCode }} ?
            </p>
            <div class="one-line">
              <div class="ol-label-time">Time</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <date-picker
                  v-model="sendInvoiceDate"
                  type="datetime"
                  format="DD-MM-YYYY HH:mm"
                  placeholder="Select Date and Time"
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="sendInvoice('send')"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- Modal Invoice-->
    <div class="modal fade" id="modalKeepCurrentInvoice" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Keep Current Invoice</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure to keep current invoice?</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="sendInvoiceExtend('keep')"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- Modal Paid-->
    <div class="modal fade" id="modalPaid" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Paid Invoice</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure the deposit already paid?</p>
            <div class="one-line">
              <div class="ol-label">Select Invoice Paid</div>
              <div class="ol-titik2">:</div>
              <div class="ol-value">
                <date-picker
                  v-model="paidDate"
                  type="datetime"
                  format="DD-MM-YYYY HH:mm:ss"
                  placeholder="Select Date and Time"
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="updateStatus('Paid')"
              v-if="orderExtendFrom.orderId == ''"
              :disabled="
                loadingButtonProcess == true && orderExtendFrom.orderId == ''
              "
            >
              <img
                src="~@/assets/images/2.gif"
                style="height: 18px"
                v-if="
                  loadingButtonProcess == true && orderExtendFrom.orderId == ''
                "
              />Yes, Sure
            </button>
            <!-- Extend -->
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="invoicePaidExtend"
              v-if="orderExtendFrom.orderId != ''"
              :disabled="
                loadingButtonProcess == true && orderExtendFrom.orderId != ''
              "
            >
              <img
                src="~@/assets/images/2.gif"
                style="height: 18px"
                v-if="
                  loadingButtonProcess == true && orderExtendFrom.orderId != ''
                "
              />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalAssignto -->
    <div class="modal fade" id="modalAssignTo" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">
                {{ productNameAssignTo }} ({{ conditionNameModal }})
              </h4>
              <h5 class="modal-title">{{ specModalAssignTo }}</h5>
              <h6>Total Qty : {{ maxQty }}</h6>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div v-if="dataItem == ''" class="text-center">
              <img src="~@/assets/images/load-button.gif" />
            </div>
            <div v-else>
              <div v-for="(dataP, idx) in dataItem" :key="idx">
                <div class="title-product">
                  {{
                    getNameAssignto(
                      dataP.productName,
                      dataP.conditionName,
                      dataP.specificationsView
                    )
                  }}
                </div>
                <div class="top-assignto">
                  <div class="one-line deliver-field">
                    <span class="delivery-sch"> Delivery Schedule</span>
                    <span class="delivery-titik2">:</span>
                    <div></div>
                    <input
                      type="date"
                      class="form-control"
                      name=""
                      v-model="deliveryDate[0]"
                      :min="todayDate"
                    />
                  </div>
                  <div class="input-title">
                    <label class="">&nbsp;</label>
                    <button
                      type="button"
                      class="btn btn-primary btn-icon-assign"
                      @click="addRow(plusIdx)"
                    >
                      <i class="fas fa-plus"></i> Vendor
                    </button>
                  </div>
                </div>
                <div class="top-assignto">
                  <div class="one-line deliver-field">
                    <span class="partnership-text">Point Name</span>
                    <span class="partnership-titik2">:</span>
                    <multiselect
                      v-model="assignVendor[0]"
                      :options="dataVendor"
                      label="vendorName"
                      :allow-empty="false"
                      deselect-label=""
                      select-label=""
                      style=""
                      track-by="vendorName"
                    ></multiselect>
                  </div>
                  <div class="one-line">
                    <label class="qty-assignto">Qty</label>
                    <input
                      type="text"
                      name="qty"
                      class="form-control process-qty"
                      v-model="vendorQty[0]"
                      @keypress="isNumber($event)"
                      @input="minimumcharacter(0, 'assignto')"
                    />
                  </div>
                </div>
                <div class="one-line">
                  <span class="pickup-sch"> Pickup Schedule</span>
                  <span class="delivery-titik2">:</span>
                  <input
                    type="date"
                    class="form-control mt-1 mr-1"
                    name=""
                    v-model="pickupDate[0]"
                    :min="todayDate"
                  />
                </div>
                <div
                  class="one-line"
                  v-if="
                    assignVendor[0].lessorId != null &&
                    assignVendor[0].lessorId != 4
                  "
                >
                  <span class="stPrice-sch"> Stock Price</span>
                  <span class="delivery-titik2">:</span>
                  <input
                    type="text"
                    class="form-control mt-1 mr-1"
                    name=""
                    v-model="stockPrice[0]"
                    @keypress="isNumber($event)"
                  />
                </div>
                <div
                  class=""
                  v-for="(input, index) in inputs"
                  style="margin-top: 5px"
                  :key="index"
                >
                  <hr />
                  <div class="top-assignto">
                    <div class="one-line deliver-field">
                      <span class="delivery-sch"> Delivery Schedule</span>
                      <span class="delivery-titik2">:</span>
                      <div></div>
                      <input
                        type="date"
                        class="form-control"
                        name=""
                        v-model="deliveryDate[index + 1]"
                        :min="todayDate"
                      />
                    </div>
                    <div class="input-title">
                      <label class="">&nbsp;</label>
                      <button
                        type="button"
                        class="btn btn-primary btn-icon-assign"
                        @click="removeRow(idx)"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                  <div class="top-assignto">
                    <div class="one-line deliver-field">
                      <span class="partnership-text">Point Name</span>
                      <span class="partnership-titik2">:</span>
                      <multiselect
                        v-model="assignVendor[index + 1]"
                        :options="dataVendor"
                        label="vendorName"
                        :allow-empty="false"
                        deselect-label=""
                        select-label=""
                        style=""
                        track-by="vendorName"
                      ></multiselect>
                    </div>
                    <div class="one-line">
                      <label class="qty-assignto">Qty </label>
                      <input
                        type="text"
                        name="qty"
                        class="form-control process-qty"
                        v-model="vendorQty[index + 1]"
                        @keypress="isNumber($event)"
                        @input="minimumcharacter(plusIdx, 'assignto')"
                      />
                    </div>
                  </div>
                  <div class="one-line">
                    <span class="pickup-sch"> Pickup Schedule</span>
                    <span class="delivery-titik2">:</span>
                    <input
                      type="date"
                      class="form-control mt-1 mr-1"
                      name=""
                      v-model="pickupDate[index + 1]"
                      :min="todayDate"
                    />
                  </div>
                  <div
                    class="one-line"
                    v-if="
                      assignVendor[index + 1] != null &&
                      assignVendor[index + 1].lessorId != 4
                    "
                  >
                    <span class="stPrice-sch"> Stock Price</span>
                    <span class="delivery-titik2">:</span>
                    <input
                      type="text"
                      class="form-control mt-1 mr-1"
                      name=""
                      v-model="stockPrice[index + 1]"
                      @keypress="isNumber($event)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div v-for="(data, idx) in dataItem" :key="idx" class="d-flex">
              <div
                class="pagination p8 alignRight jarak-assigto mr-1"
                v-if="buttonLessor != 'edit'"
              >
                <ul>
                  <a
                    class="is-active link"
                    @click="getAssignTo('', '', 'nextPage', currentData - 1, data.finalPrice)"
                    v-if="currentData != 1"
                    ><li>{{"<"}}</li></a
                  >
                  <a class="page"
                    ><li>{{ currentData }} of {{ totalData }} data</li></a
                  >
                  <a
                    class="is-active link"
                    @click="getAssignTo('', '', 'nextPage', currentData + 1, data.finalPrice)"
                    v-if="currentData != totalData"
                    ><li>></li></a
                  >
                </ul>
              </div>
              <button
                type="button"
                class="btn btn-danger btn-sm mr-1"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <!-- EDIT LESSOR  -->
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="submitAssignTo(data.productId, 1, 'edit', data.finalPrice)"
                v-if="
                  loadingButtonProcess == false &&
                  (buttonLessor == 'edit' || dataItemVendor != '')
                "
              >
                Save
              </button>
              <!-- SAVE LESSOR -->
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="submitAssignTo(data.productId, currentData + 1, 'save', data.finalPrice)"
                v-else-if="
                  loadingButtonProcess == false && currentData != totalData
                "
              >
                Save
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="submitAssignTo(data.productId, 1, 'save', data.finalPrice)"
                v-else-if="
                  loadingButtonProcess == false &&
                  currentData == totalData &&
                  buttonLessor != 'edit'
                "
              >
                Save
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                disabled
                v-else
              >
                <img src="~@/assets/images/2.gif" style="height: 18px" />Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- Modal Edit-->
    <div class="modal fade" id="modalRemarks" role="dialog">
      <div class="modal-dialog modal-dialog-centered" style="max-width: 1100px">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Remarks</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="card" style="border: none">
              <div class="card-body" style="padding: 0px">
                <table class="fixed_header table-bordered table-striped">
                  <tbody class="full-width">
                    <tr>
                      <th style="min-width: 150px">When</th>
                      <th style="min-width: 500px">What</th>
                      <th>Who</th>
                    </tr>
                    <tr v-if="dataRemarks.length == 0">
                      <td colspan="3">Tidak ada Log</td>
                    </tr>
                    <tr v-else v-for="(data, i) in dataRemarks" :key="i" >
                      <td>{{ data.time }}</td>
                      <td>{{ data.text }}</td>
                      <td>{{ data.ids }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            Note
            <input
              type="text"
              class="form-control-sm form-control"
              v-model="remarksNote"
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitRemarks"
              v-if="loadingButtonProcess == false"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- MODAL DOCUMENTS -->
    <!-- Modal DocPending-->
    <div class="modal fade" id="modalDocPending" role="dialog">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Document {{ docPilih }}</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <h5>History Documents</h5>
              <table class="table table-sm table-bordered">
                <tr>
                  <th>Status</th>
                  <th>Submit Date</th>
                  <th>Submit By</th>
                  <th>Action Date</th>
                  <th>Action By</th>
                  <th>Note</th>
                  <th>Files</th>
                </tr>
                <tr v-if="loadingTableDoc == true">
                  <td colspan="7" class="text-center">
                    <img src="~@/assets/images/load-button.gif" />
                  </td>
                </tr>
                <tr
                  v-else-if="loadingTable == false && historyDocData != ''"
                  v-for="(data,i) in historyDocData"
                  :key="i"
                >
                  <td v-if="data.docStatus == 0">Pending</td>
                  <td v-if="data.docStatus == 1">Approve</td>
                  <td v-if="data.docStatus == 2">Rejected</td>
                  <td>{{ data.submitDate }}</td>
                  <td>{{ data.submitBy }}</td>
                  <td>
                    <span v-if="data.docStatus != 0">{{
                      data.actionDate
                    }}</span>
                  </td>
                  <td>{{ data.actionBy }}</td>
                  <td>{{ data.note }}</td>
                  <td>
                    <a :href="data.docUrl + '?token=' + jwt" target="_blank">
                      download
                    </a>
                  </td>
                </tr>
                <tr v-else-if="loadingTable == false && historyDocData == ''">
                  <td colspan="7" class="text-center">Data Not Available</td>
                </tr>
              </table>
            </div>
            <div
              class="one-line"
              v-if="
                docPilih == 'KTP' && companyKTPStatus == 0 && docStatus != 2
              "
            >
              <label class="ol-label"> ID Number (KTP) </label>
              <label class="ol-titik2">:</label>
              <input
                type="text"
                class="form-control-sm form-control"
                name="ktp"
                @keypress="isNumber($event)"
                v-model="KTPNumber"
              />
            </div>
            <div
              class="one-line"
              v-if="docPilih == 'KTP' && companyKTPStatus == 0"
            >
              <label class="ol-label"> Status</label>
              <label class="ol-titik2">:</label>
              <select class="form-control form-control-sm" v-model="docStatus">
                <option value="0">None</option>
                <option value="1">Approve</option>
                <option value="2">Reject</option>
              </select>
            </div>
            <div
              class="one-line"
              v-if="docPilih == 'NPWP/SKT' && NPWPStatus == 0 && docStatus != 2"
            >
              <label class="ol-label"> NPWP Number </label>
              <label class="ol-titik2">:</label>
              <input
                type="text"
                class="form-control-sm form-control"
                name="ktp"
                @keypress="isNumber($event)"
                v-model="NpwpDocInput"
              />
            </div>
            <div
              class="one-line"
              v-if="docPilih == 'NPWP/SKT' && NPWPStatus == 0"
            >
              <label class="ol-label"> Status</label>
              <label class="ol-titik2">:</label>
              <select class="form-control form-control-sm" v-model="docStatus">
                <option value="0">None</option>
                <option value="1">Approve</option>
                <option value="2">Reject</option>
              </select>
            </div>
            <div class="one-line" v-if="docPilih == 'SIUP' && siupStatus == 0">
              <label class="ol-label"> Status</label>
              <label class="ol-titik2">:</label>
              <select class="form-control form-control-sm" v-model="docStatus">
                <option value="0">None</option>
                <option value="1">Approve</option>
                <option value="2">Reject</option>
              </select>
            </div>
            <div
              class="one-line"
              v-if="docPilih == 'SK Menkumham' && companySKMStatus == 0"
            >
              <label class="ol-label"> Status</label>
              <label class="ol-titik2">:</label>
              <select class="form-control form-control-sm" v-model="docStatus">
                <option value="0">None</option>
                <option value="1">Approve</option>
                <option value="2">Reject</option>
              </select>
            </div>
            <div
              class="one-line"
              v-if="docPilih == 'Purchase Order' && purchaseStatus == 0"
            >
              <label class="ol-label"> Status</label>
              <label class="ol-titik2">:</label>
              <select class="form-control form-control-sm" v-model="docStatus">
                <option value="0">None</option>
                <option value="1">Approve</option>
                <option value="2">Reject</option>
              </select>
            </div>
            <div
              class="one-line"
              v-if="docPilih == 'Akta' && aktaStatus == 0 && docStatus != 2"
            >
              <label class="ol-label"> Akta Address </label>
              <label class="ol-titik2">:</label>
              <input
                type="text"
                class="form-control-sm form-control"
                name="ktp"
                v-model="aktaAdressInput"
              />
            </div>
            <div class="one-line" v-if="docPilih == 'Akta' && aktaStatus == 0">
              <label class="ol-label"> Status</label>
              <label class="ol-titik2">:</label>
              <select class="form-control form-control-sm" v-model="docStatus">
                <option value="0">None</option>
                <option value="1">Approve</option>
                <option value="2">Reject</option>
              </select>
            </div>
            <div
              class="one-line"
              v-if="
                docPilih == 'SK Menkumham' &&
                companySKMStatus == 0 &&
                docStatus == 2
              "
            >
              <label class="ol-label"> Reason</label>
              <label class="ol-titik2">:</label>
              <textarea
                class="form-control form-control-sm"
                v-model="rejectReason"
              ></textarea>
            </div>
            <div
              class="one-line"
              v-if="docPilih == 'NPWP/SKT' && NPWPStatus == 0 && docStatus == 2"
            >
              <label class="ol-label"> Reason</label>
              <label class="ol-titik2">:</label>
              <textarea
                class="form-control form-control-sm"
                v-model="rejectReason"
              ></textarea>
            </div>
            <div
              class="one-line"
              v-if="docPilih == 'SIUP' && siupStatus == 0 && docStatus == 2"
            >
              <label class="ol-label"> Reason</label>
              <label class="ol-titik2">:</label>
              <textarea
                class="form-control form-control-sm"
                v-model="rejectReason"
              ></textarea>
            </div>
            <div
              class="one-line"
              v-if="
                docPilih == 'Purchase Order' &&
                purchaseStatus == 0 &&
                docStatus == 2
              "
            >
              <label class="ol-label"> Reason</label>
              <label class="ol-titik2">:</label>
              <textarea
                class="form-control form-control-sm"
                v-model="rejectReason"
              ></textarea>
            </div>
            <div
              class="one-line"
              v-if="docPilih == 'Akta' && aktaStatus == 0 && docStatus == 2"
            >
              <label class="ol-label"> Reason</label>
              <label class="ol-titik2">:</label>
              <textarea
                class="form-control form-control-sm"
                v-model="rejectReason"
              ></textarea>
            </div>
            <div
              class="one-line"
              v-if="
                docPilih == 'KTP' && companyKTPStatus == 0 && docStatus == 2
              "
            >
              <label class="ol-label"> Reason</label>
              <label class="ol-titik2">:</label>
              <textarea
                class="form-control form-control-sm"
                v-model="rejectReason"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
              v-if="docPilih == 'KTP' && companyKTPStatus == 0"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
              v-if="docPilih == 'NPWP/SKT' && NPWPStatus == 0"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
              v-if="docPilih == 'Akta' && aktaStatus == 0"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
              v-if="docPilih == 'SIUP' && siupStatus == 0"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
              v-if="docPilih == 'SK Menkumham' && companySKMStatus == 0"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
              v-if="docPilih == 'Purchase Order' && purchaseStatus == 0"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="updateDocStatus(docPilih)"
              v-if="
                docPilih == 'KTP' &&
                companyKTPStatus == 0 &&
                loadingButtonProcess == false
              "
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="updateDocStatus(docPilih)"
              v-else-if="
                docPilih == 'NPWP/SKT' &&
                NPWPStatus == 0 &&
                loadingButtonProcess == false
              "
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="updateDocStatus(docPilih)"
              v-else-if="
                docPilih == 'SIUP' &&
                siupStatus == 0 &&
                loadingButtonProcess == false
              "
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="updateDocStatus(docPilih)"
              v-else-if="
                docPilih == 'SK Menkumham' &&
                companySKMStatus == 0 &&
                loadingButtonProcess == false
              "
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="updateDocStatus(docPilih)"
              v-else-if="
                docPilih == 'Purchase Order' &&
                purchaseStatus == 0 &&
                loadingButtonProcess == false
              "
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="updateDocStatus(docPilih)"
              v-else-if="
                docPilih == 'Akta' &&
                aktaStatus == 0 &&
                loadingButtonProcess == false
              "
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else-if="loadingButtonProcess == true"
            >
              <img src="~@/assets/images/2.gif" style="height: 24px" />Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalEditInvoice" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Edit Invoice</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-sm table-borderless">
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Qty</th>
                  <th>Sub Total</th>
                </tr>
              </thead>
              <tbody v-if="loadingTableEdit == true">
                <tr>
                  <td colspan="3" class="text-center">
                    <img src="~@/assets/images/load-button.gif" />
                  </td>
                </tr>
              </tbody>
              <tbody v-for="(data, index) in dataEditInvoice" :key="index" v-else>
                <tr>
                  <td>{{ data.productName }}</td>
                  <td>{{ data.Qty }}</td>
                  <td v-if="date != '1' && invoiceTo == '1'">
                    <div class="d-flex">
                      <span class="input-group-addon">
                        <label class="label-addon-rp">Rp</label>
                      </span>
                      <input
                        type="text"
                        name=""
                        class="form-control form-control-sm"
                        @keypress="isNumber($event)"
                        @keyup="inputPriceInvoice(index, '0')"
                        @input="minimumcharacter(index, 'editInvoice')"
                        v-model="data.orderItemPrice"
                      />
                    </div>
                  </td>
                  <td v-else>
                    <div class="d-flex">
                      <div class="total-rp">Rp</div>
                      <div>{{ formatPrice(data.orderItemPrice) }}</div>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="loadingTableEdit == false">
                <tr>
                  <td colspan="2"><b>Charge</b></td>
                  <td>
                    <div class="d-flex">
                      <span class="input-group-addon">
                        <label class="label-addon-rp">Rp</label>
                      </span>
                      <input
                        type="text"
                        name=""
                        class="form-control form-control-sm"
                        @keypress="isNumber($event)"
                        @keyup="inputPriceInvoice('c', 'addition')"
                        @input="minimumcharacter('c', 'discountPrice')"
                        v-model="chargePrice"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2"><b>Discount</b></td>
                  <td>
                    <div class="d-flex">
                      <span class="input-group-addon">
                        <label class="label-addon-rp">Rp</label>
                      </span>
                      <input
                        type="text"
                        name=""
                        class="form-control form-control-sm"
                        @keypress="isNumber($event)"
                        @keyup="inputPriceInvoice('d', 'addition')"
                        @input="minimumcharacter('d', 'discountPrice')"
                        v-model="discountPrice"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2"><b>Tax</b></td>
                  <td>
                    <div class="d-flex">
                      <span class="input-group-addon">
                        <label class="label-addon-rp">Rp</label>
                      </span>
                      <input
                        type="text"
                        name=""
                        class="form-control form-control-sm"
                        @keypress="isNumber($event)"
                        @keyup="inputPriceInvoice('t', 'addition')"
                        @input="minimumcharacter('t', 'taxPrice')"
                        v-model="taxPrice"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td><b>Total</b></td>
                  <td>
                    <div class="d-flex">
                      <div class="total-rp">Rp</div>
                      <div v-if="dataEditInvoice == ''">
                        <img src="~@/assets/images/load-button.gif" />
                      </div>
                      <div v-else>{{ formatPrice(totalInvoice) }}</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="cekInputEditInvoice"
              v-if="loadingButtonProcess == false"
            >
              Edit
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else-if="loadingButtonProcess == true"
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Edit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modalReject -->
    <div class="modal fade" id="modalEditDelivery" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Edit Delivery Schedule</h4>
              <h5>
                Delivery schedule : {{ deliverSchedule }} {{ editDelivery }}
              </h5>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="one-line">
              <label class="deliver-field"> Delivery Schedule </label>
              <label class="ol-titik2">:</label>
              <input
                type="date"
                name="date"
                class="form-control form-control-sm"
                v-model="editDelivery"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitEditDelivery"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalReject -->
    <div class="modal fade" id="modalReschedule" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Reschedule</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-8">
                <input
                  type="text"
                  name="search"
                  class="form-control form-control-sm"
                  placeholder="Search"
                  v-model="searchRescheduleText"
                  @keyup.enter="searchReschedule"
                />
              </div>
              <div class="col-4">
                <button class="btn btn-primary btn-sm" @click="inputActive">
                  Update Delivery
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12" style="overflow-y: auto; max-height: 60vh">
                <table
                  class="
                    table
                    table-sm
                    table-bordered
                    table-striped
                    table-responsive-sm
                    mb-2
                    mt-2
                  "
                >
                  <thead>
                    <tr>
                      <th>Product Code</th>
                      <th>Product Name</th>
                      <th>Specification</th>
                      <th>Condition</th>
                      <th>SLA Delivery Schedule</th>
                      <th>Actual Delivery Schedule</th>
                    </tr>
                  </thead>
                  <tbody v-if="loadingTableReschedule">
                    <tr>
                      <td colspan="6" class="text-center">
                        <img src="~@/assets/images/load-button.gif" />
                      </td>
                    </tr>
                  </tbody>
                  <tbody
                    v-else-if="
                      loadingTableReschedule == false && dataAllItem != ''
                    "
                  >
                    <tr v-for="(data, index) in dataAllItem" :key="index">
                      <td>{{ data.productCode }}</td>
                      <td>{{ data.productName }}</td>
                      <td v-html="parseItemSpec.length === dataAllItem.length? parseItemSpec[index]:''" ></td>
                      <td>{{ data.condition }}</td>
                      <td v-if="!editInputDate">{{ data.deliveryDate }}</td>
                      <td v-else>
                        <input
                          type="date"
                          name="deliveryDate"
                          v-model="editDate[index].deliverySchedule"
                        />
                      </td>
                      <td v-if="!editInputDate">{{ data.actualDate }}</td>
                      <td v-else>
                        <input
                          type="date"
                          name="actualDate"
                          v-model="editDate[index].actualSchedule"
                        />
                      </td>
                    </tr>
                  </tbody>
                  <tbody
                    v-else-if="
                      loadingTableReschedule == false && dataAllItem == ''
                    "
                  >
                    <tr>
                      <td colspan="6">Data Not Available</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div v-if="editInputDate">
              <button
                type="button"
                class="btn btn-danger btn-sm"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="updateDelivery"
                v-if="loadingButtonProcess == false"
              >
                Save
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                disabled
                v-else
              >
                <img src="~@/assets/images/2.gif" style="height: 18px" />Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalReject -->
    <div class="modal fade" id="modalEditAsaniPIC" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Change ASANI Order PIC</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="one-line">
              <label class="ol-label"> Name </label>
              <label class="ol-titik2">:</label>
              <multiselect
                v-model="employeeAsaniOrder"
                :options="employeeSelect"
                label="employeeName"
                track-by="employeeName"
                :allow-empty="false"
                deselect-label="Can't remove this value"
                placeholder="Select Employee"
              ></multiselect>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
              v-if="companyStatus != 99"
            >
              Cancel
            </button>
            <button
              :disabled="!employeeAsaniOrder.id || oldPicAsani == employeeAsaniOrder.id"
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitChangePicAsani"
              v-if="!loadingButtonSave && companyStatus != 99"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else-if="loadingButtonSave && companyStatus != 99"
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalEditDepositDate -->
    <div class="modal fade" id="modalEditDepositDate" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Finance</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal" @click="cancelEditDepositDate">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="one-line">
              <label class="ol-label"> Deposit Date </label>
              <label class="ol-titik2">:</label>
              <input
                type="datetime-local"
                class="form-control"
                name="depositDate"
                v-model="selectDepositDate"
              />
            </div>
            <div v-for="(email, i) in financeEmail" :key="`financeEmail-${i}`" class="one-line">
              <label class="ol-label"> Email {{ i + 1 }} </label>
              <label class="ol-titik2">:</label>
              <div class="container">
                <div class="row align-items-center">
                  <div
                    :class="i > 0 ? 'col-lg-11 pl-0 pr-1' : 'col-lg-12 px-0'"
                  >
                    <input
                      type="text"
                      :class="{ 'form-control': true,'border-red' : errorFinanceEmail.indexOf(financeEmail[i]) !== -1}"
                      name="depositDate"
                      v-model="financeEmail[i]"
                    />
                  </div>
                  <div class="col-lg-1 px-0" v-if="i !== 0">
                    <button
                      @click="deleteFinanceEmail(financeEmail[i])"
                      class="btn btn-secondary btn-sm py-1 w-100"
                    >
                      -
                    </button>
                  </div>
                </div>
                <p v-if="errorFinanceEmail.indexOf(financeEmail[i]) !== -1" class="text-danger m-0 p-0" style="transform: translateX(-16px); font-size: 12px">Email is not valid</p>
              </div>
            </div>
            <div class="one-line">
              <label class="ol-label">
                Email {{ financeEmail.length + 1 }}
              </label>
              <label class="ol-titik2">:</label>
              <div class="container">
                <div class="row align-items-center">
                  <div class="col-lg-11 pl-0 pr-1">
                    <input
                      type="text"
                      :class="{ 'form-control': true,'border-red' : errorAddFinanceEmail}"
                      name="depositDate"
                      v-model="addFinanceEmail"
                    />
                  </div>
                  <div class="col-lg-1 px-0">
                    <button
                      @click="addMoreFinanceEmail"
                      class="btn btn-secondary btn-sm py-1 w-100"
                    >
                      +
                    </button>
                  </div>
                </div>
                <p v-if="errorAddFinanceEmail" class="text-danger m-0 p-0" style="transform: translateX(-16px); font-size: 12px">Email is not valid</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
              @click="cancelEditDepositDate"
              v-if="companyStatus != 99"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitChangeDepositDate"
              v-if="!loadingButtonSave && companyStatus != 99"
              :disabled="allEmailFilled == false"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else-if="loadingButtonSave && companyStatus != 99"
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalEditCompany -->
    <div class="modal fade" id="modalEditPIC" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Edit Company Person In Charge (PIC)</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="one-line">
              <label class="ol-label"> Name </label>
              <label class="ol-titik2">:</label>
              <multiselect
                v-model="choosePic"
                :options="lesseeSelect"
                label="lesseeName"
                track-by="lesseeName"
                :allow-empty="false"
                deselect-label="Can't remove this value"
                placeholder="Select Lessee PIC"
              ></multiselect>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              :disabled="!choosePic.lesseeId|| oldPic == choosePic.lesseeId"
              @click="submitEditPic"
              v-if="loadingButtonSave == false"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <div class="modal fade" id="modalGenerateQuotation" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Generate Quotation</h4>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div style="margin: 0 5%; margin-top: 20px">
              <div class="one-line">
                <div class="ol-label">Date</div>
                <div class="ol-titik2">:</div>
                <div class="ol-value">
                  <date-picker
                    v-model="generatQuotationDate"
                    type="date"
                    format="DD-MM-YYYY"
                    placeholder="Select Date"
                    style="width: 30%"
                  ></date-picker>
                </div>
              </div>
              <div class="one-line">
                <div class="ol-label">Client PIC</div>
                <div class="ol-titik2">:</div>
                <div class="ol-value" style="display: flex">
                  <multiselect
                    style="width: 93%"
                    v-model="mrMrsSelected"
                    :options="mrMrsSelect"
                    :allow-empty="false"
                    deselect-label=""
                    placeholder="Select One"
                    select-label=""
                  ></multiselect>
                  <input
                    type="text"
                    name="role"
                    class="form-control ml-1"
                    v-model="clientPicName"
                    placeholder="Client PIC Name"
                  />
                </div>
              </div>
              <div class="one-line">
                <div class="ol-label">Asani PIC</div>
                <div class="ol-titik2">:</div>
                <div class="ol-value" style="display: flex">
                  <multiselect
                    v-model="quotaionEmployeeSelect"
                    :options="employeeSelect"
                    label="employeeName"
                    :allow-empty="false"
                    deselect-label=""
                    placeholder="Select One"
                    select-label=""
                    track-by="employeeName"
                  ></multiselect>
                  <label style="margin: 7px 5px"> as </label>
                  <input
                    type="text"
                    name="role"
                    class="form-control ml-1"
                    v-model="quotationEmployeePosition"
                    placeholder="Asani PIC Position"
                  />
                </div>
              </div>
              <div class="one-line">
                <div class="ol-label">No SPH</div>
                <div class="ol-titik2">:</div>
                <div class="ol-value">
                  <input
                    type="text"
                    name="role"
                    class="form-control"
                    v-model="quotationSphNumber"
                    placeholder="SPH number"
                  />
                </div>
              </div>
              <div class="one-line">
                <div class="ol-label">Deposit Fee</div>
                <div class="ol-titik2">:</div>
                <div class="ol-value">
                  <multiselect
                    v-model="quotationDefositFee"
                    :options="defositFeeSelect"
                    :allow-empty="false"
                    deselect-label=""
                    placeholder="Select One"
                    select-label=""
                  ></multiselect>
                </div>
              </div>
              <div class="one-line">
                <div class="ol-label">Version</div>
                <div class="ol-titik2">:</div>
                <div class="ol-value">
                  <multiselect
                    v-model="versionSelected"
                    :options="versionSelect"
                    :allow-empty="false"
                    label="version"
                    deselect-label=""
                    placeholder="Select One"
                    select-label=""
                    @input="quotationTypeValidate"
                  ></multiselect>
                </div>
              </div>
              <div class="one-line">
                <div class="ol-label">Type</div>
                <div class="ol-titik2">:</div>
                <div class="ol-value">
                  <multiselect
                    v-model="typeSelected"
                    :options="typeSelect"
                    :allow-empty="false"
                    deselect-label=""
                    placeholder="Select One"
                    select-label=""
                  ></multiselect>
                </div>
              </div>
              <table
                class="
                  table
                  table-sm
                  table-bordered
                  table-striped
                  table-responsive-sm
                  payment
                "
              >
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Condition</th>
                    <th>Qty</th>
                    <th>Duration</th>
                    <th>
                      <span v-if="typeSelected == 'Promo'"
                        >Normal Price/Unit/Month</span
                      >
                      <span v-else>Price/Unit/Month</span>
                    </th>
                    <th v-if="typeSelected == 'Promo'">
                      Promo Price/Unit/Month
                    </th>
                  </tr>
                </thead>
                <tbody v-if="dataQuotation == ''">
                  <tr>
                    <td colspan="6" class="text-center">Data Not Available</td>
                  </tr>
                </tbody>
                <tbody v-else-if="dataQuotation != ''">
                  <tr v-for="(data, index) in dataQuotation" :key="index">
                    <td>
                      {{ data.productTitle }} <br />
                      {{ data.specificationsView }}
                    </td>
                    <td>
                      {{ data.condition }}
                    </td>
                    <td>
                      {{ data.qty }}
                    </td>
                    <td>
                      {{ data.orderItemDuration }}
                    </td>
                    <td>Rp {{ formatPrice(data.itemPrice) }}</td>
                    <td v-if="typeSelected == 'Promo'">
                      <input
                        type="text"
                        v-model="promoPrice[index]"
                        @keypress="isNumber($event)"
                        @input="inputPriceQuotation(promoPrice[index], index)"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="downloadQuotation"
              class="btn btn-primary btn-sm"
              v-if="!loadingDownloadQuotation"
            >
              Download
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Download
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- modalReject -->
    <div class="modal fade" id="modalUpdateProduct" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Update Products</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure want to update products?</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitUpdateProduct"
              v-if="orderExtendFrom.orderId == ''"
              :disabled="
                loadingButtonProcess == true && orderExtendFrom.orderId == ''
              "
            >
              <img
                src="~@/assets/images/2.gif"
                style="height: 18px"
                v-if="
                  loadingButtonProcess == true && orderExtendFrom.orderId == ''
                "
              />
              Yes, Sure
            </button>
            <!-- extend -->
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitUpdateProductExtend"
              v-if="orderExtendFrom.orderId != ''"
              :disabled="
                loadingButtonProcess == true && orderExtendFrom.orderId != ''
              "
            >
              <img
                src="~@/assets/images/2.gif"
                style="height: 18px"
                v-if="
                  loadingButtonProcess == true && orderExtendFrom.orderId != ''
                "
              />
              Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- Modal Edit-->
    <div class="modal fade" id="modalRemoveItemExtend" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Delete Product</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure to delete product {{ deleteProductName }} ?</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="deleteOrderItemExtend"
              v-if="loadingButtonProcess == false"
            >
              Yes, Sure
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Yes, Sure
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
    <!-- endModal -->
    <!-- modalReject -->
    <div class="modal fade" id="modalSetReturn" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Set Return Schedule</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="one-line">
              <label class="rs-schedule" style="width: 150px">
                Return Schedule
              </label>
              <label class="rs-ol-titik2">:</label>
              <date-picker
                style="
                  width: 100%;
                  height: 40px;
                  font-size: 16px;
                  margin-bottom: 4px;
                "
                v-model="returnScheduleForm"
                :disabled-date="notBeforeToday"
                value-type="YYYY-MM-DD HH:mm:00.0"
                type="datetime"
                format="DD-MM-YYYY HH:mm"
                placeholder="Select Date and Time"
              ></date-picker>
            </div>
            <div class="one-line">
              <label class="rs-lessee" style="width: 150px"> Lessee PIC </label>
              <label class="rs-ol-titik2">:</label>
              <multiselect
                v-model="returnScheduleEmployee"
                :options="returnEmployeeSelect"
                label="lesseeName"
                track-by="lesseeName"
                :allow-empty="false"
                deselect-label="Can't remove this value"
                placeholder="Select Employee"
              ></multiselect>
            </div>
            <div class="one-line" style="margin-top: 10px">
              <label class="rs-po" style="width: 150px"> PO Number </label>
              <label class="rs-ol-titik2">:</label>
              <input
                type="text"
                name="note"
                class="form-control"
                v-model="returnPONumber"
              />
            </div>
            <br />
            <div>
              <table class="fixed_header table-bordered table-striped">
                <tbody class="full-width">
                  <tr>
                    <th style="min-width: 300px">Product Name</th>
                    <th style="min-width: 100px">Serial Number</th>
                    <th style="min-width: 100px">Product Code</th>
                    <th>
                      Check All <input type="checkbox" v-model="selectAll" />
                    </th>
                  </tr>
                  <tr v-for="(data,i) in returnDetail" :key="i">
                    <td>{{ data.productTitle }}</td>
                    <td>{{ data.serialNumber }}</td>
                    <td>{{ data.orderCode }}</td>
                    <td>
                      <input
                        type="checkbox"
                        :value="data.orderDetailsId"
                        v-model="checkedItems"
                        :checked="data.checked"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-danger btn-sm"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="setReturnSchedule"
                v-if="loadingButtonProcess == false"
              >
                Set
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                disabled
                v-else
              >
                <img src="~@/assets/images/2.gif" style="height: 18px" />Set
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- modalReject -->
    </div>
    <ModalEditTag
        @get-order-tags="getData"
        @req-close="onReqCloseModal"
        :companyId="parseInt(companyId)"
        :orderId="parseInt(orderId)"
        :action="orderTagAction"
        :isOpen="isOpenTagModal"
        :orderData="{
          orderId: Number(orderId),
          startRent: null,
          duration: 0,
          ltCode: ltCode
        }"
      />
    <!-- MODAL EDIT PRIORITY  -->
    <ModalOrderPriorityTag 
      :statusOptionList="orderPriorityOptions" 
      :orderId="orderId" 
      :getData="getData"
      :orderPriority="orderPriority"
      :onChangeOrderPriority="handleOnChangeOrderPriority"
      :employeeList="employeeSelect"
    />
  </div>
</template>


<script>
import swal from "sweetalert";
import Swal from "sweetalert2";
import SideBar from "../SideBar";
import Multiselect from "vue-multiselect";
import moment from "moment";
import "vue-multiselect/dist/vue-multiselect.min.css";
import DatePicker from "vue2-datepicker";
import UploadBast from "./UploadBast.vue";
// import 'vue2-datepicker/index.css';
import { Money } from "v-money";
import ModalEditTag from "./CustomComponent/ModalEditInvoiceTag.vue";
import validateMixin from '../../mixins/validate'
import ModalOrderPriorityTag from "./CustomComponent/ModalOrderPriorityTag.vue";
import ModalBASTHistory from "./CustomComponent/BAST/ModalBASTHistory.vue";
import ActionDownloadSPH from "./CustomComponent/Action/DownloadSPH"
import DealOwnerSection from "./CustomComponent/DealOwnerSection.vue";
import { permissionMixin } from '@/components/Permissions'

export default {
  name: "OrderDetailPage",
  mixins: [validateMixin, permissionMixin],
  components: {
    SideBar,
    Multiselect,
    DatePicker,
    Money,
    UploadBast,
    ModalEditTag,
    ModalOrderPriorityTag,
    ModalBASTHistory,
    ActionDownloadSPH,
    DealOwnerSection,
  },
  data() {
    return {
      isOpenTagModal: false,
      orderTagAction:'nextStep',
      spaceRegex : /[\u00A0\uFEFF\u202F]/g,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
      showEditModal: 0,
      countShowEditModal: 0,
      editModalClicked: false,
      financeEmail: [""],
      financeEmailInfo: [""],
      addFinanceEmail: "",
      allEmailFilled: false,
      loadingBtnReturn: false,
      returnSchedule: "",
      returnScheduleForm: "",
      returnScheduleEmployee: "",
      returnPONumber: "",
      returnEmployeeSelect: [],
      checkedItems: [],
      returnDetail: [],
      jwt: localStorage.getItem("jwt"),
      dayStr: ["7", "1", "2", "3", "4", "5", "6"],
      dateX: "2018-06-01",
      companyStatus: "",
      searchRescheduleText: "",
      dataAllItem: [],
      alt: [],
      editDate: [],
      editInputDate: false,
      generate: false,
      loadingDownload: false,
      loadingDownloadQuotation: false,
      province: [],
      kecamatan: [],
      kabkot: [],
      picNameMandatory: "",
      picEmailMandatory: "",
      picPhoneMandatory: "",
      picDivisionMandatory: "",
      picPositionMandatory: "",
      companyZipMandatory: "",
      companyCityMandatory: "",
      companyNameMandatory: "",
      companyPhoneMandatory: "",
      companyAddressMandatory: "",
      companyVillageMandatory: "",
      companyDistrictMandatory: "",
      companyProvinceMandatory: "",
      nextStepFill: false,
      idxcompany: 0,
      companySuggestion: [],
      NpwpDocInput: "",
      aktaAdressInput: "",
      existingValue: "",
      companySelect: [],
      newCompany: true,
      existingCompany: true,
      durationBefore: "",
      conditionBefore: "",
      timePaid: "",
      addNote: "",
      editNote: "",
      itemDeliverReplace: 0,
      itemStartReplace: 0,
      remarksNote: "",
      dataRemarks: [],
      startDate: "",
      paidDate: "",
      sendQuotationDate: "",
      renewQuotationDate: "",
      sendInvoiceDate: "",
      processInvoiceDate: "",
      sendAgreementDate: "",
      processAgreementDate: "",
      ceklistDeliver: [],
      route: "",
      inputReason: "",
      rejectReasonOrder: "",
      dataOrder: [],
      columns: ["companyName", "orderID"],
      totalPage: 0,
      totalData: 0,
      currentData: 1,
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editOrderPriority : false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      loadingButtonProcess: false,
      loadingButtonProcessNo: false,
      loadingTable: true,
      loadingTableBast: false,
      loadingTableAssign: false,
      loadingStatusKTP: true,
      loadingStatusSKM: true,
      loadingStatusPurchase: true,
      loadingStatusNPWP: true,
      loadingStatusSiup: true,
      loadingStatusAkta: true,
      loadingTableDoc: false,
      loadingTableEdit: false,
      loadingExport: false,
      loadingButtonExecute: false,
      loadingRenderProductDetail: false,
      loadingDetail: false,
      productNameAssignTo: "",
      orderId: "",
      companyName: "",
      companyProvince: "",
      companyVillage: "",
      companyCity: "",
      companyZip: "",
      companyDistrict: "",
      companyAddress: "",
      companyPhone: "",
      companyNPWP: "",
      companyNPWP16: "",
      companyNPWP22: "",
      aktaAddress: "",
      picId: "",
      userName: "",
      companyKtpPassport: "",
      citizenship: "",
      userPhone: "",
      userEmail: "",
      userPosition: "",
      userDivision: "",
      statusOrder: "",
      KTPNumber: "",
      docStatus: 0,
      companyKTPStatus: 0,
      companySKMStatus: 0,
      companyKTPUrl: "",
      companySKMUrl: "",
      NPWPStatus: 0,
      siupStatus: 0,
      aktaStatus: 0,
      purchaseStatus: 0,
      NPWPUrl: "",
      aktaUrl: "",
      siupUrl: "",
      purchaseUrl: null,
      rejectReason: "",
      userId: "",
      companyId: "",
      admin: "",
      inputs: [],
      lengthInput: "",
      assignDeposit: 0,
      productOrder: [],
      Deposit: 0,
      docPilih: "",
      assignVendor: [
        {
          lessorId: "",
          vendorId: "",
          vendorName: "Select Supplier",
        },
      ],
      vendorQty: ["0"],
      pickupDate: [],
      stockPrice: [],
      dataVendor: [],
      assignQty: [],
      rentImageFileName: "",
      rentImageFile: "",
      rentImageUrl: "",
      rentImageBase64: "",
      companyInfo: [],
      picInfo: [],
      detailOrder: [],
      detailOrderDeliver: [],
      detailOrderReplace: [],
      dataPayment: [],
      historyOrder: [],
      detailAssign: [],
      detailAssignPlace: [],
      historyDocData: [],
      dataEditInvoice: [],
      totalPrice: 0,
      idx: 0,
      productRenting: 0,
      adminId: "",
      assignProductName: "",
      deleteProductName: "",
      deleteQty: "",
      deleteProductId: "",
      editProductName: "",
      editProductType: "",
      editProductId: "",
      companyLogoUrl: "",
      orderStatus: 0,
      detailProductBrand: "",
      detailProductModel: "",
      detailProductScreen: "",
      detailProductProcessor: "",
      detailProductRAM: "",
      detailProductStorage: "",
      detailProductVGA: "",
      detailProductActualProcessor: "",
      detailProductActualRAM: "",
      detailProductActualStorage: "",
      detailProductActualVGA: "",
      detailProductDisplaySize: "",
      detailProductDisplayType: "",
      detailProductPortVGA: "",
      detailProductPortHDMI: "",
      detailProductPortDvid: "",
      detailProductFeature: "",
      detailProductColorTech: "",
      typePilih: 0,
      companyId: "",
      selectedDetailOrder: {},
      productCategory: {
        type: "",
        catalogType: "Choose Product Category",
      },
      pilihProduct: {
        catalogName: "Choose Product",
        catalogId: "",
      },
      pilihVarian: {
        specification: "Choose Varian",
        catalogId: 0,
      },
      pilihDurasi: {
        tenorValue: 0,
        tenorMonths: "Choose Duration",
        tenorPrice: 0,
      },
      productCategoryAdd: {
        catalogType: "Choose Product Category",
        type: "",
        product: [],
      },
      pilihVarianAdd: {
        specification: "Choose Varian",
        catalogId: "",
      },
      pilihProductAdd: {
        catalogName: "Choose Product",
        catalogId: "",
        price: [],
      },
      pilihDurasiAdd: {
        tenorValue: 0,
        tenorMonths: "Choose Duration",
        tenorPrice: 0,
      },
      conditionChoosedAdd: {
        condition: "Choose Condition",
      },
      conditionChoosed: {
        condition: "Choose Condition",
      },
      selectDepositDate: "",
      selectCondition: [],
      addQty: 0,
      editQty: 0,
      editQtyBefore: 0,
      typeCatalog: [],
      tenorProduct: [],
      septianCategory: [],
      septianProduct: [],
      septianDuration: [],
      productIdOld: 0,
      dataItem: [],
      dataAllItemBast: [],
      dataItemVendor: [],
      maxQty: 0,
      plusIdx: 0,
      paymentId: "",
      subTotalInvoice: [],
      totalInvoice: 0,
      chargePrice: 0,
      taxPrice: "0",
      discountPrice: "0",
      date: "0",
      invoiceTo: 0,
      deliverSchedule: "",
      editDelivery: "",
      deliveryDate: [""],
      todayDate: "",
      orderCode: "",
      companyIdDetail: "",
      selectProductName: [],
      selectProductVarian: [],
      selectProductDuration: [],
      picProcess: "",
      quotationCount: null,
      quotationStatus: null,
      agreementCount: null,
      agreementStatus: "",
      invoiceCount: null,
      invoiceStatus: "",
      invoiceDepoStatus: "",
      chooseAgreementStatus: "1",
      chooseInvoiceStatus: "1",
      NPWPFileName: "",
      NPWPFile: "",
      NPWPUrl: "",
      NPWPBase64: "",
      SIUPFileName: "",
      SIUPFile: "",
      SIUPUrl: "",
      SIUPBase64: "",
      SKMFileName: "",
      SKMFile: "",
      SKMUrl: "",
      SKMBase64: "",
      aktaFileName: "",
      aktaFile: "",
      aktaUrl: "",
      aktaBase64: "",
      KTPFileName: "",
      KTPFile: "",
      KTPUrl: "",
      KTPBase64: "",
      purchaseFileName: "",
      purchaseFile: "",
      purchaseOrderUrl: "",
      purchaseBase64: "",
      invoiceTime: null,
      depositDate: "",
      quotationTime: null,
      inputAddress: "",
      inputKTP: "",
      inputNPWP: "",
      docApprove: 0,
      docApproveBefore: false,
      handoverUrl: "",
      sphUrl: "",
      actualSpecProcessor: [],
      actualSpecRAM: [],
      actualSpecStorage: [],
      actualSpecVGA: [],
      getNPWPName: "",
      getSiupName: "",
      getAktaName: "",
      getKtpName: "",
      getSKMName: "",
      dataLogOrder: [],
      dataLogLessee: [],
      newUser: false,
      loadVerif: false,
      loadingNextStep: false,
      loadingTableReschedule: false,
      loadingTableGenerate: false,
      loadingButtonSave: false,
      asaniEmployeeName: "",
      asaniPicPhone: "",
      employeeSelect: [],
      bastAsaniEmployee: "",
      employeeAsaniOrder: [],
      bastRoleAsani: "Account Executive",
      bastName: "",
      bastRole: "",
      bastCompanyName: "",
      bastPO: "",
      bastNote: "",
      bastDate: "",
      ceklistAll: false,
      selectBastItem: [],
      bastItemChoose: [],
      itemCode: [],
      statusRenting: null,
      statusDeliver: null,
      conditionNameModal: "",
      choosePic: [],
      lesseeSelect: [],
      specModal: "",
      conditionDelete: "",
      lesseeSelect: [],
      generatQuotationDate: "",
      mrMrsSelected: "",
      mrMrsSelect: ["Mr.", "Mrs."],
      clientPicName: "",
      quotaionEmployeeSelect: "",
      quotationEmployeePosition: "Account Executive",
      quotationSphNumber: "",
      versionSelected: {
        version : "Indonesia", 
        value : "IND"
      },
      versionSelect: [{version : "Indonesia", value : "IND"}, {version : "English" , value : "ENG"}],
      typeSelected: "Normal",
      typeSelect: ["Normal", "Promo"],
      dataQuotation: [],
      quotationDefositFee: "",
      defositFeeSelect: ["1", "2", "3", "4", "5"],
      promoPrice: [],
      buttonLessor: "",
      specModalAssignTo: "",
      orderExtendFrom: {
        orderId: '',
        orderCode:''
      },
      poNumberInput: "",
      searchSnLp: "",
      dataInfoSearch: [],
      addDuration: "",
      addPrice: "",
      editDuration: "",
      editPrice: "",
      erpAcc: [],
      productEditStatus: 0,
      warehouseList: [],
      warehouseAdd: "",
      addDeliverSchedule: "",
      bastProvinceMandatory: "",
      bastDistrictMandatory: "",
      bastCityMandatory: "",
      bastVillage: "",
      bastZip: "",
      bastAddress: "",
      selectedOrderItemBOM: {},
      selectedOrderItemDetailHistory: {},
      bastData: [],
      bastSelected: {},
      bastAction: "",
      uploadBastType: "",
      selectedBast: "",
      bastItems: [],
      bastLPs: [],
      bastId: "",
      bastType: "Delivery",
      disableTypeBast: false,
      oldPic: '',
      oldPicAsani: '',
      errorFinanceEmail: [],
      errorAddFinanceEmail: false,
      tags: false,
      orderPriority : {
        label : '',
        colorHex : '',
        tagId : 0
      },
      // For edit order priority Modal
      orderPriorityOptions : [],
      isNotReserved : true,

      companyNameNPWP:'',

      // Rent Adjustment
      ltCode: '',
      isLeaseOrder: null,

      // Deal Owner
      dealOwner: undefined,
    };
  },
  computed: {
    showSetupStagingOrder(){
      if (this.isLeaseOrder === null) {
        return false
      }
      return !this.orderExtendFrom.orderId && !this.isLeaseOrder
    },
    canReadOrderStagingAssigment() {
      return this.hasPermission({
        requiredPermissions:['2.9', '2.42'], 
        operator:'OR'
      }) && this.orderStatus <= 9
    },
    parseItemSpec() {
      let result = []
      if (this.editDate) {
        for (let i = 0; i < this.editDate.length; i++) {
          const detailItem = this.editDate[i]
          const specData = Object.entries(JSON.parse(detailItem.productDetail))
          const parseSpecToString = specData.map(([key, value]) => {
            return `${key}: ${value}`
          })
          result.push(parseSpecToString.join('<br>'))
        }
      }
      return result
    },
    selectAll: {
      get: function () {
        return this.returnDetail
          ? this.checkedItems.length == this.returnDetail.length
          : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.returnDetail.forEach(function (user) {
            selected.push(user.orderDetailsId);
          });
        }
        this.checkedItems = selected;
      },
    },
    filteredList() {
      return this.dataAllItem.filter((data) => {
        return data.toLowerCase().includes(this.searchReschedule.toLowerCase());
      });
    },
    isStagingOrderSetupValid() {
      return this.orderPriorityDetails 
        && this.orderPriorityDetails.expectedDepositDate
        && this.orderPriorityDetails.maxDeliverSchedule
        && this.orderPriorityDetails.priorityOrder.tag;
    }
  },
  methods: {
    handleOnChangeOrderPriority (newValue) {
      this.orderPriority = newValue;
    },
    getOrderPriorityDetails() {
        this.$http
        .post(
          `${process.env.GET_ORDER_PRIORITY_DETAIL}/${this.orderId}`,{},
          {
            timeout: 30 * 1000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.orderPriorityDetails = res.data.content;
          } else {
              swal("Sorry", res.data.message, "error", {
                button: "Close",
              });
         }

      })
      .catch((err) => {
        swal("Error", err.message, "error");
      });
    },
    showEditPriorityModal()  {
      $(`#modalEditPriorityTag`).modal("show");
    },
    handleClickSendInvoice(action) {
      $(`#modalEditInvoiceTag`).modal("show");
      this.isOpenTagModal = true
      this.orderTagAction = action
    },
    handleNextStep () {
      if (this.orderTagAction === 'sendInvoice' || this.orderTagAction === 'renewInvoiceExtend') {
        // if the order is extend order, than dosn't need to send log
        if (this.orderExtendFrom.orderId != '') {
          this.getData()
        } else  {
          // this.sendLog(18, 'Paid')
          this.getData(); 
        }
      } else {
        if (this.nextStepFill) {
          this.openModalOne("FillMandatory");
        } else {
          this.openModalOne("VerifyStep");
        }
        this.sendLog(17,'VerifyStep')
        $('#modalVerifyStep').modal('hide')
        this.getData();
        this.loadingNextStep = false;
      }
    },
    onReqCloseModal(type, isSuccess) {
      this.isOpenTagModal = false
      if (type === 'submit' && isSuccess) {
        swal("Sukses", "Sukses menyimpan data", "success").then(_=>{
         this.handleNextStep()
        })
      }
      if (type === 'submit' && !isSuccess && (this.orderTagAction === 'sendInvoice' || this.orderTagAction === 'renewInvoiceExtend')) {
          this.handleNextStep()
      }
    },
    changeInfoOpenedStatus(index) {
      this.detailOrder[index].isInfoOpened =
        !this.detailOrder[index].isInfoOpened;
    },
    toTicketDetail(ticketId) {
      window.open(
        this.$router.resolve("/resolution/detail/" + ticketId).href,
        "_blank"
      );
    },
    deleteBast(data) {
      swal("Delete BAST", "Are you sure you want delete the data?", {
        buttons: ["No", "Yes"],
      }).then((x) => {
        if (x) {
          this.$http
            .post(
              process.env.DELETE_BAST,
              { bastId: data.bastId },
              { headers: { "Asani-Token": localStorage.getItem("jwt") } }
            )
            .then((res) => {
              if (res.data.status == 200) {
                swal("Success", "Sukses menghapus BAST", "success").then(() => {
                  window.location.reload()
                });
                
              } else {
                swal("Error", res.data.message, "error").then(() => {
                  // window.location.reload()
                });
              }
            })
            .catch(error => {
              swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
              }).then(v => {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              })
            });
        }
      });
    },
    downloadBlank(bast) {
      this.$http
        .post(
          process.env.DOWNLOAD_BLANK,
          {
            bastId: bast.bastId,
            address: bast.address,
            provinceName: bast.provinceName,
            cityName: bast.cityName,
            districtId: bast.districtId,
            districtName: bast.districtName,
            village: bast.village,
            postalCode: bast.postalCode,
            phoneNumber: null,
            note: bast.note,
            orderDetailsIds: bast.orderDetailsIds,
            bastDate: bast.bastDate,
          },
          { headers: { 
              "Asani-Token": localStorage.getItem("jwt"),
            }
          }
        )
        .then((res) => {
          this.loadingDownload = false;
          const linkSource = `data:application/pdf;base64,${res.data.content}`;
          const downloadLink = document.createElement("a");
          const fileName = "BAST-" + this.orderId + ".pdf";

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          
        })
        .catch((error) => {
          this.loadingDownload = false;
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          });
        });
    },
    previewBast(link) {
      if(link) {
        window.open(link + '?token=' + localStorage.getItem('jwt'));
      } else {
        swal('Error', 'Link tidak tersedia', 'error')
      }
    },
    getItemBast(data) {
      let arr = data.orderDetailsIds.split(",");
      this.$http
        .post(
          process.env.GET_ITEM_BAST,
          {
            dataItem: arr,
            bastType: data.type,
            bastId: data.bastId
          },
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.data.status == 200) {
            this.bastItems = res.data.content.dataItem;
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    editBast(data, type) {
      this.bastId = data.bastId;
      if (type == 1) {
        let arr = data.orderDetailsIds.split(",");
        this.selectBastItem = arr
        this.$http
          .post(
            process.env.GET_ITEM_BAST,
            {
              dataItem: arr,
              bastType: data.type,
              bastId: data.bastId
            },
            {
              headers: {
                "Asani-Token": localStorage.getItem("jwt"),
              },
            }
          )
          .then((res) => {
            this.bastType = data.type
            console.log(res);
            if (res.data.status == 200) {
              let bastd = new Date(data.bastDate);
              this.bastItemChoose = res.data.content.dataItem;
              this.itemCode = res.data.content.productCode;
              this.bastDate = bastd;
              this.bastNote = data.note;
              this.bastProvinceMandatory = {
                provinceId: data.provinceId,
                provinceName: data.provinceName,
              };
              this.bastCityMandatory = {
                kabKotId: data.cityId,
                kabKotName: data.cityName,
              };
              this.bastDistrictMandatory = {
                kecamatanId: data.districtId,
                kecamatanName: data.districtName,
              };
              this.bastVillage = data.village;
              this.bastZip = data.postalCode;
              this.bastAddress = data.address;
              this.generate = true;
              this.bastAction = "edit";
              $("#modalBast").modal("show");
            }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      } else {
        let bastd = new Date(data.bastDate);
        this.bastDate = bastd;
              this.bastNote = data.note;
              this.bastProvinceMandatory = {
                provinceId: data.provinceId,
                provinceName: data.provinceName,
              };
              this.bastCityMandatory = {
                kabKotId: data.cityId,
                kabKotName: data.cityName,
              };
              this.bastDistrictMandatory = {
                kecamatanId: data.districtId,
                kecamatanName: data.districtName,
              };
              this.bastVillage = data.village;
              this.bastZip = data.postalCode;
              this.bastAddress = data.address;
        this.openBastExtend("edit", data);
      }
    },
    checkStatusBast(data) {
      if(data.type.toLowerCase() == 'delivery') {
        if (this.orderExtendFrom.orderCode) {
          if (data.orderStatus == 11 ||  data.orderStatus == 13) {
            return true
          } else {
            return false
          }
        } else {
          if (data.orderStatus == 11 || data.orderStatus == 12 || data.orderStatus == 13) {
            return true
          } else {
            return false
          }
        }
      } else if(data.type.toLowerCase() == 'return'){
        if (data.orderStatus == 13 || data.orderStatus == 14 || data.orderStatus == 15 || data.orderStatus == 16 || data.orderStatus == 17 || data.orderStatus == 18) {
            return true
          } else {
            return false
          }
      } else if(data.type.toLowerCase() == 'ticket'){
        if (data.orderStatus == 13) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    openUploadBast(data, type) {
      this.getItemBast(data);
      this.uploadBastType = type;
      this.selectedBast = data;
      $("#modalUploadBast").modal("show");
      
    },
    addMoreFinanceEmail() {
      if (this.errorAddFinanceEmail) {
        this.errorFinanceEmail = [...this.errorFinanceEmail, this.addFinanceEmail];
        this.errorAddFinanceEmail = false
      }
      // this.financeEmail.push(this.addFinanceEmail);
      this.financeEmail.push(this.addFinanceEmail.replace(this.spaceRegex, ' '));
      this.addFinanceEmail = "";
    },
    deleteFinanceEmail(data) {
      let newData = [];
      for (let i in this.financeEmail) {
        if (data !== this.financeEmail[i]) {
          newData.push(this.financeEmail[i] !== null ? this.financeEmail[i].replace(this.spaceRegex, ' ') : this.financeEmail[i]);
        }
      }
      this.financeEmail = newData;
      if (this.errorFinanceEmail.includes(data)) {
        this.errorFinanceEmail = this.errorFinanceEmail.filter((email) => email != data);
      }
    },
    isValidFinanceEmail() {
      let result = true
      if (this.addFinanceEmail && !this.validateEmail(this.addFinanceEmail)) {
        this.errorAddFinanceEmail = true
        result = false        
      }
      const invalidEmail = this.financeEmail.filter((email) => !this.validateEmail(email));
      if (invalidEmail.length > 0) {
        this.errorFinanceEmail = invalidEmail
        result = false
      }
      return result
    },
    cancelEditDepositDate() {
      this.errorAddFinanceEmail = false
      this.errorFinanceEmail = []
      this.addFinanceEmail = ""
    },
    submitChangeDepositDate() {
      if (!this.isValidFinanceEmail()) {
        return false
      }
      let sentEmailData = [...this.financeEmail]
      
      // Check If add email exist in finance email
      // If it is, push to sentEmailData
      if (this.addFinanceEmail && this.financeEmail.length > 0 && this.financeEmail.indexOf(this.addFinanceEmail) == -1) {
        sentEmailData.push(this.addFinanceEmail)
      }
      this.$http
        .post(
          process.env.UPDATE_ORDER_DEPOSIT,
          {
            orderId: this.orderId,
            depositDate: this.selectDepositDate,
            companyId: this.companyId,
            financeEmail: sentEmailData,
          },
          {
            timeout: 30 * 1000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((res) => {
          this.errorAddFinanceEmail = false
          this.errorFinanceEmail = []
          if (res.data.status == 200) {
            this.financeEmail = [""];
            this.addFinanceEmail = "";
            this.getData();
            $("#modalEditDepositDate").modal("hide");
            swal("Success", "Success update Finance Data", "success", {
              button: "Close",
            });
          } else {
            console.log(res);
            swal("Sorry", res.data.message, "error", {
              button: "Close",
            });
          }

        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
      
    },
    getProductPricing(action) {
      var same = false;
      var idx = 0;
      if (action == "add") {
        this.addPrice = 0;
        for (var i = 0; i < this.selectProductDuration.length; i++) {
          if (this.addDuration === this.selectProductDuration[i].tenorValue) {
            same = true;
            idx = i;
          }
        }
        if (same) {
          this.addPrice = this.selectProductDuration[idx].tenorPrice;
        }
      } else {
        this.editPrice = 0;
        for (var i = 0; i < this.selectProductDuration.length; i++) {
          if (this.editDuration === this.selectProductDuration[i].tenorValue) {
            same = true;
            idx = i;
          }
        }
        if (same) {
          this.editPrice = this.selectProductDuration[idx].tenorPrice;
        }
      }
    },
    executeOriginal() {
      var self = this;
      this.loadingButtonExecute = true;
      this.$http
        .get(process.env.EXECUTE_ORIGINAL_PRODUCT_ID, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.data.status === 200) {
            swal("Success", "Success update original product Id", "success", {
              button: "Close",
            });
          }
          this.loadingButtonExecute = false;
        })
        .catch(error => {
          alert("Request timeout / error with api, please try again!");
          self.loadingButtonExecute = false;
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    valBtnSetReturn() {
      var showBtn = false;
      var rsFlag = false;
      var assigned = false;
      var rescheduled = false;
      for (var idx = 0; idx < this.detailOrder.length; idx++) {
        let currentDate = 0;
        let endRentDate = 1;
        if (this.detailOrder[idx].endRent) {
          currentDate = new Date().getTime();
          endRentDate = new Date(
            this.detailOrder[idx].endRent.split("-").reverse().join("-")
          ).getTime();
        }

        if (
          showBtn == false &&
          this.detailOrder[idx].orderItemStatus != 17 &&
          (this.detailOrder[idx].orderItemStatus == 13 ||
            this.detailOrder[idx].orderItemStatus == 14 ||
            currentDate >= endRentDate)
        ) {
          showBtn = true;
        }

        if (this.detailOrder[idx].orderItemStatus == 16) {
          assigned = true;
        }
        if (this.detailOrder[idx].orderItemStatus == 15) {
          rescheduled = true;
        }
      }
      console.log("rescheduled", rescheduled);
      if (rescheduled) return false;
      else {
        if (showBtn == true && assigned == true) {
          rsFlag = true;
        }
        if ((showBtn || rsFlag) && !this.loadingBtnReturn) {
          return true;
        }
      }
      return false;
    },
    valBtnRescheduleReturn() {
      var showBtn = false;
      var rsFlag = false;
      var scheduled = false;
      for (var idx = 0; idx < this.detailOrder.length; idx++) {
        if (
          this.detailOrder[idx].orderItemStatus == 13 ||
          this.detailOrder[idx].orderItemStatus == 14
        ) {
          showBtn = true;
        }
        if (this.detailOrder[idx].orderItemStatus == 15) {
          scheduled = true;
        }
      }
      if (showBtn == true && scheduled == true) {
        rsFlag = true;
      }
      if ((scheduled || rsFlag) && !this.loadingBtnReturn) {
        return true;
      }
      return false;
    },
    submitUpdateProductExtend() {
      var self = this;
      this.loadingButtonProcess = true;
      this.$http
        .post(
          process.env.EXTEND_UPDATE_PRODUCTS,
          {
            orderId: this.orderId,
          },
          {
            timeout: 30 * 1000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
          } else if (response.data.status == 201) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
          } else if (response.data.status == 200) {
            swal(
              "Success",
              "Success change order status to update products",
              "success",
              {
                button: "Close",
              }
            );
          }
          this.loadingButtonProcess = false;
          $("#modalUpdateProduct").modal("hide");
          this.getData();
        })
        .catch(error => {
          // alert("Request timeout / error with api, please try again!");
          self.loadingButtonProcess = false;
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    openBastExtend(type, data) {
      this.disableTypeBast = true
      let words = data.type
      let capitalize = ''
      for(let i in words) {
        if(i == 0) capitalize += words[i].toUpperCase()
        else capitalize += words[i]
      }
      this.bastType = capitalize
      if (data) {
        let bastd = new Date(data.bastDate);
        this.bastDate = bastd;
        this.bastNote = data.note;
        this.bastProvinceMandatory = {
          provinceId: data.provinceId,
          provinceName: data.provinceName,
        };
        this.bastCityMandatory = {
          kabKotId: data.cityId,
          kabKotName: data.cityName,
        };
        this.bastDistrictMandatory = {
          kecamatanId: data.districtId,
          kecamatanName: data.districtName,
        };
        this.bastVillage = data.village;
        this.bastZip = data.postalCode;
        this.bastAddress = data.address;
      } else {
        this.bastDate = "";
        this.bastNote = "";
        this.bastProvinceMandatory = "";
        this.bastCityMandatory = "";
        this.bastDistrictMandatory = "";
        this.bastVillage = "";
        this.bastZip = "";
        this.bastAddress = "";
      }
      this.generate = false;
      this.bastAction = type;
      $("#modalBast").modal("show");
      this.selectBastItem = [];
      this.loadingTableBast = true;
      this.kecamatan = [];
      this.kabkot = [];
      this.$http
        .post(
          process.env.GET_ITEM_FOR_BAST,
          {
            orderId: parseInt(this.orderId),
            bastType: data.type,
            bastId: data.bastId.toString()
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          this.loadingTableBast = false;
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
          } else if (response.data.status == 200) {
            this.dataAllItemBast = response.data.content;
          }
        })
        .catch(error => {
          this.loadingTableBast = false;
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          });
        });
    },
    toEditItemExtend(productId, condition, duration) {
      this.$router.push({
        path: "/order/" + this.orderId + "/extend/edit",
        query: {
          productId: productId,
          condition: condition,
          duration: duration,
          orderCode: this.orderCode,
          companyId: this.companyId,
        },
      });
    },
    toExtendPage() {
      this.$router.push({
        path: "/order/" + this.orderId + "/extend",
        query: {
          orderCode: this.orderCode,
          companyId: this.companyId,
        },
      });
    },
    submitEditPic() {
      this.loadingButtonSave = true;
      if (this.choosePic["lesseeId"] == "") {
        swal("Sorry", "PIC must be choose", "error", {
          button: "Ok",
        });
      }else if (this.choosePic["lesseeId"] == this.oldPic) {
        swal("Sorry", "PIC must be different", "error", {
          button: "Ok",
        });
      } else {
        var self = this;
        this.loadingButtonSave = true;
        this.$http
          .post(
            process.env.EDIT_PIC,
            {
              id: this.choosePic["lesseeId"],
              orderId: this.orderId,
            },
            {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status === 200) {
              swal("Success", response.data.message, "success", {
                button: "Ok",
              });
              this.choosePic = {
                lesseeId: "",
                lesseeName: "",
              };
              this.loadingButtonSave = false;
              this.getData();
            } else if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Ok",
              });
            }
            this.loadingButtonSave = false;
            $("#modalEditPIC").modal("hide");
          })
          .catch(error => {
            alert("Request timeout / error with api, please try again!");
            self.loadingButtonSave = false;
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    submitChangePicAsani() {
      if (this.employeeAsaniOrder["id"] == "") {
        swal("Sorry", "PIC must be choose", "error", {
          button: "Ok",
        });
      } else if (this.employeeAsaniOrder["id"] == this.oldPicAsani) {
        swal("Sorry", "PIC must be different", "error", {
          button: "Ok",
        });
      } else {
        this.loadingButtonSave = true;
        this.$http
          .post(
            process.env.EDIT_ASANI_PIC_ORDER,
            {
              id: this.employeeAsaniOrder["id"],
              orderId: this.orderId,
            },
            {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status === 200) {
              swal("Success", response.data.message, "success", {
                button: "Ok",
              });
              this.employeeAsaniOrder = {
                id: "",
                employeeName: "",
              };
              this.loadingButtonSave = false;
              this.getData();
            } else if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Ok",
              });
              this.handleLogout();
            }
            this.loadingButtonSave = false;
            $("#modalEditAsaniPIC").modal("hide");
          })
          .catch(error => {
            // alert("Request timeout / error with api, please try again!");
            self.loadingButtonSave = false;
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    mergeProductCode: function (data) {
      console.log('itemchoose', this.bastItemChoose)
      let listOrderLP = '';
      data.listOrderLP.split(',').forEach(item => {
        if (listOrderLP !== "") {
          listOrderLP = listOrderLP + ", " + item;
        } else {
          listOrderLP += item;
        }
      })

      let mergeCode = "";
      for (var i = 0; i < this.bastItemChoose.length; i++) {
        if (mergeCode !== "") {
          mergeCode = mergeCode + ", " + listOrderLP;
        } else {
          mergeCode += listOrderLP;
        }
      }
      let arrm = mergeCode.split(', ')
      let result = arrm.filter((x,index) => {
        return arrm.indexOf(x) === index
      })
      console.log(result)
      return result.join(', ');
    },
    ceklistAllItem() {
      this.$nextTick(() => {
        const headerCheckbox = this.$refs.headerCheckbox;
        if (headerCheckbox.checked) {
          this.selectBastItem = [];
          for (var i = 0; i < this.dataAllItemBast.length; i++) {
            this.selectBastItem.push(this.dataAllItemBast[i].id);
          }
          this.ceklistAll = true;
          headerCheckbox.indeterminate = false;
        } else {
          this.selectBastItem = [];
          this.ceklistAll = false;
          headerCheckbox.indeterminate = false;
        }
      });
    },
    sublist() {
      this.$nextTick(() => {
        const headerCheckbox = this.$refs.headerCheckbox;
        if (headerCheckbox) {
          if (
            this.selectBastItem.length === this.dataAllItemBast.length &&
            this.selectBastItem.length > 0
          ) {
            this.ceklistAll = true;
            headerCheckbox.indeterminate = false;
          } else if (
            this.selectBastItem.length > 0 &&
            this.selectBastItem.length < this.dataAllItemBast.length
          ) {
            this.ceklistAll = false;
            headerCheckbox.indeterminate = true;
          } else {
            this.ceklistAll = false;
            headerCheckbox.indeterminate = false;
          }
        }
      });
    },
    base64ToArrayBuffer(data) {
      var bString = window.atob(data);
      var bLength = bString.length;
      var bytes = new Uint8Array(bLength);
      for (var i = 0; i < bLength; i++) {
          var ascii = bString.charCodeAt(i);
          bytes[i] = ascii;
      }
      return bytes;
    },
    base64toPDF(data) {
      var bufferArray = base64ToArrayBuffer(data);
      var blobStore = new Blob([bufferArray], { type: "application/pdf" });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blobStore);
          return;
      }
      var data = window.URL.createObjectURL(blobStore);
      var link = document.createElement('a');
      document.body.appendChild(link);
      link.href = data;
      link.download = `BAST-${this.orderId}.pdf`;
      link.click();
      window.URL.revokeObjectURL(data);
      link.remove();
    },
    downloadBast() {
      if (this.bastDate == null) {
        swal("Sorry", "Date must be select", "error", {
          button: "Close",
        });
      } else if ((!this.bastProvinceMandatory.provinceId && !this.bastProvinceMandatory.provinceName) || !this.bastProvinceMandatory) {
        swal("Sorry", "Province must be select", "error", {
          button: "Close",
        });
      } else if ((!this.bastCityMandatory.kabKotId  && !this.bastCityMandatory.kabKotName) || !this.bastCityMandatory) {
        swal("Sorry", "City must be fill", "error", {
          button: "Close",
        });
      } else if ((!this.bastDistrictMandatory.kecamatanId && !this.bastDistrictMandatory.kecamatanName ) || !this.bastDistrictMandatory ) {
        swal("Sorry", "District must be fill", "error", {
          button: "Close",
        });
      } else {
        const bastItem = this.selectBastItem.map(item => {
          const num = Number(item)
          return isNaN(num) ? 0 : num
        })
        this.loadingDownload = true;
        this.$http
          .post(
            process.env.DOWNLOAD_BAST,
            {
              bastDate: this.dateToString(this.bastDate, false),
              bastAsaniEmployee: typeof this.bastAsaniEmployee["employeeName"] === 'string' ? this.bastAsaniEmployee["employeeName"].replace(this.spaceRegex, ' ') : this.bastAsaniEmployee["employeeName"],
              bastRoleAsani: typeof this.bastRoleAsani === 'string' ? this.bastRoleAsani.replace(this.spaceRegex, ' ') : this.bastRoleAsani,
              bastName: typeof this.bastName === 'string' ? this.bastName.replace(this.spaceRegex, ' ') : this.bastName,
              bastRole: typeof this.bastRole === 'string' ? this.bastRole.replace(this.spaceRegex, ' ') : this.bastRole,
              bastCompanyName: typeof this.bastCompanyName === 'string' ? this.bastCompanyName.replace(this.spaceRegex, ' ') : this.bastCompanyName,
              bastPO: this.bastPO,
              bastItem: bastItem,
              orderId: this.orderId,
              orderCode: this.orderCode,
              bastNote: typeof this.bastNote === 'string' ? this.bastNote.replace(this.spaceRegex, ' ') : this.bastNote,
              provinceId: this.bastProvinceMandatory["provinceId"],
              cityId: this.bastCityMandatory["kabKotId"],
              districtId: this.bastDistrictMandatory["kecamatanId"],
              village: typeof this.bastVillage === 'string' ? this.bastVillage.replace(this.spaceRegex, ' ') : this.bastVillage,
              postalCode: typeof this.bastZip === 'string' ? this.bastZip.replace(this.spaceRegex, ' ') : this.bastZip,
              address: typeof this.bastAddress === 'string' ? this.bastAddress.replace(this.spaceRegex, ' ') : this.bastAddress,
              phoneNumber: "",
              action: this.bastAction,
              bastId: `${this.bastId}`,
              bastType: this.bastType,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
              timeout: 100 * 1000,
            }
          )
          .then((response) => {
            this.loadingDownload = false;
            if(response.data.status == 200) {
              const linkSource = `data:application/pdf;base64,${response.data.content}`;
              const downloadLink = document.createElement("a");
              const fileName = "BAST-" + this.orderId + ".pdf";

              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
              this.generate = false;
              this.bastRole = "";
              this.bastNote = "";
              this.bastProvinceMandatory = "";
              this.bastCityMandatory = "";
              this.bastDistrictMandatory = "";
              this.bastVillage = "";
              this.bastZip = "";
              this.bastAddress = "";
              this.selectBastItem = [];
              $("#modalBast").modal("hide");
              this.getData();
            }
            if (response.status !== 200 || response.data.status !== 200) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              }).then(() => {
                if(response.status == 401|| response.data.status == 401) {
                  this.handleLogout();
                }
              });
            }
          })
          .catch(error => {
            this.loadingDownload = false;
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    downloadReturnBast() {
      this.loadingBtnReturn = true;
      this.$http
        .post(
          process.env.DOWNLOAD_RETURN_BAST,
          {
            orderId: this.orderId,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
            responseType: "arraybuffer",
          }
        )
        .then((response) => {
          this.forceFileDownload(
            response,
            "RETURN-BAST-" + this.orderId + ".pdf"
          );
          this.loadingBtnReturn = false;
          $("#modalBast").modal("hide");
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            this.handleLogout();
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    backGenerate() {
      this.generate = false;
      if (this.dataAllItemBast.length == this.selectBastItem.length) {
        this.ceklistAll = true
      }
    },
    generateNow() {
      if (this.selectBastItem == "") {
        swal("Sorry", "Item must be choose", "error", {
          button: "Ok",
        });
      } else {
        this.generate = true;
        this.loadingTableGenerate = true;
        this.bastCompanyName = this.companyName;
        this.bastName = this.userName;
        this.bastRole = this.userPosition;
        // this.bastDate = new Date();
        this.$http
          .post(
            process.env.GET_ITEM_BAST,
            {
              dataItem: this.selectBastItem,
              bastType: this.bastType,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              let addressBast = ''
              this.bastItemChoose = response.data.content.dataItem
              this.itemCode = response.data.content.productCode;
              this.loadingTableGenerate = false;
              addressBast = response.data.content.LastAddress
              if(response.data.content.lastAddress) {
                  this.bastProvinceMandatory = { provinceId: response.data.content.lastAddress.provinceId, provinceName: response.data.content.lastAddress.ProvinceName }
                  this.bastCityMandatory = { kabKotId: response.data.content.lastAddress.cityId, kabKotName: response.data.content.lastAddress.cityName }
                  this.bastDistrictMandatory = { kecamatanId: response.data.content.lastAddress.districtId, kecamatanName: response.data.content.lastAddress.districtName }
                  this.bastVillage = response.data.content.lastAddress.village
                  this.bastZip = response.data.content.lastAddress.postalCode
                  this.bastAddress = response.data.content.lastAddress.address
              }
            }
            if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            // $('#modalReschedule').modal('hide')
            this.getData();
            this.loadingButtonProcess = false;
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    log: function (val) {
      // this.date = val
      console.log(val);
    },
    updateDelivery() {
      const sentPayload = this.editDate.map((item) => {
        const oldActual = item.actualDate ? item.actualDate.split('-').reverse().join('-') : '';
        const oldSLA = item.deliveryDate ? item.deliveryDate.split('-').reverse().join('-') : '';

        const result = {
          ...item,
          orderId: parseInt(this.orderId),
          productCode: item.productCode || '',
          oldActual,
          oldSLA,
          actualDate: item.actualSchedule || '',
          slaDate: item.deliverySchedule || ''
        }
        delete result.deliveryDate;
        delete result.actualSchedule;
        delete result.deliverySchedule;

        return result;
      })

      this.loadingButtonProcess = true;
      this.$http
        .post(
          process.env.UPDATE_DELIVERY, sentPayload,
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            swal("Success", response.data.message, "success", {
              button: "Ok",
            });
            $("#modalReschedule").modal("hide");
            this.getData();
          }
          if (response.data.status == 201 || response.data.status == 500) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
          }
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            this.handleLogout();
          }
          this.loadingButtonProcess = false;
        })
        .catch(error => {
          this.loadingButtonProcess = false;
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    inputActive() {
      this.editInputDate = true;
    },
    cekDoc() {
      // if(!this.tags) {
      //   swal('Error', 'Order tag belum dilengkapi', 'error').then(_=> this.toOrder())
      // } else {
        // this.loadingNextStep = true;
        this.$http
          .post(
            process.env.NEW_CHECK_DOC,
            {
              orderId: parseInt(this.orderId),
              companyId: parseInt(this.companyId),
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              if (this.nextStepFill) {
                this.openModalOne("FillMandatory");
              } else {
                this.openModalOne("VerifyStep");
              }
              this.sendLog(17,'VerifyStep')
              $('#modalVerifyStep').modal('hide')
              this.getData();
              this.loadingNextStep = false;
            }
            if (response.data.status == 202) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              }).then(response =>{
                if (response) {
                  $(`#modalEditInvoiceTag`).modal("show");
                  this.isOpenTagModal = true
                  this.orderTagAction = 'nextStep'
                }
              });
            }
            if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              })
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            
          })
          .catch((error) => {
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      // }
    },
    sendLogLessee(w, x) {
      var today = new Date();
      var month = today.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var dateDay = today.getDate();
      if (dateDay < 10) {
        dateDay = "0" + dateDay;
      }
      var hours = today.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = today.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var second = today.getSeconds();
      if (second < 10) {
        second = "0" + second;
      }
      var date = today.getFullYear() + "-" + month + "-" + dateDay;
      var time = hours + ":" + minutes + ":" + second;
      var dateTime = date + " " + time;
      var admin = this.admin;
      var command = "add-logs";
      // var productName = this.productNameChoose
      this.$http
        .post(
          process.env.LOG_URL + "/lessee/" + x,
          {
            codeLogs: w,
            params: [],
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          this.connectLogRemarks();
          this.connectLogOrder();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getKabkot(x, isBast) {
      let processedProvinceId = "";
      if (isBast) {
        processedProvinceId = this.bastProvinceMandatory.provinceId;
      } else {
        processedProvinceId = this.companyProvinceMandatory.provinceId;
      }
  
      if(processedProvinceId) {
        this.$http
          .post(
            process.env.API_GET_KABKOT,
            {
              provinceId: processedProvinceId,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              this.kabkot = response.data.content;
              if (x == "ada") {
                this.bastDistrictMandatory = "";
                this.bastCityMandatory = "";
              }
            }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    getKecamatan(x, isBast) {
      let processedId = "";
      if (isBast) {
        processedId = this.bastCityMandatory.kabKotId;
      } else {
        processedId = this.companyDistrictMandatory.kabKotId;
      }

      if(processedId) {
        this.$http
          .post(
            process.env.API_GET_KECAMATAN,
            {
              kabKotId: processedId,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              this.kecamatan = response.data.content;
              if (x == "ada") {
                this.bastDistrictMandatory = "";
              }
            }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    cekMandatory: function () {
      var error = false;
      if (
        this.companyNameMandatory == "" ||
        this.companyNameMandatory == null
      ) {
        swal("Sorry", "Company name must be fill", "error", {
          button: "Close",
        });
        error = true;
      } else if (
        this.companyProvinceMandatory == "" ||
        this.companyProvinceMandatory == null
      ) {
        swal("Sorry", "Company province must be select", "error", {
          button: "Close",
        });
        error = true;
      } else if (
        this.companyCityMandatory == "" ||
        this.companyCityMandatory == null
      ) {
        swal("Sorry", "Company city must be select", "error", {
          button: "Close",
        });
        error = true;
      } else if (
        this.companyDistrictMandatory == "" ||
        this.companyDistrictMandatory == null
      ) {
        swal("Sorry", "Company district must be select", "error", {
          button: "Close",
        });
        error = true;
      } else if (
        this.companyVillageMandatory == "" ||
        this.companyVillageMandatory == null
      ) {
        swal("Sorry", "Company village must be fill", "error", {
          button: "Close",
        });
        error = true;
      } else if (
        this.companyZipMandatory == "" ||
        this.companyZipMandatory == null
      ) {
        swal("Sorry", "Company zip must be fill", "error", {
          button: "Close",
        });
        error = true;
      } else if (
        this.companyAddressMandatory == "" ||
        this.companyAddressMandatory == null
      ) {
        swal("Sorry", "Company address must be fill", "error", {
          button: "Close",
        });
        error = true;
      } else if (this.picNameMandatory == "" || this.picNameMandatory == null) {
        swal("Sorry", "PIC name must be fill", "error", {
          button: "Close",
        });
        error = true;
      } else if (
        this.picPhoneMandatory == "" ||
        this.picPhoneMandatory == null
      ) {
        swal("Sorry", "PIC phone must be fill", "error", {
          button: "Close",
        });
        error = true;
      } else if (
        this.picEmailMandatory == "" ||
        this.picEmailMandatory == null
      ) {
        swal("Sorry", "PIC email must be fill", "error", {
          button: "Close",
        });
        error = true;
      }
      return error;
    },
    connectLogLessee: function () {
      var lesseeId = this.picId;
      this.$http
        .get(process.env.LOG_URL + "/lessee/" + lesseeId, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.data.status === 200) {
            this.dataLogLessee = response.data.content;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    submitMandatoryField() {
      if (this.picPhoneMandatory[0] == "0") {
        this.picPhoneMandatory = "62" + this.picPhoneMandatory.slice(1);
      }
      this.loadingButtonProcess = true;
      if (!this.cekMandatory()) {
        this.$http
          .post(
            process.env.EDIT_MANDATORY_USER,
            {
              companyId: this.companyId,
              companyName: this.companyNameMandatory !== null ? this.companyNameMandatory.replace(this.spaceRegex, ' ') : this.companyNameMandatory,
              province: this.companyProvinceMandatory.provinceName.replace(this.spaceRegex, ' '),
              kabkot: this.companyDistrictMandatory.kabKotName.replace(this.spaceRegex, ' '),
              kecamatan: this.companyCityMandatory.kecamatanName.replace(this.spaceRegex, ' '),
              kelurahan: this.companyVillageMandatory !== null ? this.companyVillageMandatory.replace(this.spaceRegex, ' ') : this.companyVillageMandatory,
              zipCode: this.companyZipMandatory !== null ? this.companyZipMandatory.replace(this.spaceRegex, ' ') : this.companyZipMandatory,
              companyAddress: this.companyAddressMandatory !== null ? this.companyAddressMandatory.replace(this.spaceRegex, ' ') : this.companyAddressMandatory,
              companyPhone: this.companyPhoneMandatory !== null ? this.companyPhoneMandatory.replace(this.spaceRegex, ' ') : this.companyPhoneMandatory,
              userId: this.picId,
              userName: this.picNameMandatory !== null ? this.picNameMandatory.replace(this.spaceRegex, ' ') : this.picNameMandatory,
              phoneNumber: this.picPhoneMandatory !== null ? this.picPhoneMandatory.replace(this.spaceRegex, ' ') : this.picPhoneMandatory,
              email: this.picEmailMandatory !== null ? this.picEmailMandatory.replace(this.spaceRegex, ' ') : this.picEmailMandatory,
              position: this.picPositionMandatory !== null ? this.picPositionMandatory.replace(this.spaceRegex, ' ') : this.picPositionMandatory,
              division: this.picDivisionMandatory !== null ? this.picDivisionMandatory.replace(this.spaceRegex, ' ') : this.picDivisionMandatory,
              orderId: this.orderId,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal("Success", response.data.message, "success", {
                button: "Ok",
              });
              this.connectLogLessee();
              if (response.data.data) {
                const responseData = response.data.data
                if (responseData.newNameCompany) {
                  this.sendLogLessee(58, this.picId);
                }
                if (responseData.newAreaCompany) {
                  this.sendLogLessee(47, this.picId);
                }
                if (responseData.newPhoneCompany) {
                  this.sendLogLessee(51, this.picId);
                }
                if (responseData.newAddressCompany) {
                  this.sendLogLessee(48, this.picId);
                }
                if (responseData.newNamePic) {
                  this.sendLogLessee(53, this.picId);
                }
                if (responseData.newPhonePic) {
                  this.sendLogLessee(54, this.picId);
                }
                if (responseData.newDivisionPic) {
                  this.sendLogLessee(57, this.picId);
                }
                if (responseData.newPositionPic) {
                  this.sendLogLessee(56, this.picId);
                }
                if (responseData.newEmailPic) {
                  this.sendLogLessee(55, this.picId);
                }
              }
            }
            if (response.data.status !== 200) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              if (response.data.status == 401) {
                this.handleLogout();
              }
              this.loadingButtonProcess = false;
            }
            if (response.data.status == 201) {
              swal("Success", response.data.message, "success", {
                button: "Close",
              });
            }
            $("#modalFillMandatory").modal("hide");
            this.getData();
            this.loadingButtonProcess = false;
          })
          .catch(error => {
            this.loadingButtonProcess = false;
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      } else {
        this.loadingButtonProcess = false;
      }
    },
    submitVerifCompany(data) {
      var create = false;
      var error = 0;
      var message = "";
      if (data == "save") {
        create = true;
        message = "Save company and process order succesfull";
      } else {
        message = "Match company and process order succesfull";
        if (this.existingValue == "") {
          swal("Sorry", "Existing company must be choose", "error", {
            button: "Close",
          });
          error = 1;
        }
      }
      if (error == 0) {
        this.loadVerif = true;
        this.$http
          .post(
            process.env.VERIF_COMPANY,
            {
              orderId: this.orderId,
              companyId: this.companyId,
              lesseeId: this.userId,
              create: create,
              companyChoose: this.existingValue.companyId,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            } else if (response.data.status == 200) {
              swal("Success", message, "success", {
                button: "Close",
              });
              this.sendLog(3, "Process");
              this.loadVerif = false;
              $("#modalMatch").modal("hide");
              this.getData();
            }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    clickTab(tab) {
      if (tab == "new") {
        this.newCompany = true;
        this.existingCompany = false;
      } else {
        this.newCompany = false;
        this.existingCompany = true;
      }
    },
    submitEditDelivery() {
      if (this.editDelivery == "") {
        swal("Sorry", "Delivery date must be select", "error", {
          button: "Close",
        });
      } else {
        var self = this;
        this.loadingButtonProcess = true;
        this.$http
          .post(
            process.env.EDIT_DELIVERY_SCHEDULE,
            {
              adminId: this.adminId,
              orderId: this.orderId,
              deliveryDate: this.editDelivery,
            },
            {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal("Success", response.data.message, "success", {
                button: "Ok",
              });
              this.sendLog(27, "editDelivery");
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            $("#modalEditDelivery").modal("hide");
            this.getData();
            this.loadingButtonProcess = false;
          })
          .catch(error => {
            // alert("Request timeout / error with api, please try again!");
            self.loadingButtonProcess = false;
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    tnotif() {
      var ws = new WebSocket(
        "wss://log-staging.asani.co.id/ws/notification-orders/broadcast"
      );
      ws.onopen = function () {
        ws.send(
          JSON.stringify({
            companyName: "add-notes",
            qty: 5,
            //.... some message the I must send when I connect ....
          })
        );
      };
    },
    submitRemarks() {
      if (this.remarksNote == "") {
        swal("Sorry", "Note must be fill", "error", {
          button: "Close",
        });
      } else {
        var today = new Date();
        var month = today.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        var dateDay = today.getDate();
        if (dateDay < 10) {
          dateDay = "0" + dateDay;
        }
        var hours = today.getHours();
        if (hours < 10) {
          hours = "0" + hours;
        }
        var minutes = today.getMinutes();
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        var second = today.getSeconds();
        if (second < 10) {
          second = "0" + second;
        }
        var date = today.getFullYear() + "-" + month + "-" + dateDay;
        var time = hours + ":" + minutes + ":" + second;
        var dateTime = date + " " + time;
        var admin = this.admin;
        var note = this.remarksNote;
        this.$http
          .post(
            process.env.LOG_URL + "/order_note/" + this.orderId,
            {
              codeLogs: 60,
              params: [note],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
            swal("Error", error.message, "error");
          });
        this.remarksNote = "";
      }
    },
    nextStep() {
      this.loadingButtonProcess = true;
        this.$http
          .post(
            process.env.VERIFY_STEP,
            {
              adminId: this.adminId,
              orderId: this.orderId,
              companyId: parseInt(this.companyId),
              picId: parseInt(this.picId),
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal("Success", response.data.message, "success", {
                button: "Okay",
              });
              // this.sendLog(17, "VerifyStep");
            }
            if (response.data.status == 201) {
              swal("Success", response.data.message, "success", {
                button: "Okay",
              });
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            $("#modalVerifyStep").modal("hide");
            this.getData();
            this.loadingButtonProcess = false;
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
    },
    dateToString: function (date, second) {
      var today = new Date(date);
      var month = today.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var dateDay = today.getDate();
      if (dateDay < 10) {
        dateDay = "0" + dateDay;
      }
      var hours = today.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = today.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var second = today.getSeconds();
      if (second < 10) {
        second = "0" + second;
      }
      var date = today.getFullYear() + "-" + month + "-" + dateDay;
      if (second) {
        var time = hours + ":" + minutes + ":" + second;
      } else {
        var time = hours + ":" + minutes;
      }
      var dateTime = date + "T" + time;
      return dateTime;
    },
    sendInvoice(action) {
      if (
        action == "process" &&
        (this.processInvoiceDate == "" || this.processInvoiceDate == null)
      ) {
        swal("Sorry", "Time must be fill.", "error", {
          button: "Close",
        });
      } else if (
        action == "send" &&
        (this.sendInvoiceDate == "" || this.sendInvoiceDate == null)
      ) {
        swal("Sorry", "Time must be fill.", "error", {
          button: "Close",
        });
      } else {
        let time = null;
        if (action == "send") {
          time = this.sendInvoiceDate;
        } else if (action == "process") {
          time = this.processInvoiceDate;
        }
        var self = this;
        this.loadingButtonProcess = true;
        this.$http
          .post(
            process.env.SEND_INVOICE,
            {
              orderId: Number(this.orderId),
              invoiceStatus: this.chooseInvoiceStatus,
              time: this.dateToString(time, false),
            },
            {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal("Success", response.data.message, "success", {
                button: "Ok",
              });
              if (action == "send") {
                this.sendLog(15, "SendInvoice");
              } else if (this.chooseInvoiceStatus != 2) {
                this.sendLog(67, "processInvoiceNew");
              }
            }
            if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            $("#modalSendInvoice").modal("hide");
            $("#modalProcessInvoice").modal("hide");
            this.processInvoiceDate = "";
            this.getData();
            this.loadingButtonProcess = false;
          })
          .catch(error => {
            // alert("Request timeout / error with api, please try again!");
            self.loadingButtonProcess = false;
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    sendAgreement(x) {
      if (x == "send" && this.sendAgreementDate == "") {
        swal("Sorry", "Time must be fill.", "error", {
          button: "Close",
        });
      } else if (x == "process" && this.processAgreementDate == "") {
        swal("Sorry", "Time must be fill.", "error", {
          button: "Close",
        });
      } else {
        let time = null;
        if (x == "send") {
          time = this.sendAgreementDate;
        } else if (x == "process") {
          time = this.processAgreementDate;
        }
        var self = this;
        this.loadingButtonProcess = true;
        this.$http
          .post(
            process.env.SEND_AGREEMENT,
            {
              adminId: this.adminId,
              orderId: this.orderId,
              agreement: x,
              agreementStatus: this.chooseAgreementStatus,
              time: time,
            },
            {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal("Success", response.data.message, "success", {
                button: "Ok",
              });
              if (x == "send") {
                this.sendLog(14, "SendAgreement");
              } else {
                if (this.chooseAgreementStatus == 1) {
                  this.sendLog(16, "ProcessAgreement");
                } else {
                  this.sendLog(14, "ProcessAgreement");
                }
              }
            }
            if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            $("#modalSendAgreement").modal("hide");
            $("#modalProcessAgreement").modal("hide");
            this.processAgreementDate = "";
            this.getData();
            this.loadingButtonProcess = false;
          })
          .catch(error => {
            // alert("Request timeout / error with api, please try again!");
            self.loadingButtonProcess = false;
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    cekUploadLegal: function () {
      var error = 0;
      if (
        this.NPWPFileName == "" &&
        this.aktaFileName == "" &&
        this.SIUPFileName == "" &&
        this.KTPFileName == "" &&
        this.SKMFileName == ""
      ) {
        swal("Sorry", "minimal 1 file must be upload", "error", {
          button: "Close",
        });
        error = error + 1;
        return error;
      } else if (this.NPWPFileName != "") {
        if (this.inputNPWP == "" || this.inputNPWP == null) {
          swal("Sorry", "NPWP Number must be fill", "error", {
            button: "Close",
          });
          error = error + 1;
          return error;
        } else if (this.aktaFileName != "") {
          if (this.inputAddress == "" || this.inputAddress == null) {
            swal("Sorry", "Address must be fill", "error", {
              button: "Close",
            });
            error = error + 1;
            return error;
          } else if (this.KTPFileName != "") {
            if (this.inputKTP == "" || this.inputKTP == null) {
              swal("Sorry", "KTP must be fill", "error", {
                button: "Close",
              });
              error = error + 1;
              return error;
            }
          }
        } else if (this.KTPFileName != "") {
          if (this.inputKTP == "" || this.inputKTP == null) {
            swal("Sorry", "KTP must be fill", "error", {
              button: "Close",
            });
            error = error + 1;
            return error;
          }
        }
      } else if (this.aktaFileName != "") {
        if (this.inputAddress == "" || this.inputAddress == null) {
          swal("Sorry", "Address must be fill", "error", {
            button: "Close",
          });
          error = error + 1;
          return error;
        } else if (this.KTPFileName != "") {
          if (this.inputKTP == "" || this.inputKTP == null) {
            swal("Sorry", "KTP must be fill", "error", {
              button: "Close",
            });
            error = error + 1;
            return error;
          }
        }
      } else if (this.KTPFileName != "") {
        if (this.inputKTP == "" || this.inputKTP == null) {
          swal("Sorry", "KTP must be fill", "error", {
            button: "Close",
          });
          error = error + 1;
          return error;
        }
      }
      return error;
    },
    uploadLegalDoc() {
      if (this.cekUploadLegal() == 0) {
        this.loadingButtonProcess = true;
        this.$http
          .post(
            process.env.ADD_LEGAL_DOC,
            {
              adminId: this.adminId,
              NPWPFileName: this.NPWPFileName !== null ? this.NPWPFileName.replace(this.spaceRegex, ' ') : this.NPWPFileName,
              NPWPBase64: this.NPWPBase64,
              npwpNumber: this.inputNPWP !== null ? this.inputNPWP.replace(this.spaceRegex, ' ') : this.inputNPWP,
              aktaFileName: this.aktaFileName !== null ? this.aktaFileName.replace(this.spaceRegex, ' ') : this.aktaFileName,
              aktaBase64: this.aktaBase64,
              companyAddress: this.inputAddress !== null ? this.inputAddress.replace(this.spaceRegex, ' ') : this.inputAddress,
              SIUPFileName: this.SIUPFileName !== null ? this.SIUPFileName.replace(this.spaceRegex, ' ') : this.SIUPFileName,
              SIUPBase64: this.SIUPBase64,
              SKFileName: this.SKMFileName !== null ? this.SKMFileName.replace(this.spaceRegex, ' ') : this.SKMFileName,
              SKBase64: this.SKMBase64,
              KTPFileName: this.KTPFileName !== null ? this.KTPFileName.replace(this.spaceRegex, ' ') : this.KTPFileName,
              KTPBase64: this.KTPBase64,
              ktpNumber: this.inputKTP !== null ? this.inputKTP.replace(this.spaceRegex, ' ') : this.inputKTP,
              companyId: this.companyId,
              picId: this.picId,
              newCompany: false,
              companyNameNPWP: this.companyNameNPWP !== null ? this.companyNameNPWP.replace(this.spaceRegex, ' ') : this.companyNameNPWP,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal("Success", response.data.message, "success", {
                button: "Ok",
              });
              if (this.NPWPBase64 != "") {
                this.sendLog(9, "legalDoc");
              }
              if (this.aktaBase64 != "") {
                this.sendLog(10, "legalDoc");
              }
              if (this.SIUPBase64 != "") {
                this.sendLog(11, "legalDoc");
              }
              if (this.KTPBase64 != "") {
                this.sendLog(12, "legalDoc");
              }
              if (this.SKMBase64 != "") {
                // this.sendLog(12,'legalDoc')
              }
            }
            if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            $("#modalUploadLegalDocument").modal("hide");
            document.getElementById("npwpInput").value = "";
            document.getElementById("ktpInput").value = "";
            document.getElementById("siupInput").value = "";
            document.getElementById("aktaInput").value = "";
            document.getElementById("skmInput").value = "";
            this.NPWPFileName = "";
            this.NPWPBase64 = "";
            this.aktaFileName = "";
            this.aktaBase64 = "";
            this.SIUPFileName = "";
            this.SIUPBase64 = "";
            this.SKMFileName = "";
            this.SKMBase64 = "";
            this.KTPFileName = "";
            this.KTPBase64 = "";
            this.getData();
            this.loadingButtonProcess = false;
            this.loadingButtonProcessNo = false;
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    uploadPurchaseOrder() {
      if (this.purchaseFileName == "") {
        swal("Sorry", "purchase file must be choose", "error", {
          button: "Close",
        });
      } else if (this.poNumberInput == "" || this.poNumberInput == null) {
        swal("Sorry", "PO number must be fill", "error", {
          button: "Close",
        });
      } else {
        this.loadingButtonProcess = true;
        var self = this;
        this.$http
          .post(
            process.env.ADD_PURCHASE_ORDER,
            {
              adminId: this.adminId,
              purchaseFileName: this.purchaseFileName !== null ? this.purchaseFileName.replace(this.spaceRegex, ' ') : this.purchaseFileName,
              purchaseBase64: this.purchaseBase64,
              orderId: this.orderId,
              poNumber: this.poNumberInput !== null ? this.poNumberInput.replace(this.spaceRegex, ' ') : this.poNumberInput,
            },
            {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal("Success", response.data.message, "success", {
                button: "Ok",
              });
              this.sendLog(13, "uploadPurchaseOrder");
            }
            if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            $("#modalUploadPurchase").modal("hide");
            document.getElementById("purchaseInput").value = "";
            this.purchaseFileName = "";
            this.purchaseBase64 = "";
            this.getData();
            this.loadingButtonProcess = false;
            this.loadingButtonProcessNo = false;
          })
          .catch(error => {
            // alert("Request timeout / error with api, please try again!");
            self.loadingButtonProcess = false;
            self.loadingButtonProcessNo = false;
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    getNameAssignto(x, z, specificationsView) {
      this.productNameAssignTo = x;
      this.specModal = specificationsView;
      this.conditionNameModal = z;
    },
    mustShowEditModal() {
      this.countShowEditModal++;
      if (
        this.showEditModal == this.countShowEditModal &&
        this.editModalClicked
      ) {
        this.editModalClicked = false;
        this.initEditShowModal();
      }
    },
    initEditShowModal() {
      // category
      for (var i = 0; i < this.typeCatalog.length; i++) {
        if (
          this.selectedDetailOrder.productType ==
          this.typeCatalog[i].catalogType
        ) {
          this.productCategory = this.typeCatalog[i];
        }
      }
      // pilih product
      this.pilihProduct.catalogName = this.detailOrder[this.idx].productTitle;
      // varian
      for (var i = 0; i < this.selectProductVarian.length; i++) {
        if (
          this.selectedDetailOrder.catalogSpecifications ==
            this.selectProductVarian[i].specification &&
          this.selectProductVarian[i].catalogId ==
            this.selectedDetailOrder.catalogId
        ) {
          this.pilihVarian = this.selectProductVarian[i];
        }
      }
      //condition
      for (var i = 0; i < this.selectCondition.length; i++) {
        if (
          this.selectedDetailOrder.condition ==
          this.selectCondition[i].condition
        ) {
          this.conditionChoosed = this.selectCondition[i];
        }
      }
      // duration
      for (var i = 0; i < this.selectProductDuration.length; i++) {
        if (
          this.selectedDetailOrder.durationValue ==
          parseInt(this.selectProductDuration[i].tenorMonths)
        ) {
          // this.editDuration = this.selectProductDuration[i].tenorValue
        }
      }
      this.editPrice = (
        this.selectedDetailOrder.orderItemPrice / this.selectedDetailOrder.qty
      ).toString();
      this.loadingTable = false;
      $("#modalEdit").modal("show");
    },
    getProductName(x) {
      var type;
      if (x == "add") {
        type = this.productCategoryAdd.type;
      } else if (x == "edit") {
        type = this.productCategory.type;
      }
      this.showEditModal++;
      this.selectProductName = [];

      this.$http
        .post(
          process.env.GET_CATALOG_NAME,
          {
            catalogType: type,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            // this.handleLogout();
          } else if (response.data.status == 200) {
            this.selectProductName = response.data.content;
            this.mustShowEditModal();
          }

        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    getProductCondition(x) {
      let name;
      let type;
      let id;
      this.showEditModal++;
      if (x == "add") {
        name = this.pilihProductAdd.catalogName;
        type = this.productCategoryAdd.type;
        id = this.pilihVarianAdd.catalogId;
      } else if (x == "edit") {
        name = this.pilihProduct.catalogName;
        type = this.productCategory.type;
        id = this.pilihVarian.catalogId;
      }
      this.$http
        .post(
          process.env.GET_CATALOG_CONDITION,
          {
            catalogId: id,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            // this.handleLogout();
          } else if (response.data.status == 200) {
            this.conditionChoosed = {
              condition: "Choose Condition",
            };
            this.selectCondition = [];

            for (
              var i = 0;
              i < response.data.content.length;
              i++
            ) {
              // this.selectCondition.push({
              //   condition: response.data.content.productCondition[i].condition,
              //   conditionName:
              //     response.data.content.productCondition[i].conditionName,
              // });
             
              this.selectCondition.push({
                // condition: response.data.content.productCondition[i].condition,
                condition:
                  response.data.content[i],
              });

            }
            this.mustShowEditModal();
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    getProductVarian(x) {
      var name;
      var type;
      var condition;
      this.showEditModal++;
      if (x == "add") {
        name = this.pilihProductAdd.catalogName;
        type = this.productCategoryAdd.type;
        condition = this.conditionChoosedAdd.condition;
      } else if (x == "edit") {
        name = this.pilihProduct.catalogName;
        type = this.productCategory.type;
        condition = this.conditionChoosed.condition;
      }

      this.selectProductVarian = [];
      this.$http
        .post(
          process.env.GET_CATALOG_VARIAN,
          {
            catalogName: name,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            // this.handleLogout();
          } else if (response.data.status == 200) {
          }
          this.selectProductVarian = response.data.content;
          this.mustShowEditModal();
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    getProductDuration(x) {
      var id;
      var condition;
      this.showEditModal++;
      if (x == "add") {
        id = this.pilihVarianAdd.catalogId;
        condition = this.conditionChoosedAdd.condition;
      } else if (x == "edit") {
        id = this.pilihVarian.catalogId;
        condition = this.conditionChoosed.condition;
      }
      this.selectProductDuration = [];
      this.$http
        .post(
          process.env.GET_CATALOG_DURATION,
          {
            catalogId: id,
            condition: condition,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            // this.handleLogout();
          } else if (response.data.status == 200) {
          }
          this.selectProductDuration = response.data.content;
          this.mustShowEditModal();
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    statusName: function (x) {
      if (x == "0") {
        return "Pending";
      } else if (x == "1") {
        return "On Process";
      } else if (x == "2") {
        return "Quotation Review";
      } else if (x == "3") {
        return "Waiting for PO";
      } else if (x == "4") {
        return "Agreement Review";
      } else if (x == "5") {
        return "Waiting for Payment";
      } else if (x == "6") {
        return "Ready to Book";
      } else if (x == "7") {
        return "Ready to Pickup";
      } else if (x == "8") {
        return "Picking Up";
      } else if (x == "9") {
        return "Ready to Prepare";
      } else if (x == "10") {
        return "Prepared";
      } else if (x == "11") {
        return "Ready to Deliver";
      } else if (x == "12") {
        return "Shipping";
      } else if (x == "13") {
        return "Renting";
      } else if (x == "14") {
        return "Finished";
      } else if (x == "15") {
        return "Return Scheduled";
      } else if (x == "16") {
        return "Return Assign";
      } else if (x == "17") {
        return "Return Matched";
      } else if (x == "18") {
        return "Return Unmatched";
      } else if (x == "19") {
        return "Completed";
      } else if (x == "99") {
        return "Cancelled";
      }
    },
    getToday() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      var date = yyyy + "-" + mm + "-" + dd;
      this.todayDate = date;
    },
    invoiceCode: function (x) {
      return x.substr(x.indexOf("/") + 1, 3);
    },
    toArray(x) {
      if (x) {
        var obj = JSON.parse(x);
        this.detailProductBrand = obj.brand;
        this.detailProductModel = obj.model;
        this.detailProductScreen = obj.screen;
        this.detailProductDisplaySize = obj.displaySize;
        this.detailProductDisplayType = obj.displayType;
        this.detailProductPortVGA = obj.portVga;
        this.detailProductPortHDMI = obj.portHdmi;
        this.detailProductPortDvid = obj.portDvid;
        this.detailProductColorTech = obj.colorTech;
        this.detailProductFeature = obj.feature;
        this.detailProductProcessor = obj.processor;
        this.detailProductRAM = obj.ram;
        this.detailProductStorage = obj.storage;
        this.detailProductVGA = obj.vga;
        this.conditionNameModal = this.detailOrder[this.idx].conditionName;
      }
    },
    toPageEditLessor(
      orderId,
      orderCode,
      companyId,
      productId,
      condition,
      action,
      orderItemStatus,
      deliveryDate,
      orderItemDuration,
      qty,
      note,
      price
    ) {
      this.$router.push({
        path: "/order/detail/lessor/" + action,
        query: {
          orderId: orderId,
          orderCode: orderCode,
          companyId: companyId,
          productId: productId,
          condition: condition,
          orderItemStatus: orderItemStatus,
          deliveryDate: deliveryDate,
          orderItemDuration: orderItemDuration,
          qty: qty,
          note: note,
          price
        },
      });
    },
    toDetailExtendBefore(id, orderCode, companyId) {
      window.open(
        this.$router.resolve(
          "/order/detail/" +
            id +
            "?orderCode=?" +
            orderCode +
            "&companyIdDetail=" +
            companyId
        ).href,
        "_blank"
      );
    },
    toDetail(id, orderCode, companyId) {
      this.$router.push({
        path: "/order/detail/" + id,
        query: {
          orderCode: orderCode,
          companyIdDetail: companyId,
        },
      });
      this.getData();
      this.scrollToTop();
    },
    toDetailPast(id, orderCode, companyId) {
      this.$router.push({
        path: "/order/detail/" + id + "/past",
        query: {
          orderCode: orderCode,
          companyIdDetail: companyId,
        },
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    searchReschedule() {
      $("#modalReschedule").modal("show");
      this.loadingTableReschedule = true;
      this.$http
        .post(
          process.env.GET_ALL_ITEM_ORDER,
          {
            orderId: this.orderId,
            past: "no",
            search: this.searchRescheduleText ? this.searchRescheduleText.replace(this.spaceRegex, ' ') : this.searchRescheduleText,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
          } else if (response.data.status == 200) {
            this.editDate = [];
            this.dataAllItem = response.data.content.dataItem;
            for (var i = 0; i <= this.dataAllItem.length; i++) {
              this.editDate.push(this.dataAllItem[i]);
              // console.log(this.dataAllItem[i].deliveryDate)
            }
            this.editDate.pop();
          }
          this.loadingTableReschedule = false;
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    openReschedule() {
      this.editInputDate = false;
      this.searchRescheduleText = "";
      $("#modalReschedule").modal("show");
      this.loadingTableReschedule = true;
      this.$http
        .post(
          process.env.GET_ALL_ITEM_ORDER,
          {
            orderId: this.orderId,
            past: "no",
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            this.handleLogout();
          } else if (response.data.status == 200) {
            this.editDate = [];
            this.dataAllItem = response.data.content.dataItem;
            for (var i = 0; i <= this.dataAllItem.length; i++) {
              this.editDate.push(this.dataAllItem[i]);
              // console.log(this.dataAllItem[i].deliveryDate)
            }
            this.editDate.pop();
          }
          this.loadingTableReschedule = false;
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    openBast() {
      this.bastDate = new Date();
      this.disableTypeBast = false
      this.generate = false;
      this.bastAction = "add";
      $("#modalBast").modal("show");
      this.selectBastItem = [];
      this.loadingTableBast = true;
      this.$http
        .post(
          process.env.GET_ITEM_FOR_BAST,
          {
            orderId: parseInt(this.orderId),
            bastType: this.bastType && this.bastType !== null ? this.bastType.replace(this.spaceRegex, ' ') : this.bastType,
            bastId: ''
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
          } else if (response.data.status == 200) {
            // this.editDate = []
            this.dataAllItemBast = response.data.content || [];
            // for (var i = 0; i <= this.dataAllItemBast.length; i++) {
            //     if (this.dataAllItemBast[i].productType == 1) {
            //     }
            // }
            // this.editDate.pop()
          }
          this.loadingTableBast = false;
        })
        .catch(error => {
          this.loadingTableBast = false;
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          });
        });
    },
    assignDetail(x, y, z, date, max_date, status, id, startRent, duration) {
      $("#modalAssignOrder").modal("show");
      this.typePilih = y;
      this.idx = z;
      this.loadingTableAssign = true;
      this.actualSpecProcessor = [];
      this.actualSpecRAM = [];
      this.actualSpecStorage = [];
      this.actualSpecVGA = [];
      this.erpAcc = [];
      this.$http
        .post(
          process.env.DETAIL_ASSIGN_ORDER,
          {
            orderId: this.orderId,
            productId: x,
            past: "no",
            deliverSchedule: date,
            maxSchedule: max_date,
            itemId: id,
            status: status,
            startRent: startRent,
            duration: parseInt(duration.split(" ")[0]),
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          console.log("response", response);
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            this.handleLogout();
          }
          let details = response.data.content;
          let dps = [];
          this.alt = details;
          // this.detailAssign = response.data.content
          for (let i in details) {
            for (let j in details[i].detailProduct) {
              dps.push(details[i].detailProduct[j]);
            }
          }
          this.detailAssign = dps;
          for (var i = 0; i < dps.length; i++) {
            if (dps[i].actualSpec != null) {
              var spec = JSON.parse(dps[i].actualSpec);
              if (dps[i].productType == 3) {
                this.actualSpecProcessor.push(spec.displaySize + " Inch");
                this.actualSpecRAM.push(spec.displayType);
              } else {
                this.actualSpecProcessor.push(spec.processor);
                this.actualSpecRAM.push(spec.ram + " GB");
                this.actualSpecStorage.push(spec.storage);
                this.actualSpecVGA.push(spec.vga);
              }
            } else {
              this.actualSpecProcessor.push("");
              this.actualSpecRAM.push("");
              this.actualSpecStorage.push("");
              this.actualSpecVGA.push("");
            }
            this.detailAssign[i].status = status;
            if (dps[i].erpAccessories) {
              let pr = JSON.parse(dps[i].erpAccessories);
              this.erpAcc.push(pr);
              // console.log('parsed', pr[0])
              console.log("acc", this.erpAcc);
            }
          }
          var qt = 0;
          response.data.content.forEach((el) => {
            qt += el.qty;
            console.log(qt);
          });
          let detailPlace = [
            {
              pickupPlace: response.data.content[0].pickupPlace,
              pickupPlaceName: response.data.content[0].pickupPlaceName,
              qty: qt,
              pickupSchedule: response.data.content[0].pickupSchedule,
            },
          ];
          this.detailAssignPlace = detailPlace;
          this.loadingTableAssign = false;
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    toInteger(x) {
      return parseInt(x);
    },
    toOrder() {
      this.$router.push({
        path: '/order',
        query: {
          companyName: '',
          orderId: '',
          statusOrder: JSON.stringify([]),
          picId: 'All',
          picName: 'All',
          startRentFrom: '',
          startRentTo: '',
          endRentFrom: '',
          endRentTo: '',
          itemPerPage: 10,
          tagOrder: JSON.stringify([]),
          batch: '',
          sortBy:'',
          page: 1
        }
      })
    },
    pickFotoFile() {
      this.$refs.file_foto.click();
    },
    addOrderItem() {
      if (this.productCategoryAdd.type == "") {
        swal("Sorry", "Product Category must be select", "error", {
          button: "Close",
        });
      } else if (this.pilihProductAdd.catalogId == "") {
        swal("Sorry", "Product must be select", "error", {
          button: "Close",
        });
      } else if (this.pilihVarianAdd.catalogId == "") {
        swal("Sorry", "Product varian must be select", "error", {
          button: "Close",
        });
      } else if (this.conditionChoosedAdd.condition == "Choose Condition") {
        swal("Sorry", "Product condition must be select", "error", {
          button: "Close",
        });
        error = error + 1;
      } else if (this.addDuration == "") {
        swal("Sorry", "Duration must be fill", "error", {
          button: "Close",
        });
      } else if (this.addDuration == "0") {
        swal("Sorry", "Minimal duration is 1 month", "error", {
          button: "Close",
        });
      } else if (parseInt(this.addDuration) > 60) {
        swal("Sorry", "Maximum duration is 60 month", "error", {
          button: "Close",
        });
      } else if (this.addQty == "" || this.addQty < 1) {
        swal(
          "Sorry",
          "Quantity must be fill or minimum Quantity is 1",
          "error",
          {
            button: "Close",
          }
        );
      } else if (this.addQty > 150) {
        swal(
          "Sorry",
          "Maximum Quantity is 150",
          "error",
          {
            button: "Close",
          }
        );
      } 
      // else if (
      //   this.orderStatus == 9 &&
      //   (this.addDeliverSchedule == "" || this.addDeliverSchedule == null)
      // ) {
      //   swal("Sorry", "Deliver schedule must be fill", "error", {
      //     button: "Close",
      //   });
      // } else if (
      //   this.orderStatus == 9 &&
      //   (this.warehouseAdd == "" || this.warehouseAdd == null)
      // ) {
      //   swal("Sorry", "Warehouse must be fill", "error", {
      //     button: "Close",
      //   });
      // } 
      else {
        this.loadingButtonProcess = true;
        if (!this.addNote.replace(/\s/g, "").length) {
          this.addNote = "";
        }
    
        this.$http
          .post(
            process.env.ADD_ORDER_ITEM,
            {
              // adminId: this.adminId,
              orderId: Number(this.orderId),
              duration: Number(this.addDuration),
              catalogId: Number(this.pilihVarianAdd.catalogId),
              orderPrice: Number(this.addPrice),
              orderQty: Number(this.addQty),
              note: this.addNote,
              condition: this.conditionChoosedAdd.condition,
              // deliverSchedule: this.addDeliverSchedule,
              // warehouse: this.warehouseAdd,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal("Success", response.data.message, "success", {
                button: "Ok",
              }).then(() => {
                location.reload()
              });
              this.sendLog(6, "addOrderItem");
              this.productCategoryAdd = {
                catalogType: "Choose Product Category",
                type: "",
                product: [],
              };
              this.inputResetAdd("category");
            } else if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            } else if (response.data.status == 401) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              }).then((value) => {
                this.handleLogout();
              });
            } else if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            this.addDeliverSchedule = "";
            this.warehouseAdd = "";
            $("#modalAdd").modal("hide");
            this.getData();
            this.loadingButtonProcess = false;
          })
          .catch((error) => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    checkIsDataUpdatedOrderProduct() {
      var same = true;
      if (this.pilihVarian.catalogId != this.selectedDetailOrder.catalogId) {
        same = false;
      }
      if (this.pilihVarian.catalogId != this.selectedDetailOrder.catalogId) {
        same = false;
      }
      if (this.editNote != this.selectedDetailOrder.orderItemNote) {
        same = false;
      }
      if (this.editQty != this.selectedDetailOrder.qty) {
        same = false;
      }
      if (
        parseInt(this.selectedDetailOrder.durationValue) !=
        parseInt(this.pilihDurasi.tenorValue)
      ) {
        same = false;
      }
      if (typeof this.pilihDurasi.tenorPrice == "number") {
        if (this.pilihDurasi.tenorPrice != this.selectedDetailOrder.itemPrice) {
          same = false;
        }
      } else if (this.editDuration != this.selectedDetailOrder.itemPrice) {
        same = false;
      }
      return same;
    },
    editOrderItem() {
      var error = 0;
      if (this.productCategory.type == "") {
        swal("Sorry", "Product Category must be select", "error", {
          button: "Close",
        });
        error = error + 1;
      } else if (this.pilihProduct.catalogName == "") {
        swal("Sorry", "Product must be select", "error", {
          button: "Close",
        });
        error = error + 1;
      } else if (this.pilihVarian.catalogId == "") {
        swal("Sorry", "Product varian must be select", "error", {
          button: "Close",
        });
        error = error + 1;
      } else if (this.conditionChoosed.condition == "Choose Condition") {
        swal("Sorry", "Product condition must be select", "error", {
          button: "Close",
        });
        error = error + 1;
      } else if (this.editDuration == "") {
        swal("Sorry", "Duration must be fill", "error", {
          button: "Close",
        });
        error = error + 1;
      } else if (this.editDuration == "0") {
        swal("Sorry", "Minimal duration is 1 month", "error", {
          button: "Close",
        });
      } else if (parseInt(this.editDuration) > 60) {
        swal("Sorry", "Maximum duration is 60 month", "error", {
          button: "Close",
        });
      } else if (this.editQty == "" || this.editQty < 1) {
        swal(
          "Sorry",
          "Quantity must be fill or minimum Quantity is 1",
          "error",
          {
            button: "Close",
          }
        );
        error = error + 1;
      } 
      // else if (this.editQty == "" || this.editQty > 150) {
      //   swal(
      //     "Sorry",
      //     "Quantity must be fill or Maximum Quantity is 150",
      //     "error",
      //     {
      //       button: "Close",
      //     }
      //   );
      //   error = error + 1;
      // } 
      else {
        for (var i = 0; i < this.detailOrder.length; i++) {
          if (
            this.pilihVarian.catalogId == this.detailOrder[i].catalogId &&
            this.editDuration != this.durationBefore
          ) {
  
            if (
              this.pilihVarian.catalogId == this.detailOrder[i].catalogId &&
              this.editDuration == this.detailOrder[i].durationValue &&
              this.conditionChoosed.condition ==
                this.detailOrder[i].condition
            ) {
              swal("Sorry", "Failed to edit product", "error", {
                button: "Close",
              });
              error = error + 1;
              $("#modalEdit").modal("hide");
              return;
            }
          }
        }
      }
      if (error == 0) {
        if (this.checkIsDataUpdatedOrderProduct()) {
          $("#modalEdit").modal("hide");
          swal("Success", "Data updated", "success", {
            button: "Ok",
          });
        } else {
          this.hitUpdateProduct();
        }
      }
    },
    hitUpdateProduct() {
      this.loadingButtonProcess = true;
      if (this.editNote != null && !this.editNote.replace(/\s/g, "").length) {
        this.editNote = "";
      }
      if (this.editNote == null) {
        this.editNote = "";
      }
      this.$http
        .post(
          process.env.EDIT_ORDER_ITEM,
          {
            adminId: this.adminId,
            orderId: Number(this.orderId),
            durationOld: this.selectedDetailOrder.durationValue,
            conditionOld: this.selectedDetailOrder.condition,
            catalogIdOld: this.selectedDetailOrder.catalogId,
            productIdOld: this.selectedDetailOrder.productId,
            duration: Number(this.editDuration),
            catalogId: this.pilihVarian.catalogId,
            orderPrice: Number(this.editPrice),
            condition: this.conditionChoosed.condition,
            orderQty: Number(this.editQty),
            note: this.editNote !== null ? this.editNote.replace(this.spaceRegex, ' ') : this.editNote,
            orderDetailsIds: this.selectedDetailOrder.orderDetailsIds,
            noteBefore: this.selectedDetailOrder.orderItemNote,
          },
          {
            timeout: 180 * 1000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            swal("Success", response.data.message, "success", {
              button: "Ok",
            }).then(() => {
              location.reload()
            });
            if (
              this.productIdOld != this.pilihVarian.productId ||
              this.editQty != this.editQtyBefore
            ) {
              this.sendLog(7, "editOrderItem");
            }
          } else if (response.data.status == 401) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            }).then((value) => {
              this.handleLogout();
            })
          } else {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            
          }
          $("#modalEdit").modal("hide");
          this.getData();
          this.loadingButtonProcess = false;
        })
        .catch((error) => {
          // alert("Request timeout / error with api, please try again!");
          this.loadingButtonProcess = false;
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    deleteOrderItem() {
      this.loadingButtonProcess = true;
      if (this.detailOrder.length == 1) {
        swal("Sorry", "Delete Item Failed", "error", {
          button: "Ok",
        });
        this.loadingButtonProcess = false;
        $("#modalDelete").modal("hide");
      } else {
        this.$http
          .post(
            process.env.DELETE_ORDER_ITEM,
            {
              adminId: this.adminId,
              orderId: parseInt(this.orderId),
              productId: this.selectedDetailOrder.productId,
              catalogId: this.selectedDetailOrder.catalogId,
              duration: this.durationBefore,
              condition: this.conditionDelete !== null ? this.conditionDelete.replace(this.spaceRegex, ' ') : this.conditionDelete,
              orderDetailsIds: this.selectedDetailOrder.orderDetailsIds,
              note: this.selectedDetailOrder.orderItemNote !== null ? this.selectedDetailOrder.orderItemNote.replace(this.spaceRegex, ' ') : this.selectedDetailOrder.orderItemNote,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal("Success", response.data.message, "success", {
                button: "Ok",
              });
              this.sendLog(8, "deleteOrderItem");
            } else if (response.data.status == 401) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            } else {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            $("#modalDelete").modal("hide");
            this.getData();
            this.loadingButtonProcess = false;
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    cekStatusOrder(x) {
      if (x == "Prepare") {
        this.loadingButtonProcess = true;
        this.$http
          .post(
            process.env.CEK_ORDER_STATUS,
            {
              orderId: this.orderId,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            if (x == "Prepare") {
              if (response.data.content == 7) {
                swal(
                  "Sorry",
                  "Sorry, please make sure all items already picked",
                  "error",
                  {
                    button: "Close",
                  }
                );
                $("#modalPrepare").modal("hide");
                this.getData();
                this.loadingButtonProcess = false;
              } else {
                this.updateStatus("Prepare");
              }
            } else {
              if (response.data.content < 11) {
                if (response.data.content > 6 && response.data.content < 11) {
                  swal(
                    "Sorry",
                    "You can't continue process, all items must be prepared",
                    "error",
                    {
                      button: "Close",
                    }
                  );
                } else {
                  swal("Sorry", response.data.message, "error", {
                    button: "Close",
                  });
                }
                $("#modalDeliver").modal("hide");
                this.getData();
                this.loadingButtonProcess = false;
              } else {
                this.updateStatus("Deliver");
              }
            }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      } else if (this.ceklistDeliver.length == 2 && x != "Prepare") {
        var deliverItem = "no";
        if (x == "DeliverItem") {
          deliverItem = "yes";
        }
        this.loadingButtonProcess = true;
        this.$http
          .post(
            process.env.CEK_ORDER_STATUS,
            {
              orderId: this.orderId,
              deliverItem: deliverItem,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            if (x == "Prepare") {
              if (response.data.content == 7) {
                swal(
                  "Sorry",
                  "Sorry, please make sure all items already picked",
                  "error",
                  {
                    button: "Close",
                  }
                );
                $("#modalPrepare").modal("hide");
                this.getData();
                this.loadingButtonProcess = false;
              } else {
                this.updateStatus("Prepare");
              }
            } else if (x == "DeliverItem") {
              if (response.data.content != 24) {
                swal("Sorry", "Item has been execute by other admin", "error", {
                  button: "Close",
                });
                $("#modalDeliver").modal("hide");
                this.getData();
                this.loadingButtonProcess = false;
              } else {
                this.updateStatusItem("DeliverItem");
              }
            } else {
              if (response.data.content < 11) {
                if (response.data.content > 6 && response.data.content < 11) {
                  swal(
                    "Sorry",
                    "You can't continue process, all items must be prepared",
                    "error",
                    {
                      button: "Close",
                    }
                  );
                } else {
                  swal("Sorry", response.data.message, "error", {
                    button: "Close",
                  });
                }
                $("#modalDeliver").modal("hide");
                this.getData();
                this.loadingButtonProcess = false;
              } else {
                this.updateStatus("Deliver");
              }
            }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      } else {
        swal("Sorry", "Please check the devices as SOP", "error", {
          button: "Close",
        });
      }
    },
    updateStatusItem(x) {
      var self = this;
      if (x == "DeliverItem") {
        this.$http
          .post(
            process.env.DELIVER_ITEM,
            {
              adminId: this.adminId,
              orderId: this.orderId,
              update: x,
            },
            {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal("Success", response.data.message, "success", {
                button: "Ok",
              });
              this.sendLog(24, "Deliver");
            }
            if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            $("#modal" + x).modal("hide");
            this.getData();
            this.itemDeliverReplace = 0;
            this.itemStartReplace = 0;
            this.loadingButtonProcess = false;
            this.loadingButtonProcessNo = false;
          })
          .catch(error => {
            // alert("Request timeout / error with api, please try again!");
            self.loadingButtonProcess = false;
            self.loadingButtonProcessNo = false;
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      } else {
        this.loadingButtonProcess = true;
        this.$http
          .post(
            process.env.START_RENT_ITEM,
            {
              adminId: this.adminId,
              orderId: this.orderId,
              imageName: this.rentImageFileName ? this.rentImageFileName.replace(this.spaceRegex, ' ') : this.rentImageFileName,
              imageBase64: this.rentImageBase64,
            },
            {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal(
                "Success",
                "start rent order Id " + this.orderId + " has been succesfull",
                "success",
                {
                  button: "Ok",
                }
              );
              this.sendLog(25, "startRent");
              this.sendLog(26, "startRent");
            }
            if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            $("#modalStartRentItem").modal("hide");
            this.getData();
            this.rentImageFileName = "";
            this.rentImageBase64 = "";
            this.loadingButtonProcess = false;
          })
          .catch(error => {
            // alert("Request timeout / error with api, please try again!");
            self.loadingButtonProcess = false;
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    setReturnSchedule() {
      if (
        this.returnScheduleForm == null ||
        this.returnScheduleForm == "" ||
        this.returnScheduleForm == "Invalid date"
      ) {
        swal("Sorry", "Return Schedule must be select", "error", {
          button: "Close",
        });
      } else if (this.returnScheduleEmployee.lesseeId == 0) {
        swal("Sorry", "Lessee PIC must be select", "error", {
          button: "Close",
        });
      } else if (this.returnPONumber == "") {
        swal("Sorry", "PO Number name must be fill", "error", {
          button: "Close",
        });
      } else if (this.checkedItems.length < 1) {
        swal("Sorry", "Items must be select", "error", {
          button: "Close",
        });
      } else {
        var self = this;
        this.loadingButtonProcess = true;

        let uncheckedItems = []
        this.returnDetail.forEach((item) => {
          if(!this.checkedItems.includes(item.orderDetailsId)) {
            uncheckedItems.push(item.orderDetailsId)
          }
        })
        console.log({
              itemsChecked:  this.checkedItems,
              itemsUnchecked: uncheckedItems,
              orderId: this.orderId,
              companyId: this.companyId,
              returnSchedule: this.returnScheduleForm,
              poNumber:this.returnPONumber,
              lesseePic: this.returnScheduleEmployee.lesseeId,
            })
        this.$http
          .post(
            process.env.RETURN_SET,
            {
              itemsChecked:  this.checkedItems,
              itemsUnchecked: uncheckedItems,
              orderId: Number(this.orderId),
              companyId: this.companyId,
              returnSchedule: this.returnScheduleForm,
              poNumber:this.returnPONumber,
              lesseePic: Number(this.returnScheduleEmployee.lesseeId),
            },
            {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal("Success", "Return successfully scheduled", "success", {
                button: "Ok",
              });
            }
            if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });

            }
            $("#modalSetReturn").modal("hide");
            this.returnScheduleForm = "";
            this.returnScheduleEmployee = "";
            this.returnPONumber = "";
            this.checkedItems = [];
            this.getData();
            this.loadingButtonProcess = false;
          })
          .catch(error => {
            alert("Request timeout / error with api, please try again!");
            self.loadingButtonProcess = false;
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    updateStatus(x, y) {
      if (x == "SendAgreement") {
        // if(this.NPWPStatus != '1' || this.userKTPStatus != '1'){
        //     swal("Oops", "All document must be approved" , "error", {
        //       button: "Ok",
        //     })
        //     this.loadingButtonProcess = false
        //     $('#modal'+x).modal('hide')
        //     this.scrollToTop()
        //     return
        // }
      }
      var self = this;
      var reject = "no";
      var message = "Order Id " + this.orderId + " has been " + x;
      var quotation = "";
      if (x == "Process") {
        message = "Order ID " + this.orderId + " is being processed.";
      } else if (x == "Quotation") {
        message = "Quotation of order ID " + this.orderId + " was sent.";
        quotation = "send";
      } else if (x == "RenewQuotation") {
        message = "Quotation of order ID " + this.orderId + " was renew.";
        quotation = "renew";
        this.sendLog(66, "renewPo");
      } else if (x == "Verify") {
        message = "Documents of order ID " + this.orderId + " was verified.";
      } else if (x == "SendAgreement") {
        message = "Agreement of order ID " + this.orderId + " was sent.";
      } else if (x == "SendInvoice") {
        message = "Invoice of order ID " + this.orderId + " was sent.";
      } else if (x == "Paid") {
        message = "Invoice of order ID " + this.orderId + " was paid.";
      } else if (x == "Reject") {
        if (this.inputReason == "") {
          swal("Sorry", "Reason must be fill", "error", {
            button: "Close",
          });
        } else {
          message = "order ID " + this.orderId + " was rejected.";
          reject = "yes";
          this.loadingButtonProcess = true;
       
          this.$http
            .post(
              process.env.REJECT_ORDER,
              {
                companyId: this.companyId,
                orderId: parseInt(this.orderId),
                reason: this.inputReason,
              },
              {
                timeout: 30 * 1000,
                headers: { "Asani-Token": localStorage.getItem("jwt") },
              }
            )
            .then((response) => {
              if (response.data.status == 200) {
                swal("Success", message, "success", {
                  button: "Ok",
                }).then((value) => {
                  this.getData();
                });
                this.sendLog(2, "Reject");
              } else {
                swal("Sorry", response.data.message, "error", {
                  button: "Close",
                }).then((value) => {
                  if (response.data.status == 401) {
                    this.handleLogout();
                  } else {
                    this.getData();
                  }
                });
                
              }
              $("#modal" + x).modal("hide");
              
              this.loadingButtonProcess = false;
              this.loadingButtonProcessNo = false;
            })
            .catch((error) => {
              alert("Request timeout / error with api, please try again!");
              self.loadingButtonProcess = false;
              self.loadingButtonProcessNo = false;
              swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
              }).then(v => {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              })
            });
        }
      }
      if (x != "Reject") {
        if (x == "Paid") {
          // new Date(this.paidDate).getSeconds()
          // console.log((this.paidDate.match(/:/g) || []).length)
          if (this.paidDate == "" || this.paidDate == null) {
            swal("Sorry", "Date must be select.", "error", {
              button: "Close",
            });
          } else {
            if (y == "No") {
              this.loadingButtonProcessNo = true;
            } else {
              this.loadingButtonProcess = true;
            }
            // this.$http
            //   .post(
            //     process.env.UPDATE_ORDER_STATUS,
            //     {
            //       adminId: this.adminId,
            //       orderId: this.orderId,
            //       orderStatus: this.orderStatus,
            //       invoice: y,
            //       totalPrice: this.totalPrice,
            //       picId: this.picId,
            //       reject: reject,
            //       // quotationStatus: this.quotationStatus,
            //       quotation: quotation,
            //       paidDate: this.dateToString(this.paidDate, true),
            //     },
            //     {
            //       timeout: 30 * 1000,
            //       headers: { "Asani-Token": localStorage.getItem("jwt") },
            //     }
            //   )
            this.$http
              .post(
                process.env.UPDATE_INVOICE_PAID,
                {
                  orderId: Number(this.orderId),
                  paidDate: this.dateToString(this.paidDate, true),
                },
                {
                  timeout: 30 * 1000,
                  headers: { "Asani-Token": localStorage.getItem("jwt") },
                }
              )
              .then((response) => {
                if (response.data.status == 200) {
                  swal("Success", message, "success", {
                    button: "Ok",
                  });
                  if (x == "Process") {
                    this.sendLog(3, x);
                  } else if (x == "Quotation") {
                    this.sendLog(4, x);
                  } else if (x == "RenewQuotation") {
                    // if (this.quotationStatus == '2') {
                    //     this.sendLog(4,x)
                    // }else if (this.quotationStatus == '1') {
                    //     this.sendLog(5,x)
                    // }
                  } else if (x == "Paid") {
                    this.sendLog(18, x);
                  } else if (x == "Deliver") {
                    this.sendLog(24, x);
                  }
                }
                if (response.data.status == 201) {
                  swal("Sorry", response.data.message, "error", {
                    button: "Close",
                  });
                }
                if (response.data.status == 400) {
                  swal("Sorry", response.data.message, "error", {
                    button: "Close",
                  });
                  this.handleLogout();
                }
                $("#modal" + x).modal("hide");
                this.getData();
                this.loadingButtonProcess = false;
                this.loadingButtonProcessNo = false;
              })
              .catch((error) => {
                alert("Request timeout / error with api, please try again!");
                self.loadingButtonProcess = false;
                self.loadingButtonProcessNo = false;
                swal("Sorry", error.response.data.message, "error", {
                  button: "Ok",
                }).then(v => {
                  if(error.response.data.status == 401) {
                    this.handleLogout()
                  }
                })
              });
          }
        } else if (x == "Quotation" || x == "RenewQuotation") {
          if (
            x == "Quotation" &&
            (this.sendQuotationDate == "" || this.sendQuotationDate == null)
          ) {
            swal("Sorry", "Time must be fill.", "error", {
              button: "Close",
            });
          } else if (
            x == "RenewQuotation" &&
            (this.renewQuotationDate == "" || this.renewQuotationDate == null)
          ) {
            swal("Sorry", "Time must be fill.", "error", {
              button: "Close",
            });
          } else {
            if (y == "No") {
              this.loadingButtonProcessNo = true;
            } else {
              this.loadingButtonProcess = true;
            }
            let time = null;
            if (x == "Quotation") {
              time = this.sendQuotationDate;
            } else if (x == "RenewQuotation") {
              time = this.renewQuotationDate;
            } else if (x == "SendAgreement") {
              time = this.sendAgreementDate;
            } else if (x == "ProcessAgreement") {
              time = this.processAgreementDate;
            } else if (x == "SendInvoice") {
              time = this.sendInvoiceDate;
            }
            this.$http
              .post(
                process.env.UPDATE_ORDER_STATUS,
                {
                  adminId: this.adminId,
                  orderId: this.orderId,
                  orderStatus: this.orderStatus,
                  invoice: y,
                  totalPrice: this.totalPrice,
                  picId: this.picId,
                  reject: reject,
                  // quotationStatus: this.quotationStatus,
                  quotation: quotation,
                  time: this.dateToString(time, false),
                },
                {
                  timeout: 30 * 1000,
                  headers: { "Asani-Token": localStorage.getItem("jwt") },
                }
              )
              .then((response) => {
                if (response.data.status == 200) {
                  swal("Success", message, "success", {
                    button: "Ok",
                  });
                  if (x == "Process") {
                    this.sendLog(3, x);
                  } else if (x == "Quotation") {
                    this.sendLog(4, x);
                  } else if (x == "RenewQuotation") {
                    // if (this.quotationStatus == '2') {
                    //     this.sendLog(4,x)
                    // }else if (this.quotationStatus == '1') {
                    //     this.sendLog(5,x)
                    // }
                  } else if (x == "Paid") {
                    this.sendLog(18, x);
                  } else if (x == "Deliver") {
                    this.sendLog(24, x);
                  }
                }
                if (response.data.status == 201) {
                  swal("Sorry", response.data.message, "error", {
                    button: "Close",
                  });
                }
                if (response.data.status == 400) {
                  swal("Sorry", response.data.message, "error", {
                    button: "Close",
                  });
                  this.handleLogout();
                }
                $("#modal" + x).modal("hide");
                this.getData();
                this.processAgreementDate = "";
                this.loadingButtonProcess = false;
                this.loadingButtonProcessNo = false;
              })
              .catch((error) => {
                alert("Request timeout / error with api, please try again!");
                self.loadingButtonProcess = false;
                self.loadingButtonProcessNo = false;
                swal("Sorry", error.response.data.message, "error", {
                  button: "Ok",
                }).then(v => {
                  if(error.response.data.status == 401) {
                    this.handleLogout()
                  }
                })
              });
          }
        } else {
          if (y == "No") {
            this.loadingButtonProcessNo = true;
          } else {
            this.loadingButtonProcess = true;
          }
          this.$http
            .post(
              process.env.UPDATE_ORDER_STATUS,
              {
                adminId: this.adminId,
                orderId: this.orderId,
                orderStatus: this.orderStatus,
                invoice: y,
                totalPrice: this.totalPrice,
                picId: this.picId,
                reject: reject,
                // quotationStatus: this.quotationStatus,
                quotation: quotation,
              },
              {
                timeout: 30 * 1000,
                headers: { "Asani-Token": localStorage.getItem("jwt") },
              }
            )
            .then((response) => {
              if (response.data.status == 200) {
                swal("Success", message, "success", {
                  button: "Ok",
                });
                if (x == "Process") {
                  this.sendLog(3, x);
                } else if (x == "Quotation") {
                  this.sendLog(4, x);
                } else if (x == "RenewQuotation") {
                  // if (this.quotationStatus == '2') {
                  //     this.sendLog(4,x)
                  // }else if (this.quotationStatus == '1') {
                  //     this.sendLog(5,x)
                  // }
                } else if (x == "Paid") {
                  this.sendLog(18, x);
                } else if (x == "Deliver") {
                  this.sendLog(24, x);
                }
              }
              if (response.data.status == 201) {
                swal("Sorry", response.data.message, "error", {
                  button: "Close",
                });
              }
              if (response.data.status == 400) {
                swal("Sorry", response.data.message, "error", {
                  button: "Close",
                });
                this.handleLogout();
              }
              $("#modal" + x).modal("hide");
              this.getData();
              this.loadingButtonProcess = false;
              this.loadingButtonProcessNo = false;
            })
            .catch((error) => {
              alert("Request timeout / error with api, please try again!");
              self.loadingButtonProcess = false;
              self.loadingButtonProcessNo = false;
              swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
              }).then(v => {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              })
            });
        }
      }
    },
    updateDocStatus(x) {
      if (x == "KTP") {
        if (this.KTPNumber == "" && this.docStatus != 2) {
          swal("Sorry", "Please fill the KTP Number", "error", {
            button: "Close",
          });
        } else if (this.KTPNumber.length != 16 && this.docStatus != 2) {
          swal("Sorry", "KTP Number must be 16 Digit", "error", {
            button: "Close",
          });
        } else if (this.docStatus == 0) {
          swal("Sorry", "Please choose status", "error", {
            button: "Close",
          });
        } else if (this.docStatus == 2) {
          if (this.rejectReason == "") {
            swal("Sorry", "Please fill reason", "error", {
              button: "Close",
            });
          } else {
            this.loadingButtonProcess = true;
            this.loadingStatusKTP = true;
            this.submitDocStatus(x);
          }
        } else {
          this.loadingButtonProcess = true;
          this.loadingStatusKTP = true;
          this.submitDocStatus(x);
        }
      } else if (x == "Akta") {
        if (this.aktaAdressInput == "" && this.docStatus != 2) {
          swal("Sorry", "Please fill akta address", "error", {
            button: "Close",
          });
        } else if (this.docStatus == 0) {
          swal("Sorry", "Please choose status", "error", {
            button: "Close",
          });
        } else if (this.docStatus == 2) {
          if (this.rejectReason == "") {
            swal("Sorry", "Please fill reason", "error", {
              button: "Close",
            });
          } else {
            this.loadingButtonProcess = true;
            this.loadingStatusAkta = true;
            this.submitDocStatus(x);
          }
        } else {
          this.loadingButtonProcess = true;
          this.loadingStatusAkta = true;
          this.submitDocStatus(x);
        }
      } else if (x == "NPWP/SKT") {
        if (this.NpwpDocInput == "" && this.docStatus != 2) {
          swal("Sorry", "Please fill NPWP Number", "error", {
            button: "Close",
          });
        } else if (this.docStatus == 0) {
          swal("Sorry", "Please choose status", "error", {
            button: "Close",
          });
        } else if (this.docStatus == 2) {
          if (this.rejectReason == "") {
            swal("Sorry", "Please fill reason", "error", {
              button: "Close",
            });
          } else {
            this.loadingButtonProcess = true;
            this.loadingStatusNPWP = true;
            this.submitDocStatus(x);
          }
        } else {
          this.loadingButtonProcess = true;
          this.loadingStatusNPWP = true;
          this.submitDocStatus(x);
        }
      } else if (x == "SIUP" || x == "SK Menkumham") {
        if (this.docStatus == 0) {
          swal("Sorry", "Please choose status", "error", {
            button: "Close",
          });
        } else if (this.docStatus == 2) {
          if (this.rejectReason == "") {
            swal("Sorry", "Please fill reason", "error", {
              button: "Close",
            });
          } else {
            if (x == "NPWP/SKT") {
              this.loadingStatusNPWP = true;
            } else if (x == "Akta") {
              this.loadingStatusAkta = true;
            } else if (x == "SIUP") {
              this.loadingStatusSiup = true;
            } else if (x == "Purchase Order") {
              this.loadingStatusPurchase = true;
            } else if (x == "SK Menkumham") {
              this.loadingStatusSKM = true;
            }
            this.loadingButtonProcess = true;
            this.submitDocStatus(x);
          }
        } else {
          if (x == "NPWP/SKT") {
            this.loadingStatusNPWP = true;
          } else if (x == "Akta") {
            this.loadingStatusAkta = true;
          } else if (x == "SIUP") {
            this.loadingStatusSiup = true;
          } else if (x == "Purchase Order") {
            this.loadingStatusPurchase = true;
          } else if (x == "SK Menkumham") {
            this.loadingStatusSKM = true;
          }
          this.loadingButtonProcess = true;
          this.submitDocStatus(x);
        }
      } else if (x == "Purchase Order") {
        if (this.docStatus == 0) {
          swal("Sorry", "Please choose status", "error", {
            button: "Close",
          });
        } else if (this.docStatus == 2) {
          if (this.rejectReason == "") {
            swal("Sorry", "Please fill reason", "error", {
              button: "Close",
            });
          } else {
            if (x == "NPWP/SKT") {
              this.loadingStatusNPWP = true;
            } else if (x == "Akta") {
              this.loadingStatusAkta = true;
            } else if (x == "SIUP") {
              this.loadingStatusSiup = true;
            } else if (x == "Purchase Order") {
              this.loadingStatusPurchase = true;
            }
            this.loadingButtonProcess = true;
            this.submitDocStatus(x);
          }
        } else {
          if (x == "NPWP/SKT") {
            this.loadingStatusNPWP = true;
          } else if (x == "Akta") {
            this.loadingStatusAkta = true;
          } else if (x == "SIUP") {
            this.loadingStatusSiup = true;
          } else if (x == "Purchase Order") {
            this.loadingStatusPurchase = true;
          }
          this.loadingButtonProcess = true;
          this.submitDocStatus(x);
        }
      }
    },
    submitDocStatus(x) {
      this.$http
        .post(
          process.env.UPDATE_DOC_STATUS,
          {
            userId: this.userId,
            type: x,
            userKTP: this.KTPNumber,
            newStatus: this.docStatus,
            adminId: this.adminId,
            orderId: this.orderId,
            rejectReason: this.rejectReason !== null  ? this.rejectReason.replace(this.spaceRegex, ' ') : this.rejectReason,
            npwpNumber: this.NpwpDocInput !== null ? this.NpwpDocInput.replace(this.spaceRegex, ' ') : this.NpwpDocInput,
            aktaAddress: this.aktaAdressInput !== null ? this.aktaAdressInput.replace(this.spaceRegex, ' ') : this.aktaAdressInput,
            newUser: this.newUser,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            this.handleLogout();
          }
          if (response.data.status == 200) {
            swal("Success", response.data.message, "success", {
              button: "Close",
            });
          }
          if (x == "KTP") {
            this.loadingStatusKTP = false;
          } else if (x == "NPWP/SKT") {
            this.loadingStatusNPWP = false;
          } else if (x == "SIUP") {
            this.loadingStatusSiup = false;
          } else if (x == "Akta") {
            this.loadingStatusAkta = false;
          } else if (x == "Purchase Order") {
            this.loadingStatusPurchase = false;
          } else if (x == "SK Menkumham") {
            this.loadingStatusSKM = false;
          }
          $("#modalDocPending").modal("hide");
          this.getData();
          this.loadingButtonProcess = false;
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    ValidateFileUpload(x) {
      this.file = this.$refs.file.files[0];
      var fuData = document.getElementById("file_foto_" + x);
      var FileUploadPath = fuData.value;
      if (FileUploadPath == "") {
        alert("Please upload an image");
      } else {
        var Extension = FileUploadPath.substring(
          FileUploadPath.lastIndexOf(".") + 1
        ).toLowerCase();
        if (Extension == "png" || Extension == "jpg") {
          if (fuData.files && fuData.files[0]) {
            var reader = new FileReader();
            reader.onload = function (e) {
              $("#show_img_" + x).attr("src", e.target.result);
            };
            reader.readAsDataURL(fuData.files[0]);
          }
        } else {
          alert("Photo only allows file types of PNG.");
          document.getElementById("file_foto_" + x).value = "";
          // document.getElementById("show_img_"+index).src = './images/no-image-icon-23485.png';
        }
      }
    },
    onrentImagePicked(e, f) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.rentImageFileName = files[0].name;
        if (this.rentImageFileName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.rentImageUrl = fr.result;
          this.rentImageFile = files[0]; // this is an image file that can be sent to server...
          this.rentImageBase64 = fr.result.split("base64,")[1];
          if (f != "") {
            $("#show_img_rent_item").attr("src", this.rentImageUrl);
          } else {
            $("#show_img_rent").attr("src", this.rentImageUrl);
          }
          if (
            this.rentImageFile.size >= 2000000 ||
            (!this.rentImageFileName.toLowerCase().includes(".png") &&
              !this.rentImageFileName.toLowerCase().includes(".jpeg") &&
              !this.rentImageFileName.toLowerCase().includes(".jpg"))
          ) {
            var message = "Ukuran foto tidak boleh lebih dari 2MB";
            if (
              !this.rentImageFileName.toLowerCase().includes(".png") &&
              !this.rentImageFileName.toLowerCase().includes(".jpeg") &&
              !this.rentImageFileName.toLowerCase().includes(".jpg")
            ) {
              message = "Tipe file harus .jpeg atau .jpg atau .png";
            }
            swal(message, "", "warning", {
              buttons: {
                agree: "OK",
              },
            }).then((value) => {
              this.rentImageFileName = "";
              this.rentImageFile = "";
              this.rentImageUrl = "";
              $("#show_img_rent").attr(
                "src",
                "https://www.freeiconspng.com/uploads/no-image-icon-6.png"
              );
              document.getElementById("file_foto_rent").value = "";
              this.pickFotoFile();
            });
          }
        });
      } else {
        this.rentImageFileName = "";
        this.rentImageFile = "";
        this.rentImageUrl = "";
      }
    },
    onFilePicked(e, x) {
      const files = e.target.files;
      if (x == "purchase") {
        if (files[0] != undefined) {
          this.purchaseFileName = files[0].name;
          if (this.purchaseFileName.lastIndexOf(".") <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(files[0]);
          fr.addEventListener("load", () => {
            this.purchaseOrderUrl = fr.result;
            this.purchaseFile = files[0]; // this is an image file that can be sent to server...
            this.purchaseBase64 = fr.result.split("base64,")[1];
            if (
              this.purchaseFileName.toLowerCase().includes(".png") ||
              this.purchaseFileName.toLowerCase().includes(".jpeg") ||
              this.purchaseFileName.toLowerCase().includes(".jpg") ||
              this.purchaseFileName.toLowerCase().includes(".pdf")
            ) {
              if (this.purchaseFile.size >= 10000000) {
                swal("Maximum file size 10MB", "", "warning", {
                  buttons: {
                    agree: "OK",
                  },
                });
                this.purchaseFileName = "";
                this.purchaseFile = "";
                this.purchaseOrderUrl = "";
                document.getElementById("purchaseInput").value = "";
              }
            } else {
              swal(
                "file type must be .jpeg or .jpg or .png or .pdf",
                "",
                "warning",
                {
                  buttons: {
                    agree: "OK",
                  },
                }
              );
              this.purchaseFileName = "";
              this.purchaseFile = "";
              this.purchaseOrderUrl = "";
              document.getElementById("purchaseInput").value = "";
            }
          });
        } else {
          this.purchaseFileName = "";
          this.purchaseFile = "";
          this.purchaseOrderUrl = "";
          document.getElementById("purchaseInput").value = "";
        }
      }
    },
    cekPermission() {
      this.permission = localStorage
        .getItem("roles")
        .replace(/"/g, "")
        .replace("[", "")
        .replace("]", "")
        .split(",");
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true;
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true;
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true;
        }
        if(this.permission[i] == "2.4") {
          this.editOrderPriority = true
        }
        if (this.permission[i] == "3.1") {
          this.viewReturn = true;
        }
        if (this.permission[i] == "3.2") {
          this.editReturn = true;
        }
        if (this.permission[i] == "4.1") {
          this.viewProduct = true;
        }
        if (this.permission[i] == "4.2") {
          this.editProduct = true;
        }
        if (this.permission[i] == "5.1") {
          this.viewPairing = true;
        }
        if (this.permission[i] == "5.2") {
          this.editPairing = true;
        }
        if (this.permission[i] == "6") {
          this.viewReconcile = true;
        }
        if (this.permission[i] == "7.1") {
          this.viewResolution = true;
        }
        if (this.permission[i] == "7.2") {
          this.editResolution = true;
        }
        if (this.permission[i] == "8.1") {
          this.viewLessor = true;
        }
        if (this.permission[i] == "8.2") {
          this.editLessor = true;
        }
        if (this.permission[i] == "9.1") {
          this.viewLessee = true;
        }
        if (this.permission[i] == "9.2") {
          this.editLessee = true;
        }
        if (this.permission[i] == "10") {
          this.viewEmployee = true;
        }
      }
      if (this.viewOrder == false) {
        this.$router.push("/");
      }
    },
    minimumcharacter(x, y) {
      if (y == "assignto") {
        var jml = this.vendorQty[x];
        this.vendorQty[x] = parseInt(this.vendorQty[x]);
        if (jml < 1) {
          this.vendorQty[x] = 0;
        }
      } else if (y == "editInvoice") {
        var jml = this.dataEditInvoice[x].orderItemPrice;
        this.dataEditInvoice[x].orderItemPrice = parseInt(
          this.dataEditInvoice[x].orderItemPrice.replace(/\./g, "")
        );
        if (jml < 1) {
          this.dataEditInvoice[x].orderItemPrice = 0;
        }
      } else {
        if (x == "c") {
          var jml = this.chargePrice;
          this.chargePrice = parseInt(this.chargePrice.replace(/\./g, ""));
          if (jml < 1) {
            this.chargePrice = "0";
          }
        } else if (x == "d") {
          var jml = this.discountPrice;
          this.discountPrice = parseInt(this.discountPrice.replace(/\./g, ""));
          if (jml < 1) {
            this.discountPrice = "0";
          }
        } else if (x == "t") {
          var jml = this.taxPrice;
          this.taxPrice = parseInt(this.taxPrice.replace(/\./g, ""));
          if (jml < 1) {
            this.taxPrice = "0";
          }
        }
      }
    },
    cekFieldAssignTo(x, y) {
      var error = 0;
      if (this.plusIdx == 0) {
        if (this.deliveryDate[x] == "" || this.deliveryDate[x] == null) {
          console.log(this.plusIdx);
          swal("Sorry", "Delivery date must be pick", "error", {
            button: "Close",
          });
          error = error + 1;
        } else if (this.assignVendor[x].vendorId == "") {
          swal("Sorry", "Vendor name must be select", "error", {
            button: "Close",
          });
          error = error + 1;
        } else if (this.vendorQty[x] == "" || this.vendorQty[x] == "0") {
          swal("Sorry", "Minimum Quantity is 1", "error", {
            button: "Close",
          });
          error = error + 1;
        } else if (this.pickupDate[x] == "" || this.pickupDate[x] == null) {
          swal("Sorry", "Pickup date must be pick", "error", {
            button: "Close",
          });
          error = error + 1;
        } else if (
          this.assignVendor[x].lessorId == 4 &&
          (this.stockPrice[x] == "" || this.stockPrice[x] == null)
        ) {
          swal("Sorry", "Stock Price must be entered", "error", {
            button: "Close",
          });
          error = error + 1;
        }
        if (error == 0) {
          if (y == "plus") {
            if (this.vendorQty[x] >= this.maxQty) {
              swal("Sorry", "Maximum Quantity is " + this.maxQty, "error", {
                button: "Close",
              });
              error = error + 1;
            } else {
              return error;
            }
          } else if (y == "save") {
            if (this.vendorQty[x] != this.maxQty) {
              swal("Sorry", "Total Quantity must be " + this.maxQty, "error", {
                button: "Close",
              });
              error = error + 1;
            } else {
              return error;
            }
          }
        }
      } else if (this.plusIdx > 0) {
        var i = 0;
        var totalQty = 0;
        for (var i = 0; i < this.plusIdx + 1; i++) {
          totalQty = totalQty + parseInt(this.vendorQty[i]);
        }
        console.log(this.plusIdx);
        for (i = 0; i < this.plusIdx + 1; i++) {
          if (y == "plus") {
            if (this.deliveryDate[i] == "" || this.deliveryDate[i] == null) {
              swal("Sorry", "Delivery date must be pick", "error", {
                button: "Close",
              });
              error = error + 1;
            } else if (this.assignVendor[i].vendorId == "") {
              swal("Sorry", "Vendor name must be select", "error", {
                button: "Close",
              });
              error = error + 1;
            } else if (this.vendorQty[i] == "" || this.vendorQty[i] == "0") {
              swal("Sorry", "Minimum Quantity is 1", "error", {
                button: "Close",
              });
              error = error + 1;
            } else if (totalQty >= this.maxQty) {
              swal("Sorry", "Maximum Quantity is " + this.maxQty, "error", {
                button: "Close",
              });
              error = error + 1;
            } else if (this.pickupDate[i] == "" || this.pickupDate[i] == null) {
              swal("Sorry", "Pickup date must be pick", "error", {
                button: "Close",
              });
              error = error + 1;
            } else if (
              this.assignVendor[i].lessorId == 4 &&
              (this.stockPrice[i] == "" || this.stockPrice[i] == null)
            ) {
              swal("Sorry", "Stock Price must be entered", "error", {
                button: "Close",
              });
              error = error + 1;
            }
          } else if (y == "save") {
            if (this.deliveryDate[i] == "" || this.deliveryDate[i] == null) {
              console.log("masuk");
              console.log(i);
              swal("Sorry", "Delivery date must be pick", "error", {
                button: "Close",
              });
              error = error + 1;
            } else if (this.assignVendor[i].vendorId == "") {
              swal("Sorry", "Vendor name must be select", "error", {
                button: "Close",
              });
              error = error + 1;
            } else if (totalQty != this.maxQty) {
              swal("Sorry", "Total Quantity must be " + this.maxQty, "error", {
                button: "Close",
              });
              error = error + 1;
            } else if (this.pickupDate[i] == "" || this.pickupDate[i] == null) {
              swal("Sorry", "Pickup date must be pick", "error", {
                button: "Close",
              });
              error = error + 1;
            } else if (
              this.assignVendor[i].lessorId == 4 &&
              (this.stockPrice[i] == "" || this.stockPrice[i] == null)
            ) {
              swal("Sorry", "Stock Price must be entered", "error", {
                button: "Close",
              });
              error = error + 1;
            }
          }
        }
        return error;
      }
    },
    addRow(x) {
      console.log(this.plusIdx);
      if (this.cekFieldAssignTo(x, "plus") == "0") {
        this.plusIdx = this.plusIdx + 1;
        this.assignVendor.push({
          lessorId: "",
          vendorId: "",
          vendorName: "Select Supplier",
        });
        this.vendorQty.push(0);
        this.deliveryDate.push("");
        this.inputs.push({
          one: "",
          two: "",
        });
        // console.log(this.inputs.length)
        // console.log(this.assignVendor.length)
        // console.log(this.inputs.length)
        this.stockPrice[this.plusIdx] = this.stockPrice[this.plusIdx - 1];
        this.pickupDate[this.plusIdx] = this.pickupDate[this.plusIdx - 1];
        this.deliveryDate[this.plusIdx] = this.deliveryDate[this.plusIdx - 1];
        this.lengthInput = this.inputs.length;
      }
    },
    removeRow(x) {
      this.assignVendor.splice(x + 1, 1);
      this.inputs.splice(x, 1);
      this.vendorQty.splice(x + 1, 1);
      this.deliveryDate.splice(x + 1, 1);
      this.stockPrice.splice(x + 1, 1);
      this.pickupDate.splice(x + 1, 1);
      this.plusIdx = this.plusIdx - 1;
      // this.pilihDurasiAdd.splice(x+1,1)
    },
    cekHaveDeposit() {
      var x = document.getElementById("haveDeposit").checked;
      if (x) {
        this.assignDeposit = 1;
      } else {
        this.assignDeposit = 0;
      }
    },
    openCannotModifyModal(action) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      if(!this.isNotReserved) {
        swalWithBootstrapButtons
              .fire({
                title: "Sorry",
                icon: "error",
                html: `
                        <div style="max-width : 100%; font-size : 16px;">
                          Order ini memiliki unit yang telah di-reservasi oleh tim Warehouse. Silakan hubungi tim Warehouse(Anggun) untuk membatalkan reservasi order ini. Setelah itu, Anda dapat mencoba melakukan ${action} pada order ini kembali.
                        </div>
                      `,
                confirmButtonText: `Close`,
                showConfirmButton: true,
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
      }
    },
    openModalEditInvoice(x, y, z, a) {
      this.paymentId = x;
      this.date = y;
      this.invoiceTo = z;
      this.loadingTableEdit = true;
      this.chargePrice = "0";
      this.discountPrice = "0";
      this.taxPrice = "0";
      this.totalInvoice = a;
      this.$http
        .post(
          process.env.GET_EDIT_INVOICE,
          {
            orderId: this.orderId,
            paymentId: x,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            this.handleLogout();
          }
          this.dataEditInvoice = response.data.content.detailOrder;
          this.chargePrice =
            response.data.content.dataPayment[0].chargePrice.toString();
          this.discountPrice =
            response.data.content.dataPayment[0].discountPrice.toString();
          this.taxPrice =
            response.data.content.dataPayment[0].taxPrice.toString();
          this.loadingTableEdit = false;
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
      $("#modalEditInvoice").modal("show");
    },
    openModalCompany(x, y) {
      this.idxcompany = y;
      $("#modal" + x).modal("show");
    },
    openGenerateQuotation() {
      this.generatQuotationDate = new Date();
      $("#modalGenerateQuotation").modal("show");
      this.resetGenerateQuotation();
    },
    openModalOne(name) {
      var today = new Date();
      var month = today.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var dateDay = today.getDate();
      if (dateDay < 10) {
        dateDay = "0" + dateDay;
      }
      var hours = today.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = today.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var second = today.getSeconds();
      if (second < 10) {
        second = "0" + second;
      }
      var date = today.getFullYear() + "-" + month + "-" + dateDay;
      var time = hours + ":" + minutes;
      var dateTime = date + "T" + time;
      if (name == "Quotation") {
        this.sendQuotationDate = new Date();
      } else if (name == "RenewQuotation") {
        this.renewQuotationDate = new Date();
      } else if (name == "SendAgreement") {
        this.sendAgreementDate = new Date();
      } else if (name == "ProcessAgreement") {
        this.processAgreementDate = new Date();
      } else if (name == "SendInvoice" || name == "RenewInvoice") {
        this.sendInvoiceDate = new Date();
      } else if (name == "ProcessInvoice") {
        this.processInvoiceDate = new Date();
      } else if (name == "Paid") {
        this.paidDate = new Date();
      } else if (name == "EditDepositDate") {
        this.getData();
      } else if (name == "Process" || name == "Match") {
        if (!this.asaniEmployeeName || !this.isStagingOrderSetupValid || !this.dealOwner) {
          swal(
            "Sorry",
            "Pilih PIC Asani, Deal Owner, dan Pengaturan Staging Order terlebih dahulu.",
            "error",
            {
              button: "Close",
            }
          );
          this.getData();
        } else {
          $("#modal" + name).modal("show");
        }
      }
      if (name != "Process" && name != "Match") {
        if (name == "Add") {
          this.warehouseAdd = "";
          this.addDeliverSchedule = "";
          if (this.orderStatus == 9) {
            this.$http
              .get(process.env.GET_ALL_LESSOR, {
                headers: {
                  "Asani-Token": localStorage.getItem("jwt"),
                },
              })
              .then((response) => {
                if (response.data.status == 400) {
                  swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  });
                } else {
                  this.warehouseList = response.data.content;
                }
              })
              .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                  button: "Ok",
                }).then(v => {
                  if(error.response.data.status == 401) {
                    this.handleLogout()
                  }
                })
              });
          }
        }
        $("#modal" + name).modal("show");
      }
      console.log(name);
    },
    openModalThree(a, b, c) {
      if (a == "DocPending") {
        this.docPilih = b;
        this.docStatus = c;
        this.docId = this.companyId;
        this.loadingTableDoc = true;
        this.$http
          .post(
            process.env.GET_HISTORY_DOC,
            {
              docType: this.docPilih,
              docId: this.docId,
              newUser: this.newUser,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            this.historyDocData = response.data.content;
            this.loadingTableDoc = false;
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
      $("#modal" + a).modal("show");
    },
    openModalFour(modalName, productName, productId, duration, condition) {
      if (modalName == "RemoveItemExtend") {
        this.deleteProductName = productName;
        this.deleteProductId = productId;
        this.durationBefore = duration;
        this.conditionDelete = condition;
      }
      $("#modal" + modalName).modal("show");
    },
    openModalFive(a, b, c, d, e, f, idx) {
      if (a == "Delete") {
        this.deleteProductName = b;
        this.deleteProductId = c;
        this.deleteQty = d;
        this.durationBefore = e;
        this.conditionDelete = f;
        this.selectedDetailOrder = this.detailOrder[idx];
      }
      $("#modal" + a).modal("show");
    },
    openmodalEditProduct(
      catalogName,
      catalogId,
      index,
      note,
      duration,
      productStatus,
      isReserved,
    ) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      if(isReserved) {
        swalWithBootstrapButtons
              .fire({
                title: "Sorry",
                icon: "error",
                html: `
                        <div style="max-width : 100%; font-size : 16px;">
                          Unit ini telah di-reservasi oleh tim Warehouse. Silakan hubungi tim Warehouse(Anggun) untuk membatalkan reservasi order ini. Setelah itu, Anda dapat melakukan pembaruan atau pengeditan produk ini kembali.
                        </div>
                      `,
                confirmButtonText: `Close`,
                showConfirmButton: true,
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
      } else {
        this.productEditStatus = productStatus;
        if (!this.editModalClicked) {
          this.editModalClicked = true;
          this.loadingTable = true;
          this.idx = index;
          this.selectedDetailOrder = this.detailOrder[this.idx];
          this.editNote = note;
          this.editProductName =
            this.detailOrder[this.idx].productTitle +
            " (" +
            this.detailOrder[this.idx].catalogProductTypeName +
            ")";
          this.editProductId = catalogId;

          this.editQty = this.detailOrder[this.idx].qty;
          this.editQtyBefore = this.detailOrder[this.idx].qty;
          this.editDuration = duration;
          this.durationBefore = duration;
          this.conditionBefore = this.detailOrder[this.idx].condition;

          this.specModal = this.detailOrder[this.idx].specificationView;
          this.selectProductDuration = [];
          this.selectProductVarian = [];
          this.selectProductName = [];

          this.productCategory.catalogType =
            this.detailOrder[this.idx].productTypeName;
          this.productCategory.type = this.detailOrder[this.idx].productTypeId;
          this.pilihProduct.catalogName = this.detailOrder[this.idx].productTitle;
          this.pilihVarian.catalogId = this.detailOrder[this.idx].catalogId;
          this.pilihVarian.specification = this.detailOrder[this.idx].specificationsView;
          this.conditionChoosed.condition = this.detailOrder[this.idx].condition;
      

          this.getProductName("edit");
          this.getProductVarian("edit"); 
          this.getProductDuration("edit");
          this.getProductCondition("edit");
        }
      }
    },
    openHistoryModal(id, index, item) {
      this.idx = index;
      this.$http
        .post(
          process.env.GET_ORDER_ITEM_HISTORY,
          {
            orderDetailId: id,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });
            this.handleLogout();
          } else {
            this.selectedOrderItemDetailHistory = response.data.content;
            $(`#modalViewHistory`).modal("show");
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    openBomDetailModal(bomData, index) {
      this.idx = index;
      this.selectedOrderItemBOM = bomData;
      $(`#modalBom`).modal("show");
    },
    openModal(x, y, z, a, b, c) {
      this.docPilih = y;
      this.idx = z;
      var today = new Date();
      var month = today.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var dateDay = today.getDate();
      if (dateDay < 10) {
        dateDay = "0" + dateDay;
      }
      var hours = today.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = today.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var second = today.getSeconds();
      if (second < 10) {
        second = "0" + second;
      }
      var date = today.getFullYear() + "-" + month + "-" + dateDay;
      var time = hours + ":" + minutes;
      var dateTime = date + "T" + time;
      if (x == "Edit") {
        this.editNote = b;
        this.editProductName = y;
        this.editProductId = z;
        this.idx = a;
        this.durationBefore = c;
        this.conditionBefore = this.detailOrder[this.idx].condition;
        this.productCategory.productType = this.detailOrder[this.idx].typeName;
        this.productCategory.type = this.detailOrder[this.idx].productType;
        this.conditionChoosed.condition = this.detailOrder[this.idx].condition;
        // this.conditionChoosed.conditionName =
        //   this.detailOrder[this.idx].conditionName;
        this.specModal = this.detailOrder[this.idx].specificationsView;
        this.selectProductDuration = [];
        this.selectProductVarian = [];
        this.selectProductName = [];
        var type;
        this.$http
          .post(
            process.env.GET_PRODUCT_EDIT,
            {
              productName: this.editProductName !== null ? this.editProductName.replace(this.spaceRegex, ' ') : this.editProductName,
              productType: this.productCategory.type !== null ? this.productCategory.type.replace(this.spaceRegex, ' ') : this.productCategory.type,
              productId: this.editProductId,
              condition: this.conditionChoosed.condition,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status === 200) {
              this.selectProductDuration =
                response.data.content.productDuration;
              this.selectProductVarian = response.data.content.productVarian;
              this.selectProductName = response.data.content.productName;
              this.selectCondition = response.data.content.productCondition;
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
          })
          .catch(error => {
            swal("Sorry", error.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
        this.editProductType = this.detailOrder[this.idx].productType;
        type = this.detailOrder[this.idx].productType;
        this.pilihProduct.productName = this.detailOrder[this.idx].productTitle;
        this.pilihProduct.productId = this.detailOrder[this.idx].productId;
        this.productIdOld = this.detailOrder[this.idx].productId;
        this.pilihDurasi.tenorMonths =
          this.detailOrder[this.idx].orderItemDuration;
        this.pilihDurasi.tenorValue = this.detailOrder[this.idx].durationValue;
        this.editQty = this.detailOrder[this.idx].qty;
        this.editQtyBefore = this.detailOrder[this.idx].qty;
        this.pilihDurasi.tenorPrice =
          this.detailOrder[this.idx].orderItemPrice /
          this.detailOrder[this.idx].qty;
        this.toArray(this.detailOrder[this.idx].specifications);
        if (type == 1 || type == 2) {
          this.pilihVarian.productDetail =
            this.detailProductProcessor +
            "/" +
            this.detailProductRAM +
            "GB /" +
            this.detailProductStorage +
            "/" +
            this.detailProductVGA;
        } else if (type == 3) {
          this.pilihVarian.productDetail =
            this.detailProductDisplaySize +
            " Inch / " +
            this.detailProductDisplayType;
        } else if (type == 4) {
          this.pilihVarian.productDetail = this.detailProductColorTech;
        } else if (type == 5 || type == 6) {
          this.pilihVarian.productDetail =
            this.detailProductProcessor +
            "/" +
            this.detailProductRAM +
            "GB /" +
            this.detailProductStorage;
        }
        this.pilihVarian.productId = this.editProductId;
        // this.septianCategory =  this.filterCategory(this.typeCatalog, this.productCategory.productType)
        // this.septianProduct =  this.filterProduct(this.septianCategory[0].product, this.pilihProduct.productName)
        // this.septianDuration =  this.septianProduct[0].price
        // this.productCategory.product = this.septianProduct
        // this.pilihProduct.price = this.septianDuration
      } else if (x == "Add") {
        this.inputResetAdd("category");
        this.productCategoryAdd = {
          productType: "Choose Product Category",
          type: "",
          product: [],
        };
        this.addQty = 0;
        this.addNote = "";
      } else if (x == "UploadLegalDocument") {
        document.getElementById("npwpInput").value = "";
        document.getElementById("ktpInput").value = "";
        document.getElementById("siupInput").value = "";
        document.getElementById("aktaInput").value = "";
        this.NPWPFileName = "";
        this.NPWPBase64 = "";
        this.aktaFileName = "";
        this.aktaBase64 = "";
        this.SIUPFileName = "";
        this.SIUPBase64 = "";
        this.KTPFileName = "";
        this.KTPBase64 = "";
      } else if (x == "Match") {
        this.existingValue = "";
        this.$http
          .get(process.env.GET_EXISTING_COMPANY, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          })
          .then((response) => {
            if (response.data.status === 200) {
              this.companySelect = response.data.content;
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      } else if (x == "FillMandatory") {
        if (this.companyProvinceMandatory != "") {
          this.getKabkot();
        }
        if (this.companyDistrictMandatory != "") {
          this.getKecamatan();
        }
      }
      $("#modal" + x).modal("show");
    },
    viewAll(x) {
      this.$router.push("/order/search");
      localStorage.setItem("companyName", x);
      localStorage.setItem("orderId", "");
      localStorage.setItem("statusOrder", "");
    },
    toNextData(pagePost) {
      this.loadingButtonProcess = true;
      this.dataItem = [];
      this.$http
        .post(
          process.env.ITEM_NEXT,
          {
            index: pagePost,
            orderId: this.orderId,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status === 200) {
            this.loadingButtonProcess = false;
          }
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
          }
          this.dataItem = response.data.content.dataItem;
          this.maxQty = response.data.content.dataItem[0].Qty;
          this.specModalAssignTo =
            response.data.content.dataItem[0].specificationsView;
          this.totalData = response.data.content.totalData;
          this.currentData = response.data.content.currentData;
          this.dataItemVendor = [];
          this.dataItemVendor = response.data.content.dataItemVendor;
          this.inputs = [];
          for (
            var i = 0;
            i < response.data.content.dataItemVendor.length - 1;
            i++
          ) {
            this.inputs.push({
              one: "",
              two: "",
            });
          }
          this.assignVendor = [];
          this.vendorQty = [];
          this.pickupDate = [];
          this.stockPrice = [];
          this.deliveryDate = [];
          this.plusIdx = 0;
          if (this.dataItemVendor.length == "0") {
            this.assignVendor.push({
              vendorId: "",
              vendorName: "Select Supplier",
            });
            this.vendorQty.push(0);
            this.pickupDate.push("");
            this.stockPrice.push("");
          }
          for (var i = 0; i < this.dataItemVendor.length; i++) {
            if (i != 0) {
              this.plusIdx = this.plusIdx + 1;
            }
            this.assignVendor.push({
              lessorId: this.dataItemVendor[i].lessorId,
              vendorId: this.dataItemVendor[i].vendorId,
              vendorName: this.dataItemVendor[i].vendorName,
            });
            this.pickupDate.push(this.dataItemVendor[i].pickupDate);
            this.stockPrice.push(this.dataItemVendor[i].stockPrice);
            this.vendorQty.push(this.dataItemVendor[i].vendorQty);
            this.deliveryDate.push(this.dataItemVendor[i].deliverSchedule);
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    StartRent() {
      if (this.startDate == "") {
        swal("Sorry", "Start date must be select", "error", {
          button: "Close",
        });
      } else {
        var self = this;
        this.loadingButtonProcess = true;
        this.$http
          .post(
            process.env.UPDATE_ORDER_STATUS,
            {
              adminId: this.adminId,
              orderId: this.orderId,
              orderStatus: this.orderStatus,
              imageName: this.rentImageFileName !== null ? this.rentImageFileName.replace(this.spaceRegex, ' ') : this.rentImageFileName,
              imageBase64: this.rentImageBase64,
              startDate: this.startDate,
              reject: "no",
            },
            {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal(
                "Success",
                "start rent order Id " + this.orderId + " has been succesfull",
                "success",
                {
                  button: "Ok",
                }
              );
              this.sendLog(25, "startRent");
              this.sendLog(26, "startRent");
            }
            if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            $("#modalStartRent").modal("hide");
            this.getData();
            this.loadingButtonProcess = false;
          })
          .catch((error) => {
            alert("Request timeout / error with api, please try again!");
            self.loadingButtonProcess = false;
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    toPage(e) {
      this.$router.push(e);
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("endrent_cache");
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push("/");
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    close() {
      this.$emit("close");
    },
    getAssignTo(productId, condition, button, pagePost, price) {
      console.log("here");
      if (pagePost == "") {
        $("#modalAssignTo").modal("show");
      }
      this.dataItem = [];
      this.loadingButtonProcess = true;
      this.buttonLessor = button;
      this.$http
        .post(
          process.env.ITEM_ASSIGN_TO,
          {
            orderId: this.orderId,
            productId: productId,
            condition: condition,
            index: pagePost,
            price
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
          }
          this.dataItem = response.data.content.dataItem;
          this.maxQty = response.data.content.dataItem[0].Qty;
          this.specModalAssignTo =
            response.data.content.dataItem[0].specificationsView;
          this.totalData = response.data.content.totalData;
          this.currentData = response.data.content.currentData;
          // this.deliveryDate = response.data.content.deliverSchedule
          this.deliveryDate = [];
          this.dataItemVendor = [];
          this.inputs = [];
          this.dataItemVendor = response.data.content.dataItemVendor;
          for (
            var i = 0;
            i < response.data.content.dataItemVendor.length - 1;
            i++
          ) {
            this.inputs.push({
              one: "",
              two: "",
            });
          }
          this.assignVendor = [];
          this.vendorQty = [];
          this.pickupDate = [];
          this.stockPrice = [];
          this.idx = 0;
          this.plusIdx = 0;
          if (this.dataItemVendor.length == "0") {
            this.assignVendor.push({
              lessorId: "",
              vendorId: "",
              vendorName: "Select Supplier",
            });
            this.pickupDate.push("");
            this.stockPrice.push("");
            this.vendorQty.push(0);
            this.deliveryDate.push("");
          } else {
            for (var i = 0; i < this.dataItemVendor.length; i++) {
              if (i != 0) {
                this.plusIdx = this.plusIdx + 1;
              }
              // this.plusIdx = this.plusIdx+i
              this.assignVendor.push({
                lessorId: this.dataItemVendor[i].lessorId,
                vendorId: this.dataItemVendor[i].vendorId,
                vendorName: this.dataItemVendor[i].vendorName,
              });
              this.pickupDate.push(this.dataItemVendor[i].pickupDate);
              this.stockPrice.push(this.dataItemVendor[i].stockPrice);
              this.vendorQty.push(this.dataItemVendor[i].vendorQty);
              this.deliveryDate.push(this.dataItemVendor[i].deliverSchedule);
            }
          }
          this.loadingButtonProcess = false;
          // this.inputs = []
          // this.detailAssignPlace = response.data.content.place
          // this.loadingTableAssign = false
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    submitAssignTo(x, pagePost, processData, price) {
      if (this.cekFieldAssignTo("0", "save") == 0 && processData == "save") {
        this.loadingButtonProcess = true;
        let condition = "";
        if (this.conditionNameModal == "New") {
          condition = 1;
        } else {
          condition = 2;
        }
        this.$http
          .post(
            process.env.UPDATE_ORDER_STATUS,
            {
              adminId: this.adminId,
              orderId: this.orderId,
              orderStatus: this.orderStatus,
              vendorOrder: this.assignVendor,
              vendorQty: this.vendorQty,
              pickupDate: this.pickupDate,
              stockPrice: this.stockPrice,
              productId: x,
              deliveryDate: this.deliveryDate,
              reject: "no",
              condition: condition,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal(
                "Success",
                "Success to set lessor of order ID " + this.orderId,
                "success",
                {
                  button: "Ok",
                }
              );
              this.sendLog(19, "assignTo");
            }
            if (response.data.status == 202) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.loadingButtonProcess = false;
              return;
            }
            if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            if (response.data.content == 0) {
              $("#modalAssignTo").modal("hide");
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            this.dataItemVendor = [];
            this.getData();
            this.getAssignTo(
              dataItem.productId,
              dataItem.condition,
              "save",
              pagePost,
              price
            );
            // this.toNextData(pagePost)
            this.loadingButtonProcess = false;
            this.plusIdx = 0;
            this.inputs = [];
            this.assignVendor = [
              {
                lessorId: "",
                vendorId: "",
                vendorName: "Select Supplier",
              },
            ];
            this.pickupDate = [];
            this.stockPrice = [];
            this.vendorQty = [];
            this.deliveryDate = [];
          })
          .catch((error) => {
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      } else if (
        this.cekFieldAssignTo("0", "save") == 0 &&
        processData == "edit"
      ) {
        this.loadingButtonProcess = true;
        let condition = "";
        if (this.conditionNameModal == "New") {
          condition = 1;
        } else {
          condition = 2;
        }
        this.$http
          .post(
            process.env.EDIT_LESSOR_ORDER,
            {
              adminId: this.adminId,
              orderId: this.orderId,
              orderStatus: this.orderStatus,
              vendorOrder: this.assignVendor,
              vendorQty: this.vendorQty,
              pickupDate: this.pickupDate,
              stockPrice: this.stockPrice,
              productId: x,
              deliveryDate: this.deliveryDate,
              reject: "no",
              condition: condition,
              price
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal(
                "Success",
                "Success to change vendor of order ID " + this.orderId,
                "success",
                {
                  button: "Ok",
                }
              );
              this.sendLog(19, "assignTo");
            }
            if (response.data.status == 202) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.loadingButtonProcess = false;
              return;
            }
            if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            if (response.data.content == 0) {
              $("#modalAssignTo").modal("hide");
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
              this.handleLogout();
            }
            this.dataItemVendor = [];
            this.getData();
            this.loadingButtonProcess = false;
            this.plusIdx = 0;
            this.inputs = [];
            this.assignVendor = [
              {
                lessorId: "",
                vendorId: "",
                vendorName: "Select Supplier",
              },
            ];
            this.pickupDate = [];
            this.stockPrice = [];
            this.vendorQty = [];
            this.deliveryDate = [];
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    submitEditInvoice() {
      this.loadingButtonProcess = true;
      var prorice = false;
      if (this.invoiceTo == 1 && this.date != 1) {
        prorice = true;
      }
      this.$http
        .post(
          process.env.EDIT_INVOICE,
          {
            adminId: this.adminId,
            orderId: this.orderId,
            dataEditInvoice: this.dataEditInvoice,
            paymentId: this.paymentId,
            chargePrice: this.chargePrice,
            discountPrice: this.discountPrice,
            taxPrice: this.taxPrice,
            prorice: prorice,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            swal("Success", response.data.message, "success", {
              button: "Ok",
            });
          }
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            this.handleLogout();
          }
          $("#modalEditInvoice").modal("hide");
          this.chargePrice = "0";
          this.discountPrice = "0";
          this.taxPrice = "0";
          this.getData();
          this.loadingButtonProcess = false;
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    cekInputEditInvoice() {
      var error = 0;
      this.loadingButtonProcess = true;
      for (var i = 0; i < this.dataEditInvoice.length; i++) {
        if (this.dataEditInvoice[i].orderItemPrice == 0) {
          swal("Sorry", "Price Cannot be fill with 0", "error", {
            button: "Close",
          });
          error = error + 1;
          this.loadingButtonProcess = false;
          return;
        }
      }
      if (error == 0) {
        this.submitEditInvoice();
      }
    },
    getLog(data) {
      this.dataLogOrder = data;
      detailOrderDeliver;
    },
    getLogRemarks(data) {
      this.dataRemarks = data;
    },
    convertByDeliver() {
      if (this.orderStatus < 13) {
        this.detailOrderDeliver = [];
        for (var i = 0; i < this.detailOrder.length; i++) {
          if (i == 0) {
            if (this.detailOrder[i].orderItemStatus >= 13) {
              this.detailOrderDeliver.push({
                maxSchedule: this.detailOrder[i].maxSchedule,
                actualSchedule: this.detailOrder[i].deliverSchedule,
                startRent: this.detailOrder[i].startRent,
              });
            } else {
              this.detailOrderDeliver.push({
                maxSchedule: this.detailOrder[i].maxSchedule,
                actualSchedule: this.detailOrder[i].deliverSchedule,
                startRent: null,
              });
            }
          } else {
            let same = false;
            for (var j = 0; j < this.detailOrderDeliver.length; j++) {
              if (this.detailOrder[i].orderItemStatus >= 13) {
                if (
                  this.detailOrderDeliver[j].startRent ==
                  this.detailOrder[i].startRent
                ) {
                  same = true;
                }
              } else {
                if (
                  this.detailOrderDeliver[j].actualSchedule ==
                    this.detailOrder[i].deliverSchedule &&
                  this.detailOrderDeliver[j].maxSchedule ==
                    this.detailOrder[i].maxSchedule
                ) {
                  same = true;
                }
              }
            }
            if (!same) {
              if (this.detailOrder[i].orderItemStatus >= 13) {
                this.detailOrderDeliver.push({
                  maxSchedule: this.detailOrder[i].maxSchedule,
                  actualSchedule: this.detailOrder[i].deliverSchedule,
                  startRent: this.detailOrder[i].startRent,
                });
              } else {
                this.detailOrderDeliver.push({
                  maxSchedule: this.detailOrder[i].maxSchedule,
                  actualSchedule: this.detailOrder[i].deliverSchedule,
                  startRent: null,
                });
              }
            }
          }
        }
      } else {
        this.detailOrderDeliver = [];
        this.detailOrderReplace = [];
        for (var i = 0; i < this.detailOrder.length; i++) {
          if (
            this.detailOrderDeliver.length == 0 &&
            this.detailOrder[i].startRent
          ) {
            this.detailOrderDeliver.push({
              startRent: this.detailOrder[i].startRent,
            });
          } else {
            let same = false;
            let status = false;
            for (var j = 0; j < this.detailOrderDeliver.length; j++) {
              if (
                this.detailOrderDeliver[j].startRent ==
                this.detailOrder[i].startRent
              ) {
                same = true;
              }
            }
            if (
              this.detailOrder[i].orderItemStatus > 19 &&
              this.detailOrder[i].orderItemStatus < 26
            ) {
              this.detailOrderReplace.push(this.detailOrder[i].deliverSchedule);
            }
            if (!same && this.detailOrder[i].orderItemStatus < 19) {
              this.detailOrderDeliver.push({
                startRent: this.detailOrder[i].startRent,
              });
            }
          }
        }
      }
      console.log("order deliver");
      console.log(this.detailOrderDeliver);
    },
    getBastList() {
      this.$http.get(process.env.GET_LIST_BAST + this.orderId, {
        headers: { "Asani-Token": localStorage.getItem("jwt") }
      })
      .then(res => {
         this.bastData = res.data.content.map(item => {
          let productCodeString = ''

          item.orderLP.split(',').forEach(item => {
            productCodeString = productCodeString + item + ', '
          })

          return {...item, orderLP : productCodeString}
        })
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    getData() {
      this.docApprove = 0;
      this.getToday();
      this.connectLogLessee();
      this.loadingTable = true;
      this.loadingDetail = true;
      this.orderCode = this.$route.query.orderCode;
      this.companyIdDetail = this.$route.query.companyIdDetail;
      this.chooseAgreementStatus = 1;
      this.chooseInvoiceStatus = 1;
      this.orderId = this.$route.params.orderId;
      this.getNewOrderDetailData();
      this.getBastList()
      this.getOrderPriorityDetails();
      this.$http
        .get(
          process.env.GET_ORDER_DETAIL + `/${this.orderId}/info`,
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            this.handleLogout();
          }
          var dates = response.data.content.companyInfo.depositDate;
          if (dates) {
            if (dates.split("-")[0] == "00") {
              this.depositDate = "";
              this.selectDepositDate = "";
            } else {
              this.depositDate = dates.split(" ")[0];
              let formatting = dates.split("-");
              let day = formatting[0];
              let month = formatting[1];
              let year = formatting[2].split(" ")[0];
              let time = formatting[2].split(" ")[1];
              this.selectDepositDate = `${year}-${month}-${day}T${time}`;
            }
          } else {
            this.depositDate = "";
            this.selectDepositDate = "";
          }
          
          if (response.data.content.companyInfo.dealOwnerName) {
            this.dealOwner = {
              employeeName: response.data.content.companyInfo.dealOwnerName,
              id: response.data.content.companyInfo.dealOwnerId,
            };
          }
          this.isLeaseOrder = response.data.content.isLeaseOrder;
          this.tags = response.data.content.tag
          this.ltCode = response.data.content.ltCode
          this.bastPO = response.data.content.poNumber;
          this.poNumberInput = response.data.content.poNumber;
          this.orderCode = response.data.content.orderCode;
          this.companyIdDetail = response.data.content.companyInfo.companyId;
          this.newUser = response.data.content.newUser;
          this.companySuggestion = response.data.content.companySuggestion;
          this.picProcess = response.data.content.picProcess;
          this.companyInfo = response.data.content.companyInfo;
          this.picInfo = response.data.content.picInfo;
          // this.detailOrder = response.data.content.detailOrder;
          // this.totalPrice = response.data.content.totalPrice[0].totalPrice;
          // this.totalInvoice = response.data.content.totalPrice[0].totalPrice;
          this.productRenting =
            response.data.content.productRenting;
          this.dataPayment = response.data.content.dataPayment;
          this.historyOrder = response.data.content.historyOrder;
          this.companyId = response.data.content.companyInfo.companyId;
          this.asaniPicPhone =
            response.data.content.companyInfo.employeePhone;
          this.asaniEmployeeName =
            response.data.content.companyInfo.employeeName;
          if (
            response.data.content.companyInfo.employeeName != "" &&
            response.data.content.companyInfo.employeeName != null
          ) {
            this.bastAsaniEmployee = {
              id: response.data.content.companyInfo.orderEmployeeId,
              employeeName: response.data.content.companyInfo.employeeName,
            };
            this.quotaionEmployeeSelect = {
              id: response.data.content.companyInfo.orderEmployeeId,
              employeeName: response.data.content.companyInfo.employeeName,
            };
            this.oldPicAsani = response.data.content.companyInfo.orderEmployeeId
            this.employeeAsaniOrder = {
              id: response.data.content.companyInfo.orderEmployeeId,
              employeeName: response.data.content.companyInfo.employeeName,
            };
          }
          this.asaniEmployeeName =
            response.data.content.companyInfo.employeeName;
          this.companyStatus =
            response.data.content.companyInfo.companyStatus;
          this.companyName = response.data.content.companyInfo.companyName;
          this.companyNameMandatory =
            response.data.content.companyInfo.companyName;
          this.companyProvince =
            response.data.content.companyInfo.companyProvince;
          this.companyProvinceMandatory =
            response.data.content.companyInfo.companyProvince;
          this.companyDistrict =
            response.data.content.companyInfo.companyDistrict;
          this.companyDistrictMandatory =
            response.data.content.companyInfo.companyDistrict;
          this.companyCity = response.data.content.companyInfo.companyCity;
          this.companyCityMandatory =
            response.data.content.companyInfo.companyCity;
          this.companyVillage =
            response.data.content.companyInfo.companyVillage;
          this.companyVillageMandatory =
            response.data.content.companyInfo.companyVillage;
          this.companyZip = response.data.content.companyInfo.companyZip;
          this.companyZipMandatory =
            response.data.content.companyInfo.companyZip;
          this.companyAddress =
            response.data.content.companyInfo.companyAddress;
          this.companyAddressMandatory =
            response.data.content.companyInfo.companyAddress;
          this.companyPhone = response.data.content.companyInfo.companyPhone;
          this.companyPhoneMandatory =
            response.data.content.companyInfo.companyPhone;
          this.companyNameNPWP = response.data.content.companyInfo.companyNameNPWP;
          this.companyNPWP = response.data.content.companyInfo.companyNPWP;
          this.companyNPWP16 = response.data.content.companyInfo.companyNpwp16;
          this.companyNPWP22 = response.data.content.companyInfo.companyNpwp22;
          this.inputNPWP = response.data.content.companyInfo.companyNPWP;
          this.aktaAddress = response.data.content.companyInfo.aktaAddress;
          this.inputAddress = response.data.content.companyInfo.aktaAddress;
          this.companyKtpPassport = response.data.content.companyInfo.companyKtpPassport;
          this.citizenship = response.data.content.companyInfo.citizenship;
          this.companyKTPStatus =
            response.data.content.companyInfo.ktpPassportStatus;
          this.companyKTPUrl = response.data.content.companyInfo.ktpPassportUrl;
          this.companySKMStatus =
            response.data.content.companyInfo.skmStatus;
          this.companySKMUrl = response.data.content.companyInfo.skmUrl;
          let financeData = response.data.content.companyInfo.financeEmail
          if (financeData) {
            this.financeEmailInfo = JSON.parse(
              response.data.content.companyInfo.financeEmail
            );
            this.financeEmail = this.financeEmailInfo;
          }
          this.picId = response.data.content.picInfo.userId;
          this.userName = response.data.content.picInfo.userName;
          this.oldPic = response.data.content.picInfo.userId
          this.choosePic = {
            lesseeId: response.data.content.picInfo.userId,
            lesseeName: response.data.content.picInfo.userName,
          };
          this.picNameMandatory = response.data.content.picInfo.userName;
          // this.userKTP = response.data.content.picInfo.userKTP
          this.inputKTP = response.data.content.picInfo.companyKtp;
          this.picPhoneMandatory = response.data.content.picInfo.userPhone;
          this.userPhone = response.data.content.picInfo.userPhone;
          this.userEmail = response.data.content.picInfo.userEmail;
          this.picEmailMandatory = response.data.content.picInfo.userEmail;
          this.userPosition = response.data.content.picInfo.userPosition;
          this.picPositionMandatory =
            response.data.content.picInfo.userPosition;
          this.userDivision = response.data.content.picInfo.userDivision;
          this.picDivisionMandatory =
            response.data.content.picInfo.userDivision;
          // this.userKTPStatus = response.data.content.picInfo.userKTPStatus
          this.NPWPStatus = response.data.content.companyInfo.NPWPStatus;
          this.aktaStatus = response.data.content.companyInfo.aktaStatus;
          this.siupStatus = response.data.content.companyInfo.siupStatus;
          this.userId = response.data.content.picInfo.userId;
          this.companyId = response.data.content.companyInfo.companyId;
          this.companyLogoUrl =
            response.data.content.companyInfo.companyLogoUrl;
          this.companyKTPUrl = response.data.content.companyInfo.ktpUrl;
          // this.userKTPUrl = response.data.content.picInfo.userKTPUrl
          this.getKtpName = response.data.content.companyInfo.ktpPassportFileName;
          this.getSKMName = response.data.content.companyInfo.skmFileName;
          this.NPWPUrl = response.data.content.companyInfo.NPWPUrl;
          this.getNPWPName = response.data.content.companyInfo.NPWPFileName;
          this.aktaUrl = response.data.content.companyInfo.aktaUrl;
          this.getAktaName = response.data.content.companyInfo.aktaFileName;
          this.siupUrl = response.data.content.companyInfo.siupUrl;
          this.getSiupName = response.data.content.companyInfo.siupFileName;
          this.purchaseUrl = response.data.content.companyInfo.purchaseUrl;
          this.handoverUrl = response.data.content.companyInfo.handoverUrl;
          this.sphUrl = response.data.content.companyInfo.sphUrl;
          this.purchaseStatus = response.data.content.companyInfo.POStatus;
          // this.orderStatus = response.data.content.orderStatus;
          // this.dataVendor = Object.values(response.data.content.dataVendor);
          this.quotationCount = response.data.content.quotationCount;
          this.quotationStatus = response.data.content.quotationStatus;
          this.agreementCount = response.data.content.agreementCount;
          this.agreementStatus = response.data.content.agreementStatus;
          this.invoiceCount = response.data.content.invoiceCount;
          this.invoiceStatus = response.data.content.invoiceStatus;
          // this.invoiceDepoStatus = response.data.content.dataPayment[0].invoiceStatus
          this.invoiceTime = response.data.content.invoiceTime;
          this.quotationTime = response.data.content.quotationTime;
          // this.deliverSchedule = response.data.content.deliverSchedule
          this.editDelivery = response.data.content.editDelivery;
          this.docApproveBefore = response.data.content.docApproveBefore;
          this.rejectReasonOrder = response.data.content.rejectReason;
          this.orderExtendFrom = response.data.content.orderExtendFrom;
          this.loadingStatusKTP = false;
          this.loadingStatusPurchase = false;
          this.loadingStatusNPWP = false;
          this.loadingStatusSiup = false;
          this.loadingStatusAkta = false;
          this.loadingStatusSKM = false;
          this.loadingTable = false;

          if (response.data.content.companyInfo.companyProvince) {
            this.companyProvinceMandatory = {
              provinceId: response.data.content.province[0].provinceId,
              provinceName: response.data.content.province[0].provinceName,
            };
          } else {
            this.companyProvinceMandatory = "";
          }
          if (response.data.content.companyInfo.companyDistrict) {
            this.companyCityMandatory = {
              kecamatanId: response.data.content.kecamatan[0].kecamatanId,
              kecamatanName: response.data.content.kecamatan[0].kecamatanName,
            };
          } else {
            this.companyDistrict = "";
          }
          if (response.data.content.companyInfo.companyCity) {
            this.companyDistrictMandatory = {
              kabKotId: response.data.content.kabkot[0].kabKotId,
              kabKotName: response.data.content.kabkot[0].kabKotName,
            };
          } else {
            this.companyCityMandatory = "";
          }
          if (this.NPWPStatus == 1) {
            this.docApprove = this.docApprove + 1;
          }
          if (this.companyKTPStatus == 1) {
            this.docApprove = this.docApprove + 1;
          }
          if (this.siupStatus == 1) {
            this.docApprove = this.docApprove + 1;
          }
          if (this.aktaStatus == 1) {
            this.docApprove = this.docApprove + 1;
          }
          if (this.companySKMStatus == 1) {
            this.docApprove = this.docApprove + 1;
          }
          this.cekReplaced();
          // CEK COMPANY AND PIC
          if (
            this.companyName == "" ||
            this.companyName == null ||
            this.companyProvince == "" ||
            this.companyProvince == null ||
            this.companyDistrict == "" ||
            this.companyDistrict == null ||
            this.companyCity == "" ||
            this.companyCity == null ||
            this.companyVillage == "" ||
            this.companyVillage == null ||
            this.companyZip == "" ||
            this.companyZip == null ||
            this.companyAddress == "" ||
            this.companyAddress == null ||
            this.userName == "" ||
            this.userName == null ||
            this.userPhone == "" ||
            this.userPhone == null ||
            this.userEmail == "" ||
            this.userEmail == null
          ) {
            this.nextStepFill = true;
          }

          // this.convertByDeliver();
          // this.dataQuotation = [];
          // this.promoPrice = [];
          // //validasi button bast
          // for (var i = 0; i < this.detailOrder.length; i++) {
          //     if (this.detailOrder[i].orderItemStatus == 13) {
          //         this.statusRenting = true;
          //     }
          //     if (this.detailOrder[i].orderItemStatus == 11 || this.detailOrder[i].orderItemStatus == 12) {
          //         this.statusDeliver = true;
          //     }
          //     //data generate quotation
          //     if (this.detailOrder[i].conditionName == "Refurbished") {
          //         this.dataQuotation.push(this.detailOrder[i]);
          //         this.promoPrice.push(this.detailOrder[i].finalPrice);
          //     }
          //     if (this.detailOrder[i].orderItemStatus >= 15 && this.detailOrder[i].orderItemStatus <= 18 && this.detailOrder[i].returnSchedule != null && this.detailOrder[i].returnSchedule != "") {
          //         this.returnSchedule = this.detailOrder[i].returnSchedule;
          //     }
          //     this.loadingBtnReturn = false;
          // }
          this.$http
            .post(
              process.env.GET_ACTIVE_ADMIN,
              {
                companyId: this.companyIdDetail,
                status: this.newUser,
                orderId: this.orderId,
              },
              {
                headers: { "Asani-Token": localStorage.getItem("jwt") },
              }
            )
            .then((response) => {
              if (response.data.status == 200) {
                this.lesseeSelect = response.data.content.activeAdmin;
              }
            })
            .catch(error => {
              swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
              }).then(v => {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              })
            });
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
      this.$http
        .get(process.env.GET_CATALOG_ADD, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          this.typeCatalog = response.data.content.catalogType;
          // this.tenorProduct = response.data.content.productTenor
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
      this.$http
        .get(process.env.API_GET_PROVINCE, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.province = response.data.content;
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
      this.$http
        .get(process.env.GET_ALL_EMPLOYEE, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.employeeSelect = response.data.content;
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
      this.connectLogOrder();
      this.connectLogRemarks();
    },
    getNewOrderDetailData() {
      this.$http
        .post(
          process.env.GET_ORDER_DETAIL_ONLY,
          {
            orderId: this.orderId,
          },
          {
            timeout: 300 * 1000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
          }
          if(response.data.content.priorityOrder.tag && response.data.content.priorityOrder.tag.length > 0) {
            this.orderPriority = response.data.content.priorityOrder.tag[0]
          } else {
            this.orderPriority = {
              label : '- None',
              colorHex : '#EEEEEE',
              tagId : 0
            }
          }

          this.detailOrder.length = 0;
          this.orderStatus = response.data.content.orderStatus;
          this.orderCode = response.data.content.orderCode;
          let rawData = response.data.content.orderDetail;
          this.totalPrice = response.data.content.totalPrice;
          this.totalInvoice = response.data.content.totalPrice;
          for (let detail of rawData) {
            detail = { ...detail, isInfoOpened: false };
            this.detailOrder.push(detail);

            if(detail.isReserved) {
              this.isNotReserved = false;
            }
          }
      
          this.convertByDeliver();
          this.dataQuotation = [];
          this.promoPrice = [];
          this.statusRenting = false;
          this.statusDeliver = false;
          //validasi button bast
          for (var i = 0; i < this.detailOrder.length; i++) {
            if (this.detailOrder[i].orderItemStatus == 13) {
              this.statusRenting = true;
            }
            if (
              this.detailOrder[i].orderItemStatus == 11 ||
              this.detailOrder[i].orderItemStatus == 12
            ) {
              this.statusDeliver = true;
            }
            //data generate quotation
              this.dataQuotation.push(this.detailOrder[i]);
              this.promoPrice.push(this.detailOrder[i].finalPrice);
              
            if (
              this.detailOrder[i].orderItemStatus >= 15 &&
              this.detailOrder[i].orderItemStatus <= 18 &&
              this.detailOrder[i].returnSchedule != null &&
              this.detailOrder[i].returnSchedule != ""
            ) {
              this.returnSchedule = this.detailOrder[i].returnSchedule;
            }
            this.loadingBtnReturn = false;
            this.loadingDetail = false;
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    getReturnActiveAdmin() {
      this.$http
        .post(
          process.env.GET_RETURN_ACTIVE_ADMIN,
          {        
            companyId: this.companyId
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
           if (response.data.status == 200) {
            this.returnEmployeeSelect = response.data.content;
           } else {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
           }
        }).catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    openModalSetReturn() {
      this.loadingBtnReturn = true;
      this.getReturnActiveAdmin()
      this.returnScheduleForm = moment(String(this.returnSchedule)).format(
        "YYYY-MM-DD HH:mm:00"
      );
      let scheduled = false
      for (var idx = 0; idx < this.detailOrder.length; idx++) {
        
        if (this.detailOrder[idx].orderItemStatus == 15) {
          scheduled = true;
        }
      }
     
      this.$http
        .post(
          process.env.RETURN_DETAIL,
          {
            orderId: Number(this.orderId),
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            console.log(response.data.content)
            this.returnDetail = response.data.content;
            this.returnScheduleEmployee = {
              lesseeId : response.data.content[0].returnPic,
              lesseeName : response.data.content[0].picName
            };
            this.returnScheduleForm = moment(
              String(response.data.content[0].returnSchedule)
            ).format("YYYY-MM-DD HH:mm:00.0");
            this.returnPONumber = this.bastPO;
            this.checkedItems = [];
            var cAll = true;
            for (var i = 0; i < this.returnDetail.length; i++) {
              if (this.returnDetail[i].checked) {
                this.checkedItems.push(this.returnDetail[i].orderDetailsId);
              } else {
                cAll = false;
              }
            }
            if (cAll) {
              this.selectAll = cAll;
            }
            $("#modalSetReturn").modal("show");
          } else if (response.data.status == 205) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
          }
          this.loadingBtnReturn = false;
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    formatPrice(value) {
      let val = value;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    tandaPemisahTitik: function (b) {
      var _minus = false;
      if (b < 0) _minus = true;
      b = b.toString();
      b = b.replace(/\./g, "");
      b = b.replace("-", "");
      var c = "";
      var panjang = b.length;
      var j = 0;
      for (var i = panjang; i > 0; i--) {
        j = j + 1;
        if (j % 3 == 1 && j != 1) {
          c = b.substr(i - 1, 1) + "." + c;
        } else {
          c = b.substr(i - 1, 1) + c;
        }
      }
      if (_minus) c = "-" + c;
      return c;
    },
    inputPrice(x) {
      if (x == "add") {
        this.pilihDurasiAdd.tenorPrice = this.tandaPemisahTitik(
          this.pilihDurasiAdd.tenorPrice
        );
      } else if (x == "edit") {
        this.pilihDurasi.tenorPrice = this.tandaPemisahTitik(
          this.pilihDurasi.tenorPrice
        );
      }
    },
    inputPriceInvoice(x, y) {
      if (y == "addition") {
        if (x == "c") {
          if (this.chargePrice != "") {
            this.chargePrice = this.tandaPemisahTitik(this.chargePrice);
          }
        } else if (x == "d") {
          if (this.discountPrice != "") {
            this.discountPrice = this.tandaPemisahTitik(this.discountPrice);
          }
        } else if (x == "t") {
          if (this.taxPrice != "") {
            this.taxPrice = this.tandaPemisahTitik(this.taxPrice);
          }
        }
        // this.x = this.tandaPemisahTitik(this.x)
        // this.totalInvoice = this.totalInvoice + parseInt(this.x.replace(/\./g,""))
      } else {
        this.dataEditInvoice[x].orderItemPrice = this.tandaPemisahTitik(
          this.dataEditInvoice[x].orderItemPrice
        );
      }
      this.totalInvoice = 0;
      for (var i = 0; i < this.dataEditInvoice.length; i++) {
        this.totalInvoice =
          this.totalInvoice +
          parseInt(this.dataEditInvoice[i].orderItemPrice.replace(/\./g, ""));
      }
      this.totalInvoice =
        this.totalInvoice +
        parseInt(this.chargePrice.replace(/\./g, "")) -
        parseInt(this.discountPrice.replace(/\./g, "")) +
        parseInt(this.taxPrice.replace(/\./g, ""));
    },
    inputPriceQuotation(angka, index) {
      this.promoPrice[index] = this.tandaPemisahTitik(this.promoPrice[index]);
    },
    inputReset(x) {
      if (x == "category") {
        this.pilihProduct = {
          productName: "Choose Product",
          productId: "",
          price: [],
        };
        this.conditionChoosed = {
          condition: "Choose Condition",
        };
        (this.pilihVarian = {
          productDetail: "Choose Varian",
          productId: "",
        }),
          (this.pilihDurasi = {
            tenorValue: 0,
            tenorMonths: "Choose Duration",
            tenorPrice: 0,
          });
        this.editQty = "";
      } else if (x == "product") {
        this.conditionChoosed = {
          condition: "Choose Condition",
        };
        (this.pilihVarian = {
          productDetail: "Choose Varian",
          productId: "",
        }),
          (this.pilihDurasi = {
            tenorValue: 0,
            tenorMonths: "Choose Duration",
            tenorPrice: 0,
          });
        if (this.productEditStatus != 9) {
          this.editQty = "";
        }
      } else if (x == "varian") {
        this.conditionChoosed = {
          condition: "Choose Condition",
        };
        this.pilihDurasi = {
          tenorValue: 0,
          tenorMonths: "Choose Duration",
          tenorPrice: 0,
        };
        console.log(this.productEditStatus);
        if (this.productEditStatus != 9) {
          this.editQty = "";
        }
      } else if (x == "condition") {
        this.pilihDurasi = {
          tenorValue: 0,
          tenorMonths: "Choose Duration",
          tenorPrice: 0,
        };
        console.log(this.productEditStatus);
        if (this.productEditStatus != 9) {
          this.editQty = "";
        }
      }
    },
    inputResetAdd(x) {
      if (x == "category") {
        this.pilihProductAdd = {
          catalogName: "Choose Product",
          catalogId: "",
          price: [],
        };
        this.conditionChoosedAdd = {
          condition: "Choose Condition",
        };
        (this.pilihVarianAdd = {
          specification: "Choose Varian",
          catalogId: "",
        }),
          (this.pilihDurasiAdd = {
            tenorValue: 0,
            tenorMonths: "Choose Duration",
            tenorPrice: 0,
          });
        this.addDuration = "";
        this.addPrice = "";
        this.addQty = "";
      } else if (x == "product") {
        this.conditionChoosedAdd = {
          condition: "Choose Condition",
        };
        (this.pilihVarianAdd = {
          specification: "Choose Varian",
          catalogId: "",
        }),
          (this.pilihDurasiAdd = {
            tenorValue: 0,
            tenorMonths: "Choose Duration",
            tenorPrice: 0,
          });
        this.addQty = "";
        this.addDuration = "";
        this.addPrice = "";
      } else if (x == "varian") {
        this.conditionChoosedAdd = {
          condition: "Choose Condition",
        };
        this.pilihDurasiAdd = {
          tenorValue: 0,
          tenorMonths: "Choose Duration",
          tenorPrice: 0,
        };
        this.addQty = "";
        this.addDuration = "";
        this.addPrice = "";
      } else if (x == "condition") {
        this.pilihDurasiAdd = {
          tenorValue: 0,
          tenorMonths: "Choose Duration",
          tenorPrice: 0,
        };
        this.addQty = "";
        this.addDuration = "";
        this.addPrice = "";
      }
    },
    forceFileDownload(response, filename) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    exportInvoice(x, y) {
      this.loadingExport = true;
      this.$http
        .post(
          process.env.EXPORT_INVOICE,
          {
            paymentId: x,
            picId: this.picId,
            orderId: this.orderId,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
            responseType: "arraybuffer",
          }
        )
        .then((response) => {
          this.forceFileDownload(response, y + ".pdf");
          this.loadingExport = false;
          // this.typeCatalog = response.data.content.productData
          // this.tenorProduct = response.data.content.productTenor
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    connectLogRemarks: function () {
      var orderId = this.orderId;
      this.$http
        .get(process.env.LOG_URL + "/order_note/" + orderId, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.data.status === 200) {
            this.dataRemarks = response.data.content;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    connectLogOrder: function () {
      var route = this.route;
      var orderId = this.orderId;
      this.$http
        .get(process.env.LOG_URL + "/" + route + "/" + orderId, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.data.status === 200) {
            this.dataLogOrder = response.data.content;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    charCount(str, letter) {
      var letter_Count = 0;
      for (var position = 0; position < str.length; position++) {
        if (str.charAt(position) == letter) {
          letter_Count += 1;
        }
      }
      return letter_Count;
    },
    getRoute() {
      var jml = this.charCount(this.$route.path, "/");
      if (jml == 1) {
        this.route = this.$route.path.replace("/", "");
      } else {
        this.route = this.$route.path.substring(
          this.$route.path.indexOf("/") + 1,
          this.$route.path.indexOf("/", 2)
        );
      }
    },
    sendLog(codeLogs, data) {
      if (data == "Quotation") {
        var today = new Date(this.sendQuotationDate);
      } else if (data == "RenewQuotation") {
        var today = new Date(this.renewQuotationDate);
      } else if (data == "SendAgreement") {
        var today = new Date(this.sendAgreementDate);
      } else if (data == "ProcessAgreement") {
        var today = new Date(this.processAgreementDate);
      } else if (data == "SendInvoice") {
        var today = new Date(this.sendInvoiceDate);
      } else if (data == "ProcessInvoice") {
        var today = new Date(this.processInvoiceDate);
      } else if (data == "Paid") {
        var today = new Date(this.paidDate);
      } else {
        var today = new Date();
      }
      var month = today.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var dateDay = today.getDate();
      if (dateDay < 10) {
        dateDay = "0" + dateDay;
      }
      var hours = today.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = today.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var second = today.getSeconds();
      if (second < 10) {
        second = "0" + second;
      }
      var date = today.getFullYear() + "-" + month + "-" + dateDay;
      var time = hours + ":" + minutes + ":" + second;
      var dateTime = date + " " + time;
      var admin = this.admin;
      var command = "add-logs";
      if (data == "Reject") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "Process") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "Quotation") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [1],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "RenewQuotation") {
        var quotationCount = this.quotationCount;
        if (codeLogs == "4") {
          this.$http
            .post(
              process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
              {
                codeLogs: codeLogs,
                params: [quotationCount + 1],
              },
              {
                headers: { "Asani-Token": localStorage.getItem("jwt") },
              }
            )
            .then((response) => {
              this.connectLogRemarks();
              this.connectLogOrder();
            })
            .catch(error => {
              console.log(error);
            });
        } else if (codeLogs == "5") {
          this.$http
            .post(
              process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
              {
                codeLogs: codeLogs,
                params: [],
              },
              {
                headers: { "Asani-Token": localStorage.getItem("jwt") },
              }
            )
            .then((response) => {
              this.connectLogRemarks();
              this.connectLogOrder();
            })
            .catch(error => {
              console.log(error);
            });
        }
      } else if (data == "addOrderItem") {
        var productTitle = this.pilihProductAdd.productName ? this.pilihProductAdd.productName.replace(this.spaceRegex, ' ') : this.pilihProductAdd.productName;
        var qty = this.addQty;
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [productTitle, qty],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "editOrderItem") {
        var productTitleBefore = this.editProductName;
        var productTitle = this.pilihProduct.productName !== null ? this.pilihProduct.productName.replace(this.spaceRegex, ' ') : this.pilihProduct.productName;
        var qty = this.editQty;
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [productTitleBefore, productTitle, qty],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "deleteOrderItem") {
        var productTitle = this.deleteProductName;
        var qty = this.deleteQty;
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [productTitle, qty],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "legalDoc") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "uploadPurchaseOrder") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "SendAgreement") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [1],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "ProcessAgreement") {
        var agreementCount = this.agreementCount;
        if (codeLogs == "14") {
          this.$http
            .post(
              process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
              {
                codeLogs: codeLogs,
                params: [agreementCount + 1],
              },
              {
                headers: { "Asani-Token": localStorage.getItem("jwt") },
              }
            )
            .then((response) => {
              this.connectLogRemarks();
              this.connectLogOrder();
            })
            .catch(error => {
              console.log(error);
            });
        } else if (codeLogs == "16") {
          this.$http
            .post(
              process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
              {
                codeLogs: codeLogs,
                params: [],
              },
              {
                headers: { "Asani-Token": localStorage.getItem("jwt") },
              }
            )
            .then((response) => {
              this.connectLogRemarks();
              this.connectLogOrder();
            })
            .catch(error => {
              console.log(error);
            });
        }
      } else if (data == "SendInvoice") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "ProcessInvoice") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "VerifyStep") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "Paid") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs, // 18
              params: [],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "assignTo") {
        var pointName;
        var productTitle = this.productNameAssignTo;
        var qty;
        var assignVendor = this.assignVendor;
        var vendorQty = this.vendorQty;
        for (var i = 0; i < assignVendor.length; i++) {
          pointName = assignVendor[i].vendorName;
          qty = vendorQty[i];
          this.$http
            .post(
              process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
              {
                codeLogs: codeLogs,
                params: [pointName, productTitle, qty],
              },
              {
                headers: { "Asani-Token": localStorage.getItem("jwt") },
              }
            )
            .then((response) => {
              this.connectLogRemarks();
              this.connectLogOrder();
            })
            .catch(error => {
              console.log(error);
            });
        }
      } else if (data == "Deliver") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "startRent") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "editDelivery") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "downloadPo") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "renewPo") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      } else if (data == "processInvoiceNew") {
        this.$http
          .post(
            process.env.LOG_URL + "/" + this.route + "/" + this.orderId,
            {
              codeLogs: codeLogs,
              params: [],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.connectLogRemarks();
            this.connectLogOrder();
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    cekReplaced() {
      var replace = 0;
      for (var i = 0; i < this.detailOrder.length; i++) {
        if (this.detailOrder[i].orderItemStatus == 24) {
          this.itemDeliverReplace = this.itemDeliverReplace + 1;
        }
        if (this.detailOrder[i].orderItemStatus == 25) {
          this.itemStartReplace = this.itemStartReplace + 1;
        }
        if (
          this.detailOrder[i].orderItemStatus == 20 ||
          this.detailOrder[i].orderItemStatus == 21 ||
          this.detailOrder[i].orderItemStatus == 22 ||
          this.detailOrder[i].orderItemStatus == 23
        ) {
          replace = replace + 1;
        }
      }
      if (replace > 0) {
        this.itemDeliverReplace = 0;
      }
    },
    quotationTypeValidate() {
      // if (this.versionSelected.value == "IND") {
      //   this.typeSelect = ["Normal", "Promo"];
      // } else {
      //   this.typeSelect = ["Promo"];
      //   this.typeSelected = "Promo";
      // }
    },
    downloadQuotation() {
      if (this.generatQuotationDate == null) {
        swal("Sorry", "Date must be select", "error", {
          button: "Close",
        });
      } else if (this.mrMrsSelected == "") {
        swal("Sorry", "Client Title name must be select", "error", {
          button: "Close",
        });
      } else if (this.clientPicName == "") {
        swal("Sorry", "Client name must be fill", "error", {
          button: "Close",
        });
      } else if (
        this.quotaionEmployeeSelect.id == "" ||
        this.quotaionEmployeeSelect.id == null
      ) {
        swal("Sorry", "Asani PIC name must be select", "error", {
          button: "Close",
        });
      } else if (this.quotationEmployeePosition == "") {
        swal("Sorry", "Asani PIC position must be fill", "error", {
          button: "Close",
        });
      } else if (this.quotationSphNumber == "") {
        swal("Sorry", "SPH number must be fill", "error", {
          button: "Close",
        });
      } else if (this.quotationDefositFee == "") {
        swal("Sorry", "Deposit fee must be select", "error", {
          button: "Close",
        });
      } else if (this.quotationSphNumber.length < 4) {
        swal("Sorry", "SPH number must have at least 4 characters", "error", {
          button: "Close",
        });
      } else if (
        this.typeSelected == "Promo" &&
        this.cekPromoPrice() != 0
      ) {
        swal("Sorry", "Promo Price must be fill", "error", {
          button: "Close",
        });
      } else {
        let self = this;
        let promo = [];
        if (this.typeSelected == "Promo") {
          for (var i = 0; i < this.dataQuotation.length; i++) {
            promo.push({
              productId: this.dataQuotation[i].productId,
              promoPrice: `${this.promoPrice[i].toString().replace(/\./g,'')}`,
              condition : this.dataQuotation[i].condition
            });
          }
        }

        this.loadingDownloadQuotation = true;
        const date = this.dateToString(this.generatQuotationDate, false).split('T')
        const quotationDate = `${date[0]} ${date[1]}`

        this.$http
          .post(
            process.env.DOWNLOAD_QUOTATION,
            {
              date: quotationDate,
              sphNumber: this.quotationSphNumber,
              mrMrs: this.mrMrsSelected,
              clientName: this.clientPicName !==  null ? this.clientPicName.replace(this.spaceRegex, ' ') : this.clientPicName,
              companyName: this.companyName !== null ? this.companyName.replace(this.spaceRegex, ' ') : this.companyName,
              orderCode: this.orderCode !== null ? this.orderCode.replace(this.spaceRegex, ' ') : this.orderCode,
              orderId: this.orderId,
              asaniEmployeeName: this.quotaionEmployeeSelect.employeeName !== null ? this.quotaionEmployeeSelect.employeeName.replace(this.spaceRegex, ' ') : this.quotaionEmployeeSelect.employeeName,
              asaniEmployeePosition: this.quotationEmployeePosition !== null ? this.quotationEmployeePosition.replace(this.spaceRegex, ' ') : this.quotationEmployeePosition,
              version: this.versionSelected.value,
              type: this.typeSelected,
              depositFee: this.quotationDefositFee,
              promoPrice: promo,
            },
            {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
              responseType: "arraybuffer",
            }
          )
          .then((response) => {
            if (this.typeSelected == "Normal") {
              this.forceFileDownload(
                response,
                "Normal_" + this.orderCode + ".pdf"
              );
            } else if (this.typeSelected == "Promo") {
              this.forceFileDownload(
                response,
                "Promo_" + this.orderCode + ".pdf"
              );
            }
            this.loadingDownloadQuotation = false;
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });

            }
            this.resetGenerateQuotation();
            this.getData();
            $("#modalGenerateQuotation").modal("hide");
            this.sendLog(65, "downloadPo");
          })
          .catch(error => {
            if (!error.status) {
              self.loadingDownloadQuotation = false;
              this.resetGenerateQuotation();
            }
            swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    cekPromoPrice: function () {
      let kosong = 0;
      for (var i = 0; i < this.dataQuotation.length; i++) {
        if (this.promoPrice[i] == "") {
          kosong++;
        }
      }
      return kosong;
    },
    resetGenerateQuotation() {
      this.mrMrsSelected = "";
      this.clientPicName = "";
      this.quotaionEmployeeSelect = this.employeeAsaniOrder;
      this.quotationEmployeePosition = "Account Executive";
      this.quotationSphNumber = "";
      this.quotationDefositFee = "";
      this.typeSelected = "Normal";
      this.versionSelected = {version : "Indonesia", value : "IND"};
      this.promoPrice = [];
      for (var i = 0; i < this.detailOrder.length; i++) {
        if (this.detailOrder[i].condition !== "New") {
          this.promoPrice.push(this.detailOrder[i].finalPrice);
        }
      }
      this.clientPicName = this.userName;
      this.quotationTypeValidate();
    },
    submitUpdateProduct() {
      var self = this;
      this.loadingButtonProcess = true;
      this.$http
        .post(
          process.env.UPDATE_PRODUCTS,
          {
            orderId: this.orderId,
          },
          {
            timeout: 30 * 1000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            this.handleLogout();
          } else if (response.data.status == 201) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
          } else if (response.data.status == 200) {
            swal(
              "Success",
              "Success change order status to update products",
              "success",
              {
                button: "Close",
              }
            );
          }
          this.loadingButtonProcess = false;
          $("#modalUpdateProduct").modal("hide");
          this.getData();
        })
        .catch(error => {
          // alert("Request timeout / error with api, please try again!");
          self.loadingButtonProcess = false;
          swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    sendInvoiceExtend(action) {
        let time = null;
        var self = this;
        this.loadingButtonProcess = true;
        this.$http
          .post(
            process.env.EXTEND_SEND_INVOICE,
            {
              orderId: Number(this.orderId),
              // action: action,
              // invoiceStatus: Number(this.chooseInvoiceStatus),
              // time: this.dateToString(time, false),
              oldOrderId: Number(this.orderExtendFrom.orderId),
            },
            {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal("Success", response.data.message, "success", {
                button: "Ok",
              });
              if (action == "renew") {
                this.sendLog(15, "SendInvoice");
              } else {
                // this.sendLog(67,'processInvoiceNew')
              }
            }
            if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            $("#modalKeepCurrentInvoice").modal("hide");
            this.processInvoiceDate = "";
            this.getData();
            this.loadingButtonProcess = false;
          })
          .catch(error => {
            // alert("Request timeout / error with api, please try again!");
            self.loadingButtonProcess = false;
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      
    },
    invoicePaidExtend() {
      if (this.paidDate == "" || this.paidDate == null) {
        swal("Sorry", "Time must be fill.", "error", {
          button: "Close",
        });
      } else {
        var self = this;
        this.loadingButtonProcess = true;
        this.$http
          .post(
            process.env.EXTEND_INVOICE_PAID,
            {
              orderId: this.orderId,
              time: this.dateToString(this.paidDate, false),
            },
            {
              timeout: 30 * 1000,
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (response.data.status == 200) {
              swal("Success", response.data.message, "success", {
                button: "Ok",
              });
            }
            if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            }
            $("#modalPaid").modal("hide");
            this.paidDate = "";
            this.getData();
            this.loadingButtonProcess = false;
          })
          .catch(error => {
            // alert("Request timeout / error with api, please try again!");
            self.loadingButtonProcess = false;
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    deleteOrderItemExtend() {
      this.loadingButtonProcess = true;
      this.$http
        .post(
          process.env.EXTEND_REMOVE_ITEM,
          {
            orderId: parseInt(this.orderId),
            orderIdExtendFrom: parseInt(this.orderExtendFrom.orderId),
            productId: this.deleteProductId,
            duration: this.durationBefore,
            condition: this.conditionDelete,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            swal("Success", response.data.message, "success", {
              button: "Ok",
            });
          } else {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
          }
          $("#modalRemoveItemExtend").modal("hide");
          this.getData();
          this.loadingButtonProcess = false;
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    resetOrderDetailFilter() {
      this.searchSnLp = "";
    },
    handleClickInvoicePaid() {
      $("#modalPaid").modal("show");
    },
    submitSearchSnLp() {
      if (this.searchSnLp) {
        this.$http
          .post(
            process.env.SEARCH_ORDER_DETAIL_PRODUCT,
            {
              orderId: this.orderId,
              uniqueId: this.searchSnLp,
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            if (
              response.data.status == 200 &&
              response.data.content.productCode
            ) {
              this.selectedOrderItemDetailHistory = response.data.content;
              $(`#modalViewHistory`).modal("show");
            } else if (response.data.status == 201) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });
            } else {
              swal("Sorry", "SN/LP Tidak Ditemukan", "error", {
                button: "Close",
              });
            }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    getOrderPriorityTag() {
       this.$http.post(process.env.GET_TAG,
      {
        groupBy: "category",
        type: "Priority",
        target: "ORDER"
      },
      {
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })
            }else{
              if(response.data.content[0].tag && response.data.content[0].tag.length > 0 ) {
                this.orderPriorityOptions = response.data.content[0].tag
              }
              
            }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    getStatusBadgeClass(status) {
      const statusMap = {
        "Belum Upload Lampiran Penyerahan": "badge-warning",
        "Pending Delivery": "badge-warning",
        "BAST Selesai": "badge-success",
      };
      return statusMap[status] || "badge-warning";
    },
    getStatusLabel(status) {
      if (!status) return "-";
      return status;
    },
   
  },
  watch: {
    selectBastItem(val) {
      console.log('jalan watcher', val)
      if(val.length) {
        console.log('kesini val')
        if(this.dataAllItemBast.length == this.selectBastItem.length) {
          this.ceklistAll = true
        } else {
          this.ceklistAll = false
        }
      } else {
        this.ceklistAll = false
      }
    },
    bastType() {
      if(!this.disableTypeBast) {
        this.loadingTableBast = true
        this.$http
          .post(
            process.env.GET_ITEM_FOR_BAST,
            {
              orderId: parseInt(this.orderId),
              bastType: this.bastType,
              bastId: ''
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {
            this.loadingTableBast = false
            if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Close",
              });

            } else if (response.data.status == 200) {
              // this.editDate = []
              this.dataAllItemBast = response.data.content || [];
              // for (var i = 0; i <= this.dataAllItemBast.length; i++) {
              //     if (this.dataAllItemBast[i].productType == 1) {
              //     }
              // }
              // this.editDate.pop()
            }
            this.loadingTableBast = false;
          })
          .catch(error => {
            this.loadingTableBast = false
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
          });
      }
    },
    financeEmail: {
      handler: function (val) {
        let isEmail = /\S+@\S+\.\S+/;
        if (this.financeEmail.length == 1) {
          if (isEmail.test(this.financeEmail[0])) {
            this.allEmailFilled = true;
          } else {
            this.allEmailFilled = false;
          }
        } else if (this.financeEmail.length > 1) {
          for (let i in this.financeEmail) {
            if (
              this.financeEmail[i] == "" ||
              this.financeEmail == null ||
              !isEmail.test(this.financeEmail[i])
            ) {
              this.allEmailFilled = false;
            } else {
              this.allEmailFilled = true;
            }
          }
        }
      },
    },
    addFinanceEmail: {
      handler: function (val) {
        let isEmail = /\S+@\S+\.\S+/;
        if (this.addFinanceEmail.length > 0) {
          if (isEmail.test(this.addFinanceEmail)) {
            this.allEmailFilled = true;
          } else {
            this.allEmailFilled = false;
          }
        } else {
          this.allEmailFilled = true;
        }
      },
    },
    companyProvinceMandatory: {
      handler: function () {
        this.getKabkot();
      },
    },
    companyDistrictMandatory: {
      handler: function () {
        this.getKecamatan();
      },
    },
    bastProvinceMandatory: {
      handler: function () {
        this.getKabkot("", true);
      },
    },
    bastDistrictMandatory: {
      handler: function () {
        this.getKecamatan("", true);
      },
    },
    orderPriority(val) {
      if(val.length > 1) {
        this.orderPriority = [val[1]]
      }
    },
  },
  created() {
    this.getRoute();
    this.getData();
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.cekLogin();
    this.cekPermission();
    this.getOrderPriorityTag();
  },
};
</script>

<!-- Add"scoped" attribute to limit CSS to this component only -->
<style scoped>
.editablePriorityBox {
  box-shadow: 0px 2px 4px 0px #00000040;
}
#editableOrderPriorityChip :hover {
  cursor: pointer;
}

.orderPriorityChips {
  display: inline-block;
  padding: 0 18px;
  /* height: 50px; */
  font-size: 14px;
  line-height: 20px;
  border-radius: 25px;
  /* color: #fff */
  /* background-color: #F1BE07; */
}
.unit-detail td {
  border : 0px solid #dee2e6;
}
.item-badge-addons {
  padding: 0.2em 0.8em;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.375rem;
  transition: color 0.15s;
  margin-right: 2px;
  color: #fff;
  background-color:#4DABC0;
}

.item-badge {
  display: inline-block;
  padding: 0.5em 0.8em;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s;
  margin-right: 2px;
  color: #fff;
}
.ticket-badge:hover {
  text-decoration: underline;
  transform: scale(1.5);
}

.ticket-no:hover {
  text-decoration: underline;
}
table thead th {
  text-align: center;
  vertical-align: middle;
}
.black-text {
  color: black;
}
.product-specs:hover {
  text-decoration: underline;
  text-decoration-color: #3099F8;
}
.grid-container {
  display: grid;
  grid-template-columns: 10% 27% 25% 28% 7%;
  grid-column-gap: 5px;
}

.item-detail-container {
  display: grid;
  grid-template-columns: 10% 45% 40%;
  grid-column-gap: 5px;
}

.btn-small {
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 0.15rem 0.3rem;
  border-radius: 0.2rem;
}

.new-detail {
  padding: 0rem 1.25rem;
}

.order-item-detail {
  margin-top: 5px;
  margin-bottom: 5px;
}
.multiselect div.multiselect__tags span.multiselect__single {
  padding-left: 0px;
  margin-bottom: 8px;
}
.rs-schedule {
  margin: 7px 0px;
}
.rs-po {
  margin: 7px 0px;
}
.rs-lessee {
  margin: 7px 0px;
}
.rs-ol-titik2 {
  width: 15px;
  margin: 7px 0px;
}
.tableFixHead {
  overflow-y: auto;
  height: 100px;
}
.tableFixHead thead th {
  position: sticky;
  top: 0;
}
.icon-verified {
  max-width: 22px;
  max-height: 22px;
  margin-right: 2px;
}
.multiselect.mandatory {
  height: calc(1.5em + 0.5rem + 2px);
}
table.mandatory-table td {
  margin-bottom: 10px;
}
.text-star {
  color: red;
  margin-bottom: 10px;
}
.link-company:hover {
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}
.text-new {
  color: orange;
  font-weight: bold;
}
.font-black {
  color: black;
}
.nav-tabs {
  width: 48%;
}
.project-tab {
  padding: 0% 0% 2% 0%;
}
.project-tab #tabs {
  background: #007b5e;
  color: #eee;
}
.project-tab #tabs h6.section-title {
  color: #eee;
}
.project-tab #tabs .nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #0062cc;
  background-color: transparent;
  border-color: transparent transparent #f3f3f3;
  border-bottom: 3px solid !important;
  font-size: 16px;
  font-weight: bold;
}
.project-tab .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  /*color: #0062cc;*/
  font-size: 16px;
  font-weight: 600;
}
.project-tab .nav-link:hover {
  border: none;
}
.project-tab thead {
  background: #f3f3f3;
  color: #333;
}
.project-tab a {
  text-decoration: none;
  color: #333;
  font-weight: 600;
}
.fa-check-circle {
  color: green;
}
.btn:focus {
  outline: none;
}
.btn-outline-right {
  border: 1px solid black;
  border-left: none;
}
.btn-outline-left {
  border: 1px solid black;
  border-right: none;
}
.two-button {
  display: flex;
  box-shadow: 2px;
}
.block {
  display: block;
  width: 100%;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  border-radius: 0px;
}
.font-red {
  color: red;
  margin-top: -15px;
}
.modal-dialog.modal-scroll {
  overflow-y: initial !important;
}
.modal-body.modal-scroll {
  height: 530px;
  overflow-y: auto;
}
.detail-order {
  color: blue;
  font-style: italic;
}
.detail-order:hover {
  cursor: pointer;
}
.product-name {
  margin-top: 6px;
  margin-left: -5px;
}
.delivery-sch {
  width: 199px;
  margin: 7px 0px;
}
.deliver-field {
  width: 84%;
}
.pickup-sch {
  width: 186px;
  margin: 7px 0px;
}
.stPrice-sch {
  width: 186px;
  margin: 7px 0px;
}
.delivery-titik2 {
  margin: 7px 0px;
  padding-right: 7px;
}
.qty-assignto {
  margin: 7px 0px;
  margin-left: 6px;
  margin-right: 5px;
}
.partnership-text {
  width: 195px;
  margin: 7px 0px;
}
.partnership-titik2 {
  margin: 7px 0px;
  padding-right: 7px;
}
.deliver-date {
  font-size: 14px;
  color: orange;
  font-weight: bold;
}
.total-rp {
  padding-left: 23px;
  padding-right: 20px;
}
.jarak-assigto {
  margin-left: 147px;
  margin-bottom: 6px;
  height: 18px;
}
.change_price {
  max-width: 150px;
  margin-right: 5px;
}
.edit-status {
  margin-bottom: 0;
}
.permonth {
  margin: 5px 0px 5px 5px;
}
.text-partnership {
  margin-bottom: 0px;
}
.img-responsive {
  width: 250px;
  height: auto;
}
.process-vendor-new {
  max-width: 345px;
  margin: 5px 5px;
}
.process-qty-new {
  max-width: 62px;
  height: 41px;
}
.process-vendor {
  min-width: 345px;
  margin-bottom: 5px;
}
.process-qty {
  max-width: 80px;
  height: 42px;
}
.button-plus {
  bottom: 0px;
  right: 0px;
}
.input-title {
  margin: 0px 5px;
}
.input-title-new {
  margin: 0px 5px;
  width: 75%;
}
.input-one-line {
  display: flex;
}
.input-one-line-assign {
  display: flex;
  width: 100%;
}
.input-title-assign {
  margin: 0px 5px;
  width: 100%;
}
.input-title-assignto {
  margin: 0px 5px;
  width: 100%;
}
.input-title-qty {
  margin: 0px 5px;
  width: 100%;
}
.title-product {
  width: 100%;
  margin: 5px 0px;
}
.input-group-addon {
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
}
.label-addon-rp {
  margin: 1px 0px;
}
.change-title {
  display: block;
}
.one-line {
  display: flex;
  margin: 5px 0px;
}
.one-line .ol-label-time {
  width: 188px;
  margin: 2px 0px;
}
.one-line .ol-label {
  width: 188px;
  margin: 2px 0px;
}
.one-line .ol-label-reason {
  width: 88px;
  margin: 2px 0px;
}
.one-line .ol-label-price {
  width: 263px;
  margin: 2px 0px;
}
.one-line .ol-titik2 {
  width: 15px;
  margin: 2px 0px;
}
.one-line .ol-titik2-price {
  margin: 2px 0px;
}
.top-assignto {
  display: flex;
}
.btn-icon-assign {
  height: 37px;
  width: 103px;
  margin-top: 5px;
}
.one-line .ol-value {
  width: 100%;
  margin: 2px 0px;
}
.fixed_header {
  table-layout: fixed;
  border-collapse: collapse;
}
.fixed_header tbody {
  display: block;
  overflow: auto;
  max-height: 200px;
  width: 100%;
}
.fixed_header tbody.full-width tr td {
  width: 1578px;
}
.fixed_header thead tr {
  display: block;
}
.fixed_header th,
.fixed_header td {
  padding: 5px;
  text-align: left;
  width: 200px;
}
.fixed_header.payment th,
.fixed_header.payment td {
  padding: 5px;
  text-align: left;
  width: 217px;
}
.pagination {
  padding: 0px 0;
}
.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.pagination a {
  display: inline-block;
  padding: 2px 6px;
  color: #222;
}
.p8 a {
  background-color: #2797fb;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797fb;
}
.p8 a:hover {
  text-decoration: none;
}
.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}
.p8 .is-active {
  background-color: #fff;
  color: #2797fb;
}
.alignleft {
  float: left;
}
.alignright {
  float: right;
}
.pagg {
  display: inline-flex;
  overflow: auto;
}
.total-data {
  font-size: 14px;
  color: #343a40;
}
#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}
#c1 {
  float: left;
}
#c2 {
  float: right;
}
/*.table td, .table th {
    padding: 0.25rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
    }*/
.search-table {
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
}
.active {
  color: #2797fb;
}
.right-dropdown {
  margin-left: 7px;
}
.account-div {
  margin: 2px 2px;
}
.right-arrow {
  margin-left: auto;
}
.brand-logo {
  width: 120px;
}
.menu-title {
  margin-left: 1.125rem;
}
.menu-title-order {
  margin-left: 1.95rem;
}
.menu-title-payment {
  margin-left: 1.525rem;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}
li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}
li a.active {
  background-color: #4caf50;
  color: white;
}
li a:hover:not(.active) {
  background-color: #2797fb;
  color: white;
}
.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}
.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}
.nav-side-menu .toggle-btn {
  display: none;
}
.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
}
.nav-side-menu ul :not(collapsed) .arrow:before,
.nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}
.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}
.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}
.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}
.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}
.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}
.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}
.border-red{
  border-color:red;
}
@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px) {
  .mobile-div {
    padding: 2px 0px;
  }
}

/** BAST Section */

.bast-section thead tr th {
  background-color: #f4f4f4;
  color: #2e3646;
  font-family: "Inter", sans-serif;
}

.bast-section tbody tr td {
  color: #2e3646;
  font-family: "Inter", sans-serif;
  font-weight: 400;
}

.bast-section tbody tr:nth-child(even) {
  background-color: #f9f9f9;
  color: #2e3646;
  font-family: "Inter", sans-serif;
}

.bast-section {
  background-color: #ffffff;
  border: 1px solid #cfd3d9;
  border-radius: 8px;
  padding: 20px;
  font-family: "Inter", sans-serif;
}

.bast-section .badge {
  font-size: 12px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 6px;
  font-family: "Inter", sans-serif;
}

.bast-section .badge-warning {
  border: 1px solid #fee685;
  color: #bb4d00;
  background-color: #fffbeb;
}

.bast-section .badge-success {
  border: 1px solid #a4f4cf;
  color: #007A55;
  background-color: #ECFDF5;
}

.primary-bg-color {
  background-color: #247fec;
  color: #ffffff;
}

.success-bg-color {
  background-color: #009966;
  color: #ffffff;
}

.error-bg-color {
  background-color: #e7000b;
  color: #ffffff;
}

.fw-500 {
  font-weight: 500;
  font-family: "Inter", sans-serif;
}

.bast-section button {
  font-size: 12px;
  border-radius: 6px;
}

.modal-bast .card {
  border-radius: 8px;
}

.modal-bast .text-subtitle {
  font-size: 14px;
  color: #62748e;
}

.modal-bast label {
  font-size: 14px;
  color: #2e3646;
  font-weight: 500;
  margin: 0;
}

.modal-bast select.form-control {
  width: 140px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23989898' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 20px center;
  background-size: 1.2em 1.2em;
  padding-right: 20px;
  padding-left: 20px;
}

.modal-bast .modal-body {
  background-color: #f8f9fa !important;
}

.modal-bast thead {
  background-color: #f4f4f4;
}

.modal-bast thead tr th {
  background-color: #f4f4f4;
  color: #2e3646;
}

.modal-bast tbody {
  background-color: white;
}

.modal-bast tbody tr td {
  background-color: white;
}

.modal-bast input[type="checkbox"] {
  cursor: pointer;
}

.modal-bast .ol-label {
  font-size: 14px;
  color: #2e3646;
  font-weight: 500;
}

.modal-bast tr td {
  vertical-align: top;
}

.modal-bast .btn-back {
  background-color: white;
  color: #007bff;
  border: 1px solid #007bff;
}

.modal-bast .btn-back:hover {
  background-color: #f8f9fa;
  color: #0056b3;
  border-color: #0056b3;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderDetailPage.vue